import { jsx as f, Fragment as Fe, jsxs as P } from "react/jsx-runtime";
import * as _ from "react";
import Y, { forwardRef as $e, useCallback as te, useEffect as ce, useRef as _e, useImperativeHandle as zt, useMemo as ht, useState as de, Fragment as Ar, createElement as Fo, useLayoutEffect as Mo, createRef as _s } from "react";
import on from "rehype-raw";
import { useTranslation as Te, getI18n as fn } from "react-i18next";
import { MessageType as Mt, LegalCaseState as Be, QuestionType as ue } from "@law-connect/types";
import Ns, { createPortal as Ro } from "react-dom";
import Is from "copy-to-clipboard";
import { toast as Es, ToastContainer as Ss } from "react-toastify";
import './index.css';const Ps = "_textareaInput_fqvv4_1", ks = {
  textareaInput: Ps
}, Os = $e((e, n) => {
  var o;
  const { value: t = "", disabled: r, onChange: i } = e, a = te((l) => {
    r || i(l.target.value);
  }, [r, i]);
  return /* @__PURE__ */ f(
    "textarea",
    {
      ref: n,
      ...e.props,
      className: `${ks.textareaInput} ${(o = e.props) == null ? void 0 : o.className}`,
      onChange: a,
      disabled: r,
      value: t
    }
  );
}), Ts = "_userChatMessage_1rvtq_1", Ls = {
  userChatMessage: Ts
};
function Fs(e, n) {
  const t = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const Ms = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Rs = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Ds = {};
function _i(e, n) {
  return (Ds.jsx ? Rs : Ms).test(e);
}
const Bs = /[ \t\n\f\r]/g;
function js(e) {
  return typeof e == "object" ? e.type === "text" ? Ni(e.value) : !1 : Ni(e);
}
function Ni(e) {
  return e.replace(Bs, "") === "";
}
class hn {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(n, t, r) {
    this.normal = t, this.property = n, r && (this.space = r);
  }
}
hn.prototype.normal = {};
hn.prototype.property = {};
hn.prototype.space = void 0;
function Do(e, n) {
  const t = {}, r = {};
  for (const i of e)
    Object.assign(t, i.property), Object.assign(r, i.normal);
  return new hn(t, r, n);
}
function wr(e) {
  return e.toLowerCase();
}
class ze {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(n, t) {
    this.attribute = t, this.property = n;
  }
}
ze.prototype.attribute = "";
ze.prototype.booleanish = !1;
ze.prototype.boolean = !1;
ze.prototype.commaOrSpaceSeparated = !1;
ze.prototype.commaSeparated = !1;
ze.prototype.defined = !1;
ze.prototype.mustUseProperty = !1;
ze.prototype.number = !1;
ze.prototype.overloadedBoolean = !1;
ze.prototype.property = "";
ze.prototype.spaceSeparated = !1;
ze.prototype.space = void 0;
let Hs = 0;
const se = Et(), Pe = Et(), xr = Et(), j = Et(), be = Et(), Rt = Et(), qe = Et();
function Et() {
  return 2 ** ++Hs;
}
const _r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: se,
  booleanish: Pe,
  commaOrSpaceSeparated: qe,
  commaSeparated: Rt,
  number: j,
  overloadedBoolean: xr,
  spaceSeparated: be
}, Symbol.toStringTag, { value: "Module" })), Kn = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(_r)
);
class ni extends ze {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(n, t, r, i) {
    let a = -1;
    if (super(n, t), Ii(this, "space", i), typeof r == "number")
      for (; ++a < Kn.length; ) {
        const o = Kn[a];
        Ii(this, Kn[a], (r & _r[o]) === _r[o]);
      }
  }
}
ni.prototype.defined = !0;
function Ii(e, n, t) {
  t && (e[n] = t);
}
function Wt(e) {
  const n = {}, t = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const a = new ni(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), n[r] = a, t[wr(r)] = r, t[wr(a.attribute)] = r;
  }
  return new hn(n, t, e.space);
}
const Bo = Wt({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Pe,
    ariaAutoComplete: null,
    ariaBusy: Pe,
    ariaChecked: Pe,
    ariaColCount: j,
    ariaColIndex: j,
    ariaColSpan: j,
    ariaControls: be,
    ariaCurrent: null,
    ariaDescribedBy: be,
    ariaDetails: null,
    ariaDisabled: Pe,
    ariaDropEffect: be,
    ariaErrorMessage: null,
    ariaExpanded: Pe,
    ariaFlowTo: be,
    ariaGrabbed: Pe,
    ariaHasPopup: null,
    ariaHidden: Pe,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: be,
    ariaLevel: j,
    ariaLive: null,
    ariaModal: Pe,
    ariaMultiLine: Pe,
    ariaMultiSelectable: Pe,
    ariaOrientation: null,
    ariaOwns: be,
    ariaPlaceholder: null,
    ariaPosInSet: j,
    ariaPressed: Pe,
    ariaReadOnly: Pe,
    ariaRelevant: null,
    ariaRequired: Pe,
    ariaRoleDescription: be,
    ariaRowCount: j,
    ariaRowIndex: j,
    ariaRowSpan: j,
    ariaSelected: Pe,
    ariaSetSize: j,
    ariaSort: null,
    ariaValueMax: j,
    ariaValueMin: j,
    ariaValueNow: j,
    ariaValueText: null,
    role: null
  },
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  }
});
function jo(e, n) {
  return n in e ? e[n] : n;
}
function Ho(e, n) {
  return jo(e, n.toLowerCase());
}
const Vs = Wt({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Rt,
    acceptCharset: be,
    accessKey: be,
    action: null,
    allow: null,
    allowFullScreen: se,
    allowPaymentRequest: se,
    allowUserMedia: se,
    alt: null,
    as: null,
    async: se,
    autoCapitalize: null,
    autoComplete: be,
    autoFocus: se,
    autoPlay: se,
    blocking: be,
    capture: null,
    charSet: null,
    checked: se,
    cite: null,
    className: be,
    cols: j,
    colSpan: null,
    content: null,
    contentEditable: Pe,
    controls: se,
    controlsList: be,
    coords: j | Rt,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: se,
    defer: se,
    dir: null,
    dirName: null,
    disabled: se,
    download: xr,
    draggable: Pe,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: se,
    formTarget: null,
    headers: be,
    height: j,
    hidden: xr,
    high: j,
    href: null,
    hrefLang: null,
    htmlFor: be,
    httpEquiv: be,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: se,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: se,
    itemId: null,
    itemProp: be,
    itemRef: be,
    itemScope: se,
    itemType: be,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: se,
    low: j,
    manifest: null,
    max: null,
    maxLength: j,
    media: null,
    method: null,
    min: null,
    minLength: j,
    multiple: se,
    muted: se,
    name: null,
    nonce: null,
    noModule: se,
    noValidate: se,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: se,
    optimum: j,
    pattern: null,
    ping: be,
    placeholder: null,
    playsInline: se,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: se,
    referrerPolicy: null,
    rel: be,
    required: se,
    reversed: se,
    rows: j,
    rowSpan: j,
    sandbox: be,
    scope: null,
    scoped: se,
    seamless: se,
    selected: se,
    shadowRootClonable: se,
    shadowRootDelegatesFocus: se,
    shadowRootMode: null,
    shape: null,
    size: j,
    sizes: null,
    slot: null,
    span: j,
    spellCheck: Pe,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: j,
    step: null,
    style: null,
    tabIndex: j,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: se,
    useMap: null,
    value: Pe,
    width: j,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: be,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: j,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: j,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: se,
    // Lists. Use CSS to reduce space between items instead
    declare: se,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: j,
    // `<img>` and `<object>`
    leftMargin: j,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: j,
    // `<body>`
    marginWidth: j,
    // `<body>`
    noResize: se,
    // `<frame>`
    noHref: se,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: se,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: se,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: j,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Pe,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: j,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: j,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: se,
    disableRemotePlayback: se,
    prefix: null,
    property: null,
    results: j,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Ho
}), zs = Wt({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: qe,
    accentHeight: j,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: j,
    amplitude: j,
    arabicForm: null,
    ascent: j,
    attributeName: null,
    attributeType: null,
    azimuth: j,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: j,
    by: null,
    calcMode: null,
    capHeight: j,
    className: be,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: j,
    diffuseConstant: j,
    direction: null,
    display: null,
    dur: null,
    divisor: j,
    dominantBaseline: null,
    download: se,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: j,
    enableBackground: null,
    end: null,
    event: null,
    exponent: j,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: j,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Rt,
    g2: Rt,
    glyphName: Rt,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: j,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: j,
    horizOriginX: j,
    horizOriginY: j,
    id: null,
    ideographic: j,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: j,
    k: j,
    k1: j,
    k2: j,
    k3: j,
    k4: j,
    kernelMatrix: qe,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: j,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: j,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: j,
    overlineThickness: j,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: j,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: be,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: j,
    pointsAtY: j,
    pointsAtZ: j,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: qe,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: qe,
    rev: qe,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: qe,
    requiredFeatures: qe,
    requiredFonts: qe,
    requiredFormats: qe,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: j,
    specularExponent: j,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: j,
    strikethroughThickness: j,
    string: null,
    stroke: null,
    strokeDashArray: qe,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: j,
    strokeOpacity: j,
    strokeWidth: null,
    style: null,
    surfaceScale: j,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: qe,
    tabIndex: j,
    tableValues: null,
    target: null,
    targetX: j,
    targetY: j,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: qe,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: j,
    underlineThickness: j,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: j,
    values: null,
    vAlphabetic: j,
    vMathematical: j,
    vectorEffect: null,
    vHanging: j,
    vIdeographic: j,
    version: null,
    vertAdvY: j,
    vertOriginX: j,
    vertOriginY: j,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: j,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: jo
}), Vo = Wt({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  }
}), zo = Wt({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Ho
}), Wo = Wt({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  }
}), Ws = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Us = /[A-Z]/g, Ei = /-[a-z]/g, qs = /^data[-\w.:]+$/i;
function Zs(e, n) {
  const t = wr(n);
  let r = n, i = ze;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && qs.test(n)) {
    if (n.charAt(4) === "-") {
      const a = n.slice(5).replace(Ei, Qs);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = n.slice(4);
      if (!Ei.test(a)) {
        let o = a.replace(Us, Gs);
        o.charAt(0) !== "-" && (o = "-" + o), n = "data" + o;
      }
    }
    i = ni;
  }
  return new i(r, n);
}
function Gs(e) {
  return "-" + e.toLowerCase();
}
function Qs(e) {
  return e.charAt(1).toUpperCase();
}
const Ks = Do([Bo, Vs, Vo, zo, Wo], "html"), ri = Do([Bo, zs, Vo, zo, Wo], "svg");
function Ys(e) {
  return e.join(" ").trim();
}
var En = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Bn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ii = {}, Si = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Xs = /\n/g, Js = /^\s*/, e1 = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, t1 = /^:\s*/, n1 = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, r1 = /^[;\s]*/, i1 = /^\s+|\s+$/g, a1 = `
`, Pi = "/", ki = "*", It = "", o1 = "comment", l1 = "declaration", s1 = function(e, n) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  n = n || {};
  var t = 1, r = 1;
  function i(y) {
    var C = y.match(Xs);
    C && (t += C.length);
    var $ = y.lastIndexOf(a1);
    r = ~$ ? y.length - $ : r + y.length;
  }
  function a() {
    var y = { line: t, column: r };
    return function(C) {
      return C.position = new o(y), u(), C;
    };
  }
  function o(y) {
    this.start = y, this.end = { line: t, column: r }, this.source = n.source;
  }
  o.prototype.content = e;
  function l(y) {
    var C = new Error(
      n.source + ":" + t + ":" + r + ": " + y
    );
    if (C.reason = y, C.filename = n.source, C.line = t, C.column = r, C.source = e, !n.silent) throw C;
  }
  function s(y) {
    var C = y.exec(e);
    if (C) {
      var $ = C[0];
      return i($), e = e.slice($.length), C;
    }
  }
  function u() {
    s(Js);
  }
  function c(y) {
    var C;
    for (y = y || []; C = d(); )
      C !== !1 && y.push(C);
    return y;
  }
  function d() {
    var y = a();
    if (!(Pi != e.charAt(0) || ki != e.charAt(1))) {
      for (var C = 2; It != e.charAt(C) && (ki != e.charAt(C) || Pi != e.charAt(C + 1)); )
        ++C;
      if (C += 2, It === e.charAt(C - 1))
        return l("End of comment missing");
      var $ = e.slice(2, C - 2);
      return r += 2, i($), e = e.slice(C), r += 2, y({
        type: o1,
        comment: $
      });
    }
  }
  function p() {
    var y = a(), C = s(e1);
    if (C) {
      if (d(), !s(t1)) return l("property missing ':'");
      var $ = s(n1), m = y({
        type: l1,
        property: Oi(C[0].replace(Si, It)),
        value: $ ? Oi($[0].replace(Si, It)) : It
      });
      return s(r1), m;
    }
  }
  function h() {
    var y = [];
    c(y);
    for (var C; C = p(); )
      C !== !1 && (y.push(C), c(y));
    return y;
  }
  return u(), h();
};
function Oi(e) {
  return e ? e.replace(i1, It) : It;
}
var u1 = En && En.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ii, "__esModule", { value: !0 });
ii.default = d1;
var c1 = u1(s1);
function d1(e, n) {
  var t = null;
  if (!e || typeof e != "string")
    return t;
  var r = (0, c1.default)(e), i = typeof n == "function";
  return r.forEach(function(a) {
    if (a.type === "declaration") {
      var o = a.property, l = a.value;
      i ? n(o, l, a) : l && (t = t || {}, t[o] = l);
    }
  }), t;
}
var jn = {};
Object.defineProperty(jn, "__esModule", { value: !0 });
jn.camelCase = void 0;
var f1 = /^--[a-zA-Z0-9_-]+$/, h1 = /-([a-z])/g, p1 = /^[^-]+$/, m1 = /^-(webkit|moz|ms|o|khtml)-/, g1 = /^-(ms)-/, y1 = function(e) {
  return !e || p1.test(e) || f1.test(e);
}, $1 = function(e, n) {
  return n.toUpperCase();
}, Ti = function(e, n) {
  return "".concat(n, "-");
}, v1 = function(e, n) {
  return n === void 0 && (n = {}), y1(e) ? e : (e = e.toLowerCase(), n.reactCompat ? e = e.replace(g1, Ti) : e = e.replace(m1, Ti), e.replace(h1, $1));
};
jn.camelCase = v1;
var C1 = En && En.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, b1 = C1(ii), A1 = jn;
function Nr(e, n) {
  var t = {};
  return !e || typeof e != "string" || (0, b1.default)(e, function(r, i) {
    r && i && (t[(0, A1.camelCase)(r, n)] = i);
  }), t;
}
Nr.default = Nr;
var w1 = Nr;
const x1 = /* @__PURE__ */ Bn(w1), Uo = qo("end"), ai = qo("start");
function qo(e) {
  return n;
  function n(t) {
    const r = t && t.position && t.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function _1(e) {
  const n = ai(e), t = Uo(e);
  if (n && t)
    return { start: n, end: t };
}
function tn(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Li(e.position) : "start" in e || "end" in e ? Li(e) : "line" in e || "column" in e ? Ir(e) : "";
}
function Ir(e) {
  return Fi(e && e.line) + ":" + Fi(e && e.column);
}
function Li(e) {
  return Ir(e && e.start) + "-" + Ir(e && e.end);
}
function Fi(e) {
  return e && typeof e == "number" ? e : 1;
}
class Me extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, r) {
    super(), typeof t == "string" && (r = t, t = void 0);
    let i = "", a = {}, o = !1;
    if (t && ("line" in t && "column" in t ? a = { place: t } : "start" in t && "end" in t ? a = { place: t } : "type" in t ? a = {
      ancestors: [t],
      place: t.position
    } : a = { ...t }), typeof n == "string" ? i = n : !a.cause && n && (o = !0, i = n.message, a.cause = n), !a.ruleId && !a.source && typeof r == "string") {
      const s = r.indexOf(":");
      s === -1 ? a.ruleId = r : (a.source = r.slice(0, s), a.ruleId = r.slice(s + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const s = a.ancestors[a.ancestors.length - 1];
      s && (a.place = s.position);
    }
    const l = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = l ? l.line : void 0, this.name = tn(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = o && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Me.prototype.file = "";
Me.prototype.name = "";
Me.prototype.reason = "";
Me.prototype.message = "";
Me.prototype.stack = "";
Me.prototype.column = void 0;
Me.prototype.line = void 0;
Me.prototype.ancestors = void 0;
Me.prototype.cause = void 0;
Me.prototype.fatal = void 0;
Me.prototype.place = void 0;
Me.prototype.ruleId = void 0;
Me.prototype.source = void 0;
const oi = {}.hasOwnProperty, N1 = /* @__PURE__ */ new Map(), I1 = /[A-Z]/g, E1 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), S1 = /* @__PURE__ */ new Set(["td", "th"]), Zo = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function P1(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let r;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = D1(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = R1(t, n.jsx, n.jsxs);
  }
  const i = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: r,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? ri : Ks,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, a = Go(i, e, void 0);
  return a && typeof a != "string" ? a : i.create(
    e,
    i.Fragment,
    { children: a || void 0 },
    void 0
  );
}
function Go(e, n, t) {
  if (n.type === "element")
    return k1(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return O1(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return L1(e, n, t);
  if (n.type === "mdxjsEsm")
    return T1(e, n);
  if (n.type === "root")
    return F1(e, n, t);
  if (n.type === "text")
    return M1(e, n);
}
function k1(e, n, t) {
  const r = e.schema;
  let i = r;
  n.tagName.toLowerCase() === "svg" && r.space === "html" && (i = ri, e.schema = i), e.ancestors.push(n);
  const a = Ko(e, n.tagName, !1), o = B1(e, n);
  let l = si(e, n);
  return E1.has(n.tagName) && (l = l.filter(function(s) {
    return typeof s == "string" ? !js(s) : !0;
  })), Qo(e, o, a, n), li(o, l), e.ancestors.pop(), e.schema = r, e.create(n, a, o, t);
}
function O1(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const r = n.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  ln(e, n.position);
}
function T1(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  ln(e, n.position);
}
function L1(e, n, t) {
  const r = e.schema;
  let i = r;
  n.name === "svg" && r.space === "html" && (i = ri, e.schema = i), e.ancestors.push(n);
  const a = n.name === null ? e.Fragment : Ko(e, n.name, !0), o = j1(e, n), l = si(e, n);
  return Qo(e, o, a, n), li(o, l), e.ancestors.pop(), e.schema = r, e.create(n, a, o, t);
}
function F1(e, n, t) {
  const r = {};
  return li(r, si(e, n)), e.create(n, e.Fragment, r, t);
}
function M1(e, n) {
  return n.value;
}
function Qo(e, n, t, r) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = r);
}
function li(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function R1(e, n, t) {
  return r;
  function r(i, a, o, l) {
    const u = Array.isArray(o.children) ? t : n;
    return l ? u(a, o, l) : u(a, o);
  }
}
function D1(e, n) {
  return t;
  function t(r, i, a, o) {
    const l = Array.isArray(a.children), s = ai(r);
    return n(
      i,
      a,
      o,
      l,
      {
        columnNumber: s ? s.column - 1 : void 0,
        fileName: e,
        lineNumber: s ? s.line : void 0
      },
      void 0
    );
  }
}
function B1(e, n) {
  const t = {};
  let r, i;
  for (i in n.properties)
    if (i !== "children" && oi.call(n.properties, i)) {
      const a = H1(e, i, n.properties[i]);
      if (a) {
        const [o, l] = a;
        e.tableCellAlignToStyle && o === "align" && typeof l == "string" && S1.has(n.tagName) ? r = l : t[o] = l;
      }
    }
  if (r) {
    const a = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    a[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return t;
}
function j1(e, n) {
  const t = {};
  for (const r of n.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const a = r.data.estree.body[0];
        a.type;
        const o = a.expression;
        o.type;
        const l = o.properties[0];
        l.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        ln(e, n.position);
    else {
      const i = r.name;
      let a;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const l = r.value.data.estree.body[0];
          l.type, a = e.evaluater.evaluateExpression(l.expression);
        } else
          ln(e, n.position);
      else
        a = r.value === null ? !0 : r.value;
      t[i] = /** @type {Props[keyof Props]} */
      a;
    }
  return t;
}
function si(e, n) {
  const t = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : N1;
  for (; ++r < n.children.length; ) {
    const a = n.children[r];
    let o;
    if (e.passKeys) {
      const s = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
      if (s) {
        const u = i.get(s) || 0;
        o = s + "-" + u, i.set(s, u + 1);
      }
    }
    const l = Go(e, a, o);
    l !== void 0 && t.push(l);
  }
  return t;
}
function H1(e, n, t) {
  const r = Zs(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = r.commaSeparated ? Fs(t) : Ys(t)), r.property === "style") {
      let i = typeof t == "object" ? t : V1(e, String(t));
      return e.stylePropertyNameCase === "css" && (i = z1(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? Ws[r.property] || r.property : r.attribute,
      t
    ];
  }
}
function V1(e, n) {
  try {
    return x1(n, { reactCompat: !0 });
  } catch (t) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      t
    ), i = new Me("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = Zo + "#cannot-parse-style-attribute", i;
  }
}
function Ko(e, n, t) {
  let r;
  if (!t)
    r = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const i = n.split(".");
    let a = -1, o;
    for (; ++a < i.length; ) {
      const l = _i(i[a]) ? { type: "Identifier", name: i[a] } : { type: "Literal", value: i[a] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: l,
        computed: !!(a && l.type === "Literal"),
        optional: !1
      } : l;
    }
    r = o;
  } else
    r = _i(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return oi.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  ln(e);
}
function ln(e, n) {
  const t = new Me(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = Zo + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function z1(e) {
  const n = {};
  let t;
  for (t in e)
    oi.call(e, t) && (n[W1(t)] = e[t]);
  return n;
}
function W1(e) {
  let n = e.replace(I1, U1);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function U1(e) {
  return "-" + e.toLowerCase();
}
const Yn = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, q1 = {};
function Z1(e, n) {
  const t = q1, r = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, i = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return Yo(e, r, i);
}
function Yo(e, n, t) {
  if (G1(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Mi(e.children, n, t);
  }
  return Array.isArray(e) ? Mi(e, n, t) : "";
}
function Mi(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Yo(e[i], n, t);
  return r.join("");
}
function G1(e) {
  return !!(e && typeof e == "object");
}
const Ri = document.createElement("i");
function ui(e) {
  const n = "&" + e + ";";
  Ri.innerHTML = n;
  const t = Ri.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t
  );
}
function ut(e, n, t, r) {
  const i = e.length;
  let a = 0, o;
  if (n < 0 ? n = -n > i ? 0 : i + n : n = n > i ? i : n, t = t > 0 ? t : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(n, t), e.splice(...o);
  else
    for (t && e.splice(n, t); a < r.length; )
      o = r.slice(a, a + 1e4), o.unshift(n, 0), e.splice(...o), a += 1e4, n += 1e4;
}
function Xe(e, n) {
  return e.length > 0 ? (ut(e, e.length, 0, n), e) : n;
}
const Di = {}.hasOwnProperty;
function Q1(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    K1(n, e[t]);
  return n;
}
function K1(e, n) {
  let t;
  for (t in n) {
    const i = (Di.call(e, t) ? e[t] : void 0) || (e[t] = {}), a = n[t];
    let o;
    if (a)
      for (o in a) {
        Di.call(i, o) || (i[o] = []);
        const l = a[o];
        Y1(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function Y1(e, n) {
  let t = -1;
  const r = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : r).push(n[t]);
  ut(e, 0, 0, r);
}
function Xo(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function Dt(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const st = bt(/[A-Za-z]/), Ge = bt(/[\dA-Za-z]/), X1 = bt(/[#-'*+\--9=?A-Z^-~]/);
function Er(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Sr = bt(/\d/), J1 = bt(/[\dA-Fa-f]/), eu = bt(/[!-/:-@[-`{-~]/);
function re(e) {
  return e !== null && e < -2;
}
function Ve(e) {
  return e !== null && (e < 0 || e === 32);
}
function pe(e) {
  return e === -2 || e === -1 || e === 32;
}
const tu = bt(new RegExp("\\p{P}|\\p{S}", "u")), nu = bt(/\s/);
function bt(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function Ut(e) {
  const n = [];
  let t = -1, r = 0, i = 0;
  for (; ++t < e.length; ) {
    const a = e.charCodeAt(t);
    let o = "";
    if (a === 37 && Ge(e.charCodeAt(t + 1)) && Ge(e.charCodeAt(t + 2)))
      i = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const l = e.charCodeAt(t + 1);
      a < 56320 && l > 56319 && l < 57344 ? (o = String.fromCharCode(a, l), i = 1) : o = "�";
    } else
      o = String.fromCharCode(a);
    o && (n.push(e.slice(r, t), encodeURIComponent(o)), r = t + i + 1, o = ""), i && (t += i, i = 0);
  }
  return n.join("") + e.slice(r);
}
function Ae(e, n, t, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return o;
  function o(s) {
    return pe(s) ? (e.enter(t), l(s)) : n(s);
  }
  function l(s) {
    return pe(s) && a++ < i ? (e.consume(s), l) : (e.exit(t), n(s));
  }
}
const ru = {
  tokenize: iu
};
function iu(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, r, i);
  let t;
  return n;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Ae(e, n, "linePrefix");
  }
  function i(l) {
    return e.enter("paragraph"), a(l);
  }
  function a(l) {
    const s = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = s), t = s, o(l);
  }
  function o(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return re(l) ? (e.consume(l), e.exit("chunkText"), a) : (e.consume(l), o);
  }
}
const au = {
  tokenize: ou
}, Bi = {
  tokenize: lu
};
function ou(e) {
  const n = this, t = [];
  let r = 0, i, a, o;
  return l;
  function l(A) {
    if (r < t.length) {
      const I = t[r];
      return n.containerState = I[1], e.attempt(I[0].continuation, s, u)(A);
    }
    return u(A);
  }
  function s(A) {
    if (r++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, i && x();
      const I = n.events.length;
      let b = I, w;
      for (; b--; )
        if (n.events[b][0] === "exit" && n.events[b][1].type === "chunkFlow") {
          w = n.events[b][1].end;
          break;
        }
      m(r);
      let S = I;
      for (; S < n.events.length; )
        n.events[S][1].end = {
          ...w
        }, S++;
      return ut(n.events, b + 1, 0, n.events.slice(I)), n.events.length = S, u(A);
    }
    return l(A);
  }
  function u(A) {
    if (r === t.length) {
      if (!i)
        return p(A);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return y(A);
      n.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Bi, c, d)(A);
  }
  function c(A) {
    return i && x(), m(r), p(A);
  }
  function d(A) {
    return n.parser.lazy[n.now().line] = r !== t.length, o = n.now().offset, y(A);
  }
  function p(A) {
    return n.containerState = {}, e.attempt(Bi, h, y)(A);
  }
  function h(A) {
    return r++, t.push([n.currentConstruct, n.containerState]), p(A);
  }
  function y(A) {
    if (A === null) {
      i && x(), m(0), e.consume(A);
      return;
    }
    return i = i || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: a
    }), C(A);
  }
  function C(A) {
    if (A === null) {
      $(e.exit("chunkFlow"), !0), m(0), e.consume(A);
      return;
    }
    return re(A) ? (e.consume(A), $(e.exit("chunkFlow")), r = 0, n.interrupt = void 0, l) : (e.consume(A), C);
  }
  function $(A, I) {
    const b = n.sliceStream(A);
    if (I && b.push(null), A.previous = a, a && (a.next = A), a = A, i.defineSkip(A.start), i.write(b), n.parser.lazy[A.start.line]) {
      let w = i.events.length;
      for (; w--; )
        if (
          // The token starts before the line ending…
          i.events[w][1].start.offset < o && // …and either is not ended yet…
          (!i.events[w][1].end || // …or ends after it.
          i.events[w][1].end.offset > o)
        )
          return;
      const S = n.events.length;
      let O = S, N, R;
      for (; O--; )
        if (n.events[O][0] === "exit" && n.events[O][1].type === "chunkFlow") {
          if (N) {
            R = n.events[O][1].end;
            break;
          }
          N = !0;
        }
      for (m(r), w = S; w < n.events.length; )
        n.events[w][1].end = {
          ...R
        }, w++;
      ut(n.events, O + 1, 0, n.events.slice(S)), n.events.length = w;
    }
  }
  function m(A) {
    let I = t.length;
    for (; I-- > A; ) {
      const b = t[I];
      n.containerState = b[1], b[0].exit.call(n, e);
    }
    t.length = A;
  }
  function x() {
    i.write([null]), a = void 0, i = void 0, n.containerState._closeFlow = void 0;
  }
}
function lu(e, n, t) {
  return Ae(e, e.attempt(this.parser.constructs.document, n, t), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function ji(e) {
  if (e === null || Ve(e) || nu(e))
    return 1;
  if (tu(e))
    return 2;
}
function ci(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (n = a(n, t), r.push(a));
  }
  return n;
}
const Pr = {
  name: "attention",
  resolveAll: su,
  tokenize: uu
};
function su(e, n) {
  let t = -1, r, i, a, o, l, s, u, c;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (r = t; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        n.sliceSerialize(e[r][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          s = e[r][1].end.offset - e[r][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const d = {
            ...e[r][1].end
          }, p = {
            ...e[t][1].start
          };
          Hi(d, -s), Hi(p, s), o = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: {
              ...e[r][1].end
            }
          }, l = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[t][1].start
            },
            end: p
          }, a = {
            type: s > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[t][1].start
            }
          }, i = {
            type: s > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...l.end
            }
          }, e[r][1].end = {
            ...o.start
          }, e[t][1].start = {
            ...l.end
          }, u = [], e[r][1].end.offset - e[r][1].start.offset && (u = Xe(u, [["enter", e[r][1], n], ["exit", e[r][1], n]])), u = Xe(u, [["enter", i, n], ["enter", o, n], ["exit", o, n], ["enter", a, n]]), u = Xe(u, ci(n.parser.constructs.insideSpan.null, e.slice(r + 1, t), n)), u = Xe(u, [["exit", a, n], ["enter", l, n], ["exit", l, n], ["exit", i, n]]), e[t][1].end.offset - e[t][1].start.offset ? (c = 2, u = Xe(u, [["enter", e[t][1], n], ["exit", e[t][1], n]])) : c = 0, ut(e, r - 1, t - r + 3, u), t = r + u.length - c - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function uu(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, r = this.previous, i = ji(r);
  let a;
  return o;
  function o(s) {
    return a = s, e.enter("attentionSequence"), l(s);
  }
  function l(s) {
    if (s === a)
      return e.consume(s), l;
    const u = e.exit("attentionSequence"), c = ji(s), d = !c || c === 2 && i || t.includes(s), p = !i || i === 2 && c || t.includes(r);
    return u._open = !!(a === 42 ? d : d && (i || !p)), u._close = !!(a === 42 ? p : p && (c || !d)), n(s);
  }
}
function Hi(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const cu = {
  name: "autolink",
  tokenize: du
};
function du(e, n, t) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(h) {
    return st(h) ? (e.consume(h), o) : h === 64 ? t(h) : u(h);
  }
  function o(h) {
    return h === 43 || h === 45 || h === 46 || Ge(h) ? (r = 1, l(h)) : u(h);
  }
  function l(h) {
    return h === 58 ? (e.consume(h), r = 0, s) : (h === 43 || h === 45 || h === 46 || Ge(h)) && r++ < 32 ? (e.consume(h), l) : (r = 0, u(h));
  }
  function s(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), n) : h === null || h === 32 || h === 60 || Er(h) ? t(h) : (e.consume(h), s);
  }
  function u(h) {
    return h === 64 ? (e.consume(h), c) : X1(h) ? (e.consume(h), u) : t(h);
  }
  function c(h) {
    return Ge(h) ? d(h) : t(h);
  }
  function d(h) {
    return h === 46 ? (e.consume(h), r = 0, c) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), n) : p(h);
  }
  function p(h) {
    if ((h === 45 || Ge(h)) && r++ < 63) {
      const y = h === 45 ? p : d;
      return e.consume(h), y;
    }
    return t(h);
  }
}
const Hn = {
  partial: !0,
  tokenize: fu
};
function fu(e, n, t) {
  return r;
  function r(a) {
    return pe(a) ? Ae(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || re(a) ? n(a) : t(a);
  }
}
const Jo = {
  continuation: {
    tokenize: pu
  },
  exit: mu,
  name: "blockQuote",
  tokenize: hu
};
function hu(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const l = r.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), a;
    }
    return t(o);
  }
  function a(o) {
    return pe(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(o));
  }
}
function pu(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return pe(o) ? Ae(e, a, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : a(o);
  }
  function a(o) {
    return e.attempt(Jo, n, t)(o);
  }
}
function mu(e) {
  e.exit("blockQuote");
}
const el = {
  name: "characterEscape",
  tokenize: gu
};
function gu(e, n, t) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return eu(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(a);
  }
}
const tl = {
  name: "characterReference",
  tokenize: yu
};
function yu(e, n, t) {
  const r = this;
  let i = 0, a, o;
  return l;
  function l(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), s;
  }
  function s(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), a = 31, o = Ge, c(d));
  }
  function u(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = J1, c) : (e.enter("characterReferenceValue"), a = 7, o = Sr, c(d));
  }
  function c(d) {
    if (d === 59 && i) {
      const p = e.exit("characterReferenceValue");
      return o === Ge && !ui(r.sliceSerialize(p)) ? t(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return o(d) && i++ < a ? (e.consume(d), c) : t(d);
  }
}
const Vi = {
  partial: !0,
  tokenize: vu
}, zi = {
  concrete: !0,
  name: "codeFenced",
  tokenize: $u
};
function $u(e, n, t) {
  const r = this, i = {
    partial: !0,
    tokenize: b
  };
  let a = 0, o = 0, l;
  return s;
  function s(w) {
    return u(w);
  }
  function u(w) {
    const S = r.events[r.events.length - 1];
    return a = S && S[1].type === "linePrefix" ? S[2].sliceSerialize(S[1], !0).length : 0, l = w, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), c(w);
  }
  function c(w) {
    return w === l ? (o++, e.consume(w), c) : o < 3 ? t(w) : (e.exit("codeFencedFenceSequence"), pe(w) ? Ae(e, d, "whitespace")(w) : d(w));
  }
  function d(w) {
    return w === null || re(w) ? (e.exit("codeFencedFence"), r.interrupt ? n(w) : e.check(Vi, C, I)(w)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), p(w));
  }
  function p(w) {
    return w === null || re(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(w)) : pe(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Ae(e, h, "whitespace")(w)) : w === 96 && w === l ? t(w) : (e.consume(w), p);
  }
  function h(w) {
    return w === null || re(w) ? d(w) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), y(w));
  }
  function y(w) {
    return w === null || re(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(w)) : w === 96 && w === l ? t(w) : (e.consume(w), y);
  }
  function C(w) {
    return e.attempt(i, I, $)(w);
  }
  function $(w) {
    return e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), m;
  }
  function m(w) {
    return a > 0 && pe(w) ? Ae(e, x, "linePrefix", a + 1)(w) : x(w);
  }
  function x(w) {
    return w === null || re(w) ? e.check(Vi, C, I)(w) : (e.enter("codeFlowValue"), A(w));
  }
  function A(w) {
    return w === null || re(w) ? (e.exit("codeFlowValue"), x(w)) : (e.consume(w), A);
  }
  function I(w) {
    return e.exit("codeFenced"), n(w);
  }
  function b(w, S, O) {
    let N = 0;
    return R;
    function R(D) {
      return w.enter("lineEnding"), w.consume(D), w.exit("lineEnding"), T;
    }
    function T(D) {
      return w.enter("codeFencedFence"), pe(D) ? Ae(w, E, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : E(D);
    }
    function E(D) {
      return D === l ? (w.enter("codeFencedFenceSequence"), L(D)) : O(D);
    }
    function L(D) {
      return D === l ? (N++, w.consume(D), L) : N >= o ? (w.exit("codeFencedFenceSequence"), pe(D) ? Ae(w, W, "whitespace")(D) : W(D)) : O(D);
    }
    function W(D) {
      return D === null || re(D) ? (w.exit("codeFencedFence"), S(D)) : O(D);
    }
  }
}
function vu(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? t(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
const Xn = {
  name: "codeIndented",
  tokenize: bu
}, Cu = {
  partial: !0,
  tokenize: Au
};
function bu(e, n, t) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), Ae(e, a, "linePrefix", 5)(u);
  }
  function a(u) {
    const c = r.events[r.events.length - 1];
    return c && c[1].type === "linePrefix" && c[2].sliceSerialize(c[1], !0).length >= 4 ? o(u) : t(u);
  }
  function o(u) {
    return u === null ? s(u) : re(u) ? e.attempt(Cu, o, s)(u) : (e.enter("codeFlowValue"), l(u));
  }
  function l(u) {
    return u === null || re(u) ? (e.exit("codeFlowValue"), o(u)) : (e.consume(u), l);
  }
  function s(u) {
    return e.exit("codeIndented"), n(u);
  }
}
function Au(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? t(o) : re(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : Ae(e, a, "linePrefix", 5)(o);
  }
  function a(o) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(o) : re(o) ? i(o) : t(o);
  }
}
const wu = {
  name: "codeText",
  previous: _u,
  resolve: xu,
  tokenize: Nu
};
function xu(e) {
  let n = e.length - 4, t = 3, r, i;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (r = t; ++r < n; )
      if (e[r][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (r = t - 1, n++; ++r <= n; )
    i === void 0 ? r !== n && e[r][1].type !== "lineEnding" && (i = r) : (r === n || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), n -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function _u(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Nu(e, n, t) {
  let r = 0, i, a;
  return o;
  function o(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(d);
  }
  function l(d) {
    return d === 96 ? (e.consume(d), r++, l) : (e.exit("codeTextSequence"), s(d));
  }
  function s(d) {
    return d === null ? t(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), s) : d === 96 ? (a = e.enter("codeTextSequence"), i = 0, c(d)) : re(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), s) : (e.enter("codeTextData"), u(d));
  }
  function u(d) {
    return d === null || d === 32 || d === 96 || re(d) ? (e.exit("codeTextData"), s(d)) : (e.consume(d), u);
  }
  function c(d) {
    return d === 96 ? (e.consume(d), i++, c) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), n(d)) : (a.type = "codeTextData", u(d));
  }
}
class Iu {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, t) {
    const r = t ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(n, r) : n > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, t, r) {
    const i = t || 0;
    this.setCursor(Math.trunc(n));
    const a = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && Qt(this.left, r), a.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Qt(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Qt(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const t = this.left.splice(n, Number.POSITIVE_INFINITY);
        Qt(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Qt(this.left, t.reverse());
      }
  }
}
function Qt(e, n) {
  let t = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; t < n.length; )
      e.push(...n.slice(t, t + 1e4)), t += 1e4;
}
function nl(e) {
  const n = {};
  let t = -1, r, i, a, o, l, s, u;
  const c = new Iu(e);
  for (; ++t < c.length; ) {
    for (; t in n; )
      t = n[t];
    if (r = c.get(t), t && r[1].type === "chunkFlow" && c.get(t - 1)[1].type === "listItemPrefix" && (s = r[1]._tokenizer.events, a = 0, a < s.length && s[a][1].type === "lineEndingBlank" && (a += 2), a < s.length && s[a][1].type === "content"))
      for (; ++a < s.length && s[a][1].type !== "content"; )
        s[a][1].type === "chunkText" && (s[a][1]._isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(n, Eu(c, t)), t = n[t], u = !0);
    else if (r[1]._container) {
      for (a = t, i = void 0; a--; )
        if (o = c.get(a), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (i && (c.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = a);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...c.get(i)[1].start
      }, l = c.slice(i, t), l.unshift(r), c.splice(i, t - i + 1, l));
    }
  }
  return ut(e, 0, Number.POSITIVE_INFINITY, c.slice(0)), !u;
}
function Eu(e, n) {
  const t = e.get(n)[1], r = e.get(n)[2];
  let i = n - 1;
  const a = [];
  let o = t._tokenizer;
  o || (o = r.parser[t.contentType](t.start), t._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const l = o.events, s = [], u = {};
  let c, d, p = -1, h = t, y = 0, C = 0;
  const $ = [C];
  for (; h; ) {
    for (; e.get(++i)[1] !== h; )
      ;
    a.push(i), h._tokenizer || (c = r.sliceStream(h), h.next || c.push(null), d && o.defineSkip(h.start), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(c), h._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), d = h, h = h.next;
  }
  for (h = t; ++p < l.length; )
    // Find a void token that includes a break.
    l[p][0] === "exit" && l[p - 1][0] === "enter" && l[p][1].type === l[p - 1][1].type && l[p][1].start.line !== l[p][1].end.line && (C = p + 1, $.push(C), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (o.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : $.pop(), p = $.length; p--; ) {
    const m = l.slice($[p], $[p + 1]), x = a.pop();
    s.push([x, x + m.length - 1]), e.splice(x, 2, m);
  }
  for (s.reverse(), p = -1; ++p < s.length; )
    u[y + s[p][0]] = y + s[p][1], y += s[p][1] - s[p][0] - 1;
  return u;
}
const Su = {
  resolve: ku,
  tokenize: Ou
}, Pu = {
  partial: !0,
  tokenize: Tu
};
function ku(e) {
  return nl(e), e;
}
function Ou(e, n) {
  let t;
  return r;
  function r(l) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), i(l);
  }
  function i(l) {
    return l === null ? a(l) : re(l) ? e.check(Pu, o, a)(l) : (e.consume(l), i);
  }
  function a(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function o(l) {
    return e.consume(l), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, i;
  }
}
function Tu(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), Ae(e, a, "linePrefix");
  }
  function a(o) {
    if (o === null || re(o))
      return t(o);
    const l = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(o) : e.interrupt(r.parser.constructs.flow, t, n)(o);
  }
}
function rl(e, n, t, r, i, a, o, l, s) {
  const u = s || Number.POSITIVE_INFINITY;
  let c = 0;
  return d;
  function d(m) {
    return m === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(m), e.exit(a), p) : m === null || m === 32 || m === 41 || Er(m) ? t(m) : (e.enter(r), e.enter(o), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), C(m));
  }
  function p(m) {
    return m === 62 ? (e.enter(a), e.consume(m), e.exit(a), e.exit(i), e.exit(r), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), h(m));
  }
  function h(m) {
    return m === 62 ? (e.exit("chunkString"), e.exit(l), p(m)) : m === null || m === 60 || re(m) ? t(m) : (e.consume(m), m === 92 ? y : h);
  }
  function y(m) {
    return m === 60 || m === 62 || m === 92 ? (e.consume(m), h) : h(m);
  }
  function C(m) {
    return !c && (m === null || m === 41 || Ve(m)) ? (e.exit("chunkString"), e.exit(l), e.exit(o), e.exit(r), n(m)) : c < u && m === 40 ? (e.consume(m), c++, C) : m === 41 ? (e.consume(m), c--, C) : m === null || m === 32 || m === 40 || Er(m) ? t(m) : (e.consume(m), m === 92 ? $ : C);
  }
  function $(m) {
    return m === 40 || m === 41 || m === 92 ? (e.consume(m), C) : C(m);
  }
}
function il(e, n, t, r, i, a) {
  const o = this;
  let l = 0, s;
  return u;
  function u(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(a), c;
  }
  function c(h) {
    return l > 999 || h === null || h === 91 || h === 93 && !s || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !l && "_hiddenFootnoteSupport" in o.parser.constructs ? t(h) : h === 93 ? (e.exit(a), e.enter(i), e.consume(h), e.exit(i), e.exit(r), n) : re(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), c) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === null || h === 91 || h === 93 || re(h) || l++ > 999 ? (e.exit("chunkString"), c(h)) : (e.consume(h), s || (s = !pe(h)), h === 92 ? p : d);
  }
  function p(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), l++, d) : d(h);
  }
}
function al(e, n, t, r, i, a) {
  let o;
  return l;
  function l(p) {
    return p === 34 || p === 39 || p === 40 ? (e.enter(r), e.enter(i), e.consume(p), e.exit(i), o = p === 40 ? 41 : p, s) : t(p);
  }
  function s(p) {
    return p === o ? (e.enter(i), e.consume(p), e.exit(i), e.exit(r), n) : (e.enter(a), u(p));
  }
  function u(p) {
    return p === o ? (e.exit(a), s(o)) : p === null ? t(p) : re(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), Ae(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), c(p));
  }
  function c(p) {
    return p === o || p === null || re(p) ? (e.exit("chunkString"), u(p)) : (e.consume(p), p === 92 ? d : c);
  }
  function d(p) {
    return p === o || p === 92 ? (e.consume(p), c) : c(p);
  }
}
function nn(e, n) {
  let t;
  return r;
  function r(i) {
    return re(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t = !0, r) : pe(i) ? Ae(e, r, t ? "linePrefix" : "lineSuffix")(i) : n(i);
  }
}
const Lu = {
  name: "definition",
  tokenize: Mu
}, Fu = {
  partial: !0,
  tokenize: Ru
};
function Mu(e, n, t) {
  const r = this;
  let i;
  return a;
  function a(h) {
    return e.enter("definition"), o(h);
  }
  function o(h) {
    return il.call(
      r,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function l(h) {
    return i = Dt(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), s) : t(h);
  }
  function s(h) {
    return Ve(h) ? nn(e, u)(h) : u(h);
  }
  function u(h) {
    return rl(
      e,
      c,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function c(h) {
    return e.attempt(Fu, d, d)(h);
  }
  function d(h) {
    return pe(h) ? Ae(e, p, "whitespace")(h) : p(h);
  }
  function p(h) {
    return h === null || re(h) ? (e.exit("definition"), r.parser.defined.push(i), n(h)) : t(h);
  }
}
function Ru(e, n, t) {
  return r;
  function r(l) {
    return Ve(l) ? nn(e, i)(l) : t(l);
  }
  function i(l) {
    return al(e, a, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function a(l) {
    return pe(l) ? Ae(e, o, "whitespace")(l) : o(l);
  }
  function o(l) {
    return l === null || re(l) ? n(l) : t(l);
  }
}
const Du = {
  name: "hardBreakEscape",
  tokenize: Bu
};
function Bu(e, n, t) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.consume(a), i;
  }
  function i(a) {
    return re(a) ? (e.exit("hardBreakEscape"), n(a)) : t(a);
  }
}
const ju = {
  name: "headingAtx",
  resolve: Hu,
  tokenize: Vu
};
function Hu(e, n) {
  let t = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), t - 2 > r && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (r === t - 1 || t - 4 > r && e[t - 2][1].type === "whitespace") && (t -= r + 1 === t ? 2 : 4), t > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[t][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, ut(e, r, t - r + 1, [["enter", i, n], ["enter", a, n], ["exit", a, n], ["exit", i, n]])), e;
}
function Vu(e, n, t) {
  let r = 0;
  return i;
  function i(c) {
    return e.enter("atxHeading"), a(c);
  }
  function a(c) {
    return e.enter("atxHeadingSequence"), o(c);
  }
  function o(c) {
    return c === 35 && r++ < 6 ? (e.consume(c), o) : c === null || Ve(c) ? (e.exit("atxHeadingSequence"), l(c)) : t(c);
  }
  function l(c) {
    return c === 35 ? (e.enter("atxHeadingSequence"), s(c)) : c === null || re(c) ? (e.exit("atxHeading"), n(c)) : pe(c) ? Ae(e, l, "whitespace")(c) : (e.enter("atxHeadingText"), u(c));
  }
  function s(c) {
    return c === 35 ? (e.consume(c), s) : (e.exit("atxHeadingSequence"), l(c));
  }
  function u(c) {
    return c === null || c === 35 || Ve(c) ? (e.exit("atxHeadingText"), l(c)) : (e.consume(c), u);
  }
}
const zu = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Wi = ["pre", "script", "style", "textarea"], Wu = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: Zu,
  tokenize: Gu
}, Uu = {
  partial: !0,
  tokenize: Ku
}, qu = {
  partial: !0,
  tokenize: Qu
};
function Zu(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function Gu(e, n, t) {
  const r = this;
  let i, a, o, l, s;
  return u;
  function u(v) {
    return c(v);
  }
  function c(v) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(v), d;
  }
  function d(v) {
    return v === 33 ? (e.consume(v), p) : v === 47 ? (e.consume(v), a = !0, C) : v === 63 ? (e.consume(v), i = 3, r.interrupt ? n : g) : st(v) ? (e.consume(v), o = String.fromCharCode(v), $) : t(v);
  }
  function p(v) {
    return v === 45 ? (e.consume(v), i = 2, h) : v === 91 ? (e.consume(v), i = 5, l = 0, y) : st(v) ? (e.consume(v), i = 4, r.interrupt ? n : g) : t(v);
  }
  function h(v) {
    return v === 45 ? (e.consume(v), r.interrupt ? n : g) : t(v);
  }
  function y(v) {
    const X = "CDATA[";
    return v === X.charCodeAt(l++) ? (e.consume(v), l === X.length ? r.interrupt ? n : E : y) : t(v);
  }
  function C(v) {
    return st(v) ? (e.consume(v), o = String.fromCharCode(v), $) : t(v);
  }
  function $(v) {
    if (v === null || v === 47 || v === 62 || Ve(v)) {
      const X = v === 47, ie = o.toLowerCase();
      return !X && !a && Wi.includes(ie) ? (i = 1, r.interrupt ? n(v) : E(v)) : zu.includes(o.toLowerCase()) ? (i = 6, X ? (e.consume(v), m) : r.interrupt ? n(v) : E(v)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? t(v) : a ? x(v) : A(v));
    }
    return v === 45 || Ge(v) ? (e.consume(v), o += String.fromCharCode(v), $) : t(v);
  }
  function m(v) {
    return v === 62 ? (e.consume(v), r.interrupt ? n : E) : t(v);
  }
  function x(v) {
    return pe(v) ? (e.consume(v), x) : R(v);
  }
  function A(v) {
    return v === 47 ? (e.consume(v), R) : v === 58 || v === 95 || st(v) ? (e.consume(v), I) : pe(v) ? (e.consume(v), A) : R(v);
  }
  function I(v) {
    return v === 45 || v === 46 || v === 58 || v === 95 || Ge(v) ? (e.consume(v), I) : b(v);
  }
  function b(v) {
    return v === 61 ? (e.consume(v), w) : pe(v) ? (e.consume(v), b) : A(v);
  }
  function w(v) {
    return v === null || v === 60 || v === 61 || v === 62 || v === 96 ? t(v) : v === 34 || v === 39 ? (e.consume(v), s = v, S) : pe(v) ? (e.consume(v), w) : O(v);
  }
  function S(v) {
    return v === s ? (e.consume(v), s = null, N) : v === null || re(v) ? t(v) : (e.consume(v), S);
  }
  function O(v) {
    return v === null || v === 34 || v === 39 || v === 47 || v === 60 || v === 61 || v === 62 || v === 96 || Ve(v) ? b(v) : (e.consume(v), O);
  }
  function N(v) {
    return v === 47 || v === 62 || pe(v) ? A(v) : t(v);
  }
  function R(v) {
    return v === 62 ? (e.consume(v), T) : t(v);
  }
  function T(v) {
    return v === null || re(v) ? E(v) : pe(v) ? (e.consume(v), T) : t(v);
  }
  function E(v) {
    return v === 45 && i === 2 ? (e.consume(v), H) : v === 60 && i === 1 ? (e.consume(v), ee) : v === 62 && i === 4 ? (e.consume(v), z) : v === 63 && i === 3 ? (e.consume(v), g) : v === 93 && i === 5 ? (e.consume(v), ae) : re(v) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(Uu, J, L)(v)) : v === null || re(v) ? (e.exit("htmlFlowData"), L(v)) : (e.consume(v), E);
  }
  function L(v) {
    return e.check(qu, W, J)(v);
  }
  function W(v) {
    return e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), D;
  }
  function D(v) {
    return v === null || re(v) ? L(v) : (e.enter("htmlFlowData"), E(v));
  }
  function H(v) {
    return v === 45 ? (e.consume(v), g) : E(v);
  }
  function ee(v) {
    return v === 47 ? (e.consume(v), o = "", V) : E(v);
  }
  function V(v) {
    if (v === 62) {
      const X = o.toLowerCase();
      return Wi.includes(X) ? (e.consume(v), z) : E(v);
    }
    return st(v) && o.length < 8 ? (e.consume(v), o += String.fromCharCode(v), V) : E(v);
  }
  function ae(v) {
    return v === 93 ? (e.consume(v), g) : E(v);
  }
  function g(v) {
    return v === 62 ? (e.consume(v), z) : v === 45 && i === 2 ? (e.consume(v), g) : E(v);
  }
  function z(v) {
    return v === null || re(v) ? (e.exit("htmlFlowData"), J(v)) : (e.consume(v), z);
  }
  function J(v) {
    return e.exit("htmlFlow"), n(v);
  }
}
function Qu(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return re(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : t(o);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
function Ku(e, n, t) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Hn, n, t);
  }
}
const Yu = {
  name: "htmlText",
  tokenize: Xu
};
function Xu(e, n, t) {
  const r = this;
  let i, a, o;
  return l;
  function l(g) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(g), s;
  }
  function s(g) {
    return g === 33 ? (e.consume(g), u) : g === 47 ? (e.consume(g), b) : g === 63 ? (e.consume(g), A) : st(g) ? (e.consume(g), O) : t(g);
  }
  function u(g) {
    return g === 45 ? (e.consume(g), c) : g === 91 ? (e.consume(g), a = 0, y) : st(g) ? (e.consume(g), x) : t(g);
  }
  function c(g) {
    return g === 45 ? (e.consume(g), h) : t(g);
  }
  function d(g) {
    return g === null ? t(g) : g === 45 ? (e.consume(g), p) : re(g) ? (o = d, ee(g)) : (e.consume(g), d);
  }
  function p(g) {
    return g === 45 ? (e.consume(g), h) : d(g);
  }
  function h(g) {
    return g === 62 ? H(g) : g === 45 ? p(g) : d(g);
  }
  function y(g) {
    const z = "CDATA[";
    return g === z.charCodeAt(a++) ? (e.consume(g), a === z.length ? C : y) : t(g);
  }
  function C(g) {
    return g === null ? t(g) : g === 93 ? (e.consume(g), $) : re(g) ? (o = C, ee(g)) : (e.consume(g), C);
  }
  function $(g) {
    return g === 93 ? (e.consume(g), m) : C(g);
  }
  function m(g) {
    return g === 62 ? H(g) : g === 93 ? (e.consume(g), m) : C(g);
  }
  function x(g) {
    return g === null || g === 62 ? H(g) : re(g) ? (o = x, ee(g)) : (e.consume(g), x);
  }
  function A(g) {
    return g === null ? t(g) : g === 63 ? (e.consume(g), I) : re(g) ? (o = A, ee(g)) : (e.consume(g), A);
  }
  function I(g) {
    return g === 62 ? H(g) : A(g);
  }
  function b(g) {
    return st(g) ? (e.consume(g), w) : t(g);
  }
  function w(g) {
    return g === 45 || Ge(g) ? (e.consume(g), w) : S(g);
  }
  function S(g) {
    return re(g) ? (o = S, ee(g)) : pe(g) ? (e.consume(g), S) : H(g);
  }
  function O(g) {
    return g === 45 || Ge(g) ? (e.consume(g), O) : g === 47 || g === 62 || Ve(g) ? N(g) : t(g);
  }
  function N(g) {
    return g === 47 ? (e.consume(g), H) : g === 58 || g === 95 || st(g) ? (e.consume(g), R) : re(g) ? (o = N, ee(g)) : pe(g) ? (e.consume(g), N) : H(g);
  }
  function R(g) {
    return g === 45 || g === 46 || g === 58 || g === 95 || Ge(g) ? (e.consume(g), R) : T(g);
  }
  function T(g) {
    return g === 61 ? (e.consume(g), E) : re(g) ? (o = T, ee(g)) : pe(g) ? (e.consume(g), T) : N(g);
  }
  function E(g) {
    return g === null || g === 60 || g === 61 || g === 62 || g === 96 ? t(g) : g === 34 || g === 39 ? (e.consume(g), i = g, L) : re(g) ? (o = E, ee(g)) : pe(g) ? (e.consume(g), E) : (e.consume(g), W);
  }
  function L(g) {
    return g === i ? (e.consume(g), i = void 0, D) : g === null ? t(g) : re(g) ? (o = L, ee(g)) : (e.consume(g), L);
  }
  function W(g) {
    return g === null || g === 34 || g === 39 || g === 60 || g === 61 || g === 96 ? t(g) : g === 47 || g === 62 || Ve(g) ? N(g) : (e.consume(g), W);
  }
  function D(g) {
    return g === 47 || g === 62 || Ve(g) ? N(g) : t(g);
  }
  function H(g) {
    return g === 62 ? (e.consume(g), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(g);
  }
  function ee(g) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), V;
  }
  function V(g) {
    return pe(g) ? Ae(e, ae, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(g) : ae(g);
  }
  function ae(g) {
    return e.enter("htmlTextData"), o(g);
  }
}
const di = {
  name: "labelEnd",
  resolveAll: nc,
  resolveTo: rc,
  tokenize: ic
}, Ju = {
  tokenize: ac
}, ec = {
  tokenize: oc
}, tc = {
  tokenize: lc
};
function nc(e) {
  let n = -1;
  const t = [];
  for (; ++n < e.length; ) {
    const r = e[n][1];
    if (t.push(e[n]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", n += i;
    }
  }
  return e.length !== t.length && ut(e, 0, e.length, t), e;
}
function rc(e, n) {
  let t = e.length, r = 0, i, a, o, l;
  for (; t--; )
    if (i = e[t][1], a) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[t][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[t][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = t, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = t);
  const s = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, u = {
    type: "label",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, c = {
    type: "labelText",
    start: {
      ...e[a + r + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return l = [["enter", s, n], ["enter", u, n]], l = Xe(l, e.slice(a + 1, a + r + 3)), l = Xe(l, [["enter", c, n]]), l = Xe(l, ci(n.parser.constructs.insideSpan.null, e.slice(a + r + 4, o - 3), n)), l = Xe(l, [["exit", c, n], e[o - 2], e[o - 1], ["exit", u, n]]), l = Xe(l, e.slice(o + 1)), l = Xe(l, [["exit", s, n]]), ut(e, a, e.length, l), e;
}
function ic(e, n, t) {
  const r = this;
  let i = r.events.length, a, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return l;
  function l(p) {
    return a ? a._inactive ? d(p) : (o = r.parser.defined.includes(Dt(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(p), e.exit("labelMarker"), e.exit("labelEnd"), s) : t(p);
  }
  function s(p) {
    return p === 40 ? e.attempt(Ju, c, o ? c : d)(p) : p === 91 ? e.attempt(ec, c, o ? u : d)(p) : o ? c(p) : d(p);
  }
  function u(p) {
    return e.attempt(tc, c, d)(p);
  }
  function c(p) {
    return n(p);
  }
  function d(p) {
    return a._balanced = !0, t(p);
  }
}
function ac(e, n, t) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return Ve(d) ? nn(e, a)(d) : a(d);
  }
  function a(d) {
    return d === 41 ? c(d) : rl(e, o, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function o(d) {
    return Ve(d) ? nn(e, s)(d) : c(d);
  }
  function l(d) {
    return t(d);
  }
  function s(d) {
    return d === 34 || d === 39 || d === 40 ? al(e, u, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : c(d);
  }
  function u(d) {
    return Ve(d) ? nn(e, c)(d) : c(d);
  }
  function c(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), n) : t(d);
  }
}
function oc(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    return il.call(r, e, a, o, "reference", "referenceMarker", "referenceString")(l);
  }
  function a(l) {
    return r.parser.defined.includes(Dt(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? n(l) : t(l);
  }
  function o(l) {
    return t(l);
  }
}
function lc(e, n, t) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), n) : t(a);
  }
}
const sc = {
  name: "labelStartImage",
  resolveAll: di.resolveAll,
  tokenize: uc
};
function uc(e, n, t) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), a;
  }
  function a(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), o) : t(l);
  }
  function o(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(l) : n(l);
  }
}
const cc = {
  name: "labelStartLink",
  resolveAll: di.resolveAll,
  tokenize: dc
};
function dc(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(o) : n(o);
  }
}
const Jn = {
  name: "lineEnding",
  tokenize: fc
};
function fc(e, n) {
  return t;
  function t(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Ae(e, n, "linePrefix");
  }
}
const xn = {
  name: "thematicBreak",
  tokenize: hc
};
function hc(e, n, t) {
  let r = 0, i;
  return a;
  function a(u) {
    return e.enter("thematicBreak"), o(u);
  }
  function o(u) {
    return i = u, l(u);
  }
  function l(u) {
    return u === i ? (e.enter("thematicBreakSequence"), s(u)) : r >= 3 && (u === null || re(u)) ? (e.exit("thematicBreak"), n(u)) : t(u);
  }
  function s(u) {
    return u === i ? (e.consume(u), r++, s) : (e.exit("thematicBreakSequence"), pe(u) ? Ae(e, l, "whitespace")(u) : l(u));
  }
}
const He = {
  continuation: {
    tokenize: yc
  },
  exit: vc,
  name: "list",
  tokenize: gc
}, pc = {
  partial: !0,
  tokenize: Cc
}, mc = {
  partial: !0,
  tokenize: $c
};
function gc(e, n, t) {
  const r = this, i = r.events[r.events.length - 1];
  let a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return l;
  function l(h) {
    const y = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (y === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : Sr(h)) {
      if (r.containerState.type || (r.containerState.type = y, e.enter(y, {
        _container: !0
      })), y === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(xn, t, u)(h) : u(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), s(h);
    }
    return t(h);
  }
  function s(h) {
    return Sr(h) && ++o < 10 ? (e.consume(h), s) : (!r.interrupt || o < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), u(h)) : t(h);
  }
  function u(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      Hn,
      // Can’t be empty when interrupting.
      r.interrupt ? t : c,
      e.attempt(pc, p, d)
    );
  }
  function c(h) {
    return r.containerState.initialBlankLine = !0, a++, p(h);
  }
  function d(h) {
    return pe(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), p) : t(h);
  }
  function p(h) {
    return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(h);
  }
}
function yc(e, n, t) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Hn, i, a);
  function i(l) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Ae(e, n, "listItemIndent", r.containerState.size + 1)(l);
  }
  function a(l) {
    return r.containerState.furtherBlankLines || !pe(l) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(l)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(mc, n, o)(l));
  }
  function o(l) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Ae(e, e.attempt(He, n, t), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function $c(e, n, t) {
  const r = this;
  return Ae(e, i, "listItemIndent", r.containerState.size + 1);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? n(a) : t(a);
  }
}
function vc(e) {
  e.exit(this.containerState.type);
}
function Cc(e, n, t) {
  const r = this;
  return Ae(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return !pe(a) && o && o[1].type === "listItemPrefixWhitespace" ? n(a) : t(a);
  }
}
const Ui = {
  name: "setextUnderline",
  resolveTo: bc,
  tokenize: Ac
};
function bc(e, n) {
  let t = e.length, r, i, a;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        r = t;
        break;
      }
      e[t][1].type === "paragraph" && (i = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !a && e[t][1].type === "definition" && (a = t);
  const o = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", o, n]), e.splice(a + 1, 0, ["exit", e[r][1], n]), e[r][1].end = {
    ...e[a][1].end
  }) : e[r][1] = o, e.push(["exit", o, n]), e;
}
function Ac(e, n, t) {
  const r = this;
  let i;
  return a;
  function a(u) {
    let c = r.events.length, d;
    for (; c--; )
      if (r.events[c][1].type !== "lineEnding" && r.events[c][1].type !== "linePrefix" && r.events[c][1].type !== "content") {
        d = r.events[c][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = u, o(u)) : t(u);
  }
  function o(u) {
    return e.enter("setextHeadingLineSequence"), l(u);
  }
  function l(u) {
    return u === i ? (e.consume(u), l) : (e.exit("setextHeadingLineSequence"), pe(u) ? Ae(e, s, "lineSuffix")(u) : s(u));
  }
  function s(u) {
    return u === null || re(u) ? (e.exit("setextHeadingLine"), n(u)) : t(u);
  }
}
const wc = {
  tokenize: xc
};
function xc(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    Hn,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, Ae(e, e.attempt(this.parser.constructs.flow, i, e.attempt(Su, i)), "linePrefix"))
  );
  return t;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const _c = {
  resolveAll: ll()
}, Nc = ol("string"), Ic = ol("text");
function ol(e) {
  return {
    resolveAll: ll(e === "text" ? Ec : void 0),
    tokenize: n
  };
  function n(t) {
    const r = this, i = this.parser.constructs[e], a = t.attempt(i, o, l);
    return o;
    function o(c) {
      return u(c) ? a(c) : l(c);
    }
    function l(c) {
      if (c === null) {
        t.consume(c);
        return;
      }
      return t.enter("data"), t.consume(c), s;
    }
    function s(c) {
      return u(c) ? (t.exit("data"), a(c)) : (t.consume(c), s);
    }
    function u(c) {
      if (c === null)
        return !0;
      const d = i[c];
      let p = -1;
      if (d)
        for (; ++p < d.length; ) {
          const h = d[p];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function ll(e) {
  return n;
  function n(t, r) {
    let i = -1, a;
    for (; ++i <= t.length; )
      a === void 0 ? t[i] && t[i][1].type === "data" && (a = i, i++) : (!t[i] || t[i][1].type !== "data") && (i !== a + 2 && (t[a][1].end = t[i - 1][1].end, t.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(t, r) : t;
  }
}
function Ec(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const r = e[t - 1][1], i = n.sliceStream(r);
      let a = i.length, o = -1, l = 0, s;
      for (; a--; ) {
        const u = i[a];
        if (typeof u == "string") {
          for (o = u.length; u.charCodeAt(o - 1) === 32; )
            l++, o--;
          if (o) break;
          o = -1;
        } else if (u === -2)
          s = !0, l++;
        else if (u !== -1) {
          a++;
          break;
        }
      }
      if (n._contentTypeTextTrailing && t === e.length && (l = 0), l) {
        const u = {
          type: t === e.length || s || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: a ? o : r.start._bufferIndex + o,
            _index: r.start._index + a,
            line: r.end.line,
            column: r.end.column - l,
            offset: r.end.offset - l
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...u.start
        }, r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(t, 0, ["enter", u, n], ["exit", u, n]), t += 2);
      }
      t++;
    }
  return e;
}
const Sc = {
  42: He,
  43: He,
  45: He,
  48: He,
  49: He,
  50: He,
  51: He,
  52: He,
  53: He,
  54: He,
  55: He,
  56: He,
  57: He,
  62: Jo
}, Pc = {
  91: Lu
}, kc = {
  [-2]: Xn,
  [-1]: Xn,
  32: Xn
}, Oc = {
  35: ju,
  42: xn,
  45: [Ui, xn],
  60: Wu,
  61: Ui,
  95: xn,
  96: zi,
  126: zi
}, Tc = {
  38: tl,
  92: el
}, Lc = {
  [-5]: Jn,
  [-4]: Jn,
  [-3]: Jn,
  33: sc,
  38: tl,
  42: Pr,
  60: [cu, Yu],
  91: cc,
  92: [Du, el],
  93: di,
  95: Pr,
  96: wu
}, Fc = {
  null: [Pr, _c]
}, Mc = {
  null: [42, 95]
}, Rc = {
  null: []
}, Dc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Mc,
  contentInitial: Pc,
  disable: Rc,
  document: Sc,
  flow: Oc,
  flowInitial: kc,
  insideSpan: Fc,
  string: Tc,
  text: Lc
}, Symbol.toStringTag, { value: "Module" }));
function Bc(e, n, t) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: t && t.line || 1,
    column: t && t.column || 1,
    offset: t && t.offset || 0
  };
  const i = {}, a = [];
  let o = [], l = [];
  const s = {
    attempt: S(b),
    check: S(w),
    consume: x,
    enter: A,
    exit: I,
    interrupt: S(w, {
      interrupt: !0
    })
  }, u = {
    code: null,
    containerState: {},
    defineSkip: C,
    events: [],
    now: y,
    parser: e,
    previous: null,
    sliceSerialize: p,
    sliceStream: h,
    write: d
  };
  let c = n.tokenize.call(u, s);
  return n.resolveAll && a.push(n), u;
  function d(T) {
    return o = Xe(o, T), $(), o[o.length - 1] !== null ? [] : (O(n, 0), u.events = ci(a, u.events, u), u.events);
  }
  function p(T, E) {
    return Hc(h(T), E);
  }
  function h(T) {
    return jc(o, T);
  }
  function y() {
    const {
      _bufferIndex: T,
      _index: E,
      line: L,
      column: W,
      offset: D
    } = r;
    return {
      _bufferIndex: T,
      _index: E,
      line: L,
      column: W,
      offset: D
    };
  }
  function C(T) {
    i[T.line] = T.column, R();
  }
  function $() {
    let T;
    for (; r._index < o.length; ) {
      const E = o[r._index];
      if (typeof E == "string")
        for (T = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === T && r._bufferIndex < E.length; )
          m(E.charCodeAt(r._bufferIndex));
      else
        m(E);
    }
  }
  function m(T) {
    c = c(T);
  }
  function x(T) {
    re(T) ? (r.line++, r.column = 1, r.offset += T === -3 ? 2 : 1, R()) : T !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = T;
  }
  function A(T, E) {
    const L = E || {};
    return L.type = T, L.start = y(), u.events.push(["enter", L, u]), l.push(L), L;
  }
  function I(T) {
    const E = l.pop();
    return E.end = y(), u.events.push(["exit", E, u]), E;
  }
  function b(T, E) {
    O(T, E.from);
  }
  function w(T, E) {
    E.restore();
  }
  function S(T, E) {
    return L;
    function L(W, D, H) {
      let ee, V, ae, g;
      return Array.isArray(W) ? (
        /* c8 ignore next 1 */
        J(W)
      ) : "tokenize" in W ? (
        // Looks like a construct.
        J([
          /** @type {Construct} */
          W
        ])
      ) : z(W);
      function z(K) {
        return ne;
        function ne(q) {
          const M = q !== null && K[q], Q = q !== null && K.null, Z = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(M) ? M : M ? [M] : [],
            ...Array.isArray(Q) ? Q : Q ? [Q] : []
          ];
          return J(Z)(q);
        }
      }
      function J(K) {
        return ee = K, V = 0, K.length === 0 ? H : v(K[V]);
      }
      function v(K) {
        return ne;
        function ne(q) {
          return g = N(), ae = K, K.partial || (u.currentConstruct = K), K.name && u.parser.constructs.disable.null.includes(K.name) ? ie() : K.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            E ? Object.assign(Object.create(u), E) : u,
            s,
            X,
            ie
          )(q);
        }
      }
      function X(K) {
        return T(ae, g), D;
      }
      function ie(K) {
        return g.restore(), ++V < ee.length ? v(ee[V]) : H;
      }
    }
  }
  function O(T, E) {
    T.resolveAll && !a.includes(T) && a.push(T), T.resolve && ut(u.events, E, u.events.length - E, T.resolve(u.events.slice(E), u)), T.resolveTo && (u.events = T.resolveTo(u.events, u));
  }
  function N() {
    const T = y(), E = u.previous, L = u.currentConstruct, W = u.events.length, D = Array.from(l);
    return {
      from: W,
      restore: H
    };
    function H() {
      r = T, u.previous = E, u.currentConstruct = L, u.events.length = W, l = D, R();
    }
  }
  function R() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function jc(e, n) {
  const t = n.start._index, r = n.start._bufferIndex, i = n.end._index, a = n.end._bufferIndex;
  let o;
  if (t === i)
    o = [e[t].slice(r, a)];
  else {
    if (o = e.slice(t, i), r > -1) {
      const l = o[0];
      typeof l == "string" ? o[0] = l.slice(r) : o.shift();
    }
    a > 0 && o.push(e[i].slice(0, a));
  }
  return o;
}
function Hc(e, n) {
  let t = -1;
  const r = [];
  let i;
  for (; ++t < e.length; ) {
    const a = e[t];
    let o;
    if (typeof a == "string")
      o = a;
    else switch (a) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && i) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(a);
    }
    i = a === -2, r.push(o);
  }
  return r.join("");
}
function Vc(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      Q1([Dc, ...(e || {}).extensions || []])
    ),
    content: i(ru),
    defined: [],
    document: i(au),
    flow: i(wc),
    lazy: {},
    string: i(Nc),
    text: i(Ic)
  };
  return r;
  function i(a) {
    return o;
    function o(l) {
      return Bc(r, a, l);
    }
  }
}
function zc(e) {
  for (; !nl(e); )
    ;
  return e;
}
const qi = /[\0\t\n\r]/g;
function Wc() {
  let e = 1, n = "", t = !0, r;
  return i;
  function i(a, o, l) {
    const s = [];
    let u, c, d, p, h;
    for (a = n + (typeof a == "string" ? a.toString() : new TextDecoder(o || void 0).decode(a)), d = 0, n = "", t && (a.charCodeAt(0) === 65279 && d++, t = void 0); d < a.length; ) {
      if (qi.lastIndex = d, u = qi.exec(a), p = u && u.index !== void 0 ? u.index : a.length, h = a.charCodeAt(p), !u) {
        n = a.slice(d);
        break;
      }
      if (h === 10 && d === p && r)
        s.push(-3), r = void 0;
      else
        switch (r && (s.push(-5), r = void 0), d < p && (s.push(a.slice(d, p)), e += p - d), h) {
          case 0: {
            s.push(65533), e++;
            break;
          }
          case 9: {
            for (c = Math.ceil(e / 4) * 4, s.push(-2); e++ < c; ) s.push(-1);
            break;
          }
          case 10: {
            s.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = p + 1;
    }
    return l && (r && s.push(-5), n && s.push(n), s.push(null)), s;
  }
}
const Uc = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function qc(e) {
  return e.replace(Uc, Zc);
}
function Zc(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const i = t.charCodeAt(1), a = i === 120 || i === 88;
    return Xo(t.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return ui(t) || e;
}
const sl = {}.hasOwnProperty;
function Gc(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), Qc(t)(zc(Vc(t).document().write(Wc()(e, n, !0))));
}
function Qc(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(wi),
      autolinkProtocol: N,
      autolinkEmail: N,
      atxHeading: a(ve),
      blockQuote: a(Q),
      characterEscape: N,
      characterReference: N,
      codeFenced: a(Z),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: a(Z, o),
      codeText: a(F, o),
      codeTextData: N,
      data: N,
      codeFlowValue: N,
      definition: a(oe),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: a(he),
      hardBreakEscape: a(xe),
      hardBreakTrailing: a(xe),
      htmlFlow: a(Ie, o),
      htmlFlowData: N,
      htmlText: a(Ie, o),
      htmlTextData: N,
      image: a(gt),
      label: o,
      link: a(wi),
      listItem: a(Cs),
      listItemValue: p,
      listOrdered: a(xi, d),
      listUnordered: a(xi),
      paragraph: a(bs),
      reference: v,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: a(ve),
      strong: a(As),
      thematicBreak: a(xs)
    },
    exit: {
      atxHeading: s(),
      atxHeadingSequence: b,
      autolink: s(),
      autolinkEmail: M,
      autolinkProtocol: q,
      blockQuote: s(),
      characterEscapeValue: R,
      characterReferenceMarkerHexadecimal: ie,
      characterReferenceMarkerNumeric: ie,
      characterReferenceValue: K,
      characterReference: ne,
      codeFenced: s($),
      codeFencedFence: C,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: y,
      codeFlowValue: R,
      codeIndented: s(m),
      codeText: s(D),
      codeTextData: R,
      data: R,
      definition: s(),
      definitionDestinationString: I,
      definitionLabelString: x,
      definitionTitleString: A,
      emphasis: s(),
      hardBreakEscape: s(E),
      hardBreakTrailing: s(E),
      htmlFlow: s(L),
      htmlFlowData: R,
      htmlText: s(W),
      htmlTextData: R,
      image: s(ee),
      label: ae,
      labelText: V,
      lineEnding: T,
      link: s(H),
      listItem: s(),
      listOrdered: s(),
      listUnordered: s(),
      paragraph: s(),
      referenceString: X,
      resourceDestinationString: g,
      resourceTitleString: z,
      resource: J,
      setextHeading: s(O),
      setextHeadingLineSequence: S,
      setextHeadingText: w,
      strong: s(),
      thematicBreak: s()
    }
  };
  ul(n, (e || {}).mdastExtensions || []);
  const t = {};
  return r;
  function r(k) {
    let U = {
      type: "root",
      children: []
    };
    const le = {
      stack: [U],
      tokenStack: [],
      config: n,
      enter: l,
      exit: u,
      buffer: o,
      resume: c,
      data: t
    }, fe = [];
    let Ce = -1;
    for (; ++Ce < k.length; )
      if (k[Ce][1].type === "listOrdered" || k[Ce][1].type === "listUnordered")
        if (k[Ce][0] === "enter")
          fe.push(Ce);
        else {
          const Je = fe.pop();
          Ce = i(k, Je, Ce);
        }
    for (Ce = -1; ++Ce < k.length; ) {
      const Je = n[k[Ce][0]];
      sl.call(Je, k[Ce][1].type) && Je[k[Ce][1].type].call(Object.assign({
        sliceSerialize: k[Ce][2].sliceSerialize
      }, le), k[Ce][1]);
    }
    if (le.tokenStack.length > 0) {
      const Je = le.tokenStack[le.tokenStack.length - 1];
      (Je[1] || Zi).call(le, void 0, Je[0]);
    }
    for (U.position = {
      start: yt(k.length > 0 ? k[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: yt(k.length > 0 ? k[k.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Ce = -1; ++Ce < n.transforms.length; )
      U = n.transforms[Ce](U) || U;
    return U;
  }
  function i(k, U, le) {
    let fe = U - 1, Ce = -1, Je = !1, wt, ct, Zt, Gt;
    for (; ++fe <= le; ) {
      const We = k[fe];
      switch (We[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          We[0] === "enter" ? Ce++ : Ce--, Gt = void 0;
          break;
        }
        case "lineEndingBlank": {
          We[0] === "enter" && (wt && !Gt && !Ce && !Zt && (Zt = fe), Gt = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Gt = void 0;
      }
      if (!Ce && We[0] === "enter" && We[1].type === "listItemPrefix" || Ce === -1 && We[0] === "exit" && (We[1].type === "listUnordered" || We[1].type === "listOrdered")) {
        if (wt) {
          let St = fe;
          for (ct = void 0; St--; ) {
            const dt = k[St];
            if (dt[1].type === "lineEnding" || dt[1].type === "lineEndingBlank") {
              if (dt[0] === "exit") continue;
              ct && (k[ct][1].type = "lineEndingBlank", Je = !0), dt[1].type = "lineEnding", ct = St;
            } else if (!(dt[1].type === "linePrefix" || dt[1].type === "blockQuotePrefix" || dt[1].type === "blockQuotePrefixWhitespace" || dt[1].type === "blockQuoteMarker" || dt[1].type === "listItemIndent")) break;
          }
          Zt && (!ct || Zt < ct) && (wt._spread = !0), wt.end = Object.assign({}, ct ? k[ct][1].start : We[1].end), k.splice(ct || fe, 0, ["exit", wt, We[2]]), fe++, le++;
        }
        if (We[1].type === "listItemPrefix") {
          const St = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, We[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          wt = St, k.splice(fe, 0, ["enter", St, We[2]]), fe++, le++, Zt = void 0, Gt = !0;
        }
      }
    }
    return k[U][1]._spread = Je, le;
  }
  function a(k, U) {
    return le;
    function le(fe) {
      l.call(this, k(fe), fe), U && U.call(this, fe);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(k, U, le) {
    this.stack[this.stack.length - 1].children.push(k), this.stack.push(k), this.tokenStack.push([U, le || void 0]), k.position = {
      start: yt(U.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function s(k) {
    return U;
    function U(le) {
      k && k.call(this, le), u.call(this, le);
    }
  }
  function u(k, U) {
    const le = this.stack.pop(), fe = this.tokenStack.pop();
    if (fe)
      fe[0].type !== k.type && (U ? U.call(this, k, fe[0]) : (fe[1] || Zi).call(this, k, fe[0]));
    else throw new Error("Cannot close `" + k.type + "` (" + tn({
      start: k.start,
      end: k.end
    }) + "): it’s not open");
    le.position.end = yt(k.end);
  }
  function c() {
    return Z1(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function p(k) {
    if (this.data.expectingFirstListItemValue) {
      const U = this.stack[this.stack.length - 2];
      U.start = Number.parseInt(this.sliceSerialize(k), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.lang = k;
  }
  function y() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.meta = k;
  }
  function C() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function $() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = k.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function m() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = k.replace(/(\r?\n|\r)$/g, "");
  }
  function x(k) {
    const U = this.resume(), le = this.stack[this.stack.length - 1];
    le.label = U, le.identifier = Dt(this.sliceSerialize(k)).toLowerCase();
  }
  function A() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.title = k;
  }
  function I() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.url = k;
  }
  function b(k) {
    const U = this.stack[this.stack.length - 1];
    if (!U.depth) {
      const le = this.sliceSerialize(k).length;
      U.depth = le;
    }
  }
  function w() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function S(k) {
    const U = this.stack[this.stack.length - 1];
    U.depth = this.sliceSerialize(k).codePointAt(0) === 61 ? 1 : 2;
  }
  function O() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function N(k) {
    const le = this.stack[this.stack.length - 1].children;
    let fe = le[le.length - 1];
    (!fe || fe.type !== "text") && (fe = ws(), fe.position = {
      start: yt(k.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, le.push(fe)), this.stack.push(fe);
  }
  function R(k) {
    const U = this.stack.pop();
    U.value += this.sliceSerialize(k), U.position.end = yt(k.end);
  }
  function T(k) {
    const U = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const le = U.children[U.children.length - 1];
      le.position.end = yt(k.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(U.type) && (N.call(this, k), R.call(this, k));
  }
  function E() {
    this.data.atHardBreak = !0;
  }
  function L() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = k;
  }
  function W() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = k;
  }
  function D() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.value = k;
  }
  function H() {
    const k = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const U = this.data.referenceType || "shortcut";
      k.type += "Reference", k.referenceType = U, delete k.url, delete k.title;
    } else
      delete k.identifier, delete k.label;
    this.data.referenceType = void 0;
  }
  function ee() {
    const k = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const U = this.data.referenceType || "shortcut";
      k.type += "Reference", k.referenceType = U, delete k.url, delete k.title;
    } else
      delete k.identifier, delete k.label;
    this.data.referenceType = void 0;
  }
  function V(k) {
    const U = this.sliceSerialize(k), le = this.stack[this.stack.length - 2];
    le.label = qc(U), le.identifier = Dt(U).toLowerCase();
  }
  function ae() {
    const k = this.stack[this.stack.length - 1], U = this.resume(), le = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, le.type === "link") {
      const fe = k.children;
      le.children = fe;
    } else
      le.alt = U;
  }
  function g() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.url = k;
  }
  function z() {
    const k = this.resume(), U = this.stack[this.stack.length - 1];
    U.title = k;
  }
  function J() {
    this.data.inReference = void 0;
  }
  function v() {
    this.data.referenceType = "collapsed";
  }
  function X(k) {
    const U = this.resume(), le = this.stack[this.stack.length - 1];
    le.label = U, le.identifier = Dt(this.sliceSerialize(k)).toLowerCase(), this.data.referenceType = "full";
  }
  function ie(k) {
    this.data.characterReferenceType = k.type;
  }
  function K(k) {
    const U = this.sliceSerialize(k), le = this.data.characterReferenceType;
    let fe;
    le ? (fe = Xo(U, le === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : fe = ui(U);
    const Ce = this.stack[this.stack.length - 1];
    Ce.value += fe;
  }
  function ne(k) {
    const U = this.stack.pop();
    U.position.end = yt(k.end);
  }
  function q(k) {
    R.call(this, k);
    const U = this.stack[this.stack.length - 1];
    U.url = this.sliceSerialize(k);
  }
  function M(k) {
    R.call(this, k);
    const U = this.stack[this.stack.length - 1];
    U.url = "mailto:" + this.sliceSerialize(k);
  }
  function Q() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Z() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function F() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function oe() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function he() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ve() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function xe() {
    return {
      type: "break"
    };
  }
  function Ie() {
    return {
      type: "html",
      value: ""
    };
  }
  function gt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function wi() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function xi(k) {
    return {
      type: "list",
      ordered: k.type === "listOrdered",
      start: null,
      spread: k._spread,
      children: []
    };
  }
  function Cs(k) {
    return {
      type: "listItem",
      spread: k._spread,
      checked: null,
      children: []
    };
  }
  function bs() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function As() {
    return {
      type: "strong",
      children: []
    };
  }
  function ws() {
    return {
      type: "text",
      value: ""
    };
  }
  function xs() {
    return {
      type: "thematicBreak"
    };
  }
}
function yt(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function ul(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const r = n[t];
    Array.isArray(r) ? ul(e, r) : Kc(e, r);
  }
}
function Kc(e, n) {
  let t;
  for (t in n)
    if (sl.call(n, t))
      switch (t) {
        case "canContainEols": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "transforms": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = n[t];
          r && Object.assign(e[t], r);
          break;
        }
      }
}
function Zi(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + tn({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + tn({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + tn({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function Yc(e) {
  const n = this;
  n.parser = t;
  function t(r) {
    return Gc(r, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function Xc(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Jc(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function e2(e, n) {
  const t = n.value ? n.value + `
` : "", r = {};
  n.lang && (r.className = ["language-" + n.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (i.data = { meta: n.meta }), e.patch(n, i), i = e.applyData(n, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(n, i), i;
}
function t2(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function n2(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function r2(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(n.identifier).toUpperCase(), i = Ut(r.toLowerCase()), a = e.footnoteOrder.indexOf(r);
  let o, l = e.footnoteCounts.get(r);
  l === void 0 ? (l = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = a + 1, l += 1, e.footnoteCounts.set(r, l);
  const s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + i,
      id: t + "fnref-" + i + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(n, s);
  const u = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(n, u), e.applyData(n, u);
}
function i2(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function a2(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function cl(e, n) {
  const t = n.referenceType;
  let r = "]";
  if (t === "collapsed" ? r += "[]" : t === "full" && (r += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + r }];
  const i = e.all(n), a = i[0];
  a && a.type === "text" ? a.value = "[" + a.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function o2(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return cl(e, n);
  const i = { src: Ut(r.url || ""), alt: n.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(n, a), e.applyData(n, a);
}
function l2(e, n) {
  const t = { src: Ut(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, r), e.applyData(n, r);
}
function s2(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, r), e.applyData(n, r);
}
function u2(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return cl(e, n);
  const i = { href: Ut(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(n)
  };
  return e.patch(n, a), e.applyData(n, a);
}
function c2(e, n) {
  const t = { href: Ut(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function d2(e, n, t) {
  const r = e.all(n), i = t ? f2(t) : dl(n), a = {}, o = [];
  if (typeof n.checked == "boolean") {
    const c = r[0];
    let d;
    c && c.type === "element" && c.tagName === "p" ? d = c : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < r.length; ) {
    const c = r[l];
    (i || l !== 0 || c.type !== "element" || c.tagName !== "p") && o.push({ type: "text", value: `
` }), c.type === "element" && c.tagName === "p" && !i ? o.push(...c.children) : o.push(c);
  }
  const s = r[r.length - 1];
  s && (i || s.type !== "element" || s.tagName !== "p") && o.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: a, children: o };
  return e.patch(n, u), e.applyData(n, u);
}
function f2(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let r = -1;
    for (; !n && ++r < t.length; )
      n = dl(t[r]);
  }
  return n;
}
function dl(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function h2(e, n) {
  const t = {}, r = e.all(n);
  let i = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(r, !0)
  };
  return e.patch(n, a), e.applyData(n, a);
}
function p2(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function m2(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function g2(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function y2(e, n) {
  const t = e.all(n), r = t.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(n.children[0], o), i.push(o);
  }
  if (t.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, l = ai(n.children[1]), s = Uo(n.children[n.children.length - 1]);
    l && s && (o.position = { start: l, end: s }), i.push(o);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(n, a), e.applyData(n, a);
}
function $2(e, n, t) {
  const r = t ? t.children : void 0, a = (r ? r.indexOf(n) : 1) === 0 ? "th" : "td", o = t && t.type === "table" ? t.align : void 0, l = o ? o.length : n.children.length;
  let s = -1;
  const u = [];
  for (; ++s < l; ) {
    const d = n.children[s], p = {}, h = o ? o[s] : void 0;
    h && (p.align = h);
    let y = { type: "element", tagName: a, properties: p, children: [] };
    d && (y.children = e.all(d), e.patch(d, y), y = e.applyData(d, y)), u.push(y);
  }
  const c = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(n, c), e.applyData(n, c);
}
function v2(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const Gi = 9, Qi = 32;
function C2(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let r = t.exec(n), i = 0;
  const a = [];
  for (; r; )
    a.push(
      Ki(n.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = t.exec(n);
  return a.push(Ki(n.slice(i), i > 0, !1)), a.join("");
}
function Ki(e, n, t) {
  let r = 0, i = e.length;
  if (n) {
    let a = e.codePointAt(r);
    for (; a === Gi || a === Qi; )
      r++, a = e.codePointAt(r);
  }
  if (t) {
    let a = e.codePointAt(i - 1);
    for (; a === Gi || a === Qi; )
      i--, a = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function b2(e, n) {
  const t = { type: "text", value: C2(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function A2(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const w2 = {
  blockquote: Xc,
  break: Jc,
  code: e2,
  delete: t2,
  emphasis: n2,
  footnoteReference: r2,
  heading: i2,
  html: a2,
  imageReference: o2,
  image: l2,
  inlineCode: s2,
  linkReference: u2,
  link: c2,
  listItem: d2,
  list: h2,
  paragraph: p2,
  // @ts-expect-error: root is different, but hard to type.
  root: m2,
  strong: g2,
  table: y2,
  tableCell: v2,
  tableRow: $2,
  text: b2,
  thematicBreak: A2,
  toml: mn,
  yaml: mn,
  definition: mn,
  footnoteDefinition: mn
};
function mn() {
}
const fl = -1, Vn = 0, rn = 1, Sn = 2, fi = 3, hi = 4, pi = 5, mi = 6, hl = 7, pl = 8, Yi = typeof self == "object" ? self : globalThis, x2 = (e, n) => {
  const t = (i, a) => (e.set(a, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [a, o] = n[i];
    switch (a) {
      case Vn:
      case fl:
        return t(o, i);
      case rn: {
        const l = t([], i);
        for (const s of o)
          l.push(r(s));
        return l;
      }
      case Sn: {
        const l = t({}, i);
        for (const [s, u] of o)
          l[r(s)] = r(u);
        return l;
      }
      case fi:
        return t(new Date(o), i);
      case hi: {
        const { source: l, flags: s } = o;
        return t(new RegExp(l, s), i);
      }
      case pi: {
        const l = t(/* @__PURE__ */ new Map(), i);
        for (const [s, u] of o)
          l.set(r(s), r(u));
        return l;
      }
      case mi: {
        const l = t(/* @__PURE__ */ new Set(), i);
        for (const s of o)
          l.add(r(s));
        return l;
      }
      case hl: {
        const { name: l, message: s } = o;
        return t(new Yi[l](s), i);
      }
      case pl:
        return t(BigInt(o), i);
      case "BigInt":
        return t(Object(BigInt(o)), i);
      case "ArrayBuffer":
        return t(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: l } = new Uint8Array(o);
        return t(new DataView(l), o);
      }
    }
    return t(new Yi[a](o), i);
  };
  return r;
}, Xi = (e) => x2(/* @__PURE__ */ new Map(), e)(0), Pt = "", { toString: _2 } = {}, { keys: N2 } = Object, Kt = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Vn, n];
  const t = _2.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [rn, Pt];
    case "Object":
      return [Sn, Pt];
    case "Date":
      return [fi, Pt];
    case "RegExp":
      return [hi, Pt];
    case "Map":
      return [pi, Pt];
    case "Set":
      return [mi, Pt];
    case "DataView":
      return [rn, t];
  }
  return t.includes("Array") ? [rn, t] : t.includes("Error") ? [hl, t] : [Sn, t];
}, gn = ([e, n]) => e === Vn && (n === "function" || n === "symbol"), I2 = (e, n, t, r) => {
  const i = (o, l) => {
    const s = r.push(o) - 1;
    return t.set(l, s), s;
  }, a = (o) => {
    if (t.has(o))
      return t.get(o);
    let [l, s] = Kt(o);
    switch (l) {
      case Vn: {
        let c = o;
        switch (s) {
          case "bigint":
            l = pl, c = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + s);
            c = null;
            break;
          case "undefined":
            return i([fl], o);
        }
        return i([l, c], o);
      }
      case rn: {
        if (s) {
          let p = o;
          return s === "DataView" ? p = new Uint8Array(o.buffer) : s === "ArrayBuffer" && (p = new Uint8Array(o)), i([s, [...p]], o);
        }
        const c = [], d = i([l, c], o);
        for (const p of o)
          c.push(a(p));
        return d;
      }
      case Sn: {
        if (s)
          switch (s) {
            case "BigInt":
              return i([s, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([s, o.valueOf()], o);
          }
        if (n && "toJSON" in o)
          return a(o.toJSON());
        const c = [], d = i([l, c], o);
        for (const p of N2(o))
          (e || !gn(Kt(o[p]))) && c.push([a(p), a(o[p])]);
        return d;
      }
      case fi:
        return i([l, o.toISOString()], o);
      case hi: {
        const { source: c, flags: d } = o;
        return i([l, { source: c, flags: d }], o);
      }
      case pi: {
        const c = [], d = i([l, c], o);
        for (const [p, h] of o)
          (e || !(gn(Kt(p)) || gn(Kt(h)))) && c.push([a(p), a(h)]);
        return d;
      }
      case mi: {
        const c = [], d = i([l, c], o);
        for (const p of o)
          (e || !gn(Kt(p))) && c.push(a(p));
        return d;
      }
    }
    const { message: u } = o;
    return i([l, { name: s, message: u }], o);
  };
  return a;
}, Ji = (e, { json: n, lossy: t } = {}) => {
  const r = [];
  return I2(!(n || t), !!n, /* @__PURE__ */ new Map(), r)(e), r;
}, Pn = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Xi(Ji(e, n)) : structuredClone(e)
) : (e, n) => Xi(Ji(e, n));
function E2(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function S2(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function P2(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || E2, r = e.options.footnoteBackLabel || S2, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let s = -1;
  for (; ++s < e.footnoteOrder.length; ) {
    const u = e.footnoteById.get(
      e.footnoteOrder[s]
    );
    if (!u)
      continue;
    const c = e.all(u), d = String(u.identifier).toUpperCase(), p = Ut(d.toLowerCase());
    let h = 0;
    const y = [], C = e.footnoteCounts.get(d);
    for (; C !== void 0 && ++h <= C; ) {
      y.length > 0 && y.push({ type: "text", value: " " });
      let x = typeof t == "string" ? t : t(s, h);
      typeof x == "string" && (x = { type: "text", value: x }), y.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + p + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(s, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(x) ? x : [x]
      });
    }
    const $ = c[c.length - 1];
    if ($ && $.type === "element" && $.tagName === "p") {
      const x = $.children[$.children.length - 1];
      x && x.type === "text" ? x.value += " " : $.children.push({ type: "text", value: " " }), $.children.push(...y);
    } else
      c.push(...y);
    const m = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + p },
      children: e.wrap(c, !0)
    };
    e.patch(u, m), l.push(m);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...Pn(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const ml = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return L2;
    if (typeof e == "function")
      return zn(e);
    if (typeof e == "object")
      return Array.isArray(e) ? k2(e) : O2(e);
    if (typeof e == "string")
      return T2(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function k2(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = ml(e[t]);
  return zn(r);
  function r(...i) {
    let a = -1;
    for (; ++a < n.length; )
      if (n[a].apply(this, i)) return !0;
    return !1;
  }
}
function O2(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return zn(t);
  function t(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let a;
    for (a in e)
      if (i[a] !== n[a]) return !1;
    return !0;
  }
}
function T2(e) {
  return zn(n);
  function n(t) {
    return t && t.type === e;
  }
}
function zn(e) {
  return n;
  function n(t, r, i) {
    return !!(F2(t) && e.call(
      this,
      t,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function L2() {
  return !0;
}
function F2(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const gl = [], M2 = !0, ea = !1, R2 = "skip";
function D2(e, n, t, r) {
  let i;
  typeof n == "function" && typeof t != "function" ? (r = t, t = n) : i = n;
  const a = ml(i), o = r ? -1 : 1;
  l(e, void 0, [])();
  function l(s, u, c) {
    const d = (
      /** @type {Record<string, unknown>} */
      s && typeof s == "object" ? s : {}
    );
    if (typeof d.type == "string") {
      const h = (
        // `hast`
        typeof d.tagName == "string" ? d.tagName : (
          // `xast`
          typeof d.name == "string" ? d.name : void 0
        )
      );
      Object.defineProperty(p, "name", {
        value: "node (" + (s.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return p;
    function p() {
      let h = gl, y, C, $;
      if ((!n || a(s, u, c[c.length - 1] || void 0)) && (h = B2(t(s, c)), h[0] === ea))
        return h;
      if ("children" in s && s.children) {
        const m = (
          /** @type {UnistParent} */
          s
        );
        if (m.children && h[0] !== R2)
          for (C = (r ? m.children.length : -1) + o, $ = c.concat(m); C > -1 && C < m.children.length; ) {
            const x = m.children[C];
            if (y = l(x, C, $)(), y[0] === ea)
              return y;
            C = typeof y[1] == "number" ? y[1] : C + o;
          }
      }
      return h;
    }
  }
}
function B2(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [M2, e] : e == null ? gl : [e];
}
function yl(e, n, t, r) {
  let i, a, o;
  typeof n == "function" && typeof t != "function" ? (a = void 0, o = n, i = t) : (a = n, o = t, i = r), D2(e, a, l, i);
  function l(s, u) {
    const c = u[u.length - 1], d = c ? c.children.indexOf(s) : void 0;
    return o(s, d, c);
  }
}
const kr = {}.hasOwnProperty, j2 = {};
function H2(e, n) {
  const t = n || j2, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = { ...w2, ...t.handlers }, l = {
    all: u,
    applyData: z2,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: o,
    one: s,
    options: t,
    patch: V2,
    wrap: U2
  };
  return yl(e, function(c) {
    if (c.type === "definition" || c.type === "footnoteDefinition") {
      const d = c.type === "definition" ? r : i, p = String(c.identifier).toUpperCase();
      d.has(p) || d.set(p, c);
    }
  }), l;
  function s(c, d) {
    const p = c.type, h = l.handlers[p];
    if (kr.call(l.handlers, p) && h)
      return h(l, c, d);
    if (l.options.passThrough && l.options.passThrough.includes(p)) {
      if ("children" in c) {
        const { children: C, ...$ } = c, m = Pn($);
        return m.children = l.all(c), m;
      }
      return Pn(c);
    }
    return (l.options.unknownHandler || W2)(l, c, d);
  }
  function u(c) {
    const d = [];
    if ("children" in c) {
      const p = c.children;
      let h = -1;
      for (; ++h < p.length; ) {
        const y = l.one(p[h], c);
        if (y) {
          if (h && p[h - 1].type === "break" && (!Array.isArray(y) && y.type === "text" && (y.value = ta(y.value)), !Array.isArray(y) && y.type === "element")) {
            const C = y.children[0];
            C && C.type === "text" && (C.value = ta(C.value));
          }
          Array.isArray(y) ? d.push(...y) : d.push(y);
        }
      }
    }
    return d;
  }
}
function V2(e, n) {
  e.position && (n.position = _1(e));
}
function z2(e, n) {
  let t = n;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, a = e.data.hProperties;
    if (typeof r == "string")
      if (t.type === "element")
        t.tagName = r;
      else {
        const o = "children" in t ? t.children : [t];
        t = { type: "element", tagName: r, properties: {}, children: o };
      }
    t.type === "element" && a && Object.assign(t.properties, Pn(a)), "children" in t && t.children && i !== null && i !== void 0 && (t.children = i);
  }
  return t;
}
function W2(e, n) {
  const t = n.data || {}, r = "value" in n && !(kr.call(t, "hProperties") || kr.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function U2(e, n) {
  const t = [];
  let r = -1;
  for (n && t.push({ type: "text", value: `
` }); ++r < e.length; )
    r && t.push({ type: "text", value: `
` }), t.push(e[r]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function ta(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function na(e, n) {
  const t = H2(e, n), r = t.one(e, void 0), i = P2(t), a = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && a.children.push({ type: "text", value: `
` }, i), a;
}
function q2(e, n) {
  return e && "run" in e ? async function(t, r) {
    const i = (
      /** @type {HastRoot} */
      na(t, { file: r, ...n })
    );
    await e.run(i, r);
  } : function(t, r) {
    return (
      /** @type {HastRoot} */
      na(t, { file: r, ...e || n })
    );
  };
}
function ra(e) {
  if (e)
    throw e;
}
var _n = Object.prototype.hasOwnProperty, $l = Object.prototype.toString, ia = Object.defineProperty, aa = Object.getOwnPropertyDescriptor, oa = function(n) {
  return typeof Array.isArray == "function" ? Array.isArray(n) : $l.call(n) === "[object Array]";
}, la = function(n) {
  if (!n || $l.call(n) !== "[object Object]")
    return !1;
  var t = _n.call(n, "constructor"), r = n.constructor && n.constructor.prototype && _n.call(n.constructor.prototype, "isPrototypeOf");
  if (n.constructor && !t && !r)
    return !1;
  var i;
  for (i in n)
    ;
  return typeof i > "u" || _n.call(n, i);
}, sa = function(n, t) {
  ia && t.name === "__proto__" ? ia(n, t.name, {
    enumerable: !0,
    configurable: !0,
    value: t.newValue,
    writable: !0
  }) : n[t.name] = t.newValue;
}, ua = function(n, t) {
  if (t === "__proto__")
    if (_n.call(n, t)) {
      if (aa)
        return aa(n, t).value;
    } else return;
  return n[t];
}, Z2 = function e() {
  var n, t, r, i, a, o, l = arguments[0], s = 1, u = arguments.length, c = !1;
  for (typeof l == "boolean" && (c = l, l = arguments[1] || {}, s = 2), (l == null || typeof l != "object" && typeof l != "function") && (l = {}); s < u; ++s)
    if (n = arguments[s], n != null)
      for (t in n)
        r = ua(l, t), i = ua(n, t), l !== i && (c && i && (la(i) || (a = oa(i))) ? (a ? (a = !1, o = r && oa(r) ? r : []) : o = r && la(r) ? r : {}, sa(l, { name: t, newValue: e(c, o, i) })) : typeof i < "u" && sa(l, { name: t, newValue: i }));
  return l;
};
const er = /* @__PURE__ */ Bn(Z2);
function Or(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function G2() {
  const e = [], n = { run: t, use: r };
  return n;
  function t(...i) {
    let a = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    l(null, ...i);
    function l(s, ...u) {
      const c = e[++a];
      let d = -1;
      if (s) {
        o(s);
        return;
      }
      for (; ++d < i.length; )
        (u[d] === null || u[d] === void 0) && (u[d] = i[d]);
      i = u, c ? Q2(c, l)(...u) : o(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), n;
  }
}
function Q2(e, n) {
  let t;
  return r;
  function r(...o) {
    const l = e.length > o.length;
    let s;
    l && o.push(i);
    try {
      s = e.apply(this, o);
    } catch (u) {
      const c = (
        /** @type {Error} */
        u
      );
      if (l && t)
        throw c;
      return i(c);
    }
    l || (s && s.then && typeof s.then == "function" ? s.then(a, i) : s instanceof Error ? i(s) : a(s));
  }
  function i(o, ...l) {
    t || (t = !0, n(o, ...l));
  }
  function a(o) {
    i(null, o);
  }
}
const lt = { basename: K2, dirname: Y2, extname: X2, join: J2, sep: "/" };
function K2(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  pn(e);
  let t = 0, r = -1, i = e.length, a;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (a) {
          t = i + 1;
          break;
        }
      } else r < 0 && (a = !0, r = i + 1);
    return r < 0 ? "" : e.slice(t, r);
  }
  if (n === e)
    return "";
  let o = -1, l = n.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (a) {
        t = i + 1;
        break;
      }
    } else
      o < 0 && (a = !0, o = i + 1), l > -1 && (e.codePointAt(i) === n.codePointAt(l--) ? l < 0 && (r = i) : (l = -1, r = o));
  return t === r ? r = o : r < 0 && (r = e.length), e.slice(t, r);
}
function Y2(e) {
  if (pn(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, r;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (r) {
        n = t;
        break;
      }
    } else r || (r = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function X2(e) {
  pn(e);
  let n = e.length, t = -1, r = 0, i = -1, a = 0, o;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (o) {
        r = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (o = !0, t = n + 1), l === 46 ? i < 0 ? i = n : a !== 1 && (a = 1) : i > -1 && (a = -1);
  }
  return i < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && i === t - 1 && i === r + 1 ? "" : e.slice(i, t);
}
function J2(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    pn(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : ed(t);
}
function ed(e) {
  pn(e);
  const n = e.codePointAt(0) === 47;
  let t = td(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function td(e, n) {
  let t = "", r = 0, i = -1, a = 0, o = -1, l, s;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      l = e.codePointAt(o);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(i === o - 1 || a === 1)) if (i !== o - 1 && a === 2) {
        if (t.length < 2 || r !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (s = t.lastIndexOf("/"), s !== t.length - 1) {
              s < 0 ? (t = "", r = 0) : (t = t.slice(0, s), r = t.length - 1 - t.lastIndexOf("/")), i = o, a = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", r = 0, i = o, a = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", r = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(i + 1, o) : t = e.slice(i + 1, o), r = o - i - 1;
      i = o, a = 0;
    } else l === 46 && a > -1 ? a++ : a = -1;
  }
  return t;
}
function pn(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const nd = { cwd: rd };
function rd() {
  return "/";
}
function Tr(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function id(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Tr(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return ad(e);
}
function ad(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const r = n.codePointAt(t + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(n);
}
const tr = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class vl {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? Tr(n) ? t = { path: n } : typeof n == "string" || od(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : nd.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < tr.length; ) {
      const a = tr[r];
      a in t && t[a] !== void 0 && t[a] !== null && (this[a] = a === "history" ? [...t[a]] : t[a]);
    }
    let i;
    for (i in t)
      tr.includes(i) || (this[i] = t[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? lt.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    rr(n, "basename"), nr(n, "basename"), this.path = lt.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? lt.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    ca(this.basename, "dirname"), this.path = lt.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? lt.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (nr(n, "extname"), ca(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = lt.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Tr(n) && (n = id(n)), rr(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? lt.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    rr(n, "stem"), nr(n, "stem"), this.path = lt.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, r) {
    const i = this.message(n, t, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, r) {
    const i = this.message(n, t, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, r) {
    const i = new Me(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function nr(e, n) {
  if (e && e.includes(lt.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + lt.sep + "`"
    );
}
function rr(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function ca(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function od(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const ld = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], a = function() {
      return i.apply(a, arguments);
    };
    return Object.setPrototypeOf(a, r), a;
  }
), sd = {}.hasOwnProperty;
class gi extends ld {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = G2();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new gi()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const r = this.attachers[t];
      n.use(...r);
    }
    return n.data(er(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (or("data", this.frozen), this.namespace[n] = t, this) : sd.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (or("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = t.call(n, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = yn(n), r = this.parser || this.Parser;
    return ir("parse", r), r(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const r = this;
    return this.freeze(), ir("process", this.parser || this.Parser), ar("process", this.compiler || this.Compiler), t ? i(void 0, t) : new Promise(i);
    function i(a, o) {
      const l = yn(n), s = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(l)
      );
      r.run(s, l, function(c, d, p) {
        if (c || !d || !p)
          return u(c);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), y = r.stringify(h, p);
        dd(y) ? p.value = y : p.result = y, u(
          c,
          /** @type {VFileWithOutput<CompileResult>} */
          p
        );
      });
      function u(c, d) {
        c || !d ? o(c) : a ? a(d) : t(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, r;
    return this.freeze(), ir("processSync", this.parser || this.Parser), ar("processSync", this.compiler || this.Compiler), this.process(n, i), fa("processSync", "process", t), r;
    function i(a, o) {
      t = !0, ra(a), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, r) {
    da(n), this.freeze();
    const i = this.transformers;
    return !r && typeof t == "function" && (r = t, t = void 0), r ? a(void 0, r) : new Promise(a);
    function a(o, l) {
      const s = yn(t);
      i.run(n, s, u);
      function u(c, d, p) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || n
        );
        c ? l(c) : o ? o(h) : r(void 0, h, p);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let r = !1, i;
    return this.run(n, t, a), fa("runSync", "run", r), i;
    function a(o, l) {
      ra(o), i = l, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const r = yn(t), i = this.compiler || this.Compiler;
    return ar("stringify", i), da(n), i(n, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const r = this.attachers, i = this.namespace;
    if (or("use", this.frozen), n != null) if (typeof n == "function")
      s(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : o(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function a(u) {
      if (typeof u == "function")
        s(u, []);
      else if (typeof u == "object")
        if (Array.isArray(u)) {
          const [c, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            u
          );
          s(c, d);
        } else
          o(u);
      else
        throw new TypeError("Expected usable value, not `" + u + "`");
    }
    function o(u) {
      if (!("plugins" in u) && !("settings" in u))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(u.plugins), u.settings && (i.settings = er(!0, i.settings, u.settings));
    }
    function l(u) {
      let c = -1;
      if (u != null) if (Array.isArray(u))
        for (; ++c < u.length; ) {
          const d = u[c];
          a(d);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + u + "`");
    }
    function s(u, c) {
      let d = -1, p = -1;
      for (; ++d < r.length; )
        if (r[d][0] === u) {
          p = d;
          break;
        }
      if (p === -1)
        r.push([u, ...c]);
      else if (c.length > 0) {
        let [h, ...y] = c;
        const C = r[p][1];
        Or(C) && Or(h) && (h = er(!0, C, h)), r[p] = [u, h, ...y];
      }
    }
  }
}
const ud = new gi().freeze();
function ir(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function ar(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function or(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function da(e) {
  if (!Or(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function fa(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function yn(e) {
  return cd(e) ? e : new vl(e);
}
function cd(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function dd(e) {
  return typeof e == "string" || fd(e);
}
function fd(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const hd = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", ha = [], pa = { allowDangerousHtml: !0 }, pd = /^(https?|ircs?|mailto|xmpp)$/i, md = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function sn(e) {
  const n = e.allowedElements, t = e.allowElement, r = e.children || "", i = e.className, a = e.components, o = e.disallowedElements, l = e.rehypePlugins || ha, s = e.remarkPlugins || ha, u = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...pa } : pa, c = e.skipHtml, d = e.unwrapDisallowed, p = e.urlTransform || gd, h = ud().use(Yc).use(s).use(q2, u).use(l), y = new vl();
  typeof r == "string" && (y.value = r);
  for (const x of md)
    Object.hasOwn(e, x.from) && ("" + x.from + (x.to ? "use `" + x.to + "` instead" : "remove it") + hd + x.id, void 0);
  const C = h.parse(y);
  let $ = h.runSync(C, y);
  return i && ($ = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      $.type === "root" ? $.children : [$]
    )
  }), yl($, m), P1($, {
    Fragment: Fe,
    components: a,
    ignoreInvalidStyle: !0,
    jsx: f,
    jsxs: P,
    passKeys: !0,
    passNode: !0
  });
  function m(x, A, I) {
    if (x.type === "raw" && I && typeof A == "number")
      return c ? I.children.splice(A, 1) : I.children[A] = { type: "text", value: x.value }, A;
    if (x.type === "element") {
      let b;
      for (b in Yn)
        if (Object.hasOwn(Yn, b) && Object.hasOwn(x.properties, b)) {
          const w = x.properties[b], S = Yn[b];
          (S === null || S.includes(x.tagName)) && (x.properties[b] = p(String(w || ""), b, x));
        }
    }
    if (x.type === "element") {
      let b = n ? !n.includes(x.tagName) : o ? o.includes(x.tagName) : !1;
      if (!b && t && typeof A == "number" && (b = !t(x, A, I)), b && I && typeof A == "number")
        return d && x.children ? I.children.splice(A, 1, ...x.children) : I.children.splice(A, 1), A;
    }
  }
}
function gd(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i > -1 && n > i || t > -1 && n > t || r > -1 && n > r || // It is a protocol, it should be allowed.
    pd.test(e.slice(0, n)) ? e : ""
  );
}
const jg = (e) => {
  const { message: n, className: t, children: r, ...i } = e;
  let a = n ? /* @__PURE__ */ f(sn, { rehypePlugins: [on], children: n }) : r;
  return !n && r && typeof r == "string" && (a = /* @__PURE__ */ f(sn, { rehypePlugins: [on], children: r })), /* @__PURE__ */ f("div", { className: `${Ls.userChatMessage} ${t ?? ""}`, ...i, children: a });
}, yd = "_lawyerChatMessage_mfjjx_1", $d = {
  lawyerChatMessage: yd
}, Hg = (e) => {
  const { message: n, className: t, children: r, ...i } = e;
  let a = n ? /* @__PURE__ */ f(sn, { rehypePlugins: [on], children: n }) : r;
  return !n && r && typeof r == "string" && (a = /* @__PURE__ */ f(sn, { rehypePlugins: [on], children: r })), /* @__PURE__ */ f("div", { className: `${$d.lawyerChatMessage} ${t ?? ""}`, ...i, children: a });
}, vd = "_questionsWrapper_w7vjg_20", Cd = "_questions_w7vjg_20", bd = "_expanded_w7vjg_42", Ad = "_question_w7vjg_20", wd = "_addQuestion_w7vjg_60", xd = "_inputQuestion_w7vjg_71", _d = "_inputWrapper_w7vjg_83", Nd = "_rotateSpinner_w7vjg_1", Id = "_dash_w7vjg_1", Ed = "_active_w7vjg_133", Sd = "_cancelQuestion_w7vjg_139", Pd = "_seeMore_w7vjg_152", kd = "_seeMoreText_w7vjg_172", Od = "_errorContainer_w7vjg_197", Le = {
  questionsWrapper: vd,
  questions: Cd,
  expanded: bd,
  question: Ad,
  addQuestion: wd,
  inputQuestion: xd,
  inputWrapper: _d,
  rotateSpinner: Nd,
  dash: Id,
  active: Ed,
  cancelQuestion: Sd,
  seeMore: Pd,
  seeMoreText: kd,
  errorContainer: Od
}, Td = (e) => {
  const { questions: n, onAddQuestion: t, pending: r, error: i, disabled: a } = e, { t: o } = Te(), l = Y.useRef(r), [s, u] = Y.useState(!1), [c, d] = Y.useState(!1), [p, h] = Y.useState(""), y = (m) => {
    h(m.target.value);
  }, C = te(() => {
    p.trim() && t(p.trim());
  }, [t, p]), $ = te(
    (m) => {
      m.key === "Enter" && m.shiftKey === !1 && C();
    },
    [C]
  );
  return ce(() => {
    l.current && !r && (i || (h(""), u(!1))), l.current = r;
  }, [i, r]), /* @__PURE__ */ P("div", { className: Le.questionsWrapper, children: [
    /* @__PURE__ */ P("div", { className: `${Le.questions} ${c ? Le.expanded : ""}`, children: [
      n.map((m) => /* @__PURE__ */ f("div", { className: Le.question, children: m.question })),
      !a && s ? /* @__PURE__ */ P(Fe, { children: [
        /* @__PURE__ */ P(
          "div",
          {
            className: `${Le.question} ${Le.inputQuestion}`,
            children: [
              /* @__PURE__ */ P("div", { className: Le.inputWrapper, children: [
                r ? /* @__PURE__ */ f("svg", { viewBox: "0 0 50 50", fill: "none", children: /* @__PURE__ */ f("circle", { cx: "25", cy: "25", r: "20", strokeWidth: "5" }) }) : null,
                /* @__PURE__ */ f(
                  "textarea",
                  {
                    value: p,
                    onChange: y,
                    placeholder: o("chat.add-question-placeholder"),
                    onKeyDown: $,
                    disabled: r,
                    autoFocus: !0
                  }
                )
              ] }),
              /* @__PURE__ */ P(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  className: p.trim() && !r ? Le.active : "",
                  onClick: C,
                  children: [
                    /* @__PURE__ */ f(
                      "path",
                      {
                        d: "M14.375 6.25C14.7202 6.25 15 6.52982 15 6.875C15 7.04757 14.9301 7.2038 14.817 7.3169L8.56699 13.5669C8.45388 13.68 8.29761 13.75 8.125 13.75C7.94944 13.75 7.79079 13.6776 7.67726 13.5611L5.18893 11.0727C5.07238 10.9592 5 10.8006 5 10.625C5 10.2798 5.27982 10 5.625 10C5.79759 10 5.95385 10.07 6.06695 10.1831L8.12505 12.2411L13.9302 6.4359C14.0436 6.32113 14.201 6.25 14.375 6.25Z",
                        fill: "#DDDDDD"
                      }
                    ),
                    /* @__PURE__ */ f(
                      "path",
                      {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10ZM16.875 10C16.875 13.797 13.797 16.875 10 16.875C6.20304 16.875 3.125 13.797 3.125 10C3.125 6.20304 6.20304 3.125 10 3.125C13.797 3.125 16.875 6.20304 16.875 10Z",
                        fill: "#DDDDDD"
                      }
                    )
                  ]
                }
              ),
              i && !r && c ? /* @__PURE__ */ P("div", { className: Le.errorContainer, children: [
                /* @__PURE__ */ P(
                  "svg",
                  {
                    width: "25",
                    height: "24",
                    viewBox: "0 0 25 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                      /* @__PURE__ */ f(
                        "path",
                        {
                          d: "M13.25 7.5V13.5C13.25 13.9142 12.9142 14.25 12.5 14.25C12.0858 14.25 11.75 13.9142 11.75 13.5V7.5C11.75 7.08579 12.0858 6.75 12.5 6.75C12.9142 6.75 13.25 7.08579 13.25 7.5Z",
                          fill: "#191919"
                        }
                      ),
                      /* @__PURE__ */ f(
                        "path",
                        {
                          d: "M13.25 16.5C13.25 16.9142 12.9142 17.25 12.5 17.25C12.0858 17.25 11.75 16.9142 11.75 16.5C11.75 16.0858 12.0858 15.75 12.5 15.75C12.9142 15.75 13.25 16.0858 13.25 16.5Z",
                          fill: "#191919"
                        }
                      ),
                      /* @__PURE__ */ f(
                        "path",
                        {
                          fillRule: "evenodd",
                          clipRule: "evenodd",
                          d: "M22.25 12C22.25 17.3848 17.8848 21.75 12.5 21.75C7.11522 21.75 2.75 17.3848 2.75 12C2.75 6.61522 7.11522 2.25 12.5 2.25C17.8848 2.25 22.25 6.61522 22.25 12ZM20.75 12C20.75 16.5563 17.0563 20.25 12.5 20.25C7.94365 20.25 4.25 16.5563 4.25 12C4.25 7.44365 7.94365 3.75 12.5 3.75C17.0563 3.75 20.75 7.44365 20.75 12Z",
                          fill: "#191919"
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ f("div", { className: Le.errorText, children: i })
              ] }) : null
            ]
          }
        ),
        /* @__PURE__ */ f("div", { className: `${Le.question} ${Le.cancelQuestion}`, children: /* @__PURE__ */ f("span", { onClick: () => u(!s), children: "Cancel" }) })
      ] }) : a ? null : /* @__PURE__ */ P(
        "div",
        {
          className: `${Le.question} ${Le.addQuestion}`,
          onClick: () => u(!s),
          children: [
            "Add your own question",
            /* @__PURE__ */ P(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                children: [
                  /* @__PURE__ */ f(
                    "rect",
                    {
                      x: "0.5",
                      y: "0.5",
                      width: "15",
                      height: "15",
                      rx: "7.5",
                      stroke: "#666666"
                    }
                  ),
                  /* @__PURE__ */ f(
                    "path",
                    {
                      d: "M8.5 4C8.5 3.72386 8.27614 3.5 8 3.5C7.72386 3.5 7.5 3.72386 7.5 4V7.5H4C3.72386 7.5 3.5 7.72386 3.5 8C3.5 8.27614 3.72386 8.5 4 8.5H7.5V12C7.5 12.2761 7.72386 12.5 8 12.5C8.27614 12.5 8.5 12.2761 8.5 12V8.5H12C12.2761 8.5 12.5 8.27614 12.5 8C12.5 7.72386 12.2761 7.5 12 7.5H8.5V4Z",
                      fill: "#666666"
                    }
                  )
                ]
              }
            )
          ]
        }
      )
    ] }),
    c ? null : /* @__PURE__ */ f("div", { className: `${Le.seeMore} ${c ? Le.expanded : ""}`, children: /* @__PURE__ */ f(
      "div",
      {
        className: Le.seeMoreText,
        onClick: () => d(!c),
        children: c ? /* @__PURE__ */ f(Fe, { children: o("chat.see-less") }) : /* @__PURE__ */ f(Fe, { children: o("chat.see-more") })
      }
    ) })
  ] });
}, Ld = "_chatInputContainer_14avl_1", Fd = "_shinyBorderContainer_14avl_8", Md = "_moveGradient_14avl_1", Rd = "_chatInput_14avl_1", Dd = "_shinyBorder_14avl_8", Bd = "_actions_14avl_66", jd = "_disabled_14avl_86", Hd = "_inputs_14avl_90", Vd = "_noFiles_14avl_103", zd = "_message_14avl_103", Wd = "_files_14avl_160", Ud = "_fileInput_14avl_175", qd = "_attachButton_14avl_186", Zd = "_hasText_14avl_218", Gd = "_sendButton_14avl_221", Ze = {
  chatInputContainer: Ld,
  shinyBorderContainer: Fd,
  moveGradient: Md,
  chatInput: Rd,
  shinyBorder: Dd,
  actions: Bd,
  disabled: jd,
  inputs: Hd,
  noFiles: Vd,
  message: zd,
  files: Wd,
  fileInput: Ud,
  attachButton: qd,
  hasText: Zd,
  sendButton: Gd
}, Qd = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M10.5004 12H5.00043M4.91577 12.2915L2.58085 19.2662C2.39742 19.8142 2.3057 20.0881 2.37152 20.2569C2.42868 20.4034 2.55144 20.5145 2.70292 20.5567C2.87736 20.6054 3.14083 20.4869 3.66776 20.2497L20.3792 12.7296C20.8936 12.4981 21.1507 12.3824 21.2302 12.2216C21.2993 12.082 21.2993 11.9181 21.2302 11.7784C21.1507 11.6177 20.8936 11.5019 20.3792 11.2705L3.66193 3.74776C3.13659 3.51135 2.87392 3.39315 2.69966 3.44164C2.54832 3.48375 2.42556 3.59454 2.36821 3.74078C2.30216 3.90917 2.3929 4.18255 2.57437 4.72931L4.91642 11.7856C4.94759 11.8795 4.96317 11.9264 4.96933 11.9744C4.97479 12.0171 4.97473 12.0602 4.96916 12.1028C4.96289 12.1508 4.94718 12.1977 4.91577 12.2915Z", stroke: "#0E5FE3", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" })), Kd = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M17.5 5.25581V16.5C17.5 19.5376 15.0376 22 12 22C8.96243 22 6.5 19.5376 6.5 16.5V5.66667C6.5 3.64162 8.14162 2 10.1667 2C12.1917 2 13.8333 3.64162 13.8333 5.66667V16.4457C13.8333 17.4583 13.0125 18.2791 12 18.2791C10.9875 18.2791 10.1667 17.4583 10.1667 16.4457V6.65116", stroke: "#666666", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" })), Yd = "_chips_3yd1m_20", Xd = "_fileChip_3yd1m_26", Jd = "_uploaded_3yd1m_49", e0 = "_fileName_3yd1m_52", t0 = "_crossCircleIcon_3yd1m_55", n0 = "_folderIconContainer_3yd1m_58", r0 = "_folderIcon_3yd1m_58", i0 = "_loading_3yd1m_107", a0 = "_loadingIcon_3yd1m_120", o0 = "_rotateSpinner_3yd1m_1", l0 = "_dash_3yd1m_1", $t = {
  chips: Yd,
  fileChip: Xd,
  uploaded: Jd,
  fileName: e0,
  crossCircleIcon: t0,
  folderIconContainer: n0,
  folderIcon: r0,
  loading: i0,
  loadingIcon: a0,
  rotateSpinner: o0,
  dash: l0
}, s0 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "#666666", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/file-generic" }, /* @__PURE__ */ _.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M11.8438 4.12926L11.8921 4.17752C12.0528 4.33827 12.1431 4.55628 12.1431 4.78361V12.1429C12.1431 12.6162 11.7594 13 11.286 13H2.71456C2.24118 13 1.85742 12.6162 1.85742 12.1429V1.85714C1.85742 1.38376 2.24118 1 2.71456 1H8.35952C8.58685 1 8.80487 1.09031 8.96562 1.25105L9.01381 1.29924C9.01508 1.30049 9.01635 1.30174 9.01761 1.303L11.8401 4.12548C11.8413 4.12674 11.8426 4.128 11.8438 4.12926ZM11.286 12.1429H2.71456L2.71456 1.85714H8.28599V4.42853C8.28599 4.66522 8.47787 4.8571 8.71457 4.8571H11.286V12.1429Z" }))), u0 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#CCCCCC", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M8.78038 16.2803C8.64465 16.416 8.45713 16.5 8.25 16.5C7.83579 16.5 7.5 16.1642 7.5 15.75C7.5 15.5412 7.58535 15.3523 7.72308 15.2163L10.9394 12L7.72672 8.78729C7.58686 8.65105 7.5 8.46067 7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5C8.45711 7.5 8.64462 7.58395 8.78034 7.71968L12.0001 10.9393L15.2163 7.72308C15.3523 7.58535 15.5412 7.5 15.75 7.5C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 8.45708 16.4161 8.64456 16.2804 8.78028L13.0607 12L16.2804 15.2196C16.4161 15.3554 16.5 15.5429 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5C15.5393 16.5 15.349 16.4131 15.2127 16.2733L12.0001 13.0606L8.78038 16.2803Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25Z" })), c0 = (e) => /* @__PURE__ */ _.createElement("svg", { className: "spinner", viewBox: "0 0 50 50", fill: "none", ...e }, /* @__PURE__ */ _.createElement("circle", { className: "path", cx: 25, cy: 25, r: 20, strokeWidth: 5 })), d0 = (e) => {
  const { filename: n, disabled: t, removeFile: r } = e;
  return /* @__PURE__ */ P(
    "button",
    {
      className: `${$t.fileChip} ${t === !1 ? $t.uploaded : ""}`,
      onClick: r,
      disabled: t,
      children: [
        /* @__PURE__ */ f("div", { className: $t.folderIconContainer, children: /* @__PURE__ */ f(s0, { className: $t.folderIcon }) }),
        /* @__PURE__ */ f("div", { className: $t.fileName, children: n }),
        /* @__PURE__ */ f(u0, { className: $t.crossCircleIcon }),
        t && /* @__PURE__ */ f("div", { className: $t.loading, children: /* @__PURE__ */ f(c0, { className: $t.loadingIcon }) })
      ]
    }
  );
}, ma = (e) => {
  const n = e.name.replace(/([^a-zA-Z0-9-_. ])/g, "_");
  return new File([e], n, { type: e.type });
}, f0 = ({ children: e }) => /* @__PURE__ */ f("div", { className: Ze.shinyBorderContainer, children: e });
function h0(e) {
  const [n, t] = de(!1);
  return ce(() => {
    if (typeof window < "u") {
      const r = window.matchMedia(e);
      t(r.matches);
      const i = () => {
        t(r.matches);
      };
      return window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
    }
  }, [e]), n;
}
const p0 = $e((e, n) => {
  const {
    onSendMessage: t,
    className: r,
    inputsClassName: i,
    chatInputClassName: a,
    disabled: o,
    disableFileInput: l,
    failedFiles: s,
    onInput: u,
    placeholder: c,
    sendOnEnter: d,
    shiny: p = !1
  } = e, { t: h } = Te(), y = _e(null), [C, $] = _.useState(""), m = _e(null), [x, A] = _.useState([]), I = _e(null), b = _.useRef(null), w = h0("(min-width: 769px)"), S = p && w, O = async (V = void 0) => {
    var ae;
    if (V == null || V.preventDefault(), V == null || V.stopPropagation(), !o)
      try {
        (ae = b.current) == null || ae.focus(), await t({ text: C, files: x }), $(""), A([]);
      } catch {
      }
  }, N = (V) => {
    d && V.key === "Enter" && !V.shiftKey && (V.preventDefault(), O());
  }, R = () => {
    const V = b.current;
    V && (V.style.height = "auto", V.style.height = `${V.scrollHeight}px`), V && I.current && (V.style.height = "auto", V.style.height = `${V.scrollHeight}px`);
  };
  ce(() => {
    R();
  }, [C]);
  const T = (V) => {
    V.preventDefault(), m.current && m.current.click();
  }, E = te(
    (V) => {
      var g;
      const ae = (g = V.clipboardData) == null ? void 0 : g.items;
      if (ae) {
        const z = [];
        for (let J = 0; J < ae.length; J++)
          if (ae[J].kind === "file") {
            const v = ae[J].getAsFile();
            v && z.push(v);
          }
        z.length && (A([...x, ...z]), V.preventDefault());
      }
    },
    [x, A]
  ), L = te(
    (V) => {
      if (m.current) {
        const ae = V.map(ma);
        A([...x, ...ae]);
      }
    },
    [x]
  );
  zt(
    n,
    () => ({
      ...y.current,
      // Spread the HTMLDivElement properties
      inputContainerRef: y,
      addFiles: L,
      setMessage: $,
      focus: () => {
        var V;
        return (V = b.current) == null ? void 0 : V.focus();
      }
    })
  );
  const W = te(
    (V) => {
      const ae = [...x];
      ae.splice(V, 1), A(ae);
    },
    [x, A]
  );
  ce(() => {
    var V;
    o ? ($(""), A([])) : (V = b.current) == null || V.focus({
      preventScroll: !0
    });
  }, [o]);
  const D = te(
    (V) => {
      const ae = Array.from(V.target.files ?? []).map(ma);
      A((g) => [...g, ...ae]);
    },
    []
  );
  ce(() => {
    s && A((V) => V.filter((ae) => !s.includes(ae)));
  }, [s]);
  const H = te(
    (V) => {
      if (o)
        $("");
      else {
        const ae = C;
        $(V), b.current && ae.slice(-1) !== V.slice(-1) && (b.current.scrollTop = b.current.scrollHeight);
      }
    },
    [o, C]
  ), ee = ht(() => /* @__PURE__ */ P(
    "div",
    {
      className: `${Ze.chatInput} ${o ? Ze.disabled : ""} ${a ?? ""}`,
      id: "chat-input",
      ref: y,
      children: [
        /* @__PURE__ */ f(
          "input",
          {
            ref: m,
            type: "file",
            className: Ze.fileInput,
            multiple: !0,
            onChange: D,
            disabled: o
          }
        ),
        /* @__PURE__ */ P(
          "div",
          {
            ref: I,
            className: `${Ze.inputs} ${l ? Ze.noFiles : ""} ${i ?? ""}`,
            children: [
              /* @__PURE__ */ f(
                "textarea",
                {
                  ref: b,
                  className: Ze.message,
                  value: C,
                  onChange: (V) => H(V.target.value),
                  onKeyDown: N,
                  rows: 1,
                  placeholder: c || h("chat.input-placeholder"),
                  autoFocus: !0,
                  onPaste: E,
                  onInput: u
                }
              ),
              x && (x == null ? void 0 : x.length) > 0 && !o ? /* @__PURE__ */ f("div", { className: Ze.files, children: x.map((V, ae) => /* @__PURE__ */ f(
                d0,
                {
                  filename: V.name,
                  removeFile: () => W(ae)
                },
                V.name
              )) }) : null
            ]
          }
        ),
        /* @__PURE__ */ P("div", { className: Ze.actions, children: [
          l ? null : /* @__PURE__ */ f("button", { className: Ze.attachButton, onClick: T, children: /* @__PURE__ */ f(Kd, {}) }),
          /* @__PURE__ */ f(
            "button",
            {
              className: `${Ze.sendButton} ${C.trim() ? Ze.hasText : ""}`,
              onClick: O,
              children: /* @__PURE__ */ f(Qd, {})
            }
          )
        ] })
      ]
    }
  ), [
    o,
    l,
    C,
    x,
    c,
    h,
    H,
    N,
    E,
    u,
    W,
    T,
    O,
    a,
    i
  ]);
  return /* @__PURE__ */ f("div", { className: `${Ze.chatInputContainer} ${r ?? ""}`, children: S ? /* @__PURE__ */ f(f0, { children: ee }) : ee });
}), m0 = "_chat_q7zz7_1", g0 = "_body_q7zz7_10", y0 = "_loadingMessage_q7zz7_39", $0 = "_loader_q7zz7_50", v0 = "_dot_q7zz7_54", C0 = "_fade_q7zz7_1", b0 = "_messageWithAction_q7zz7_79", A0 = "_message_q7zz7_79", w0 = "_formWrapper_q7zz7_91", x0 = "_contactForm_q7zz7_104", _0 = "_chatEnded_q7zz7_107", N0 = "_input_q7zz7_129", I0 = "_messageWrapper_q7zz7_133", E0 = "_timestamp_q7zz7_144", S0 = "_right_q7zz7_162", P0 = "_show_q7zz7_167", Re = {
  chat: m0,
  body: g0,
  loadingMessage: y0,
  loader: $0,
  dot: v0,
  fade: C0,
  messageWithAction: b0,
  message: A0,
  formWrapper: w0,
  contactForm: x0,
  chatEnded: _0,
  input: N0,
  messageWrapper: I0,
  timestamp: E0,
  right: S0,
  show: P0
}, k0 = "_chatElementMessageContainer_149m5_1", O0 = "_sender_149m5_6", T0 = "_messageWrapper_149m5_9", L0 = "_avatarIconContainer_149m5_13", F0 = "_avatarIcon_149m5_13", M0 = "_buttonWrapper_149m5_33", R0 = "_button_149m5_33", Ee = {
  chatElementMessageContainer: k0,
  sender: O0,
  messageWrapper: T0,
  avatarIconContainer: L0,
  avatarIcon: F0,
  buttonWrapper: M0,
  button: R0
}, D0 = "_messageWrapper_1x1m0_1", B0 = "_left_1x1m0_14", j0 = "_message_1x1m0_1", H0 = "_right_1x1m0_21", V0 = "_relativeWrapper_1x1m0_30", z0 = "_relativeContainer_1x1m0_35", W0 = "_timestampContainer_1x1m0_43", U0 = "_show_1x1m0_57", q0 = "_timestamp_1x1m0_43", Z0 = "_senderContainer_1x1m0_111", G0 = "_withExternalBody_1x1m0_136", Q0 = "_expandMargin_1x1m0_140", K0 = "_noExternalBody_1x1m0_157", Y0 = "_avatarIconContainer_1x1m0_186", we = {
  messageWrapper: D0,
  left: B0,
  message: j0,
  right: H0,
  relativeWrapper: V0,
  relativeContainer: z0,
  timestampContainer: W0,
  show: U0,
  timestamp: q0,
  senderContainer: Z0,
  withExternalBody: G0,
  expandMargin: Q0,
  noExternalBody: K0,
  avatarIconContainer: Y0
}, X0 = "_fileTextContainer_eq8nc_1", J0 = "_fileName_eq8nc_7", e3 = "_full_eq8nc_13", t3 = "_icon_eq8nc_16", n3 = "_loadingContainer_eq8nc_20", r3 = "_loadingIconContainer_eq8nc_26", i3 = "_loadingIcon_eq8nc_26", a3 = "_rotateSpinner_eq8nc_1", o3 = "_dash_eq8nc_1", l3 = "_text_eq8nc_47", s3 = "_receiver_eq8nc_77", u3 = "_filePreviewContainer_eq8nc_90", c3 = "_contextMenuContainer_eq8nc_100", d3 = "_contextMenu_eq8nc_100", f3 = "_fileImageContainer_eq8nc_111", h3 = "_fileImage_eq8nc_111", p3 = "_textContent_eq8nc_129", m3 = "_sender_eq8nc_144", g3 = "_noPreviewContainer_eq8nc_166", y3 = "_bgOverlay_eq8nc_174", Se = {
  fileTextContainer: X0,
  fileName: J0,
  full: e3,
  icon: t3,
  loadingContainer: n3,
  loadingIconContainer: r3,
  loadingIcon: i3,
  rotateSpinner: a3,
  dash: o3,
  text: l3,
  receiver: s3,
  filePreviewContainer: u3,
  contextMenuContainer: c3,
  contextMenu: d3,
  fileImageContainer: f3,
  fileImage: h3,
  textContent: p3,
  sender: m3,
  noPreviewContainer: g3,
  bgOverlay: y3
}, $3 = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#103F91", fillRule: "evenodd", d: "M13 21.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#185ABD", fillRule: "evenodd", d: "M13 18.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#2B7CD3", fillRule: "evenodd", d: "M13 15.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#41A5EE", fillRule: "evenodd", d: "M13 12.5c0-.2761.2558-.5.5714-.5h6.8572c.3156 0 .5714.2239.5714.5s-.2558.5-.5714.5h-6.8572c-.3156 0-.5714-.2239-.5714-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#185ABD", d: "M3.28571 22h9.42859c.341 0 .668-.1355.9091-.3766.2411-.2411.3766-.5681.3766-.9091v-9.4286c0-.341-.1355-.668-.3766-.9091-.2411-.2411-.5681-.3766-.9091-.3766H3.28571c-.34099 0-.66801.1355-.90913.3766-.24112.2411-.37658.5681-.37658.9091v9.4286c0 .341.13546.668.37658.9091.24112.2411.56814.3766.90913.3766Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#F9F7F7", d: "M6.66125 17.9114h.0165C6.6845 17.8129 7.5275 13 7.5275 13h.9795s.855 4.5883.88125 4.9029H9.401c.01125-.216.708-4.9029.708-4.9029H11l-1.0965 6H8.86175s-.86475-4.74-.8715-4.824h-.0135C7.96925 14.2729 7.1645 19 7.1645 19H6.107L5 13h.9075s.75 4.806.75375 4.9114Z" }))), v3 = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#C8C6C4", fillRule: "evenodd", d: "M10.4545 12c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091ZM10 15.5c0-.2761.2035-.5.4545-.5h9.091c.251 0 .4545.2239.4545.5s-.2035.5-.4545.5h-9.091c-.251 0-.4545-.2239-.4545-.5Zm.4545 2.5c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Zm0 3c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Z", clipRule: "evenodd" }))), C3 = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M4.28571 22h9.42859c.341 0 .668-.1355.9091-.3766.2411-.2411.3766-.5681.3766-.9091v-9.4286c0-.341-.1355-.668-.3766-.9091-.2411-.2411-.5681-.3766-.9091-.3766H4.28571c-.34099 0-.66801.1355-.90913.3766-.24112.2411-.37658.5681-.37658.9091v9.4286c0 .341.13546.668.37658.9091.24112.2411.56814.3766.90913.3766Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M13.7143 23H4.28571c-.60621 0-1.18759-.2408-1.61624-.6695C2.24082 21.9019 2 21.3205 2 20.7143v-9.4286c0-.6062.24082-1.1876.66947-1.61623C3.09812 9.24082 3.67951 9 4.28571 9h9.42859c.6062 0 1.1876.24082 1.6162.66947.4287.42863.6695 1.01003.6695 1.61623v9.4286c0 .6062-.2408 1.1876-.6695 1.6162-.4286.4287-1.01.6695-1.6162.6695Zm0-1H4.28571c-.34099 0-.66801-.1355-.90913-.3766C3.13546 21.3823 3 21.0553 3 20.7143v-9.4286c0-.341.13546-.668.37658-.9091.24112-.2411.56814-.3766.90913-.3766h9.42859c.341 0 .668.1355.9091.3766.2411.2411.3766.5681.3766.9091v9.4286c0 .341-.1355.668-.3766.9091-.2411.2411-.5681.3766-.9091.3766Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#A6CCC3", d: "m9.86848 16.228-.84379 1.1999-1.35011-1.8089c-.02779-.0372-.06282-.0672-.10255-.0877-.03972-.0206-.08315-.0313-.12714-.0313-.04398 0-.08741.0107-.12713.0313-.03973.0205-.07476.0505-.10255.0877l-2.15248 2.8836c-.15021.2019-.01371.4974.22983.4974h6.41484c.2398 0 .3774-.2872.2348-.4901l-1.6041-2.2819c-.0277-.0393-.0632-.0712-.1039-.0931-.0407-.0219-.0855-.0333-.1309-.0333-.0454 0-.0902.0114-.13096.0333-.04071.0219-.07625.0538-.10386.0931Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#FF9810", d: "M11.5 15c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z" }))), b3 = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#D65532", d: "M4.91667 22h4.85416c.06078 0 .11907-.0101.16205-.0492.04298-.0391.06712-.0681.06712-.1234v-4.5833c0-.0553-.02414-.1455-.06712-.1845C9.8899 17.0205 9.83161 17 9.77083 17H4.91667c-.24312 0-.47628.0878-.64818.2441-.17191.1563-.26849.3682-.26849.5892v3.3334c0 .221.09658.4329.26849.5892.1719.1563.40506.2441.64818.2441Zm20.16663-5h-4.8541c-.0608 0-.1191.0219-.1621.061-.043.0391-.0671.0921-.0671.1473v4.5834c0 .115.1027.2083.2292.2083h4.8541c.2431 0 .4763-.0878.6482-.2441S26 21.3877 26 21.1667v-3.3334c0-.221-.0966-.4329-.2685-.5892-.1719-.1563-.4051-.2441-.6482-.2441Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#D65532", fillRule: "evenodd", d: "M11 17.5848C11 16.7095 11.613 16 12.3691 16h5.2618C18.387 16 19 16.7095 19 17.5848v3.8304C19 22.2905 18.387 23 17.6309 23h-5.2618C11.613 23 11 22.2905 11 21.4152v-3.8304ZM12.4564 17c-.2521 0-.4564.293-.4564.5848v3.8304c0 .2918.2043.5848.4564.5848h5.1745c.252 0 .3691-.293.3691-.5848v-3.8304c0-.2918-.1171-.5848-.3691-.5848h-5.1745Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#C8C6C4", fillRule: "evenodd", d: "M10.4545 11c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Zm0 3c-.251 0-.4545.2239-.4545.5s.2035.5.4545.5h9.091c.251 0 .4545-.2239.4545-.5s-.2035-.5-.4545-.5h-9.091Z", clipRule: "evenodd" }))), A3 = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#134A2C", fillRule: "evenodd", d: "M17 21.5c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#21A366", fillRule: "evenodd", d: "M17 18.5c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#33C481", fillRule: "evenodd", d: "M17 15.5c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Zm0-3c0-.2761.2239-.5.5-.5h3c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-3c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#185C37", fillRule: "evenodd", d: "M13 21.5c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#107C41", fillRule: "evenodd", d: "M13 18.5c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#21A366", fillRule: "evenodd", d: "M13 15.5c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Zm0-3c0-.2761.2239-.5.5-.5h2c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-2c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#107C41", d: "M3.09091 22h9.81819c.2893 0 .5668-.1149.7714-.3195S14 21.1984 14 20.9091v-9.8182c0-.2893-.1149-.5668-.3195-.7714S13.1984 10 12.9091 10H3.09091c-.28933 0-.56681.1149-.77139.3195-.20459.2046-.31952.4821-.31952.7714v9.8182c0 .2893.11493.5668.31952.7714.20458.2046.48206.3195.77139.3195Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#F9F7F7", d: "m5.00056 19 2.17305-3.0085L5.18283 13h1.60199l1.08681 1.9125c.09987.181.16815.3165.20596.4055h.01411c.07166-.145.14671-.286.22458-.4225L9.4787 13h1.47l-2.04275 2.975L11 19H9.43581l-1.25552-2.1c-.05906-.0894-.1091-.1833-.14954-.2805h-.01862c-.03636.0952-.08502.1863-.14502.2715L6.57434 19H5h.00056Z" }))), w3 = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2h10.3512v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874V2c.4897.00011.9448.20883 1.2691.55575m0 0 4.1249 4.41129c0 .00004-.0001-.00003 0 0 .3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486H23c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-4.6549c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#C8C6C4", fillRule: "evenodd", d: "M10 11.5c0-.2761.2239-.5.5-.5h9c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-9c-.2761 0-.5-.2239-.5-.5Zm0 3c0-.2761.2239-.5.5-.5h9c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-9c-.2761 0-.5-.2239-.5-.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#185ABD", d: "M5 17c0-.5523.44772-1 1-1h12.9847c.5523 0 1 .4477 1 1v5.0431c0 .5523-.4477 1-1 1H6c-.55228 0-1-.4477-1-1V17Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M7.89258 17.9h1.54651c.03942.0306.15135.1604.15135.6298 0 .3601-.07468.5081-.10844.5538l-.00359.0048H7.89258V17.9Zm-.4-.8h2.01048c.50544.0133.88734.548.88734 1.4298 0 .4531-.0913.7941-.265 1.0292-.17149.2322-.41693.3457-.65033.3294h-.4855l1.29653 1.3239c.1546.1578.1519.4111-.0059.5656-.1578.1546-.4111.152-.56567-.0059l-1.82195-1.8604V21.5c0 .2209-.17908.4-.4.4-.22091 0-.4-.1791-.4-.4v-2.005l-.00005-.0066.00005-.0067v-1.9751L7.09253 17.5c0-.2209.17909-.4.4-.4h.00005Zm6.50002.8c.2209 0 .4-.1791.4-.4s-.1791-.4-.4-.4h-3c-.2209 0-.4.1791-.4.4s.1791.4.4.4h1.1002v3.6c0 .2209.1791.4.4.4s.4-.1791.4-.4v-3.6h1.0998Zm3.9-.4c0 .2209-.1791.4-.4.4h-1.5998v1.2h1.5998c.2209 0 .4.1791.4.4s-.1791.4-.4.4h-1.5998v1.6c0 .2209-.1791.4-.4.4s-.4-.1791-.4-.4v-1.9874l-.0002-.0126.0002-.0127v-1.9747l-.0002-.0126c0-.2209.1791-.4.4-.4h2c.2209 0 .4.1791.4.4Z", clipRule: "evenodd" }))), x3 = (e) => /* @__PURE__ */ _.createElement("svg", { className: "MuiSvgIcon-root", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...e }, /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ...e }, /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M18.1131 3H7.7619c-.20206 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33668.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141c-.1428-.15282-.3366-.23869-.5387-.23874Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M24 8.22622V24.1852c0 .4604-.1704.9144-.4927 1.2591-.3245.347-.7794.5557-1.2692.5557H7.7619c-.48977 0-.94473-.2087-1.26917-.5557C6.17042 25.0996 6 24.6456 6 24.1852V3.81481c0-.46046.17042-.91445.49273-1.25915C6.81717 2.20869 7.27213 2 7.7619 2H18v1H7.7619c-.20207 0-.39586.08585-.53874.23865C7.08027 3.39146 7 3.59871 7 3.81481V24.1852c0 .2161.08027.4233.22316.5761.14288.1529.33667.2387.53874.2387h14.4762c.2021 0 .3959-.0858.5387-.2387.1429-.1528.2232-.36.2232-.5761V8.22622c0-.21608-.0803-.4233-.2232-.57607l-4.125-4.41141C18.509 3.08592 18.2021 3.00005 18 3V2c.4897.00011 1.0579.20883 1.3822.55575m0 0 4.1249 4.41129c.3223.34462.4928.79881.4929 1.25918", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#979593", fillRule: "evenodd", d: "M17.5 2.5c.2761 0 .5.22386.5.5v4.61111c0 .11107.0422.21282.1099.28403.0669.07036.152.10486.2352.10486v1c-.3652 0-.7099-.1528-.96-.41584C17.1359 8.32198 17 7.97154 17 7.61111V3c0-.27614.2239-.5.5-.5Zm.8451 6V9H23c.2761 0 .5-.22386.5-.5S23.2761 8 23 8h-4.6549v.5Z", clipRule: "evenodd" }), /* @__PURE__ */ _.createElement("path", { fill: "#ED6C47", d: "M16.1818 16.625 15.5455 16h-1.9091L13 16.625v3.24c.7686.7287 1.7954 1.1356 2.8636 1.135 1.0971 0 2.1492-.428 2.9249-1.1899C19.5642 19.0483 20 18.0149 20 16.9375v-.3125h-3.8182Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#FF8F6B", d: "M15.7 13c-1.0077-.0009-1.9762.4343-2.7 1.2133V17h3v-4h-.3Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#FFC7B5", d: "M17 12v4h4c0-1.0609-.4214-2.0783-1.1716-2.8284C19.0783 12.4214 18.0609 12 17 12Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#C43E1C", d: "M3.28571 22h9.42859c.341 0 .668-.1355.9091-.3766.2411-.2411.3766-.5681.3766-.9091v-9.4286c0-.341-.1355-.668-.3766-.9091-.2411-.2411-.5681-.3766-.9091-.3766H3.28571c-.34099 0-.66801.1355-.90913.3766-.24112.2411-.37658.5681-.37658.9091v9.4286c0 .341.13546.668.37658.9091.24112.2411.56814.3766.90913.3766Z" }), /* @__PURE__ */ _.createElement("path", { fill: "#fff", d: "M8.45259 13c.8238 0 1.45349.1877 1.89181.5614.4365.3746.6556.9167.6556 1.6263 0 .4562-.1038.8649-.3202 1.2193-.2156.3553-.5277.6263-.92667.8228-.39893.1974-.85599.3-1.38104.3H7.05993L7.05546 20H6v-7h2.45259Zm-1.39713 3.4912H8.5c.44991 0 .79159-.1035 1.02236-.3096.23077-.207.39446-.5746.39446-.972 0-.771-.49017-1.35-1.37478-1.35H7.05546v2.6316Z" }))), _3 = "_fileIconContainer_1mrbn_1", N3 = {
  fileIconContainer: _3
}, I3 = (e) => {
  const { file: n, className: t, noContainer: r, containerClassName: i } = e;
  let a = "";
  if (n != null && n.id)
    a = n == null ? void 0 : n.mime;
  else {
    const l = e == null ? void 0 : e.file;
    a = l == null ? void 0 : l.type;
  }
  let o = null;
  if (a != null && a.startsWith("image/"))
    o = /* @__PURE__ */ f(C3, { className: t ?? "" });
  else
    switch (a) {
      case "application/pdf":
        o = /* @__PURE__ */ f(b3, { className: t ?? "" });
        break;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        o = /* @__PURE__ */ f($3, { className: t ?? "" });
        break;
      case "application/rtf":
        o = /* @__PURE__ */ f(w3, { className: t ?? "" });
        break;
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        o = /* @__PURE__ */ f(A3, { className: t ?? "" });
        break;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        o = /* @__PURE__ */ f(x3, { className: t ?? "" });
        break;
      default:
        o = /* @__PURE__ */ f(v3, { className: t ?? "" });
        break;
    }
  return r ? o : /* @__PURE__ */ f("div", { className: `${N3.fileIconContainer} ${i ?? ""}`, children: o });
}, E3 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 33, height: 32, viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/download export" }, /* @__PURE__ */ _.createElement("g", { id: "Union" }, /* @__PURE__ */ _.createElement("path", { d: "M6.5 13V23C6.5 23.5523 6.94772 24 7.5 24H25.5C26.0523 24 26.5 23.5523 26.5 23V13C26.5 12.4477 26.9477 12 27.5 12C28.0523 12 28.5 12.4477 28.5 13V23C28.5 24.6569 27.1569 26 25.5 26H7.5C5.84315 26 4.5 24.6569 4.5 23L4.5 13C4.5 12.4477 4.94772 12 5.5 12C6.05229 12 6.5 12.4477 6.5 13Z", fill: "#333333" }), /* @__PURE__ */ _.createElement("path", { d: "M22.5 14C22.5 14.2814 22.3838 14.5357 22.1967 14.7174L17.2184 19.6957C17.2147 19.6995 17.2109 19.7033 17.2071 19.7071C16.8166 20.0977 16.1834 20.0977 15.7929 19.7071L10.7929 14.7071C10.6932 14.6074 10.619 14.4919 10.5702 14.3687C10.5249 14.2546 10.5 14.1302 10.5 14C10.5 13.859 10.5292 13.7248 10.5818 13.6032C10.6231 13.5076 10.68 13.4172 10.7525 13.3358C10.7793 13.3056 10.8079 13.2771 10.8381 13.2504C10.9142 13.1831 10.998 13.1294 11.0865 13.0892C11.2125 13.0319 11.3525 13 11.5 13C11.6475 13 11.7875 13.0319 11.9135 13.0892C12.002 13.1294 12.0858 13.1831 12.1619 13.2504C12.179 13.2655 12.1955 13.2811 12.2116 13.2974L15.5 16.5858V7C15.5 6.44772 15.9477 6 16.5 6C17.0523 6 17.5 6.44772 17.5 7V16.5856L20.7928 13.2928C20.9738 13.1119 21.2239 13 21.5 13C22.0523 13 22.5 13.4477 22.5 14Z", fill: "#333333" })))), S3 = "_contextMenuWrapper_1fsmd_1", P3 = "_open_1fsmd_13", k3 = "_menuIcon_1fsmd_19", O3 = "_contextMenu_1fsmd_1", T3 = "_show_1fsmd_48", L3 = "_fixedPositioning_1fsmd_52", F3 = "_leftPositioning_1fsmd_57", M3 = "_contextMenuItem_1fsmd_68", R3 = "_disabled_1fsmd_84", D3 = "_label_1fsmd_91", B3 = "_icon_1fsmd_97", Qe = {
  contextMenuWrapper: S3,
  open: P3,
  menuIcon: k3,
  contextMenu: O3,
  show: T3,
  fixedPositioning: L3,
  leftPositioning: F3,
  contextMenuItem: M3,
  disabled: R3,
  label: D3,
  icon: B3
}, j3 = (e) => /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M8 5C8.55228 5 9 4.55228 9 4C9 3.44772 8.55228 3 8 3C7.44772 3 7 3.44772 7 4C7 4.55228 7.44772 5 8 5Z", fill: "#666666" }), /* @__PURE__ */ _.createElement("path", { d: "M9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8Z", fill: "#666666" }), /* @__PURE__ */ _.createElement("path", { d: "M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z", fill: "#666666" })), Cl = (e, n) => {
  ce(
    () => {
      const t = (r) => {
        !e.current || e.current.contains(r.target) || n(r);
      };
      return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), () => {
        document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [e, n]
  );
}, H3 = (e, n) => {
  ce(
    () => {
      const t = (r) => {
        e.some((i) => !i.current || i.current.contains(r.target)) || n(r);
      };
      return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), () => {
        document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [e, n]
  );
}, bl = (e) => {
  const {
    items: n,
    className: t,
    activeClassName: r,
    menuItemsClassName: i,
    fixedPositioning: a,
    positioning: o
  } = e, [l, s] = Y.useState(!1), u = _e(null), c = _e(null);
  H3([u, c], () => s(!1));
  const d = te(
    (h) => {
      if (h.preventDefault(), h.stopPropagation(), s((y) => !y), a && c.current && u.current) {
        const { top: y, height: C, left: $, width: m } = u.current.getBoundingClientRect();
        c.current.style.top = `${y + C}px`, c.current.style.setProperty(
          "--context-menu-parent-width",
          `${m}px`
        ), c.current.style.setProperty(
          "--context-menu-left-position",
          `${$}px`
        );
      }
    },
    [a]
  );
  ce(() => {
    if (a) {
      const h = () => s(!1);
      return window.addEventListener("scroll", h), () => window.removeEventListener("scroll", h);
    }
  }, [a]);
  const p = /* @__PURE__ */ f(
    "div",
    {
      className: `${Qe.contextMenu} 
    ${a ? Qe.fixedPositioning : ""} 
     ${o === "left" ? Qe.leftPositioning : ""} 
    ${l ? Qe.show : ""} 
    ${i ?? ""}
  `,
      ref: c,
      children: n.map((h, y) => /* @__PURE__ */ P(
        "div",
        {
          className: `${Qe.contextMenuItem} ${h.disabled ? Qe.disabled : ""} ${t ?? ""}`,
          onClick: (C) => {
            C.preventDefault(), C.stopPropagation(), h.disabled || (s(!1), h.onClick(C));
          },
          children: [
            /* @__PURE__ */ f("div", { className: Qe.label, children: h.label }),
            h.icon && /* @__PURE__ */ f("div", { className: Qe.icon, children: h.icon })
          ]
        },
        y
      ))
    }
  );
  return /* @__PURE__ */ P(
    "div",
    {
      className: `${Qe.contextMenuWrapper} ${t ?? ""} ${l ? `${Qe.open} ${a ? Qe.fixedPositioning : ""} ${r ?? ""}` : ""}`,
      onClick: d,
      ref: u,
      children: [
        /* @__PURE__ */ f(j3, { className: Qe.menuIcon }),
        a ? Ro(p, document.body) : p
      ]
    }
  );
}, V3 = (e) => {
  var $;
  const {
    file: n,
    receiver: t,
    className: r,
    previewClassName: i,
    receiverOverlayClassName: a,
    senderOverlayClassName: o,
    fixedPositioning: l,
    toggleTimestamp: s
  } = e, { t: u } = Te(), [c, d] = Y.useState(null), p = te((m) => m.replace(/(?:\r\n|\r|\n)/g, " "), []), h = te(() => {
    var x;
    const m = ((x = n.url) == null ? void 0 : x.path) ?? "";
    if (m) {
      const A = document.createElement("a");
      A.href = m, A.download = "", document.body.appendChild(A), A.click(), document.body.removeChild(A);
    } else
      console.error("File URL is missing.");
  }, [($ = n == null ? void 0 : n.url) == null ? void 0 : $.path]);
  if (!n)
    return null;
  let y = null;
  const C = /* @__PURE__ */ f(
    "div",
    {
      className: `${Se.textContent} ${Se.noPreviewContainer} ${t ? Se.receiver : Se.sender}`,
      children: /* @__PURE__ */ f("div", { className: Se.noPreview, children: u("chat.no-preview") })
    }
  );
  return c ? y = C : n.mime.startsWith("image/") && n.url ? y = /* @__PURE__ */ f(
    "div",
    {
      className: `${Se.fileImageContainer}
        ${t ? Se.receiver : ""}`,
      children: /* @__PURE__ */ f(
        "img",
        {
          src: n.url.path,
          alt: n.name,
          className: Se.fileImage,
          onError: () => d(!0)
        }
      )
    }
  ) : n.textContent ? y = /* @__PURE__ */ P(
    "div",
    {
      className: `${Se.textContent} ${t ? Se.receiver : Se.sender}`,
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            className: `${Se.bgOverlay} ${t ? a : o}`
          }
        ),
        p(n.textContent)
      ]
    }
  ) : y = C, /* @__PURE__ */ P(Fe, { children: [
    /* @__PURE__ */ P(
      "div",
      {
        className: `
        ${Se.fileName}
        ${t ? Se.receiver : ""}
        ${r ?? ""}
      `,
        onClick: s,
        children: [
          /* @__PURE__ */ f(I3, { file: n, className: Se.icon }),
          n == null ? void 0 : n.name
        ]
      }
    ),
    !c && /* @__PURE__ */ P(
      "div",
      {
        className: `
        ${Se.filePreviewContainer}
        ${t ? Se.receiver : ""}
        ${i ?? ""}
      `,
        children: [
          y,
          n.url ? /* @__PURE__ */ f("div", { className: Se.contextMenuContainer, children: /* @__PURE__ */ f(
            bl,
            {
              items: [
                {
                  label: u("lawyer.download"),
                  onClick: () => h(),
                  icon: /* @__PURE__ */ f(E3, { className: Se.downloadIcon })
                }
              ],
              className: Se.contextMenu,
              fixedPositioning: l,
              positioning: l ? t ? "left" : "right" : void 0
            }
          ) }) : null
        ]
      }
    )
  ] });
};
var en = /* @__PURE__ */ ((e) => (e.Receiver = "Receiver", e.Sender = "Sender", e))(en || {});
const z3 = (e) => /* @__PURE__ */ f("a", { href: e.href, target: "_blank", rel: "noreferrer", children: e.children }), ga = (e) => {
  const {
    externalBody: n,
    messageBody: t,
    sender: r,
    avatarLeft: i,
    avatarRight: a,
    avatarClassName: o,
    type: l,
    className: s,
    wrapperClassName: u,
    timestamp: c,
    timestampClassName: d,
    files: p,
    fileClassName: h,
    filePreviewClassName: y,
    systemFormMessage: C,
    senderOverlayClassName: $,
    receiverOverlayClassName: m,
    fixedPositioning: x,
    ...A
  } = e, [I, b] = de(!1), w = _e(null), S = te(() => {
    b && (I ? b(!1) : (w.current && clearTimeout(w.current), w.current = setTimeout(() => {
      b(!1), w.current = null;
    }, 2e3), b(!0)));
  }, [I, b]), O = t && typeof t == "string" ? /* @__PURE__ */ f(
    sn,
    {
      rehypePlugins: [on],
      components: { a: z3 },
      children: t
    }
  ) : t;
  return /* @__PURE__ */ P(
    "div",
    {
      className: `${we.messageWrapper} ${l === "Sender" ? we.right : we.left} ${u ?? ""}`,
      children: [
        i ? /* @__PURE__ */ f("div", { className: `${o ?? ""}`, children: i }) : null,
        /* @__PURE__ */ P("div", { className: we.relativeWrapper, children: [
          /* @__PURE__ */ P("div", { className: `${we.relativeContainer} ${n ? we.withExternalBody : we.noExternalBody}
          ${I ? we.show : we.hide}
          `, children: [
            r ? /* @__PURE__ */ f("div", { className: `${we.senderContainer}
            ${l === "Receiver" ? we.left : we.right}`, children: r }) : null,
            O ? /* @__PURE__ */ f(
              "div",
              {
                className: `${we.message} ${C ? we.systemFormMessage : l === "Sender" ? we.messageRight : we.messageLeft} ${s ?? ""}`,
                ...A,
                onClick: S,
                children: O
              }
            ) : null,
            p == null ? void 0 : p.map((N, R) => /* @__PURE__ */ f(
              V3,
              {
                file: N,
                receiver: l === "Receiver",
                className: h,
                previewClassName: y,
                toggleTimestamp: S,
                senderOverlayClassName: $,
                receiverOverlayClassName: m,
                fixedPositioning: x
              },
              (N == null ? void 0 : N.id) ?? R
            )),
            c ? /* @__PURE__ */ f("div", { className: `${we.timestampContainer}
              ${I ? we.show : we.hide}`, children: /* @__PURE__ */ f(
              "div",
              {
                className: `${we.timestamp} ${d ?? ""}
                ${l === "Receiver" ? we.left : we.right}
                ${n ? we.withExternalBody : we.noExternalBody}`,
                children: c
              }
            ) }) : null
          ] }),
          n
        ] }),
        a ? /* @__PURE__ */ f("div", { className: `${o ?? ""}`, children: a }) : null
      ]
    }
  );
}, W3 = (e, n) => {
  var i;
  const t = n || ((i = fn()) == null ? void 0 : i.language) || (navigator == null ? void 0 : navigator.language), r = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(t, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: r
  }).format(e);
}, Vg = (e, n) => {
  var i;
  const t = n || ((i = fn()) == null ? void 0 : i.language) || navigator.language, r = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(t, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: r
  }).format(e);
}, zg = (e, n) => {
  var i;
  const t = n || ((i = fn()) == null ? void 0 : i.language) || navigator.language, r = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(t, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: r
  }).format(e);
}, Wg = (e, n) => {
  var i;
  const t = n || ((i = fn()) == null ? void 0 : i.language) || navigator.language, r = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return new Intl.DateTimeFormat(t, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: r
  }).format(e);
}, ya = (e, n) => {
  var r;
  const t = n || ((r = fn()) == null ? void 0 : r.language) || navigator.language;
  return new Intl.DateTimeFormat(t, {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: !0
  }).format(e);
}, $n = (e) => {
  var C, $;
  const {
    prematter: n,
    message: t,
    files: r = [],
    sendMessage: i,
    showAction: a = !0,
    children: o,
    lawyerImage: l,
    addQuestion: s,
    addQuestionError: u,
    addQuestionPending: c
  } = e, d = e.hoverDelay ?? 200, p = Y.useRef(null), { t: h } = Te(), y = t.from === "lawyer" ? "Assistant" : "You";
  if (t.type === Mt.Chat || t.type === Mt.Location || t.type === Mt.Confirmation) {
    if (t.content) {
      const m = [];
      return t.questions && m.push(
        /* @__PURE__ */ f(Td, { questions: n.context.questions || [], disabled: n.state !== Be.Questions, onAddQuestion: s, error: u, pending: c })
      ), m.push(
        /* @__PURE__ */ f(
          "div",
          {
            ref: p,
            className: `${Ee.chatElementMessageContainer}
          ${t.from === "client" ? Ee.sender : ""}`,
            children: /* @__PURE__ */ f(
              ga,
              {
                messageBody: o || t.content,
                type: t.from === "lawyer" ? en.Receiver : en.Sender,
                timestamp: ya(t.createdAt || Date.now()),
                avatarLeft: t.from === "lawyer" ? /* @__PURE__ */ f(
                  "img",
                  {
                    src: l || "data:image/jpeg;base64,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",
                    className: Ee.avatarIcon,
                    onError: ({ currentTarget: x }) => {
                      x.onerror = null;
                    }
                  }
                ) : null,
                avatarClassName: `
              ${Ee.avatarIconContainer}
            `,
                sender: y ? /* @__PURE__ */ f("div", { children: y }) : null,
                hoverDelay: d,
                wrapperClassName: `${Ee.messageWrapper} ${t.from === "lawyer" ? Ee.noBottomBorderRadiusReceiver : Ee.noBottomBorderRadiusSender}`,
                externalBody: t.questions && a ? /* @__PURE__ */ f("div", { className: Ee.buttonWrapper, children: /* @__PURE__ */ f(
                  "div",
                  {
                    className: Ee.button,
                    onClick: i ? () => i({ text: "continue" }) : void 0,
                    children: h("confirm.continue")
                  }
                ) }) : null
              }
            )
          }
        )
      ), m;
    } else if ((C = t.fileIds) != null && C.length) {
      const m = ($ = t.fileIds) == null ? void 0 : $.map((x) => r.find((A) => A.id === x)).filter((x) => x);
      return /* @__PURE__ */ f(
        "div",
        {
          ref: p,
          className: `${Ee.chatElementMessageContainer}
          ${t.from === "client" ? Ee.sender : ""}`,
          children: /* @__PURE__ */ f(
            ga,
            {
              messageBody: t.content || "",
              type: t.from === "lawyer" ? en.Receiver : en.Sender,
              timestamp: t.createdAt ? ya(t.createdAt) : null,
              files: m,
              fileClassName: t.from === "lawyer" ? Ee.lawyerFileName : Ee.clientFileName,
              filePreviewClassName: t.from === "lawyer" ? Ee.lawyerFilePreview : Ee.clientFilePreview,
              className: `${Ee.messageWrapper} ${t.from === "lawyer" ? Ee.noBottomBorderRadiusReceiver : Ee.noBottomBorderRadiusSender}`,
              avatarLeft: t.from === "lawyer" ? /* @__PURE__ */ f(
                "img",
                {
                  src: "/profile-no-image.png",
                  className: Ee.avatarIcon,
                  onError: ({ currentTarget: x }) => {
                    x.onerror = null;
                  }
                }
              ) : null,
              avatarClassName: `
              ${Ee.avatarIconContainer}
            `,
              sender: y ? /* @__PURE__ */ f("div", { children: y }) : null,
              fixedPositioning: !0
            },
            t.id
          )
        }
      );
    }
  }
  return null;
}, U3 = "_complete_1w5za_1", q3 = "_inlineForm_1w5za_11", Z3 = "_inlineFormTitle_1w5za_32", G3 = "_inlineFormQuestionWrapper_1w5za_48", Q3 = "_inlineFormProgressBar_1w5za_54", K3 = "_formFooter_1w5za_57", Y3 = "_formFooterLeft_1w5za_75", X3 = "_formFooterRight_1w5za_101", J3 = "_inlineFormError_1w5za_132", vt = {
  complete: U3,
  inlineForm: q3,
  inlineFormTitle: Z3,
  inlineFormQuestionWrapper: G3,
  inlineFormProgressBar: Q3,
  formFooter: K3,
  formFooterLeft: Y3,
  formFooterRight: X3,
  inlineFormError: J3
}, e5 = "_questionWrapper_fraoc_1", t5 = "_multiPartQuestion_fraoc_7", n5 = "_childQuestionWrapper_fraoc_13", Yt = {
  questionWrapper: e5,
  multiPartQuestion: t5,
  childQuestionWrapper: n5
}, r5 = "_tabList_1eqw8_1", i5 = "_tabItems_1eqw8_7", a5 = "_tabItem_1eqw8_7", o5 = "_reverse_1eqw8_31", l5 = "_active_1eqw8_40", s5 = "_tabAdd_1eqw8_44", u5 = "_tab_1eqw8_1", c5 = "_tabRemove_1eqw8_90", Ue = {
  tabList: r5,
  tabItems: i5,
  tabItem: a5,
  reverse: o5,
  active: l5,
  tabAdd: s5,
  tab: u5,
  tabRemove: c5
}, $a = (e) => /* @__PURE__ */ _.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 8.5, stroke: "#0E5FE3" }), /* @__PURE__ */ _.createElement("path", { d: "M9.5 5C9.5 4.72386 9.27614 4.5 9 4.5C8.72386 4.5 8.5 4.72386 8.5 5V8.5H5C4.72386 8.5 4.5 8.72386 4.5 9C4.5 9.27614 4.72386 9.5 5 9.5H8.5V13C8.5 13.2761 8.72386 13.5 9 13.5C9.27614 13.5 9.5 13.2761 9.5 13V9.5H13C13.2761 9.5 13.5 9.27614 13.5 9C13.5 8.72386 13.2761 8.5 13 8.5H9.5V5Z", fill: "#0E5FE3" })), d5 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 8.5, stroke: "#BB1600" }), /* @__PURE__ */ _.createElement("path", { d: "M12.75 4.875C12.9571 4.875 13.125 5.04289 13.125 5.25C13.125 5.35354 13.083 5.44728 13.0152 5.51514L9.53036 8.99998L13.0152 12.4848C13.0831 12.5527 13.125 12.6464 13.125 12.75C13.125 12.9571 12.9571 13.125 12.75 13.125C12.6447 13.125 12.5495 13.0816 12.4814 13.0117L9.00003 9.53031L5.51519 13.0151C5.44733 13.083 5.35356 13.125 5.25 13.125C5.04289 13.125 4.875 12.9571 4.875 12.75C4.875 12.6456 4.91768 12.5511 4.98654 12.4831L8.4697 8.99998L4.98835 5.51864C4.91843 5.45052 4.875 5.35533 4.875 5.25C4.875 5.04289 5.04289 4.875 5.25 4.875C5.35356 4.875 5.44731 4.91698 5.51517 4.98484L9.00003 8.46965L12.4831 4.98654C12.5511 4.91768 12.6456 4.875 12.75 4.875Z", fill: "#BB1600" })), f5 = "_inputSeparator_u8u7l_1", h5 = {
  inputSeparator: f5
}, Al = $e((e, n) => {
  var t;
  return /* @__PURE__ */ f("div", { ref: n, ...e.props, className: `${h5.inputSeparator} ${(t = e.props) == null ? void 0 : t.className}` });
}), p5 = (e) => {
  var h, y, C;
  const { questions: n, question: t, onChange: r, disabled: i = !1, language: a } = e, { t: o } = Te(), [l, s] = de(0), u = ($) => (m) => {
    m.preventDefault(), s($);
  }, c = ($) => {
    $.stopPropagation(), $.preventDefault();
    const m = {
      ...t,
      answer: [
        ...t.answer || [],
        t.questions
      ]
    };
    r(m), s(m.answer && m.answer.length > 0 ? m.answer.length - 1 : 0);
  }, d = ($) => (m) => {
    var A;
    m.stopPropagation(), m.preventDefault();
    const x = {
      ...t,
      answer: (A = t.answer) == null ? void 0 : A.filter(
        (I, b) => b !== $
      )
    };
    r(x), s($ - 1 > 0 ? $ - 1 : 0);
  }, p = ($) => (m) => {
    const x = { ...t };
    x.answer && x.answer[$] && (x.answer[$] = x.answer[$].map((A) => A.id === m.id ? m : A)), r(x);
  };
  return ce(() => {
    t.answer || c(new MouseEvent("click"));
  }, []), /* @__PURE__ */ P("div", { className: Ue.tabList, children: [
    /* @__PURE__ */ P("div", { className: Ue.tabItems, children: [
      (h = t.answer) == null ? void 0 : h.map(($, m) => {
        var A;
        const x = (A = $.find((I) => I.id === t.label)) == null ? void 0 : A.answer;
        return /* @__PURE__ */ f(
          "button",
          {
            onClick: u(m),
            className: `${Ue.tabItem} ${m === l ? Ue.active : ""}`,
            children: t.label && x && typeof x != "object" ? x || o("prematter.new") : `#${m + 1}`
          },
          m
        );
      }),
      /* @__PURE__ */ P("button", { onClick: c, className: Ue.tabAdd, disabled: i, children: [
        /* @__PURE__ */ f($a, {}),
        " ",
        o("prematter.add")
      ] })
    ] }),
    (y = t.answer) == null ? void 0 : y.map(($, m) => /* @__PURE__ */ P(
      "div",
      {
        className: `${Ue.tab} ${m === l ? Ue.active : ""}`,
        children: [
          $.map((x, A) => /* @__PURE__ */ f(
            Ht,
            {
              questions: n,
              question: x,
              onChange: p(m),
              disabled: i,
              language: a
            },
            A
          )),
          /* @__PURE__ */ f(Al, {}),
          /* @__PURE__ */ P("button", { onClick: d(m), className: Ue.tabRemove, children: [
            /* @__PURE__ */ f(d5, {}),
            " ",
            o("prematter.remove")
          ] })
        ]
      },
      m
    )),
    /* @__PURE__ */ P("div", { className: Ue.tabItems, children: [
      (C = t.answer) == null ? void 0 : C.map(($, m) => {
        var A;
        const x = (A = $.find((I) => I.id === t.label)) == null ? void 0 : A.answer;
        return /* @__PURE__ */ f(
          "button",
          {
            onClick: u(m),
            className: `${Ue.tabItem} ${Ue.reverse} ${m === l ? Ue.active : ""}`,
            children: typeof x != "object" && x || o("prematter.new")
          },
          m
        );
      }),
      /* @__PURE__ */ P("button", { onClick: c, className: Ue.tabAdd, disabled: i, children: [
        /* @__PURE__ */ f($a, {}),
        " ",
        o("prematter.add")
      ] })
    ] })
  ] });
}, m5 = "_yesNoInput_5sblm_1", g5 = "_actionButton_5sblm_8", y5 = "_dot_5sblm_25", $5 = "_disabled_5sblm_31", v5 = "_active_5sblm_35", Ct = {
  yesNoInput: m5,
  actionButton: g5,
  dot: y5,
  disabled: $5,
  active: v5
}, C5 = $e(
  (e, n) => {
    var s;
    const {
      value: t,
      disabled: r,
      onChange: i,
      language: a
    } = e, { t: o } = Te(void 0, { lng: a }), l = te((u) => (c) => {
      c.preventDefault(), r || i(u);
    }, [r, i]);
    return /* @__PURE__ */ P(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${Ct.yesNoInput} ${r ? Ct.disabled : ""} ${(s = e.props) == null ? void 0 : s.className}`,
        children: [
          /* @__PURE__ */ P(
            "button",
            {
              className: `${Ct.actionButton} ${(t == null ? void 0 : t.toLocaleLowerCase()) === "yes" ? Ct.active : ""}`,
              onClick: l("yes"),
              disabled: r,
              children: [
                /* @__PURE__ */ f("div", { className: Ct.dot }),
                o("confirm.yes")
              ]
            }
          ),
          /* @__PURE__ */ P(
            "button",
            {
              className: `${Ct.actionButton} ${(t == null ? void 0 : t.toLocaleLowerCase()) === "no" ? Ct.active : ""}`,
              onClick: l("no"),
              disabled: r,
              children: [
                /* @__PURE__ */ f("div", { className: Ct.dot }),
                o("confirm.no")
              ]
            }
          )
        ]
      }
    );
  }
), b5 = "_numericInput_xfpgp_1", A5 = {
  numericInput: b5
}, w5 = $e(
  (e, n) => {
    var o;
    const { value: t, disabled: r, onChange: i } = e, a = te((l) => {
      l.preventDefault(), l.stopPropagation(), r || i(l.target.value);
    }, [r, i]);
    return /* @__PURE__ */ f(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${A5.numericInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "number",
        value: t,
        onChange: a
      }
    );
  }
), x5 = "_checkboxInputLabel_18whr_1", _5 = "_checkboxInput_18whr_1", va = {
  checkboxInputLabel: x5,
  checkboxInput: _5
}, N5 = $e((e, n) => {
  var s;
  const { checked: t = !1, value: r, label: i, disabled: a, onChange: o } = e, l = te((u) => {
    a || o(u.target.value, u.target.checked);
  }, [a, o]);
  return /* @__PURE__ */ P("label", { className: va.checkboxInputLabel, htmlFor: `checkbox-${r}`, children: [
    /* @__PURE__ */ f(
      "input",
      {
        id: `checkbox-${r}`,
        ref: n,
        ...e.props,
        className: `${va.checkboxInput} ${((s = e.props) == null ? void 0 : s.className) || ""}`,
        type: "checkbox",
        value: r,
        checked: t,
        onChange: l,
        disabled: a
      }
    ),
    i
  ] });
}), I5 = "_dateInputWrapper_1ac36_1", E5 = "_dateInput_1ac36_1", S5 = "_calendarIcon_1ac36_37", lr = {
  dateInputWrapper: I5,
  dateInput: E5,
  calendarIcon: S5
}, P5 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/calendar" }, /* @__PURE__ */ _.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M5.49631 3.5H7.49631V3C7.49631 2.72386 7.72016 2.5 7.99631 2.5C8.27245 2.5 8.49631 2.72386 8.49631 3V3.5H10.4963V3C10.4963 2.72386 10.7202 2.5 10.9963 2.5C11.2724 2.5 11.4963 2.72386 11.4963 3V3.5H13.4963C14.0486 3.5 14.4963 3.94772 14.4963 4.5V13.5C14.4963 14.0523 14.0486 14.5 13.4963 14.5H2.49631C1.94402 14.5 1.49631 14.0523 1.49631 13.5V4.5C1.49631 3.94772 1.94402 3.5 2.49631 3.5H4.49631V3C4.49631 2.72386 4.72016 2.5 4.99631 2.5C5.27245 2.5 5.49631 2.72386 5.49631 3V3.5ZM10.4963 5C10.4963 5.27614 10.7202 5.5 10.9963 5.5C11.2724 5.5 11.4963 5.27614 11.4963 5V4.5H13.4963V6.5H2.49631V4.5H4.49631V5C4.49631 5.27614 4.72017 5.5 4.99631 5.5C5.27245 5.5 5.49631 5.27614 5.49631 5V4.5H7.49631V5C7.49631 5.27614 7.72017 5.5 7.99631 5.5C8.27245 5.5 8.49631 5.27614 8.49631 5V4.5H10.4963V5ZM2.49631 13.5L2.49631 7.5H13.4963V13.5H2.49631Z", fill: "#666666" }))), k5 = $e((e, n) => {
  var o;
  const { value: t, disabled: r, onChange: i } = e, a = te((l) => {
    r || i(new Date(l.target.value).getTime());
  }, [r, i]);
  return /* @__PURE__ */ P("div", { className: lr.dateInputWrapper, children: [
    /* @__PURE__ */ f(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${lr.dateInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "date",
        value: t && !isNaN(t) ? new Date(t).toISOString().split("T")[0] : "",
        onChange: a,
        disabled: r
      }
    ),
    /* @__PURE__ */ f("div", { className: lr.calendarIcon, children: /* @__PURE__ */ f(P5, {}) })
  ] });
}), O5 = "_dateTimeInputWrapper_ugoon_1", T5 = "_dateTimeInput_ugoon_1", L5 = "_calendarIcon_ugoon_35", sr = {
  dateTimeInputWrapper: O5,
  dateTimeInput: T5,
  calendarIcon: L5
}, F5 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/calendar" }, /* @__PURE__ */ _.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M5.49631 3.5H7.49631V3C7.49631 2.72386 7.72016 2.5 7.99631 2.5C8.27245 2.5 8.49631 2.72386 8.49631 3V3.5H10.4963V3C10.4963 2.72386 10.7202 2.5 10.9963 2.5C11.2724 2.5 11.4963 2.72386 11.4963 3V3.5H13.4963C14.0486 3.5 14.4963 3.94772 14.4963 4.5V13.5C14.4963 14.0523 14.0486 14.5 13.4963 14.5H2.49631C1.94402 14.5 1.49631 14.0523 1.49631 13.5V4.5C1.49631 3.94772 1.94402 3.5 2.49631 3.5H4.49631V3C4.49631 2.72386 4.72016 2.5 4.99631 2.5C5.27245 2.5 5.49631 2.72386 5.49631 3V3.5ZM10.4963 5C10.4963 5.27614 10.7202 5.5 10.9963 5.5C11.2724 5.5 11.4963 5.27614 11.4963 5V4.5H13.4963V6.5H2.49631V4.5H4.49631V5C4.49631 5.27614 4.72017 5.5 4.99631 5.5C5.27245 5.5 5.49631 5.27614 5.49631 5V4.5H7.49631V5C7.49631 5.27614 7.72017 5.5 7.99631 5.5C8.27245 5.5 8.49631 5.27614 8.49631 5V4.5H10.4963V5ZM2.49631 13.5L2.49631 7.5H13.4963V13.5H2.49631Z", fill: "#666666" }))), M5 = $e((e, n) => {
  var o;
  const { value: t, disabled: r, onChange: i } = e, a = te((l) => {
    r || i(l.target.value);
  }, [r, i]);
  return /* @__PURE__ */ P("div", { className: sr.dateTimeInputWrapper, children: [
    /* @__PURE__ */ f(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${sr.dateTimeInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "datetime-local",
        value: t ? new Date(t).toISOString().slice(0, 16) : "",
        onChange: a,
        disabled: r
      }
    ),
    /* @__PURE__ */ f("div", { className: sr.calendarIcon, children: /* @__PURE__ */ f(F5, {}) })
  ] });
}), R5 = "_inputDescription_q7ory_1", D5 = {
  inputDescription: R5
}, vn = $e((e, n) => {
  var r;
  const { text: t } = e;
  return /* @__PURE__ */ f("div", { ref: n, ...e.props, className: `${D5.inputDescription} ${((r = e.props) == null ? void 0 : r.className) || ""}`, children: t });
}), B5 = "_inputLabel_1owa9_1", j5 = "_desktop_1owa9_15", H5 = "_mobile_1owa9_19", V5 = "_textWithEmail_1owa9_56", Xt = {
  inputLabel: B5,
  desktop: j5,
  mobile: H5,
  textWithEmail: V5
}, z5 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3V2C12 1.44772 11.5523 1 11 1H3C2.44772 1 2 1.44772 2 2V12C2 12.5523 2.44772 13 3 13H4V14C4 14.5523 4.44772 15 5 15H13C13.5523 15 14 14.5523 14 14V4C14 3.44772 13.5523 3 13 3H12ZM11 2H3V12H4V4C4 3.44772 4.44772 3 5 3H11V2ZM5 4V14H13V4H5Z", fill: "#666666" })), W5 = $e(
  (e, n) => {
    var s;
    const { text: t, language: r } = e, { t: i } = Te(void 0, { lng: r }), [a, o] = de(null);
    ce(() => {
      if (typeof t == "string") {
        const u = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, c = t.match(u);
        c && o(c[0]);
      }
    }, [t]);
    const l = te((u) => {
      a && (u.preventDefault(), Is(a), Es.success(i("chat.copied-link")));
    }, [a, i]);
    return ce(() => {
      var u;
      return (u = document.getElementById("email-files")) == null || u.addEventListener("click", l), () => {
        var c;
        (c = document.getElementById("email-files")) == null || c.removeEventListener("click", l);
      };
    }, [l, a]), /* @__PURE__ */ f(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${Xt.inputLabel} ${((s = e.props) == null ? void 0 : s.className) || ""}`,
        children: typeof t == "string" && a ? /* @__PURE__ */ P(Fe, { children: [
          /* @__PURE__ */ f("div", { className: Xt.mobile, children: /* @__PURE__ */ f("div", { className: Xt.mobileFileLabel, dangerouslySetInnerHTML: { __html: i("chat.questionnaire-upload-mobile") } }) }),
          /* @__PURE__ */ P("div", { className: Xt.desktop, children: [
            i("chat.questionnaire-upload-desktop"),
            /* @__PURE__ */ f("div", { style: { display: "inline-block" }, children: /* @__PURE__ */ P("div", { className: Xt.textWithEmail, onClick: l, children: [
              /* @__PURE__ */ P("div", { children: [
                /* @__PURE__ */ f("span", { children: a }),
                "."
              ] }),
              /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(z5, {}) })
            ] }) })
          ] })
        ] }) : t
      }
    );
  }
), U5 = "_radioInputLabel_rfgrj_1", q5 = "_radioInput_rfgrj_1", Ca = {
  radioInputLabel: U5,
  radioInput: q5
}, Z5 = $e(
  (e, n) => {
    var c;
    const {
      checked: t = !1,
      value: r,
      name: i,
      label: a,
      disabled: o,
      onChange: l,
      className: s
    } = e, u = te(
      (d) => {
        o || l(d.target.checked ? d.target.value : "");
      },
      [o, l]
    );
    return /* @__PURE__ */ P(
      "label",
      {
        className: `${Ca.radioInputLabel} ${s}`,
        htmlFor: `${i}-${r}`,
        children: [
          /* @__PURE__ */ f(
            "input",
            {
              id: `${i}-${r}`,
              ref: n,
              ...e.props,
              className: `${Ca.radioInput} ${((c = e.props) == null ? void 0 : c.className) || ""}`,
              type: "radio",
              name: i,
              value: r,
              checked: t,
              onChange: u,
              disabled: o
            }
          ),
          a
        ]
      }
    );
  }
), G5 = "_timeInputWrapper_9nngk_1", Q5 = "_timeInput_9nngk_1", K5 = "_clockIcon_9nngk_35", ur = {
  timeInputWrapper: G5,
  timeInput: Q5,
  clockIcon: K5
}, Y5 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/clock" }, /* @__PURE__ */ _.createElement("g", { id: "Union" }, /* @__PURE__ */ _.createElement("path", { d: "M10.5 10.5C10.5 10.7761 10.2761 11 10 11C9.85956 11 9.73264 10.9421 9.64182 10.8489L7.65114 8.85819C7.55791 8.76737 7.5 8.64045 7.5 8.5V5.5C7.5 5.22386 7.72386 5 8 5C8.27614 5 8.5 5.22386 8.5 5.5V8.29283L10.3536 10.1464C10.4441 10.2369 10.5 10.3619 10.5 10.5Z", fill: "#666666" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.5899 15 14.5 12.0899 14.5 8.5C14.5 4.91015 11.5899 2 8 2C4.41015 2 1.5 4.91015 1.5 8.5C1.5 12.0899 4.41015 15 8 15ZM8 14C11.0376 14 13.5 11.5376 13.5 8.5C13.5 5.46243 11.0376 3 8 3C4.96243 3 2.5 5.46243 2.5 8.5C2.5 11.5376 4.96243 14 8 14Z", fill: "#666666" })))), X5 = $e((e, n) => {
  var o;
  const { value: t, disabled: r, onChange: i } = e, a = te((l) => {
    r || i(l.target.value);
  }, [r, i]);
  return /* @__PURE__ */ P("div", { className: ur.timeInputWrapper, children: [
    /* @__PURE__ */ f(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${ur.timeInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "time",
        value: t,
        onChange: a,
        disabled: r
      }
    ),
    /* @__PURE__ */ f("div", { className: ur.clockIcon, children: /* @__PURE__ */ f(Y5, {}) })
  ] });
}), J5 = "_scaleInputContainer_rp5d1_1", ef = "_scaleInput_rp5d1_1", tf = "_scaleInputLabels_rp5d1_64", nf = "_labelWrapper_rp5d1_72", rf = "_currentValue_rp5d1_79", af = "_label_rp5d1_72", kt = {
  scaleInputContainer: J5,
  scaleInput: ef,
  scaleInputLabels: tf,
  labelWrapper: nf,
  currentValue: rf,
  label: af
}, of = $e(
  (e, n) => {
    var h, y;
    const { value: t, labels: r = [], min: i, max: a, onChange: o, disabled: l } = e, [s, u] = de(t), [c, d] = de(void 0);
    ce(() => {
      if (s !== void 0)
        for (let C = 0; C < r.length; C++) {
          const $ = r[C];
          if ($.lower && $.upper && s >= $.lower && s <= $.upper) {
            d($.text);
            break;
          } else if ($.lower && !$.upper && s >= $.lower) {
            d($.text);
            break;
          } else if (!$.lower && $.upper && s <= $.upper) {
            d($.text);
            break;
          }
        }
    }, [s, r]);
    const p = (C) => {
      u(C), o(C);
    };
    return ce(() => {
      u(t);
    }, [t]), /* @__PURE__ */ P("div", { className: kt.scaleInputContainer, children: [
      /* @__PURE__ */ f(
        "input",
        {
          ref: n,
          ...e.props,
          className: `${kt.scaleInput} ${((h = e.props) == null ? void 0 : h.className) || ""}`,
          type: "range",
          value: s === void 0 ? i : s,
          min: i,
          max: a,
          onChange: (C) => p(parseInt(C.target.value)),
          style: {
            ...(y = e.props) == null ? void 0 : y.style,
            ...s ? {
              "--percentage": s === void 0 ? 0 : ((s || 0) - i) / (a - i) * 100 + "%"
            } : {}
          },
          disabled: l
        }
      ),
      /* @__PURE__ */ P("div", { className: kt.scaleInputLabels, children: [
        /* @__PURE__ */ f("div", { children: i }),
        /* @__PURE__ */ P("div", { className: kt.labelWrapper, children: [
          /* @__PURE__ */ f("div", { className: kt.currentValue, children: s }),
          c ? /* @__PURE__ */ f("div", { className: kt.label, children: c }) : null
        ] }),
        /* @__PURE__ */ f("div", { children: a })
      ] })
    ] });
  }
), lf = "_splitDateInputWrapper_1kh95_1", sf = "_splitDateInput_1kh95_1", Cn = {
  splitDateInputWrapper: lf,
  splitDateInput: sf
}, uf = $e(
  (e, n) => {
    var A;
    const { value: t = {}, onChange: r, disabled: i } = e, [a, o] = de(t.year || ""), [l, s] = de(t.month || ""), [u, c] = de(t.day || ""), [d, p] = de([
      "day",
      "month",
      "year"
    ]);
    ce(() => {
      m();
    }, []);
    const h = (I, b) => new Date(I, b, 0).getDate(), y = (I) => {
      const b = I.target.value, w = parseInt(b, 10), S = parseInt(a, 10), O = parseInt(l, 10);
      if (!isNaN(w) && !isNaN(S) && !isNaN(O)) {
        const N = h(S, O);
        w >= 1 && w <= N && (c(b), r({ year: a, month: l, day: b }));
      } else (b === "" || !isNaN(w) && w < 31 && !a && !l) && (c(b), r({ year: a, month: l, day: b }));
    }, C = (I) => {
      const b = I.target.value, w = parseInt(b, 10), S = parseInt(a, 10), O = parseInt(u, 10);
      if (!isNaN(w) && w >= 1 && w <= 12) {
        s(b), r({ year: a, month: b, day: u });
        const N = h(S, w);
        !isNaN(O) && O > N && (c(N.toString()), r({ year: a, month: b, day: N.toString() }));
      } else b === "" && (s(b), r({ year: a, month: b, day: u }));
    }, $ = (I) => {
      const b = I.target.value, w = parseInt(b, 10), S = parseInt(l, 10), O = parseInt(u, 10);
      if (isNaN(w))
        b === "" && (o(b), r({ year: b, month: l, day: u }));
      else {
        o(b), r({ year: b, month: l, day: u });
        const N = h(w, S);
        !isNaN(O) && O > N && (c(N.toString()), r({ year: b, month: l, day: N.toString() }));
      }
    }, m = () => {
      const w = new Date(1999, 11, 31).toLocaleDateString().split(/\D/);
      parseInt(w[0], 10) === 31 ? p(["day", "month", "year"]) : parseInt(w[0], 10) === 1999 ? p(["year", "month", "day"]) : p(["month", "day", "year"]);
    }, x = () => d.map((I, b) => I === "day" ? /* @__PURE__ */ f(
      "input",
      {
        type: "text",
        value: u,
        onChange: y,
        placeholder: "Day",
        className: Cn.splitDateInput,
        disabled: i
      },
      b
    ) : I === "month" ? /* @__PURE__ */ P("select", { value: l, onChange: C, className: Cn.splitDateInput, disabled: i, children: [
      /* @__PURE__ */ f("option", { value: "", children: "Month" }),
      /* @__PURE__ */ f("option", { value: "1", children: "January" }),
      /* @__PURE__ */ f("option", { value: "2", children: "February" }),
      /* @__PURE__ */ f("option", { value: "3", children: "March" }),
      /* @__PURE__ */ f("option", { value: "4", children: "April" }),
      /* @__PURE__ */ f("option", { value: "5", children: "May" }),
      /* @__PURE__ */ f("option", { value: "6", children: "June" }),
      /* @__PURE__ */ f("option", { value: "7", children: "July" }),
      /* @__PURE__ */ f("option", { value: "8", children: "August" }),
      /* @__PURE__ */ f("option", { value: "9", children: "September" }),
      /* @__PURE__ */ f("option", { value: "10", children: "October" }),
      /* @__PURE__ */ f("option", { value: "11", children: "November" }),
      /* @__PURE__ */ f("option", { value: "12", children: "December" })
    ] }, b) : I === "year" ? /* @__PURE__ */ f(
      "input",
      {
        type: "text",
        value: a,
        onChange: $,
        placeholder: "Year",
        className: Cn.splitDateInput,
        disabled: i
      },
      b
    ) : null);
    return /* @__PURE__ */ f(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${Cn.splitDateInputWrapper} ${(A = e.props) == null ? void 0 : A.className}`,
        children: x()
      }
    );
  }
), cf = "_fileInput_1yz6i_9", df = "_fileInputLabel_1yz6i_20", ff = "_dragging_1yz6i_45", hf = "_fileList_1yz6i_51", pf = "_fileChips_1yz6i_69", mf = "_fileChip_1yz6i_69", gf = "_uploaded_1yz6i_91", yf = "_uploading_1yz6i_95", $f = "_active_1yz6i_110", vf = "_rotate_1yz6i_1", Cf = "_fileIcon_1yz6i_116", bf = "_fileRemoveIcon_1yz6i_128", et = {
  fileInput: cf,
  fileInputLabel: df,
  dragging: ff,
  fileList: hf,
  fileChips: pf,
  fileChip: mf,
  uploaded: gf,
  uploading: yf,
  active: $f,
  rotate: vf,
  fileIcon: Cf,
  fileRemoveIcon: bf
}, Af = (e) => /* @__PURE__ */ _.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("rect", { width: 32, height: 32, rx: 16, fill: "#EEEEEE" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.458 12.1724L22.5224 12.2367C22.7367 12.451 22.8571 12.7417 22.8571 13.0448V22.8571C22.8571 23.4883 22.3454 24 21.7143 24H10.2857C9.6545 24 9.14282 23.4883 9.14282 22.8571V9.14286C9.14282 8.51168 9.6545 8 10.2857 8H17.8123C18.1154 8 18.4061 8.12041 18.6204 8.33474L18.6847 8.39899C18.6864 8.40065 18.6881 8.40232 18.6897 8.404L22.453 12.1673C22.4547 12.169 22.4564 12.1707 22.458 12.1724ZM21.7143 22.8571H10.2857L10.2857 9.14286H17.7143V12.5714C17.7143 12.887 17.9701 13.1428 18.2857 13.1428H21.7143V22.8571Z", fill: "#666666" })), wf = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#CCCCCC", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M8.78038 16.2803C8.64465 16.416 8.45713 16.5 8.25 16.5C7.83579 16.5 7.5 16.1642 7.5 15.75C7.5 15.5412 7.58535 15.3523 7.72308 15.2163L10.9394 12L7.72672 8.78729C7.58686 8.65105 7.5 8.46067 7.5 8.25C7.5 7.83579 7.83579 7.5 8.25 7.5C8.45711 7.5 8.64462 7.58395 8.78034 7.71968L12.0001 10.9393L15.2163 7.72308C15.3523 7.58535 15.5412 7.5 15.75 7.5C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 8.45708 16.4161 8.64456 16.2804 8.78028L13.0607 12L16.2804 15.2196C16.4161 15.3554 16.5 15.5429 16.5 15.75C16.5 16.1642 16.1642 16.5 15.75 16.5C15.5393 16.5 15.349 16.4131 15.2127 16.2733L12.0001 13.0606L8.78038 16.2803Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75ZM12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25Z" })), xf = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGYSURBVHgB1VRLUsJAFJwEizVHiCdQb8ANgBNgNlCs0BOIJ1BXFGSReILoCeQG6gmMN4jbfO2mJhT5SUiykK6CN4HJ6zc9/Z4Qpw7l0AbTNHue510rinKBRy2O49fpdPooKuKs7I/lcql1Op07JuczEjsgccSRKDyBYRj9KIpsrhGfEKzZbOaIGsgRrFarIYKNaj/CMBzVTVxIQFlUVX3jutvtXum67oqGSN0BNYfWGmQ5byM5sTuBrP4L0liTyUQXLUHdW/f5Bd3vRYvYEUCeAYLb9FJLCYAenSMaYr1ez+HEmyKCtjBEoYMcAdzzTQeJhkCOS7jwJ0cAUB4Ns0cTNUEnIvTgxpccARrLYkxmTx2wjxjhxE2OQDbWMz5zWclR4DuQh1M3NbdSlwztFrISm2NaVAT3yhHjZPsoRUBmkIx4UZDqvcpJuMf3fSbn3ttsHxWOazlRH/gSj8yqsi/SDEEQjFHQ1vMsDHs22VzKX5Xh2Assx/InN2lEaWdtm6CkgIME+0QIfZANkCy5Fwckn3ReW1P3/+IX0T/GHCkkTN4AAAAASUVORK5CYII=", _f = $e(
  (e, n) => {
    var $;
    const { value: t = [], onChange: r, disabled: i, language: a } = e, { t: o } = Te(void 0, { lng: a }), l = _e(null), [s, u] = de(!1), c = te(() => {
      i || u(!0);
    }, [i]), d = te(() => {
      i || u(!1);
    }, [i]), p = (m) => {
      m.target.files && !i && r([...t || [], ...Array.from(m.target.files)]);
    }, h = (m) => {
      m.preventDefault(), m.dataTransfer.files && !i && r([...t || [], ...Array.from(m.dataTransfer.files)]), u(!1);
    }, y = (m) => {
      var x;
      m.preventDefault(), i || (x = l.current) == null || x.click();
    }, C = (m) => {
      i || r((t || []).filter((x, A) => A !== m));
    };
    return ce(() => {
      var m;
      return (m = document.getElementById("browse-file")) == null || m.addEventListener("click", y), () => {
        var x;
        (x = document.getElementById("browse-file")) == null || x.removeEventListener("click", y);
      };
    }, []), zt(n, () => ({
      click: y
    })), /* @__PURE__ */ P(
      "div",
      {
        ...e.props,
        className: `${et.fileInput} ${s ? et.dragging : ""} ${(($ = e.props) == null ? void 0 : $.className) || ""}`,
        onDrop: h,
        onDragOver: (m) => m.preventDefault(),
        onDragEnter: c,
        onDragLeave: d,
        children: [
          /* @__PURE__ */ f(
            "div",
            {
              className: et.fileInputLabel,
              dangerouslySetInnerHTML: { __html: o("chat.browse-or-drop") }
            }
          ),
          /* @__PURE__ */ f("input", { ref: l, type: "file", onChange: p }),
          t.length > 0 ? /* @__PURE__ */ f("div", { className: et.fileList, children: /* @__PURE__ */ f("div", { className: et.fileChips, children: t.map((m, x) => /* @__PURE__ */ P(
            "div",
            {
              className: `${et.fileChip} ${!(m instanceof File) && m.id ? et.uploaded : ""}`,
              children: [
                /* @__PURE__ */ f("div", { className: `${et.uploading} ${m.uploading ? et.active : ""}`, children: /* @__PURE__ */ f("img", { src: xf, alt: "loading" }) }),
                /* @__PURE__ */ f("div", { className: et.fileIcon, children: /* @__PURE__ */ f(Af, {}) }),
                m.name || "file",
                "id" in m && !m.attachedToMessage || !("id" in m) ? /* @__PURE__ */ f(
                  "div",
                  {
                    className: et.fileRemoveIcon,
                    onClick: () => C(x),
                    title: "Remove file",
                    children: /* @__PURE__ */ f(wf, {})
                  }
                ) : null
              ]
            },
            x
          )) }) }) : null
        ]
      }
    );
  }
), Nf = "_emailInput_1e9u1_1", If = {
  emailInput: Nf
}, Ef = $e((e, n) => {
  var i, a;
  const { value: t, onChange: r } = e;
  return /* @__PURE__ */ f(
    "input",
    {
      ref: n,
      ...e.props,
      className: `${If.emailInput} ${((i = e.props) == null ? void 0 : i.className) || ""}`,
      type: "email",
      value: t || "",
      onChange: (o) => r(o.target.value),
      autoFocus: typeof ((a = e.props) == null ? void 0 : a.autoFocus) == "boolean" ? e.props.autoFocus : !0,
      disabled: e.disabled
    }
  );
}), Sf = "_textInput_1t3ia_1", Pf = {
  textInput: Sf
}, kf = $e((e, n) => {
  var a, o;
  const { value: t, disabled: r, onChange: i } = e;
  return /* @__PURE__ */ f(
    "input",
    {
      ref: n,
      ...e.props,
      className: `${Pf.textInput} ${((a = e.props) == null ? void 0 : a.className) || ""}`,
      type: "text",
      value: t || "",
      onChange: (l) => i(l.target.value),
      autoFocus: typeof ((o = e.props) == null ? void 0 : o.autoFocus) == "boolean" ? e.props.autoFocus : !1,
      disabled: r
    }
  );
}), Of = "_phoneInput_15jse_1", Tf = {
  phoneInput: Of
}, wl = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
var Lr = { exports: {} }, bn = { exports: {} }, me = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ba;
function Lf() {
  if (ba) return me;
  ba = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function A(b) {
    if (typeof b == "object" && b !== null) {
      var w = b.$$typeof;
      switch (w) {
        case n:
          switch (b = b.type, b) {
            case s:
            case u:
            case r:
            case a:
            case i:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case l:
                case c:
                case y:
                case h:
                case o:
                  return b;
                default:
                  return w;
              }
          }
        case t:
          return w;
      }
    }
  }
  function I(b) {
    return A(b) === u;
  }
  return me.AsyncMode = s, me.ConcurrentMode = u, me.ContextConsumer = l, me.ContextProvider = o, me.Element = n, me.ForwardRef = c, me.Fragment = r, me.Lazy = y, me.Memo = h, me.Portal = t, me.Profiler = a, me.StrictMode = i, me.Suspense = d, me.isAsyncMode = function(b) {
    return I(b) || A(b) === s;
  }, me.isConcurrentMode = I, me.isContextConsumer = function(b) {
    return A(b) === l;
  }, me.isContextProvider = function(b) {
    return A(b) === o;
  }, me.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === n;
  }, me.isForwardRef = function(b) {
    return A(b) === c;
  }, me.isFragment = function(b) {
    return A(b) === r;
  }, me.isLazy = function(b) {
    return A(b) === y;
  }, me.isMemo = function(b) {
    return A(b) === h;
  }, me.isPortal = function(b) {
    return A(b) === t;
  }, me.isProfiler = function(b) {
    return A(b) === a;
  }, me.isStrictMode = function(b) {
    return A(b) === i;
  }, me.isSuspense = function(b) {
    return A(b) === d;
  }, me.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === u || b === a || b === i || b === d || b === p || typeof b == "object" && b !== null && (b.$$typeof === y || b.$$typeof === h || b.$$typeof === o || b.$$typeof === l || b.$$typeof === c || b.$$typeof === $ || b.$$typeof === m || b.$$typeof === x || b.$$typeof === C);
  }, me.typeOf = A, me;
}
var ge = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Aa;
function Ff() {
  return Aa || (Aa = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function A(F) {
      return typeof F == "string" || typeof F == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      F === r || F === u || F === a || F === i || F === d || F === p || typeof F == "object" && F !== null && (F.$$typeof === y || F.$$typeof === h || F.$$typeof === o || F.$$typeof === l || F.$$typeof === c || F.$$typeof === $ || F.$$typeof === m || F.$$typeof === x || F.$$typeof === C);
    }
    function I(F) {
      if (typeof F == "object" && F !== null) {
        var oe = F.$$typeof;
        switch (oe) {
          case n:
            var he = F.type;
            switch (he) {
              case s:
              case u:
              case r:
              case a:
              case i:
              case d:
                return he;
              default:
                var ve = he && he.$$typeof;
                switch (ve) {
                  case l:
                  case c:
                  case y:
                  case h:
                  case o:
                    return ve;
                  default:
                    return oe;
                }
            }
          case t:
            return oe;
        }
      }
    }
    var b = s, w = u, S = l, O = o, N = n, R = c, T = r, E = y, L = h, W = t, D = a, H = i, ee = d, V = !1;
    function ae(F) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), g(F) || I(F) === s;
    }
    function g(F) {
      return I(F) === u;
    }
    function z(F) {
      return I(F) === l;
    }
    function J(F) {
      return I(F) === o;
    }
    function v(F) {
      return typeof F == "object" && F !== null && F.$$typeof === n;
    }
    function X(F) {
      return I(F) === c;
    }
    function ie(F) {
      return I(F) === r;
    }
    function K(F) {
      return I(F) === y;
    }
    function ne(F) {
      return I(F) === h;
    }
    function q(F) {
      return I(F) === t;
    }
    function M(F) {
      return I(F) === a;
    }
    function Q(F) {
      return I(F) === i;
    }
    function Z(F) {
      return I(F) === d;
    }
    ge.AsyncMode = b, ge.ConcurrentMode = w, ge.ContextConsumer = S, ge.ContextProvider = O, ge.Element = N, ge.ForwardRef = R, ge.Fragment = T, ge.Lazy = E, ge.Memo = L, ge.Portal = W, ge.Profiler = D, ge.StrictMode = H, ge.Suspense = ee, ge.isAsyncMode = ae, ge.isConcurrentMode = g, ge.isContextConsumer = z, ge.isContextProvider = J, ge.isElement = v, ge.isForwardRef = X, ge.isFragment = ie, ge.isLazy = K, ge.isMemo = ne, ge.isPortal = q, ge.isProfiler = M, ge.isStrictMode = Q, ge.isSuspense = Z, ge.isValidElementType = A, ge.typeOf = I;
  }()), ge;
}
var wa;
function xl() {
  return wa || (wa = 1, process.env.NODE_ENV === "production" ? bn.exports = Lf() : bn.exports = Ff()), bn.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var cr, xa;
function Mf() {
  if (xa) return cr;
  xa = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, l = 0; l < 10; l++)
        o["_" + String.fromCharCode(l)] = l;
      var s = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return cr = i() ? Object.assign : function(a, o) {
    for (var l, s = r(a), u, c = 1; c < arguments.length; c++) {
      l = Object(arguments[c]);
      for (var d in l)
        n.call(l, d) && (s[d] = l[d]);
      if (e) {
        u = e(l);
        for (var p = 0; p < u.length; p++)
          t.call(l, u[p]) && (s[u[p]] = l[u[p]]);
      }
    }
    return s;
  }, cr;
}
var dr, _a;
function yi() {
  if (_a) return dr;
  _a = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return dr = e, dr;
}
var fr, Na;
function _l() {
  return Na || (Na = 1, fr = Function.call.bind(Object.prototype.hasOwnProperty)), fr;
}
var hr, Ia;
function Rf() {
  if (Ia) return hr;
  Ia = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = yi(), t = {}, r = _l();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, l, s, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in a)
        if (r(a, c)) {
          var d;
          try {
            if (typeof a[c] != "function") {
              var p = Error(
                (s || "React class") + ": " + l + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            d = a[c](o, c, s, l, null, n);
          } catch (y) {
            d = y;
          }
          if (d && !(d instanceof Error) && e(
            (s || "React class") + ": type specification of " + l + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var h = u ? u() : "";
            e(
              "Failed " + l + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, hr = i, hr;
}
var pr, Ea;
function Df() {
  if (Ea) return pr;
  Ea = 1;
  var e = xl(), n = Mf(), t = yi(), r = _l(), i = Rf(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(l) {
    var s = "Warning: " + l;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return pr = function(l, s) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(g) {
      var z = g && (u && g[u] || g[c]);
      if (typeof z == "function")
        return z;
    }
    var p = "<<anonymous>>", h = {
      array: m("array"),
      bigint: m("bigint"),
      bool: m("boolean"),
      func: m("function"),
      number: m("number"),
      object: m("object"),
      string: m("string"),
      symbol: m("symbol"),
      any: x(),
      arrayOf: A,
      element: I(),
      elementType: b(),
      instanceOf: w,
      node: R(),
      objectOf: O,
      oneOf: S,
      oneOfType: N,
      shape: E,
      exact: L
    };
    function y(g, z) {
      return g === z ? g !== 0 || 1 / g === 1 / z : g !== g && z !== z;
    }
    function C(g, z) {
      this.message = g, this.data = z && typeof z == "object" ? z : {}, this.stack = "";
    }
    C.prototype = Error.prototype;
    function $(g) {
      if (process.env.NODE_ENV !== "production")
        var z = {}, J = 0;
      function v(ie, K, ne, q, M, Q, Z) {
        if (q = q || p, Q = Q || ne, Z !== t) {
          if (s) {
            var F = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw F.name = "Invariant Violation", F;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var oe = q + ":" + ne;
            !z[oe] && // Avoid spamming the console because they are often not actionable except for lib authors
            J < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Q + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), z[oe] = !0, J++);
          }
        }
        return K[ne] == null ? ie ? K[ne] === null ? new C("The " + M + " `" + Q + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new C("The " + M + " `" + Q + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : g(K, ne, q, M, Q);
      }
      var X = v.bind(null, !1);
      return X.isRequired = v.bind(null, !0), X;
    }
    function m(g) {
      function z(J, v, X, ie, K, ne) {
        var q = J[v], M = H(q);
        if (M !== g) {
          var Q = ee(q);
          return new C(
            "Invalid " + ie + " `" + K + "` of type " + ("`" + Q + "` supplied to `" + X + "`, expected ") + ("`" + g + "`."),
            { expectedType: g }
          );
        }
        return null;
      }
      return $(z);
    }
    function x() {
      return $(o);
    }
    function A(g) {
      function z(J, v, X, ie, K) {
        if (typeof g != "function")
          return new C("Property `" + K + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var ne = J[v];
        if (!Array.isArray(ne)) {
          var q = H(ne);
          return new C("Invalid " + ie + " `" + K + "` of type " + ("`" + q + "` supplied to `" + X + "`, expected an array."));
        }
        for (var M = 0; M < ne.length; M++) {
          var Q = g(ne, M, X, ie, K + "[" + M + "]", t);
          if (Q instanceof Error)
            return Q;
        }
        return null;
      }
      return $(z);
    }
    function I() {
      function g(z, J, v, X, ie) {
        var K = z[J];
        if (!l(K)) {
          var ne = H(K);
          return new C("Invalid " + X + " `" + ie + "` of type " + ("`" + ne + "` supplied to `" + v + "`, expected a single ReactElement."));
        }
        return null;
      }
      return $(g);
    }
    function b() {
      function g(z, J, v, X, ie) {
        var K = z[J];
        if (!e.isValidElementType(K)) {
          var ne = H(K);
          return new C("Invalid " + X + " `" + ie + "` of type " + ("`" + ne + "` supplied to `" + v + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return $(g);
    }
    function w(g) {
      function z(J, v, X, ie, K) {
        if (!(J[v] instanceof g)) {
          var ne = g.name || p, q = ae(J[v]);
          return new C("Invalid " + ie + " `" + K + "` of type " + ("`" + q + "` supplied to `" + X + "`, expected ") + ("instance of `" + ne + "`."));
        }
        return null;
      }
      return $(z);
    }
    function S(g) {
      if (!Array.isArray(g))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function z(J, v, X, ie, K) {
        for (var ne = J[v], q = 0; q < g.length; q++)
          if (y(ne, g[q]))
            return null;
        var M = JSON.stringify(g, function(Z, F) {
          var oe = ee(F);
          return oe === "symbol" ? String(F) : F;
        });
        return new C("Invalid " + ie + " `" + K + "` of value `" + String(ne) + "` " + ("supplied to `" + X + "`, expected one of " + M + "."));
      }
      return $(z);
    }
    function O(g) {
      function z(J, v, X, ie, K) {
        if (typeof g != "function")
          return new C("Property `" + K + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var ne = J[v], q = H(ne);
        if (q !== "object")
          return new C("Invalid " + ie + " `" + K + "` of type " + ("`" + q + "` supplied to `" + X + "`, expected an object."));
        for (var M in ne)
          if (r(ne, M)) {
            var Q = g(ne, M, X, ie, K + "." + M, t);
            if (Q instanceof Error)
              return Q;
          }
        return null;
      }
      return $(z);
    }
    function N(g) {
      if (!Array.isArray(g))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var z = 0; z < g.length; z++) {
        var J = g[z];
        if (typeof J != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + V(J) + " at index " + z + "."
          ), o;
      }
      function v(X, ie, K, ne, q) {
        for (var M = [], Q = 0; Q < g.length; Q++) {
          var Z = g[Q], F = Z(X, ie, K, ne, q, t);
          if (F == null)
            return null;
          F.data && r(F.data, "expectedType") && M.push(F.data.expectedType);
        }
        var oe = M.length > 0 ? ", expected one of type [" + M.join(", ") + "]" : "";
        return new C("Invalid " + ne + " `" + q + "` supplied to " + ("`" + K + "`" + oe + "."));
      }
      return $(v);
    }
    function R() {
      function g(z, J, v, X, ie) {
        return W(z[J]) ? null : new C("Invalid " + X + " `" + ie + "` supplied to " + ("`" + v + "`, expected a ReactNode."));
      }
      return $(g);
    }
    function T(g, z, J, v, X) {
      return new C(
        (g || "React class") + ": " + z + " type `" + J + "." + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function E(g) {
      function z(J, v, X, ie, K) {
        var ne = J[v], q = H(ne);
        if (q !== "object")
          return new C("Invalid " + ie + " `" + K + "` of type `" + q + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var M in g) {
          var Q = g[M];
          if (typeof Q != "function")
            return T(X, ie, K, M, ee(Q));
          var Z = Q(ne, M, X, ie, K + "." + M, t);
          if (Z)
            return Z;
        }
        return null;
      }
      return $(z);
    }
    function L(g) {
      function z(J, v, X, ie, K) {
        var ne = J[v], q = H(ne);
        if (q !== "object")
          return new C("Invalid " + ie + " `" + K + "` of type `" + q + "` " + ("supplied to `" + X + "`, expected `object`."));
        var M = n({}, J[v], g);
        for (var Q in M) {
          var Z = g[Q];
          if (r(g, Q) && typeof Z != "function")
            return T(X, ie, K, Q, ee(Z));
          if (!Z)
            return new C(
              "Invalid " + ie + " `" + K + "` key `" + Q + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(J[v], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(g), null, "  ")
            );
          var F = Z(ne, Q, X, ie, K + "." + Q, t);
          if (F)
            return F;
        }
        return null;
      }
      return $(z);
    }
    function W(g) {
      switch (typeof g) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !g;
        case "object":
          if (Array.isArray(g))
            return g.every(W);
          if (g === null || l(g))
            return !0;
          var z = d(g);
          if (z) {
            var J = z.call(g), v;
            if (z !== g.entries) {
              for (; !(v = J.next()).done; )
                if (!W(v.value))
                  return !1;
            } else
              for (; !(v = J.next()).done; ) {
                var X = v.value;
                if (X && !W(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(g, z) {
      return g === "symbol" ? !0 : z ? z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && z instanceof Symbol : !1;
    }
    function H(g) {
      var z = typeof g;
      return Array.isArray(g) ? "array" : g instanceof RegExp ? "object" : D(z, g) ? "symbol" : z;
    }
    function ee(g) {
      if (typeof g > "u" || g === null)
        return "" + g;
      var z = H(g);
      if (z === "object") {
        if (g instanceof Date)
          return "date";
        if (g instanceof RegExp)
          return "regexp";
      }
      return z;
    }
    function V(g) {
      var z = ee(g);
      switch (z) {
        case "array":
        case "object":
          return "an " + z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + z;
        default:
          return z;
      }
    }
    function ae(g) {
      return !g.constructor || !g.constructor.name ? p : g.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, pr;
}
var mr, Sa;
function Bf() {
  if (Sa) return mr;
  Sa = 1;
  var e = yi();
  function n() {
  }
  function t() {
  }
  return t.resetWarningCache = n, mr = function() {
    function r(o, l, s, u, c, d) {
      if (d !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: t,
      resetWarningCache: n
    };
    return a.PropTypes = a, a;
  }, mr;
}
if (process.env.NODE_ENV !== "production") {
  var jf = xl(), Hf = !0;
  Lr.exports = Df()(jf.isElement, Hf);
} else
  Lr.exports = Bf()();
var Vf = Lr.exports;
const B = /* @__PURE__ */ Bn(Vf);
var Nl = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var n = {}.hasOwnProperty;
    function t() {
      for (var a = "", o = 0; o < arguments.length; o++) {
        var l = arguments[o];
        l && (a = i(a, r(l)));
      }
      return a;
    }
    function r(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return t.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var o = "";
      for (var l in a)
        n.call(a, l) && a[l] && (o = i(o, l));
      return o;
    }
    function i(a, o) {
      return o ? a ? a + " " + o : a + o : a;
    }
    e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
  })();
})(Nl);
var zf = Nl.exports;
const kn = /* @__PURE__ */ Bn(zf);
function Wf(e, n, t) {
  switch (t) {
    case "Backspace":
      n > 0 && (e = e.slice(0, n - 1) + e.slice(n), n--);
      break;
    case "Delete":
      e = e.slice(0, n) + e.slice(n + 1);
      break;
  }
  return {
    value: e,
    caret: n
  };
}
function Uf(e, n, t) {
  for (var r = {}, i = "", a = 0, o = 0; o < e.length; ) {
    var l = t(e[o], i, r);
    l !== void 0 && (i += l, n !== void 0 && (n === o ? a = i.length - 1 : n > o && (a = i.length))), o++;
  }
  n === void 0 && (a = i.length);
  var s = {
    value: i,
    caret: a
  };
  return s;
}
function qf(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Zf(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zf(e, n) {
  if (e) {
    if (typeof e == "string") return Pa(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Pa(e, n);
  }
}
function Pa(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function Fr(e, n) {
  for (var t = 0, r = qf(n.split("")), i; !(i = r()).done; ) {
    var a = i.value;
    a === e && t++;
  }
  return t;
}
function Gf(e, n) {
  for (var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "x", r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : " ", i = e.length, a = Fr("(", e), o = Fr(")", e), l = a - o; l > 0 && i < n.length; )
    e += n[i].replace(t, r), n[i] === ")" && l--, i++;
  return e;
}
function Qf(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Kf(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kf(e, n) {
  if (e) {
    if (typeof e == "string") return ka(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ka(e, n);
  }
}
function ka(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function Yf(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", t = arguments.length > 2 ? arguments[2] : void 0;
  if (!e)
    return function(i) {
      return {
        text: i
      };
    };
  var r = Fr(n, e);
  return function(i) {
    if (!i)
      return {
        text: "",
        template: e
      };
    for (var a = 0, o = "", l = Qf(e.split("")), s; !(s = l()).done; ) {
      var u = s.value;
      if (u !== n) {
        o += u;
        continue;
      }
      if (o += i[a], a++, a === i.length && i.length < r)
        break;
    }
    return t && (o = Gf(o, e)), {
      text: o,
      template: e
    };
  };
}
function Xf(e, n, t) {
  typeof t == "string" && (t = Yf(t));
  var r = t(e) || {}, i = r.text, a = r.template;
  if (i === void 0 && (i = e), a)
    if (n === void 0)
      n = i.length;
    else {
      for (var o = 0, l = !1, s = -1; o < i.length && o < a.length; ) {
        if (i[o] !== a[o]) {
          if (n === 0) {
            l = !0, n = o;
            break;
          }
          s = o, n--;
        }
        o++;
      }
      l || (n = s + 1);
    }
  return {
    text: i,
    caret: n
  };
}
function Jf(e) {
  return e.hasAttribute("readonly");
}
function e4(e) {
  if (e.selectionStart !== e.selectionEnd)
    return {
      start: e.selectionStart,
      end: e.selectionEnd
    };
}
var Oa = {
  Backspace: 8,
  Delete: 46
};
function t4(e) {
  switch (e.keyCode) {
    case Oa.Backspace:
      return "Backspace";
    case Oa.Delete:
      return "Delete";
  }
}
function n4(e) {
  return e.selectionStart;
}
function Il(e, n) {
  n !== void 0 && (r4() ? setTimeout(function() {
    return e.setSelectionRange(n, n);
  }, 0) : e.setSelectionRange(n, n));
}
function r4() {
  if (typeof navigator < "u")
    return i4.test(navigator.userAgent);
}
var i4 = /Android/i;
function a4(e, n, t, r, i) {
  Mr(n, t, r, void 0, i);
}
function o4(e, n, t, r, i) {
  if (!Jf(n)) {
    var a = t4(e);
    switch (a) {
      case "Delete":
      case "Backspace":
        e.preventDefault();
        var o = e4(n);
        return o ? (l4(n, o), Mr(n, t, r, void 0, i)) : Mr(n, t, r, a, i);
    }
  }
}
function l4(e, n) {
  var t = e.value;
  t = t.slice(0, n.start) + t.slice(n.end), e.value = t, Il(e, n.start);
}
function Mr(e, n, t, r, i) {
  var a = Uf(e.value, n4(e), n), o = a.value, l = a.caret;
  if (r) {
    var s = Wf(o, l, r);
    o = s.value, l = s.caret;
  }
  var u = Xf(o, l, t), c = u.text;
  l = u.caret, e.value = c, Il(e, l), i && i(o);
}
var s4 = ["ref", "parse", "format", "value", "defaultValue", "controlled", "onChange", "onKeyDown"];
function Ta(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Ot(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Ta(Object(t), !0).forEach(function(r) {
      u4(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ta(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function u4(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function c4(e, n) {
  if (e == null) return {};
  var t = d4(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function d4(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function f4(e) {
  var n = e.ref, t = e.parse, r = e.format, i = e.value, a = e.defaultValue, o = e.controlled, l = o === void 0 ? !0 : o, s = e.onChange, u = e.onKeyDown, c = c4(e, s4), d = _e(), p = te(function($) {
    d.current = $, n && (typeof n == "function" ? n($) : n.current = $);
  }, [n]), h = te(function($) {
    return a4($, d.current, t, r, s);
  }, [d, t, r, s]), y = te(function($) {
    if (u && u($), !$.defaultPrevented)
      return o4($, d.current, t, r, s);
  }, [d, t, r, s, u]), C = Ot(Ot({}, c), {}, {
    ref: p,
    onChange: h,
    onKeyDown: y
  });
  return l ? Ot(Ot({}, C), {}, {
    value: r(La(i) ? "" : i).text
  }) : Ot(Ot({}, C), {}, {
    defaultValue: r(La(a) ? "" : a).text
  });
}
function La(e) {
  return e == null;
}
var h4 = ["inputComponent", "parse", "format", "value", "defaultValue", "onChange", "controlled", "onKeyDown", "type"];
function Fa(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function p4(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Fa(Object(t), !0).forEach(function(r) {
      m4(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Fa(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function m4(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function g4(e, n) {
  if (e == null) return {};
  var t = y4(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function y4(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function On(e, n) {
  var t = e.inputComponent, r = t === void 0 ? "input" : t, i = e.parse, a = e.format, o = e.value, l = e.defaultValue, s = e.onChange, u = e.controlled, c = e.onKeyDown, d = e.type, p = d === void 0 ? "text" : d, h = g4(e, h4), y = f4(p4({
    ref: n,
    parse: i,
    format: a,
    value: o,
    defaultValue: l,
    onChange: s,
    controlled: u,
    onKeyDown: c,
    type: p
  }, h));
  return /* @__PURE__ */ Y.createElement(r, y);
}
On = /* @__PURE__ */ Y.forwardRef(On);
On.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: B.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: B.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: B.elementType,
  // `<input/>` `type` attribute.
  type: B.string,
  // Is parsed from <input/> text.
  value: B.string,
  // An initial value for an "uncontrolled" <input/>.
  defaultValue: B.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: B.func,
  // Whether this input should be "controlled" or "uncontrolled".
  // The default value is `true` meaning "uncontrolled".
  controlled: B.bool,
  // Passthrough
  onKeyDown: B.func,
  onCut: B.func,
  onPaste: B.func
};
function Rr(e) {
  "@babel/helpers - typeof";
  return Rr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Rr(e);
}
function $4(e, n, t) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function v4(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function C4(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), n && un(e, n);
}
function b4(e) {
  var n = Sl();
  return function() {
    var r = cn(e), i;
    if (n) {
      var a = cn(this).constructor;
      i = Reflect.construct(r, arguments, a);
    } else
      i = r.apply(this, arguments);
    return A4(this, i);
  };
}
function A4(e, n) {
  if (n && (Rr(n) === "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return El(e);
}
function El(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Dr(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Dr = function(r) {
    if (r === null || !w4(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof n < "u") {
      if (n.has(r)) return n.get(r);
      n.set(r, i);
    }
    function i() {
      return Nn(r, arguments, cn(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), un(i, r);
  }, Dr(e);
}
function Nn(e, n, t) {
  return Sl() ? Nn = Reflect.construct : Nn = function(i, a, o) {
    var l = [null];
    l.push.apply(l, a);
    var s = Function.bind.apply(i, l), u = new s();
    return o && un(u, o.prototype), u;
  }, Nn.apply(null, arguments);
}
function Sl() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function w4(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function un(e, n) {
  return un = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, un(e, n);
}
function cn(e) {
  return cn = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, cn(e);
}
var ft = /* @__PURE__ */ function(e) {
  C4(t, e);
  var n = b4(t);
  function t(r) {
    var i;
    return v4(this, t), i = n.call(this, r), Object.setPrototypeOf(El(i), t.prototype), i.name = i.constructor.name, i;
  }
  return $4(t);
}(/* @__PURE__ */ Dr(Error)), $i = 2, x4 = 17, _4 = 3, je = "0-9０-９٠-٩۰-۹", N4 = "-‐-―−ー－", I4 = "／/", E4 = "．.", S4 = "  ­​⁠　", P4 = "()（）［］\\[\\]", k4 = "~⁓∼～", it = "".concat(N4).concat(I4).concat(E4).concat(S4).concat(P4).concat(k4), Wn = "+＋";
function Ma(e, n) {
  e = e.split("-"), n = n.split("-");
  for (var t = e[0].split("."), r = n[0].split("."), i = 0; i < 3; i++) {
    var a = Number(t[i]), o = Number(r[i]);
    if (a > o) return 1;
    if (o > a) return -1;
    if (!isNaN(a) && isNaN(o)) return 1;
    if (isNaN(a) && !isNaN(o)) return -1;
  }
  return e[1] && n[1] ? e[1] > n[1] ? 1 : e[1] < n[1] ? -1 : 0 : !e[1] && n[1] ? 1 : e[1] && !n[1] ? -1 : 0;
}
var O4 = {}.constructor;
function an(e) {
  return e != null && e.constructor === O4;
}
function Br(e) {
  "@babel/helpers - typeof";
  return Br = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Br(e);
}
function Un(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function T4(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function qn(e, n, t) {
  return n && T4(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var L4 = "1.2.0", F4 = "1.7.35", Ra = " ext. ", M4 = /^\d+$/, Oe = /* @__PURE__ */ function() {
  function e(n) {
    Un(this, e), j4(n), this.metadata = n, kl.call(this, n);
  }
  return qn(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && M4.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new Da(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new Da(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[t];
        if (i)
          return i;
      } else {
        var a = this.countryCallingCodes()[t];
        if (a && a.length === 1 && a[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), Da = /* @__PURE__ */ function() {
  function e(n, t) {
    Un(this, e), this.globalMetadataObject = t, this.metadata = n, kl.call(this, t.metadata);
  }
  return qn(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(i) {
        return new R4(i, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && Ba(this.types(), t))
        return new B4(Ba(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Ra : this.metadata[13] || Ra;
    }
  }]), e;
}(), R4 = /* @__PURE__ */ function() {
  function e(n, t) {
    Un(this, e), this._format = n, this.metadata = t;
  }
  return qn(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !D4.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), D4 = /^\(?\$1\)?$/, B4 = /* @__PURE__ */ function() {
  function e(n, t) {
    Un(this, e), this.type = n, this.metadata = t;
  }
  return qn(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Ba(e, n) {
  switch (n) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function j4(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!an(e) || !an(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(an(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + H4(e) + ": " + e, "."));
}
var H4 = function(n) {
  return Br(n);
};
function At(e, n) {
  if (n = new Oe(n), n.hasCountry(e))
    return n.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Pl(e, n) {
  return n.countries.hasOwnProperty(e);
}
function kl(e) {
  var n = e.version;
  typeof n == "number" ? (this.v1 = n === 1, this.v2 = n === 2, this.v3 = n === 3, this.v4 = n === 4) : n ? Ma(n, L4) === -1 ? this.v2 = !0 : Ma(n, F4) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var V4 = ";ext=", Tt = function(n) {
  return "([".concat(je, "]{1,").concat(n, "})");
};
function Ol(e) {
  var n = "20", t = "15", r = "9", i = "6", a = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", l = "#?", s = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", u = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", d = "[  \\t]*", p = "(?:,{2}|;)", h = V4 + Tt(n), y = a + s + o + Tt(n) + l, C = a + u + o + Tt(r) + l, $ = c + Tt(i) + "#", m = d + p + o + Tt(t) + l, x = d + "(?:,)+" + o + Tt(r) + l;
  return h + "|" + y + "|" + C + "|" + $ + "|" + m + "|" + x;
}
var z4 = "[" + je + "]{" + $i + "}", W4 = "[" + Wn + "]{0,1}(?:[" + it + "]*[" + je + "]){3,}[" + it + je + "]*", U4 = new RegExp("^[" + Wn + "]{0,1}(?:[" + it + "]*[" + je + "]){1,2}$", "i"), q4 = W4 + // Phone number extensions
"(?:" + Ol() + ")?", Z4 = new RegExp(
  // Either a short two-digit-only phone number
  "^" + z4 + "$|^" + q4 + "$",
  "i"
);
function G4(e) {
  return e.length >= $i && Z4.test(e);
}
function Q4(e) {
  return U4.test(e);
}
var ja = new RegExp("(?:" + Ol() + ")$", "i");
function K4(e) {
  var n = e.search(ja);
  if (n < 0)
    return {};
  for (var t = e.slice(0, n), r = e.match(ja), i = 1; i < r.length; ) {
    if (r[i])
      return {
        number: t,
        ext: r[i]
      };
    i++;
  }
}
function Y4(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = X4(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function X4(e, n) {
  if (e) {
    if (typeof e == "string") return Ha(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ha(e, n);
  }
}
function Ha(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
var J4 = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Tl(e) {
  return J4[e];
}
function Tn(e) {
  for (var n = "", t = Y4(e.split("")), r; !(r = t()).done; ) {
    var i = r.value, a = Tl(i);
    a && (n += a);
  }
  return n;
}
function e6(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = t6(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function t6(e, n) {
  if (e) {
    if (typeof e == "string") return Va(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Va(e, n);
  }
}
function Va(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function jr(e) {
  for (var n = "", t = e6(e.split("")), r; !(r = t()).done; ) {
    var i = r.value;
    n += Ll(i, n) || "";
  }
  return n;
}
function Ll(e, n, t) {
  if (e === "+") {
    if (n) {
      typeof t == "function" && t("end");
      return;
    }
    return "+";
  }
  return Tl(e);
}
function Zn(e, n) {
  return n6(e, void 0, n);
}
function n6(e, n, t) {
  var r = t.type(n), i = r && r.possibleLengths() || t.possibleLengths();
  if (!i)
    return "IS_POSSIBLE";
  var a = e.length, o = i[0];
  return o === a ? "IS_POSSIBLE" : o > a ? "TOO_SHORT" : i[i.length - 1] < a ? "TOO_LONG" : i.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function r6(e, n, t) {
  if (n === void 0 && (n = {}), t = new Oe(t), n.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    t.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!t.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      t.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      t.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (t.possibleLengths())
    return Fl(e.phone || e.nationalNumber, t);
  if (e.countryCallingCode && t.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Fl(e, n) {
  switch (Zn(e, n)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function mt(e, n) {
  return e = e || "", new RegExp("^(?:" + n + ")$").test(e);
}
function i6(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = a6(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function a6(e, n) {
  if (e) {
    if (typeof e == "string") return za(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return za(e, n);
  }
}
function za(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
var o6 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function vi(e, n, t) {
  if (n = n || {}, !(!e.country && !e.countryCallingCode)) {
    t = new Oe(t), t.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = n.v2 ? e.nationalNumber : e.phone;
    if (mt(r, t.nationalNumberPattern())) {
      if (gr(r, "FIXED_LINE", t))
        return t.type("MOBILE") && t.type("MOBILE").pattern() === "" || !t.type("MOBILE") || gr(r, "MOBILE", t) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = i6(o6), a; !(a = i()).done; ) {
        var o = a.value;
        if (gr(r, o, t))
          return o;
      }
    }
  }
}
function gr(e, n, t) {
  return n = t.type(n), !n || !n.pattern() || n.possibleLengths() && n.possibleLengths().indexOf(e.length) < 0 ? !1 : mt(e, n.pattern());
}
function l6(e, n, t) {
  if (n = n || {}, t = new Oe(t), t.selectNumberingPlan(e.country, e.countryCallingCode), t.hasTypes())
    return vi(e, n, t.metadata) !== void 0;
  var r = n.v2 ? e.nationalNumber : e.phone;
  return mt(r, t.nationalNumberPattern());
}
function s6(e, n, t) {
  var r = new Oe(t), i = r.getCountryCodesForCallingCode(e);
  return i ? i.filter(function(a) {
    return u6(n, a, t);
  }) : [];
}
function u6(e, n, t) {
  var r = new Oe(t);
  return r.selectNumberingPlan(n), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function Ml(e) {
  return e.replace(new RegExp("[".concat(it, "]+"), "g"), " ").trim();
}
var Rl = /(\$\d)/;
function Dl(e, n, t) {
  var r = t.useInternationalFormat, i = t.withNationalPrefix;
  t.carrierCode, t.metadata;
  var a = e.replace(new RegExp(n.pattern()), r ? n.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && n.nationalPrefixFormattingRule() ? n.format().replace(Rl, n.nationalPrefixFormattingRule()) : n.format()
  ));
  return r ? Ml(a) : a;
}
var c6 = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function d6(e, n, t) {
  var r = new Oe(t);
  if (r.selectNumberingPlan(e, n), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (c6.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
function f6(e) {
  var n = e.number, t = e.ext;
  if (!n)
    return "";
  if (n[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(n).concat(t ? ";ext=" + t : "");
}
function h6(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = p6(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p6(e, n) {
  if (e) {
    if (typeof e == "string") return Wa(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Wa(e, n);
  }
}
function Wa(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function Ua(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function qa(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Ua(Object(t), !0).forEach(function(r) {
      m6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ua(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function m6(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
var Za = {
  formatExtension: function(n, t, r) {
    return "".concat(n).concat(r.ext()).concat(t);
  }
};
function g6(e, n, t, r) {
  if (t ? t = qa(qa({}, Za), t) : t = Za, r = new Oe(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var i = r.countryCallingCode(), a = t.v2 ? e.nationalNumber : e.phone, o;
  switch (n) {
    case "NATIONAL":
      return a ? (o = Ln(a, e.carrierCode, "NATIONAL", r, t), yr(o, e.ext, r, t.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (o = Ln(a, null, "INTERNATIONAL", r, t), o = "+".concat(i, " ").concat(o), yr(o, e.ext, r, t.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(a);
    case "RFC3966":
      return f6({
        number: "+".concat(i).concat(a),
        ext: e.ext
      });
    case "IDD":
      if (!t.fromCountry)
        return;
      var l = $6(a, e.carrierCode, i, t.fromCountry, r);
      return yr(l, e.ext, r, t.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(n, '"'));
  }
}
function Ln(e, n, t, r, i) {
  var a = y6(r.formats(), e);
  return a ? Dl(e, a, {
    useInternationalFormat: t === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: n,
    metadata: r
  }) : e;
}
function y6(e, n) {
  for (var t = h6(e), r; !(r = t()).done; ) {
    var i = r.value;
    if (i.leadingDigitsPatterns().length > 0) {
      var a = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
      if (n.search(a) !== 0)
        continue;
    }
    if (mt(n, i.pattern()))
      return i;
  }
}
function yr(e, n, t, r) {
  return n ? r(e, n, t) : e;
}
function $6(e, n, t, r, i) {
  var a = At(r, i.metadata);
  if (a === t) {
    var o = Ln(e, n, "NATIONAL", i);
    return t === "1" ? t + " " + o : o;
  }
  var l = d6(r, void 0, i.metadata);
  if (l)
    return "".concat(l, " ").concat(t, " ").concat(Ln(e, null, "INTERNATIONAL", i));
}
function Ga(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Qa(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Ga(Object(t), !0).forEach(function(r) {
      v6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ga(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function v6(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function C6(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function b6(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function A6(e, n, t) {
  return n && b6(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Bl = /* @__PURE__ */ function() {
  function e(n, t, r) {
    if (C6(this, e), !n)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!t)
      throw new TypeError("`nationalNumber` not passed");
    if (!r)
      throw new TypeError("`metadata` not passed");
    var i = x6(n, r), a = i.country, o = i.countryCallingCode;
    this.country = a, this.countryCallingCode = o, this.nationalNumber = t, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return A6(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : s6(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return r6(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return l6(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new Oe(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return vi(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return g6(this, t, r ? Qa(Qa({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), e;
}(), w6 = function(n) {
  return /^[A-Z]{2}$/.test(n);
};
function x6(e, n) {
  var t, r, i = new Oe(n);
  return w6(e) ? (t = e, i.selectNumberingPlan(t), r = i.countryCallingCode()) : r = e, {
    country: t,
    countryCallingCode: r
  };
}
var _6 = new RegExp("([" + je + "])");
function jl(e, n, t, r) {
  if (n) {
    var i = new Oe(r);
    i.selectNumberingPlan(n, t);
    var a = new RegExp(i.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var o = e.match(_6);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function Hr(e, n) {
  if (e && n.numberingPlan.nationalPrefixForParsing()) {
    var t = new RegExp("^(?:" + n.numberingPlan.nationalPrefixForParsing() + ")"), r = t.exec(e);
    if (r) {
      var i, a, o = r.length - 1, l = o > 0 && r[o];
      if (n.nationalPrefixTransformRule() && l)
        i = e.replace(t, n.nationalPrefixTransformRule()), o > 1 && (a = r[1]);
      else {
        var s = r[0];
        i = e.slice(s.length), l && (a = r[1]);
      }
      var u;
      if (l) {
        var c = e.indexOf(r[1]), d = e.slice(0, c);
        d === n.numberingPlan.nationalPrefix() && (u = n.numberingPlan.nationalPrefix());
      } else
        u = r[0];
      return {
        nationalNumber: i,
        nationalPrefix: u,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function Vr(e, n) {
  var t = Hr(e, n), r = t.carrierCode, i = t.nationalNumber;
  if (i !== e) {
    if (!N6(e, i, n))
      return {
        nationalNumber: e
      };
    if (n.possibleLengths() && !I6(i, n))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: i,
    carrierCode: r
  };
}
function N6(e, n, t) {
  return !(mt(e, t.nationalNumberPattern()) && !mt(n, t.nationalNumberPattern()));
}
function I6(e, n) {
  switch (Zn(e, n)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Hl(e, n, t, r) {
  var i = n ? At(n, r) : t;
  if (e.indexOf(i) === 0) {
    r = new Oe(r), r.selectNumberingPlan(n, t);
    var a = e.slice(i.length), o = Vr(a, r), l = o.nationalNumber, s = Vr(e, r), u = s.nationalNumber;
    if (!mt(u, r.nationalNumberPattern()) && mt(l, r.nationalNumberPattern()) || Zn(u, r) === "TOO_LONG")
      return {
        countryCallingCode: i,
        number: a
      };
  }
  return {
    number: e
  };
}
function Vl(e, n, t, r) {
  if (!e)
    return {};
  var i;
  if (e[0] !== "+") {
    var a = jl(e, n, t, r);
    if (a && a !== e)
      i = !0, e = "+" + a;
    else {
      if (n || t) {
        var o = Hl(e, n, t, r), l = o.countryCallingCode, s = o.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: s
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new Oe(r);
  for (var u = 2; u - 1 <= _4 && u <= e.length; ) {
    var c = e.slice(1, u);
    if (r.hasCallingCode(c))
      return r.selectNumberingPlan(c), {
        countryCallingCodeSource: i ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: e.slice(u)
      };
    u++;
  }
  return {};
}
function E6(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = S6(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function S6(e, n) {
  if (e) {
    if (typeof e == "string") return Ka(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ka(e, n);
  }
}
function Ka(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function zl(e, n) {
  var t = n.countries;
  n.defaultCountry;
  var r = n.metadata;
  r = new Oe(r);
  for (var i = E6(t), a; !(a = i()).done; ) {
    var o = a.value;
    if (r.country(o), r.leadingDigits()) {
      if (e && e.search(r.leadingDigits()) === 0)
        return o;
    } else if (vi({
      phone: e,
      country: o
    }, void 0, r.metadata))
      return o;
  }
}
function Wl(e, n) {
  var t = n.nationalNumber, r = n.defaultCountry, i = n.metadata, a = i.getCountryCodesForCallingCode(e);
  if (a)
    return a.length === 1 ? a[0] : zl(t, {
      countries: a,
      defaultCountry: r,
      metadata: i.metadata
    });
}
var Ul = "+", P6 = "[\\-\\.\\(\\)]?", Ya = "([" + je + "]|" + P6 + ")", k6 = "^\\" + Ul + Ya + "*[" + je + "]" + Ya + "*$", O6 = new RegExp(k6, "g"), zr = je, T6 = "[" + zr + "]+((\\-)*[" + zr + "])*", L6 = "a-zA-Z", F6 = "[" + L6 + "]+((\\-)*[" + zr + "])*", M6 = "^(" + T6 + "\\.)*" + F6 + "\\.?$", R6 = new RegExp(M6, "g"), Xa = "tel:", Wr = ";phone-context=", D6 = ";isub=";
function B6(e) {
  var n = e.indexOf(Wr);
  if (n < 0)
    return null;
  var t = n + Wr.length;
  if (t >= e.length)
    return "";
  var r = e.indexOf(";", t);
  return r >= 0 ? e.substring(t, r) : e.substring(t);
}
function j6(e) {
  return e === null ? !0 : e.length === 0 ? !1 : O6.test(e) || R6.test(e);
}
function H6(e, n) {
  var t = n.extractFormattedPhoneNumber, r = B6(e);
  if (!j6(r))
    throw new ft("NOT_A_NUMBER");
  var i;
  if (r === null)
    i = t(e) || "";
  else {
    i = "", r.charAt(0) === Ul && (i += r);
    var a = e.indexOf(Xa), o;
    a >= 0 ? o = a + Xa.length : o = 0;
    var l = e.indexOf(Wr);
    i += e.substring(o, l);
  }
  var s = i.indexOf(D6);
  if (s > 0 && (i = i.substring(0, s)), i !== "")
    return i;
}
var V6 = 250, z6 = new RegExp("[" + Wn + je + "]"), W6 = new RegExp("[^" + je + "#]+$");
function U6(e, n, t) {
  if (n = n || {}, t = new Oe(t), n.defaultCountry && !t.hasCountry(n.defaultCountry))
    throw n.v2 ? new ft("INVALID_COUNTRY") : new Error("Unknown country: ".concat(n.defaultCountry));
  var r = Z6(e, n.v2, n.extract), i = r.number, a = r.ext, o = r.error;
  if (!i) {
    if (n.v2)
      throw o === "TOO_SHORT" ? new ft("TOO_SHORT") : new ft("NOT_A_NUMBER");
    return {};
  }
  var l = Q6(i, n.defaultCountry, n.defaultCallingCode, t), s = l.country, u = l.nationalNumber, c = l.countryCallingCode, d = l.countryCallingCodeSource, p = l.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (n.v2)
      throw new ft("INVALID_COUNTRY");
    return {};
  }
  if (!u || u.length < $i) {
    if (n.v2)
      throw new ft("TOO_SHORT");
    return {};
  }
  if (u.length > x4) {
    if (n.v2)
      throw new ft("TOO_LONG");
    return {};
  }
  if (n.v2) {
    var h = new Bl(c, u, t.metadata);
    return s && (h.country = s), p && (h.carrierCode = p), a && (h.ext = a), h.__countryCallingCodeSource = d, h;
  }
  var y = (n.extended ? t.hasSelectedNumberingPlan() : s) ? mt(u, t.nationalNumberPattern()) : !1;
  return n.extended ? {
    country: s,
    countryCallingCode: c,
    carrierCode: p,
    valid: y,
    possible: y ? !0 : !!(n.extended === !0 && t.possibleLengths() && Fl(u, t)),
    phone: u,
    ext: a
  } : y ? G6(s, u, a) : {};
}
function q6(e, n, t) {
  if (e) {
    if (e.length > V6) {
      if (t)
        throw new ft("TOO_LONG");
      return;
    }
    if (n === !1)
      return e;
    var r = e.search(z6);
    if (!(r < 0))
      return e.slice(r).replace(W6, "");
  }
}
function Z6(e, n, t) {
  var r = H6(e, {
    extractFormattedPhoneNumber: function(o) {
      return q6(o, t, n);
    }
  });
  if (!r)
    return {};
  if (!G4(r))
    return Q4(r) ? {
      error: "TOO_SHORT"
    } : {};
  var i = K4(r);
  return i.ext ? i : {
    number: r
  };
}
function G6(e, n, t) {
  var r = {
    country: e,
    phone: n
  };
  return t && (r.ext = t), r;
}
function Q6(e, n, t, r) {
  var i = Vl(jr(e), n, t, r.metadata), a = i.countryCallingCodeSource, o = i.countryCallingCode, l = i.number, s;
  if (o)
    r.selectNumberingPlan(o);
  else if (l && (n || t))
    r.selectNumberingPlan(n, t), n && (s = n), o = t || At(n, r.metadata);
  else return {};
  if (!l)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: o
    };
  var u = Vr(jr(l), r), c = u.nationalNumber, d = u.carrierCode, p = Wl(o, {
    nationalNumber: c,
    defaultCountry: n,
    metadata: r
  });
  return p && (s = p, p === "001" || r.country(s)), {
    country: s,
    countryCallingCode: o,
    countryCallingCodeSource: a,
    nationalNumber: c,
    carrierCode: d
  };
}
function Ja(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function eo(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Ja(Object(t), !0).forEach(function(r) {
      K6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ja(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function K6(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function Y6(e, n, t) {
  return U6(e, eo(eo({}, n), {}, {
    v2: !0
  }), t);
}
function to(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function X6(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? to(Object(t), !0).forEach(function(r) {
      J6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : to(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function J6(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function e7(e, n) {
  return i7(e) || r7(e, n) || n7(e, n) || t7();
}
function t7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function n7(e, n) {
  if (e) {
    if (typeof e == "string") return no(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return no(e, n);
  }
}
function no(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function r7(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r = [], i = !0, a = !1, o, l;
    try {
      for (t = t.call(e); !(i = (o = t.next()).done) && (r.push(o.value), !(n && r.length === n)); i = !0)
        ;
    } catch (s) {
      a = !0, l = s;
    } finally {
      try {
        !i && t.return != null && t.return();
      } finally {
        if (a) throw l;
      }
    }
    return r;
  }
}
function i7(e) {
  if (Array.isArray(e)) return e;
}
function ql(e) {
  var n = Array.prototype.slice.call(e), t = e7(n, 4), r = t[0], i = t[1], a = t[2], o = t[3], l, s, u;
  if (typeof r == "string")
    l = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    o ? (s = a, u = o) : (s = void 0, u = a), i && (s = X6({
      defaultCountry: i
    }, s));
  else if (an(i))
    a ? (s = i, u = a) : u = i;
  else throw new Error("Invalid second argument: ".concat(i));
  return {
    text: l,
    options: s,
    metadata: u
  };
}
function ro(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function io(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ro(Object(t), !0).forEach(function(r) {
      a7(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ro(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function a7(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function Zl(e, n, t) {
  n && n.defaultCountry && !Pl(n.defaultCountry, t) && (n = io(io({}, n), {}, {
    defaultCountry: void 0
  }));
  try {
    return Y6(e, n, t);
  } catch (r) {
    if (!(r instanceof ft)) throw r;
  }
}
function o7() {
  var e = ql(arguments), n = e.text, t = e.options, r = e.metadata;
  return Zl(n, t, r);
}
function ao(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function oo(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ao(Object(t), !0).forEach(function(r) {
      l7(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ao(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function l7(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function s7() {
  var e = ql(arguments), n = e.text, t = e.options, r = e.metadata;
  t = oo(oo({}, t), {}, {
    extract: !1
  });
  var i = Zl(n, t, r);
  return i && i.isValid() || !1;
}
function u7(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function c7(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function d7(e, n, t) {
  return n && c7(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var f7 = /* @__PURE__ */ function() {
  function e(n) {
    var t = n.onCountryChange, r = n.onCallingCodeChange;
    u7(this, e), this.onCountryChange = t, this.onCallingCodeChange = r;
  }
  return d7(e, [{
    key: "reset",
    value: function(t) {
      var r = t.country, i = t.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, i);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(t) {
      for (var r = 0, i = Object.keys(t); r < i.length; r++) {
        var a = i[r];
        this[a] = t[a];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(t, r) {
      this.setCountry(t), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(t) {
      this.country = t, this.onCountryChange(t);
    }
  }, {
    key: "setCallingCode",
    value: function(t) {
      this.callingCode = t, this.onCallingCodeChange(t, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      this.international = !0, this.initCountryAndCallingCode(t, r);
    }
  }, {
    key: "appendDigits",
    value: function(t) {
      this.digits += t;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(t) {
      this.nationalSignificantNumber += t;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function h7(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = p7(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p7(e, n) {
  if (e) {
    if (typeof e == "string") return lo(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return lo(e, n);
  }
}
function lo(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
var nt = "x", $r = new RegExp(nt);
function In(e, n) {
  if (n < 1)
    return "";
  for (var t = ""; n > 1; )
    n & 1 && (t += e), n >>= 1, e += e;
  return t + e;
}
function so(e, n) {
  return e[n] === ")" && n++, m7(e.slice(0, n));
}
function m7(e) {
  for (var n = [], t = 0; t < e.length; )
    e[t] === "(" ? n.push(t) : e[t] === ")" && n.pop(), t++;
  var r = 0, i = "";
  n.push(e.length);
  for (var a = 0, o = n; a < o.length; a++) {
    var l = o[a];
    i += e.slice(r, l), r = l + 1;
  }
  return i;
}
function g7(e, n, t) {
  for (var r = h7(t.split("")), i; !(i = r()).done; ) {
    var a = i.value;
    if (e.slice(n + 1).search($r) < 0)
      return;
    n = e.search($r), e = e.replace($r, a);
  }
  return [e, n];
}
function y7(e, n, t) {
  var r = t.metadata, i = t.shouldTryNationalPrefixFormattingRule, a = t.getSeparatorAfterNationalPrefix, o = new RegExp("^(?:".concat(n.pattern(), ")$"));
  if (o.test(e.nationalSignificantNumber))
    return v7(e, n, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: i,
      getSeparatorAfterNationalPrefix: a
    });
}
function $7(e, n) {
  return Zn(e, n) === "IS_POSSIBLE";
}
function v7(e, n, t) {
  var r = t.metadata, i = t.shouldTryNationalPrefixFormattingRule, a = t.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, i(n)) {
    var o = uo(e, n, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: a,
      metadata: r
    });
    if (o)
      return o;
  }
  return uo(e, n, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: a,
    metadata: r
  });
}
function uo(e, n, t) {
  var r = t.metadata, i = t.useNationalPrefixFormattingRule, a = t.getSeparatorAfterNationalPrefix, o = Dl(e.nationalSignificantNumber, n, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: i,
    metadata: r
  });
  if (i || (e.nationalPrefix ? o = e.nationalPrefix + a(n) + o : e.complexPrefixBeforeNationalSignificantNumber && (o = e.complexPrefixBeforeNationalSignificantNumber + " " + o)), C7(o, e))
    return o;
}
function C7(e, n) {
  return Tn(e) === n.getNationalDigits();
}
function b7(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function A7(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function w7(e, n, t) {
  return n && A7(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var x7 = /* @__PURE__ */ function() {
  function e() {
    b7(this, e);
  }
  return w7(e, [{
    key: "parse",
    value: function(t) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(t), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], i = r.branches, a = r.instructions;
      if (i)
        return {
          op: "|",
          args: i.concat([vr(a)])
        };
      if (a.length === 0)
        throw new Error("Pattern is required");
      return a.length === 1 ? a[0] : a;
    }
  }, {
    key: "startContext",
    value: function(t) {
      this.context.push(t);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(t) {
      if (!t)
        throw new Error("Pattern is required");
      var r = t.match(I7);
      if (!r) {
        if (N7.test(t))
          throw new Error("Illegal characters found in a pattern: ".concat(t));
        this.getContext().instructions = this.getContext().instructions.concat(t.split(""));
        return;
      }
      var i = r[1], a = t.slice(0, r.index), o = t.slice(r.index + i.length);
      switch (i) {
        case "(?:":
          a && this.parsePattern(a), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (a && this.parsePattern(a), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var l = this.getContext(), s = l.branches;
          s.push(vr(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: s
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (a && this.parsePattern(a), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(vr(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          a && this.parsePattern(a), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: _7(a)
          });
          break;
        default:
          throw new Error("Unknown operator: ".concat(i));
      }
      o && this.parsePattern(o);
    }
  }]), e;
}();
function _7(e) {
  for (var n = [], t = 0; t < e.length; ) {
    if (e[t] === "-") {
      if (t === 0 || t === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var r = e[t - 1].charCodeAt(0) + 1, i = e[t + 1].charCodeAt(0) - 1, a = r; a <= i; )
        n.push(String.fromCharCode(a)), a++;
    } else
      n.push(e[t]);
    t++;
  }
  return n;
}
var N7 = /[\(\)\[\]\?\:\|]/, I7 = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function vr(e) {
  return e.length === 1 ? e[0] : e;
}
function co(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = E7(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function E7(e, n) {
  if (e) {
    if (typeof e == "string") return fo(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return fo(e, n);
  }
}
function fo(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function S7(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function P7(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function k7(e, n, t) {
  return n && P7(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var O7 = /* @__PURE__ */ function() {
  function e(n) {
    S7(this, e), this.matchTree = new x7().parse(n);
  }
  return k7(e, [{
    key: "match",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.allowOverflow;
      if (!t)
        throw new Error("String is required");
      var a = Ur(t.split(""), this.matchTree, !0);
      if (a && a.match && delete a.matchedChars, !(a && a.overflow && !i))
        return a;
    }
  }]), e;
}();
function Ur(e, n, t) {
  if (typeof n == "string") {
    var r = e.join("");
    return n.indexOf(r) === 0 ? e.length === n.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(n) === 0 ? t && e.length > n.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, n.length)
    } : void 0;
  }
  if (Array.isArray(n)) {
    for (var i = e.slice(), a = 0; a < n.length; ) {
      var o = n[a], l = Ur(i, o, t && a === n.length - 1);
      if (l) {
        if (l.overflow)
          return l;
        if (l.match) {
          if (i = i.slice(l.matchedChars.length), i.length === 0)
            return a === n.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (l.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(l, null, 2)));
        }
      } else return;
      a++;
    }
    return t ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - i.length)
    };
  }
  switch (n.op) {
    case "|":
      for (var s, u = co(n.args), c; !(c = u()).done; ) {
        var d = c.value, p = Ur(e, d, t);
        if (p) {
          if (p.overflow)
            return p;
          if (p.match)
            return {
              match: !0,
              matchedChars: p.matchedChars
            };
          if (p.partialMatch)
            s = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(p, null, 2)));
        }
      }
      return s ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var h = co(n.args), y; !(y = h()).done; ) {
        var C = y.value;
        if (e[0] === C)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : t ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [C]
          };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(n));
  }
}
function ho(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = T7(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function T7(e, n) {
  if (e) {
    if (typeof e == "string") return po(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return po(e, n);
  }
}
function po(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function L7(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function F7(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function M7(e, n, t) {
  return n && F7(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var qr = "9", R7 = 15, D7 = In(qr, R7), B7 = /[- ]/, j7 = function() {
  return /\[([^\[\]])*\]/g;
}, H7 = function() {
  return /\d(?=[^,}][^,}])/g;
}, V7 = new RegExp("[" + it + "]*\\$1[" + it + "]*(\\$\\d[" + it + "]*)*$"), mo = 3, z7 = /* @__PURE__ */ function() {
  function e(n) {
    n.state;
    var t = n.metadata;
    L7(this, e), this.metadata = t, this.resetFormat();
  }
  return M7(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(t, r) {
      this.resetFormat(), t ? (this.isNANP = t.callingCode() === "1", this.matchingFormats = t.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(t, r) {
      var i = this;
      if ($7(r.nationalSignificantNumber, this.metadata))
        for (var a = ho(this.matchingFormats), o; !(o = a()).done; ) {
          var l = o.value, s = y7(r, l, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(c) {
              return i.shouldTryNationalPrefixFormattingRule(c, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(c) {
              return i.getSeparatorAfterNationalPrefix(c);
            }
          });
          if (s)
            return this.resetFormat(), this.chosenFormat = l, this.setNationalNumberTemplate(s.replace(/\d/g, nt), r), this.populatedNationalNumberTemplate = s, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(nt), s;
        }
      return this.formatNationalNumberWithNextDigits(t, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(t, r) {
      var i = this.chosenFormat, a = this.chooseFormat(r);
      if (a)
        return a === i ? this.formatNextNationalNumberDigits(t) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(t) {
      var r = this, i = t.nationalSignificantNumber, a = t.nationalPrefix, o = t.international, l = i, s = l.length - mo;
      s < 0 && (s = 0), this.matchingFormats = this.matchingFormats.filter(function(u) {
        return r.formatSuits(u, o, a) && r.formatMatches(u, l, s);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(t, r, i) {
      return !(i && !t.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !t.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !i && t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(t, r, i) {
      var a = t.leadingDigitsPatterns().length;
      if (a === 0)
        return !0;
      i = Math.min(i, a - 1);
      var o = t.leadingDigitsPatterns()[i];
      if (r.length < mo)
        try {
          return new O7(o).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (l) {
          return console.error(l), !0;
        }
      return new RegExp("^(".concat(o, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(t, r) {
      return r ? t.internationalFormat() : t.format();
    }
  }, {
    key: "chooseFormat",
    value: function(t) {
      for (var r = this, i = function() {
        var u = o.value;
        return r.chosenFormat === u ? "break" : V7.test(r.getFormatFormat(u, t.international)) ? r.createTemplateForFormat(u, t) ? (r.chosenFormat = u, "break") : (r.matchingFormats = r.matchingFormats.filter(function(c) {
          return c !== u;
        }), "continue") : "continue";
      }, a = ho(this.matchingFormats.slice()), o; !(o = a()).done; ) {
        var l = i();
        if (l === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(t, r) {
      if (!(t.pattern().indexOf("|") >= 0)) {
        var i = this.getTemplateForFormat(t, r);
        if (i)
          return this.setNationalNumberTemplate(i, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(t) {
      return this.isNANP || t && t.nationalPrefixFormattingRule() && B7.test(t.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(t, r) {
      var i = t.IDDPrefix, a = t.missingPlus;
      return i ? r && r.spacing === !1 ? i : i + " " : a ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(t) {
      if (this.template) {
        for (var r = -1, i = 0, a = t.international ? this.getInternationalPrefixBeforeCountryCallingCode(t, {
          spacing: !1
        }) : ""; i < a.length + t.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(nt, r + 1), i++;
        return so(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(t, r) {
      this.nationalNumberTemplate = t, this.populatedNationalNumberTemplate = t, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, nt) + In(nt, r.callingCode.length) + " " + t : this.template = t;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(t, r) {
      var i = r.nationalSignificantNumber, a = r.international, o = r.nationalPrefix, l = r.complexPrefixBeforeNationalSignificantNumber, s = t.pattern();
      s = s.replace(j7(), "\\d").replace(H7(), "\\d");
      var u = D7.match(s)[0];
      if (!(i.length > u.length)) {
        var c = new RegExp("^" + s + "$"), d = i.replace(/\d/g, qr);
        c.test(d) && (u = d);
        var p = this.getFormatFormat(t, a), h;
        if (this.shouldTryNationalPrefixFormattingRule(t, {
          international: a,
          nationalPrefix: o
        })) {
          var y = p.replace(Rl, t.nationalPrefixFormattingRule());
          if (Tn(t.nationalPrefixFormattingRule()) === (o || "") + Tn("$1") && (p = y, h = !0, o))
            for (var C = o.length; C > 0; )
              p = p.replace(/\d/, nt), C--;
        }
        var $ = u.replace(new RegExp(s), p).replace(new RegExp(qr, "g"), nt);
        return h || (l ? $ = In(nt, l.length) + " " + $ : o && ($ = In(nt, o.length) + this.getSeparatorAfterNationalPrefix(t) + $)), a && ($ = Ml($)), $;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(t) {
      var r = g7(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, t);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], so(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(t, r) {
      var i = r.international, a = r.nationalPrefix;
      if (t.nationalPrefixFormattingRule()) {
        var o = t.usesNationalPrefix();
        if (o && a || !o && !i)
          return !0;
      }
    }
  }]), e;
}();
function Gl(e, n) {
  return Z7(e) || q7(e, n) || U7(e, n) || W7();
}
function W7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function U7(e, n) {
  if (e) {
    if (typeof e == "string") return go(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return go(e, n);
  }
}
function go(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function q7(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r = [], i = !0, a = !1, o, l;
    try {
      for (t = t.call(e); !(i = (o = t.next()).done) && (r.push(o.value), !(n && r.length === n)); i = !0)
        ;
    } catch (s) {
      a = !0, l = s;
    } finally {
      try {
        !i && t.return != null && t.return();
      } finally {
        if (a) throw l;
      }
    }
    return r;
  }
}
function Z7(e) {
  if (Array.isArray(e)) return e;
}
function G7(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Q7(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function K7(e, n, t) {
  return n && Q7(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Y7 = "[" + it + je + "]+", X7 = new RegExp("^" + Y7 + "$", "i"), J7 = "(?:[" + Wn + "][" + it + je + "]*|[" + it + je + "]+)", e9 = new RegExp("[^" + it + je + "]+.*$"), t9 = /[^\d\[\]]/, n9 = /* @__PURE__ */ function() {
  function e(n) {
    var t = n.defaultCountry, r = n.defaultCallingCode, i = n.metadata, a = n.onNationalSignificantNumberChange;
    G7(this, e), this.defaultCountry = t, this.defaultCallingCode = r, this.metadata = i, this.onNationalSignificantNumberChange = a;
  }
  return K7(e, [{
    key: "input",
    value: function(t, r) {
      var i = a9(t), a = Gl(i, 2), o = a[0], l = a[1], s = Tn(o), u;
      return l && (r.digits || (r.startInternationalNumber(), s || (u = !0))), s && this.inputDigits(s, r), {
        digits: s,
        justLeadingPlus: u
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(t, r) {
      var i = r.digits, a = i.length < 3 && i.length + t.length >= 3;
      if (r.appendDigits(t), a && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(t);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(o) {
        return r.update(o);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(t) {
      var r = t.international, i = t.callingCode;
      return r && !i;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(t) {
      var r = Vl("+" + t.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = r.countryCallingCode, a = r.number;
      if (i)
        return t.setCallingCode(i), t.update({
          nationalSignificantNumber: a
        }), !0;
    }
  }, {
    key: "reset",
    value: function(t) {
      if (t) {
        this.hasSelectedNumberingPlan = !0;
        var r = t._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && t9.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(t, r) {
      if (this.hasSelectedNumberingPlan) {
        var i = Hr(t, this.metadata), a = i.nationalPrefix, o = i.nationalNumber, l = i.carrierCode;
        if (o !== t)
          return this.onExtractedNationalNumber(a, l, o, t, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(t, r, i) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(t, i);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var a = Hr(t, this.metadata), o = a.nationalPrefix, l = a.nationalNumber, s = a.carrierCode;
        if (l !== r)
          return this.onExtractedNationalNumber(o, s, l, t, i), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(t, r, i, a, o) {
      var l, s, u = a.lastIndexOf(i);
      if (u >= 0 && u === a.length - i.length) {
        s = !0;
        var c = a.slice(0, u);
        c !== t && (l = c);
      }
      o({
        nationalPrefix: t,
        carrierCode: r,
        nationalSignificantNumber: i,
        nationalSignificantNumberMatchesInput: s,
        complexPrefixBeforeNationalSignificantNumber: l
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(t) {
      if (this.extractAnotherNationalSignificantNumber(t.getNationalDigits(), t.nationalSignificantNumber, function(r) {
        return t.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
      if (this.fixMissingPlus(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(t) {
      var r = t.international, i = t.IDDPrefix, a = t.digits;
      if (t.nationalSignificantNumber, !(r || i)) {
        var o = jl(a, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (o !== void 0 && o !== a)
          return t.update({
            IDDPrefix: a.slice(0, a.length - o.length)
          }), this.startInternationalNumber(t, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(t) {
      if (!t.international) {
        var r = Hl(t.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = r.countryCallingCode;
        if (r.number, i)
          return t.update({
            missingPlus: !0
          }), this.startInternationalNumber(t, {
            country: t.country,
            callingCode: i
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      var i = r.country, a = r.callingCode;
      t.startInternationalNumber(i, a), t.nationalSignificantNumber && (t.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(t) {
      this.extractCountryCallingCode(t) && this.extractNationalSignificantNumber(t.getNationalDigits(), function(r) {
        return t.update(r);
      });
    }
  }]), e;
}();
function r9(e) {
  var n = e.search(J7);
  if (!(n < 0)) {
    e = e.slice(n);
    var t;
    return e[0] === "+" && (t = !0, e = e.slice(1)), e = e.replace(e9, ""), t && (e = "+" + e), e;
  }
}
function i9(e) {
  var n = r9(e) || "";
  return n[0] === "+" ? [n.slice(1), !0] : [n];
}
function a9(e) {
  var n = i9(e), t = Gl(n, 2), r = t[0], i = t[1];
  return X7.test(r) || (r = ""), [r, i];
}
function o9(e, n) {
  return c9(e) || u9(e, n) || s9(e, n) || l9();
}
function l9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function s9(e, n) {
  if (e) {
    if (typeof e == "string") return yo(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return yo(e, n);
  }
}
function yo(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function u9(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r = [], i = !0, a = !1, o, l;
    try {
      for (t = t.call(e); !(i = (o = t.next()).done) && (r.push(o.value), !(n && r.length === n)); i = !0)
        ;
    } catch (s) {
      a = !0, l = s;
    } finally {
      try {
        !i && t.return != null && t.return();
      } finally {
        if (a) throw l;
      }
    }
    return r;
  }
}
function c9(e) {
  if (Array.isArray(e)) return e;
}
function d9(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function f9(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function h9(e, n, t) {
  return n && f9(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var qt = /* @__PURE__ */ function() {
  function e(n, t) {
    d9(this, e), this.metadata = new Oe(t);
    var r = this.getCountryAndCallingCode(n), i = o9(r, 2), a = i[0], o = i[1];
    this.defaultCountry = a, this.defaultCallingCode = o, this.reset();
  }
  return h9(e, [{
    key: "getCountryAndCallingCode",
    value: function(t) {
      var r, i;
      return t && (an(t) ? (r = t.defaultCountry, i = t.defaultCallingCode) : r = t), r && !this.metadata.hasCountry(r) && (r = void 0), [r, i];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(t) {
      var r = this.parser.input(t, this.state), i = r.digits, a = r.justLeadingPlus;
      if (a)
        this.formattedOutput = "+";
      else if (i) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var o;
        if (this.metadata.hasSelectedNumberingPlan() && (o = this.formatter.format(i, this.state)), o === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var l = this.state.getNationalDigits();
          l && (o = this.formatter.format(l, this.state));
        }
        this.formattedOutput = o ? this.getFullNumber(o) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var t = this;
      return this.state = new f7({
        onCountryChange: function(i) {
          t.country = i;
        },
        onCallingCodeChange: function(i, a) {
          t.metadata.selectNumberingPlan(a, i), t.formatter.reset(t.metadata.numberingPlan, t.state), t.parser.reset(t.metadata.numberingPlan);
        }
      }), this.formatter = new z7({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new n9({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          t.determineTheCountryIfNeeded(), t.formatter.reset(t.metadata.numberingPlan, t.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var t = this.state.digits;
      if (t)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var t = this.state.country;
      return t;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(t) {
      var r = this;
      if (this.isInternational()) {
        var i = function(l) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!l
          }) + l;
        }, a = this.state.callingCode;
        return i(a ? t ? "".concat(a, " ").concat(t) : a : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return t;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, i = t.complexPrefixBeforeNationalSignificantNumber, a = t.nationalPrefix, o = r, l = i || a;
      return l && (o = l + o), o;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var t = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(t ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var t = this.getNonFormattedNumber();
      if (t)
        return t.replace(/[\+\d]/g, nt);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var t = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(t);
      return r && r.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(Wl(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var t = this.state, r = t.digits, i = t.callingCode, a = t.country, o = t.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return i ? "+" + i + o : "+" + r;
        if (a || i) {
          var l = a ? this.metadata.countryCallingCode() : i;
          return "+" + l + o;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, i = t.carrierCode, a = t.callingCode, o = this._getCountry();
      if (r && !(!o && !a)) {
        if (o && o === this.defaultCountry) {
          var l = new Oe(this.metadata.metadata);
          l.selectNumberingPlan(o);
          var s = l.numberingPlan.callingCode(), u = this.metadata.getCountryCodesForCallingCode(s);
          if (u.length > 1) {
            var c = zl(r, {
              countries: u,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            c && (o = c);
          }
        }
        var d = new Bl(o || a, r, this.metadata.metadata);
        return i && (d.carrierCode = i), d;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var t = this.getNumber();
      return t ? t.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var t = this.getNumber();
      return t ? t.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function $o(e) {
  return new Oe(e).getCountries();
}
function p9(e, n, t) {
  return t || (t = n, n = void 0), new qt(n, t).input(e);
}
function Ql(e) {
  var n = e.inputFormat, t = e.country, r = e.metadata;
  return n === "NATIONAL_PART_OF_INTERNATIONAL" ? "+".concat(At(t, r)) : "";
}
function Zr(e, n) {
  return n && (e = e.slice(n.length), e[0] === " " && (e = e.slice(1))), e;
}
function m9(e, n, t) {
  if (!(t && t.ignoreRest)) {
    var r = function(a) {
      if (t)
        switch (a) {
          case "end":
            t.ignoreRest = !0;
            break;
        }
    };
    return Ll(e, n, r);
  }
}
function Kl(e) {
  var n = e.onKeyDown, t = e.inputFormat;
  return te(function(r) {
    if (r.keyCode === y9 && t === "INTERNATIONAL" && r.target instanceof HTMLInputElement && g9(r.target) === $9.length) {
      r.preventDefault();
      return;
    }
    n && n(r);
  }, [n, t]);
}
function g9(e) {
  return e.selectionStart;
}
var y9 = 8, $9 = "+", v9 = ["onKeyDown", "country", "inputFormat", "metadata", "international", "withCountryCallingCode"];
function Gr() {
  return Gr = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Gr.apply(this, arguments);
}
function C9(e, n) {
  if (e == null) return {};
  var t = b9(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function b9(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function A9(e) {
  function n(t, r) {
    var i = t.onKeyDown, a = t.country, o = t.inputFormat, l = t.metadata, s = l === void 0 ? e : l;
    t.international, t.withCountryCallingCode;
    var u = C9(t, v9), c = te(function(p) {
      var h = new qt(a, s), y = Ql({
        inputFormat: o,
        country: a,
        metadata: s
      }), C = h.input(y + p), $ = h.getTemplate();
      return y && (C = Zr(C, y), $ && ($ = Zr($, y))), {
        text: C,
        template: $
      };
    }, [a, s]), d = Kl({
      onKeyDown: i,
      inputFormat: o
    });
    return /* @__PURE__ */ Y.createElement(On, Gr({}, u, {
      ref: r,
      parse: m9,
      format: c,
      onKeyDown: d
    }));
  }
  return n = /* @__PURE__ */ Y.forwardRef(n), n.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: B.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: B.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: B.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: B.string,
    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: B.oneOf(["INTERNATIONAL", "NATIONAL_PART_OF_INTERNATIONAL", "NATIONAL", "INTERNATIONAL_OR_NATIONAL"]).isRequired,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: B.object
  }, n;
}
const w9 = A9();
var x9 = ["value", "onChange", "onKeyDown", "country", "inputFormat", "metadata", "inputComponent", "international", "withCountryCallingCode"];
function Qr() {
  return Qr = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Qr.apply(this, arguments);
}
function _9(e, n) {
  if (e == null) return {};
  var t = N9(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function N9(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function I9(e) {
  function n(t, r) {
    var i = t.value, a = t.onChange, o = t.onKeyDown, l = t.country, s = t.inputFormat, u = t.metadata, c = u === void 0 ? e : u, d = t.inputComponent, p = d === void 0 ? "input" : d;
    t.international, t.withCountryCallingCode;
    var h = _9(t, x9), y = Ql({
      inputFormat: s,
      country: l,
      metadata: c
    }), C = te(function(m) {
      var x = jr(m.target.value);
      if (x === i) {
        var A = vo(y, x, l, c);
        A.indexOf(m.target.value) === 0 && (x = x.slice(0, -1));
      }
      a(x);
    }, [y, i, a, l, c]), $ = Kl({
      onKeyDown: o,
      inputFormat: s
    });
    return /* @__PURE__ */ Y.createElement(p, Qr({}, h, {
      ref: r,
      value: vo(y, i, l, c),
      onChange: C,
      onKeyDown: $
    }));
  }
  return n = /* @__PURE__ */ Y.forwardRef(n), n.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: B.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: B.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: B.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: B.string,
    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: B.oneOf(["INTERNATIONAL", "NATIONAL_PART_OF_INTERNATIONAL", "NATIONAL", "INTERNATIONAL_OR_NATIONAL"]).isRequired,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: B.object,
    /**
     * The `<input/>` component.
     */
    inputComponent: B.elementType
  }, n;
}
const E9 = I9();
function vo(e, n, t, r) {
  return Zr(p9(e + n, t, r), e);
}
function S9(e) {
  return Co(e[0]) + Co(e[1]);
}
function Co(e) {
  return String.fromCodePoint(127397 + e.toUpperCase().charCodeAt(0));
}
var P9 = ["value", "onChange", "options", "disabled", "readOnly"], k9 = ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"];
function O9(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = T9(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function T9(e, n) {
  if (e) {
    if (typeof e == "string") return bo(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return bo(e, n);
  }
}
function bo(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
  return r;
}
function Fn() {
  return Fn = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Fn.apply(this, arguments);
}
function Yl(e, n) {
  if (e == null) return {};
  var t = L9(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function L9(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function Xl(e) {
  var n = e.value, t = e.onChange, r = e.options, i = e.disabled, a = e.readOnly, o = Yl(e, P9), l = te(function(s) {
    var u = s.target.value;
    t(u === "ZZ" ? void 0 : u);
  }, [t]);
  return ht(function() {
    return es(r, n);
  }, [r, n]), /* @__PURE__ */ Y.createElement("select", Fn({}, o, {
    disabled: i || a,
    readOnly: a,
    value: n || "ZZ",
    onChange: l
  }), r.map(function(s) {
    var u = s.value, c = s.label, d = s.divider;
    return /* @__PURE__ */ Y.createElement("option", {
      key: d ? "|" : u || "ZZ",
      value: d ? "|" : u || "ZZ",
      disabled: !!d,
      style: d ? F9 : void 0
    }, c);
  }));
}
Xl.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: B.string,
  /**
   * A function of `value: string`.
   * Updates the `value` property.
   */
  onChange: B.func.isRequired,
  // `<select/>` options.
  options: B.arrayOf(B.shape({
    value: B.string,
    label: B.string,
    divider: B.bool
  })).isRequired,
  // `readonly` attribute doesn't work on a `<select/>`.
  // https://github.com/catamphetamine/react-phone-number-input/issues/419#issuecomment-1764384480
  // https://www.delftstack.com/howto/html/html-select-readonly/
  // To work around that, if `readOnly: true` property is passed
  // to this component, it behaves analogous to `disabled: true`.
  disabled: B.bool,
  readOnly: B.bool
};
var F9 = {
  fontSize: "1px",
  backgroundColor: "currentColor",
  color: "inherit"
};
function Jl(e) {
  var n = e.value, t = e.options, r = e.className, i = e.iconComponent;
  e.getIconAspectRatio;
  var a = e.arrowComponent, o = a === void 0 ? M9 : a, l = e.unicodeFlags, s = Yl(e, k9), u = ht(function() {
    return es(t, n);
  }, [t, n]);
  return /* @__PURE__ */ Y.createElement("div", {
    className: "PhoneInputCountry"
  }, /* @__PURE__ */ Y.createElement(Xl, Fn({}, s, {
    value: n,
    options: t,
    className: kn("PhoneInputCountrySelect", r)
  })), u && (l && n ? /* @__PURE__ */ Y.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, S9(n)) : /* @__PURE__ */ Y.createElement(i, {
    "aria-hidden": !0,
    country: n,
    label: u.label,
    aspectRatio: l ? 1 : void 0
  })), /* @__PURE__ */ Y.createElement(o, null));
}
Jl.propTypes = {
  // Country flag component.
  iconComponent: B.elementType,
  // Select arrow component.
  arrowComponent: B.elementType,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: B.bool
};
function M9() {
  return /* @__PURE__ */ Y.createElement("div", {
    className: "PhoneInputCountrySelectArrow"
  });
}
function es(e, n) {
  for (var t = O9(e), r; !(r = t()).done; ) {
    var i = r.value;
    if (!i.divider && R9(i.value, n))
      return i;
  }
}
function R9(e, n) {
  return e == null ? n == null : e === n;
}
var D9 = ["country", "countryName", "flags", "flagUrl"];
function Kr() {
  return Kr = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Kr.apply(this, arguments);
}
function B9(e, n) {
  if (e == null) return {};
  var t = j9(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function j9(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function Ci(e) {
  var n = e.country, t = e.countryName, r = e.flags, i = e.flagUrl, a = B9(e, D9);
  return r && r[n] ? r[n]({
    title: t
  }) : /* @__PURE__ */ Y.createElement("img", Kr({}, a, {
    alt: t,
    role: t ? void 0 : "presentation",
    src: i.replace("{XX}", n).replace("{xx}", n.toLowerCase())
  }));
}
Ci.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: B.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: B.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: B.objectOf(B.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: B.string.isRequired
};
var H9 = ["aspectRatio"], V9 = ["title"], z9 = ["title"];
function Mn() {
  return Mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Mn.apply(this, arguments);
}
function bi(e, n) {
  if (e == null) return {};
  var t = W9(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function W9(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function Gn(e) {
  var n = e.aspectRatio, t = bi(e, H9);
  return n === 1 ? /* @__PURE__ */ Y.createElement(ns, t) : /* @__PURE__ */ Y.createElement(ts, t);
}
Gn.propTypes = {
  title: B.string.isRequired,
  aspectRatio: B.number
};
function ts(e) {
  var n = e.title, t = bi(e, V9);
  return /* @__PURE__ */ Y.createElement("svg", Mn({}, t, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), /* @__PURE__ */ Y.createElement("title", null, n), /* @__PURE__ */ Y.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, /* @__PURE__ */ Y.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), /* @__PURE__ */ Y.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), /* @__PURE__ */ Y.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), /* @__PURE__ */ Y.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), /* @__PURE__ */ Y.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), /* @__PURE__ */ Y.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), /* @__PURE__ */ Y.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}
ts.propTypes = {
  title: B.string.isRequired
};
function ns(e) {
  var n = e.title, t = bi(e, z9);
  return /* @__PURE__ */ Y.createElement("svg", Mn({}, t, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), /* @__PURE__ */ Y.createElement("title", null, n), /* @__PURE__ */ Y.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /* @__PURE__ */ Y.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), /* @__PURE__ */ Y.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), /* @__PURE__ */ Y.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), /* @__PURE__ */ Y.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), /* @__PURE__ */ Y.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), /* @__PURE__ */ Y.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), /* @__PURE__ */ Y.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}
ns.propTypes = {
  title: B.string.isRequired
};
function U9(e) {
  if (e.length < 2 || e[0] !== "+")
    return !1;
  for (var n = 1; n < e.length; ) {
    var t = e.charCodeAt(n);
    if (!(t >= 48 && t <= 57)) return !1;
    n++;
  }
  return !0;
}
function rs(e) {
  U9(e) || console.error("[react-phone-number-input] Expected the initial `value` to be a E.164 phone number. Got", e);
}
function q9(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Z9(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z9(e, n) {
  if (e) {
    if (typeof e == "string") return Ao(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ao(e, n);
  }
}
function Ao(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
  return r;
}
function G9(e, n) {
  if (!n)
    return e;
  for (var t = [], r = [], i = t, a = function() {
    var u = l.value;
    if (u === "|")
      i.push({
        divider: !0
      });
    else if (u === "..." || u === "…")
      i = r;
    else {
      var c;
      u === "🌐" ? c = void 0 : c = u;
      var d = e.indexOf(e.filter(function(h) {
        return h.value === c;
      })[0]), p = e[d];
      e.splice(d, 1), i.push(p);
    }
  }, o = q9(n), l; !(l = o()).done; )
    a();
  return t.concat(e).concat(r);
}
function Q9(e, n) {
  if (e && (e = e.filter(function(t) {
    switch (t) {
      case "🌐":
      case "|":
      case "...":
      case "…":
        return !0;
      default:
        return Qn(t, n);
    }
  }), e.length > 0))
    return e;
}
function Qn(e, n) {
  return Pl(e, n) ? !0 : (console.error("Country not found: ".concat(e)), !1);
}
function is(e, n) {
  return e && (e = e.filter(function(t) {
    return Qn(t, n);
  }), e.length === 0 && (e = void 0)), e;
}
var K9 = ["country", "label", "aspectRatio"];
function Yr() {
  return Yr = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Yr.apply(this, arguments);
}
function Y9(e, n) {
  if (e == null) return {};
  var t = X9(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function X9(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function as(e) {
  var n = e.flags, t = e.flagUrl, r = e.flagComponent, i = e.internationalIcon;
  function a(o) {
    var l = o.country, s = o.label, u = o.aspectRatio, c = Y9(o, K9), d = i === Gn ? u : void 0;
    return /* @__PURE__ */ Y.createElement("div", Yr({}, c, {
      className: kn("PhoneInputCountryIcon", {
        "PhoneInputCountryIcon--square": d === 1,
        "PhoneInputCountryIcon--border": l
      })
    }), l ? /* @__PURE__ */ Y.createElement(r, {
      country: l,
      countryName: s,
      flags: n,
      flagUrl: t,
      className: "PhoneInputCountryIconImg"
    }) : /* @__PURE__ */ Y.createElement(i, {
      title: s,
      aspectRatio: d,
      className: "PhoneInputCountryIconImg"
    }));
  }
  return a.propTypes = {
    country: B.string,
    label: B.string.isRequired,
    aspectRatio: B.number
  }, a;
}
as({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  flagComponent: Ci,
  internationalIcon: Gn
});
function J9(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = eh(e)) || n) {
    t && (e = t);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eh(e, n) {
  if (e) {
    if (typeof e == "string") return wo(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return wo(e, n);
  }
}
function wo(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++) r[t] = e[t];
  return r;
}
function th(e, n) {
  for (var t = J9(e), r; !(r = t()).done; ) {
    var i = r.value;
    i && nh(i, n);
  }
}
function nh(e, n) {
  typeof e == "function" ? e(n) : e.current = n;
}
var os = B.shape({
  country_calling_codes: B.object.isRequired,
  countries: B.object.isRequired
}), ls = B.objectOf(B.string);
function pt(e, n) {
  var t = "+" + At(e, n);
  return t;
}
function rh(e) {
  var n = e.value, t = e.phoneNumber, r = e.defaultCountry, i = e.getAnyCountry, a = e.countries, o = e.required, l = e.metadata, s;
  return t && t.country ? s = t.country : r && (!n || Bt(n, r, l)) && (s = r), a && a.indexOf(s) < 0 && (s = void 0), !s && o && a && a.length > 0 && (s = i()), s;
}
function ih(e) {
  var n = e.countries, t = e.countryNames, r = e.addInternationalOption, i = e.compareStringsLocales, a = e.compareStrings;
  a || (a = dh);
  var o = n.map(function(l) {
    return {
      value: l,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: t[l] || l
    };
  });
  return o.sort(function(l, s) {
    return a(l.label, s.label, i);
  }), r && o.unshift({
    label: t.ZZ
  }), o;
}
function ss(e, n) {
  return o7(e || "", n);
}
function ah(e) {
  return e.formatNational().replace(/\D/g, "");
}
function oh(e, n) {
  var t = n.prevCountry, r = n.newCountry, i = n.metadata, a = n.useNationalFormat;
  if (t === r)
    return e;
  if (!e)
    return a ? "" : r ? pt(r, i) : "";
  if (r) {
    if (e[0] === "+") {
      if (a)
        return e.indexOf("+" + At(r, i)) === 0 ? fh(e, r, i) : "";
      if (t) {
        var o = pt(r, i);
        return e.indexOf(o) === 0 ? e : o;
      } else {
        var l = pt(r, i);
        return e.indexOf(l) === 0 ? e : l;
      }
    }
  } else if (e[0] !== "+")
    return Ft(e, t, i) || "";
  return e;
}
function Ft(e, n, t) {
  if (e) {
    if (e[0] === "+") {
      if (e === "+")
        return;
      var r = new qt(n, t);
      return r.input(e), r.getNumberValue();
    }
    if (n) {
      var i = cs(e, n, t);
      return "+".concat(At(n, t)).concat(i || "");
    }
  }
}
function lh(e, n, t) {
  var r = cs(e, n, t);
  if (r) {
    var i = r.length - sh(n, t);
    if (i > 0)
      return e.slice(0, e.length - i);
  }
  return e;
}
function sh(e, n) {
  return n = new Oe(n), n.selectNumberingPlan(e), n.numberingPlan.possibleLengths()[n.numberingPlan.possibleLengths().length - 1];
}
function us(e, n) {
  var t = n.country, r = n.countries, i = n.defaultCountry, a = n.latestCountrySelectedByUser, o = n.required, l = n.metadata;
  if (e === "+")
    return t;
  var s = ch(e, l);
  if (s)
    return !r || r.indexOf(s) >= 0 ? s : void 0;
  if (t) {
    if (Bt(e, t, l)) {
      if (a && Bt(e, a, l))
        return a;
      if (i && Bt(e, i, l))
        return i;
      if (!o)
        return;
    } else if (!o)
      return;
  }
  return t;
}
function uh(e, n) {
  var t = n.prevPhoneDigits, r = n.country, i = n.defaultCountry, a = n.latestCountrySelectedByUser, o = n.countryRequired, l = n.getAnyCountry, s = n.countries, u = n.international, c = n.limitMaxLength, d = n.countryCallingCodeEditable, p = n.metadata;
  if (u && d === !1 && r) {
    var h = pt(r, p);
    if (e.indexOf(h) !== 0) {
      var y, C = e && e[0] !== "+";
      return C ? (e = h + e, y = Ft(e, r, p)) : e = h, {
        phoneDigits: e,
        value: y,
        country: r
      };
    }
  }
  u === !1 && r && e && e[0] === "+" && (e = xo(e, r, p)), e && r && c && (e = lh(e, r, p)), e && e[0] !== "+" && (!r || u) && (e = "+" + e), !e && t && t[0] === "+" && (u ? r = void 0 : r = i), e === "+" && t && t[0] === "+" && t.length > 1 && (r = void 0);
  var $;
  return e && (e[0] === "+" && (e === "+" || r && pt(r, p).indexOf(e) === 0) ? $ = void 0 : $ = Ft(e, r, p)), $ && (r = us($, {
    country: r,
    countries: s,
    defaultCountry: i,
    latestCountrySelectedByUser: a,
    // `countryRequired` flag is not passed here.
    // Instead, it's explicitly checked a bit later in the code.
    required: !1,
    metadata: p
  }), u === !1 && r && e && e[0] === "+" && (e = xo(e, r, p), $ = Ft(e, r, p))), !r && o && (r = i || l()), {
    // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
    // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
    // `prevPhoneDigits` parameter to this same function on next input change event.
    phoneDigits: e,
    country: r,
    value: $
  };
}
function xo(e, n, t) {
  if (e.indexOf(pt(n, t)) === 0) {
    var r = new qt(n, t);
    r.input(e);
    var i = r.getNumber();
    return i ? i.formatNational().replace(/\D/g, "") : "";
  } else
    return e.replace(/\D/g, "");
}
function ch(e, n) {
  var t = new qt(null, n);
  return t.input(e), t.getCountry();
}
function dh(e, n, t) {
  return String.prototype.localeCompare ? e.localeCompare(n, t) : e < n ? -1 : e > n ? 1 : 0;
}
function fh(e, n, t) {
  if (n) {
    var r = "+" + At(n, t);
    if (e.length < r.length) {
      if (r.indexOf(e) === 0)
        return "";
    } else if (e.indexOf(r) === 0)
      return e.slice(r.length);
  }
  for (var i = 0, a = Object.keys(t.country_calling_codes); i < a.length; i++) {
    var o = a[i];
    if (e.indexOf(o) === 1)
      return e.slice(1 + o.length);
  }
  return "";
}
function cs(e, n, t) {
  var r = new qt(n, t);
  r.input(e);
  var i = r.getNumber();
  return i && i.nationalNumber;
}
function Bt(e, n, t) {
  for (var r = pt(n, t), i = 0; i < e.length && i < r.length; ) {
    if (e[i] !== r[i])
      return !1;
    i++;
  }
  return !0;
}
function ds(e) {
  var n = e.value, t = e.phoneNumber, r = e.defaultCountry, i = e.international, a = e.useNationalFormat, o = e.metadata;
  return (i === !1 || a) && t && t.country ? ah(t) : !n && i && r ? pt(r, o) : n;
}
function dn(e) {
  "@babel/helpers - typeof";
  return dn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, dn(e);
}
function _o(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function An(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? _o(Object(t), !0).forEach(function(r) {
      hh(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : _o(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function hh(e, n, t) {
  return n = ph(n), n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function ph(e) {
  var n = mh(e, "string");
  return dn(n) == "symbol" ? n : n + "";
}
function mh(e, n) {
  if (dn(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, n || "default");
    if (dn(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function gh(e, n, t) {
  var r = e.metadata, i = e.countries, a = e.defaultCountry, o = e.value, l = e.reset, s = e.international, u = e.displayInitialValueAsLocalNumber, c = e.initialValueFormat, d = n.defaultCountry, p = n.value, h = n.reset;
  t.country;
  var y = t.value, C = t.hasUserSelectedACountry, $ = t.latestCountrySelectedByUser, m = function(T) {
    return ds(An(An({}, T), {}, {
      international: s,
      useNationalFormat: u || c === "national",
      metadata: r
    }));
  };
  if (l !== h)
    return {
      phoneDigits: m({
        value: void 0,
        defaultCountry: a
      }),
      value: void 0,
      country: a,
      latestCountrySelectedByUser: void 0,
      hasUserSelectedACountry: void 0
    };
  if (a !== d) {
    var x = !a || Qn(a, r), A = (
      // By default, "no value has been entered" means `value` is `undefined`.
      !y || // When `international` is `true`, and some country has been pre-selected,
      // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
      // so in case of `international` being `true`, "the user hasn't entered anything" situation
      // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
      s && y === m({
        value: void 0,
        defaultCountry: d
      })
    ), I = !o && A;
    if (!C && x && I)
      return {
        country: a,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: m({
          value: void 0,
          defaultCountry: a
        }),
        // `value` is `undefined` and it stays so.
        value: void 0
      };
  }
  if (!No(o, p) && !No(o, y)) {
    var b, w;
    if (o) {
      o && rs(o), b = ss(o, r);
      var S = is(i, r);
      b && b.country ? (!S || S.indexOf(b.country) >= 0) && (w = b.country) : (w = us(o, {
        country: void 0,
        countries: S,
        metadata: r
      }), w || a && o.indexOf(pt(a, r)) === 0 && (w = a));
    }
    var O;
    if (o) {
      if ($) {
        var N = w ? $ === w : Bt(o, $, r);
        N ? w || (w = $) : O = {
          latestCountrySelectedByUser: void 0
        };
      }
    } else
      O = {
        latestCountrySelectedByUser: void 0,
        hasUserSelectedACountry: void 0
      };
    return An(An({}, O), {}, {
      phoneDigits: m({
        phoneNumber: b,
        value: o,
        defaultCountry: a
      }),
      value: o,
      country: o ? w : a
    });
  }
}
function No(e, n) {
  return e === null && (e = void 0), n === null && (n = void 0), e === n;
}
var yh = ["name", "disabled", "readOnly", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "containerComponentProps", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"];
function Vt(e) {
  "@babel/helpers - typeof";
  return Vt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Vt(e);
}
function Io(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function fs(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Io(Object(t), !0).forEach(function(r) {
      tt(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Io(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function jt() {
  return jt = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, jt.apply(this, arguments);
}
function $h(e, n) {
  if (e == null) return {};
  var t = vh(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function vh(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function Ch(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Eo(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ps(r.key), r);
  }
}
function bh(e, n, t) {
  return n && Eo(e.prototype, n), t && Eo(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ah(e, n, t) {
  return n = Rn(n), wh(e, hs() ? Reflect.construct(n, t || [], Rn(e).constructor) : n.apply(e, t));
}
function wh(e, n) {
  if (n && (Vt(n) === "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return xh(e);
}
function xh(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function hs() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (hs = function() {
    return !!e;
  })();
}
function Rn(e) {
  return Rn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Rn(e);
}
function _h(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), n && Xr(e, n);
}
function Xr(e, n) {
  return Xr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Xr(e, n);
}
function tt(e, n, t) {
  return n = ps(n), n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function ps(e) {
  var n = Nh(e, "string");
  return Vt(n) == "symbol" ? n : n + "";
}
function Nh(e, n) {
  if (Vt(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, n || "default");
    if (Vt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
var Ih = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    Ch(this, n), r = Ah(this, n, [t]), tt(r, "setInputRef", function($) {
      th([r.props.inputRef, r.inputRef], $);
    }), tt(r, "isCountrySupportedWithError", function($) {
      var m = r.props.metadata;
      return Qn($, m);
    }), tt(r, "onCountryChange", function($) {
      var m = r.props, x = m.international, A = m.metadata, I = m.onChange, b = m.focusInputOnCountrySelection, w = r.state, S = w.phoneDigits, O = w.country, N = oh(S, {
        prevCountry: O,
        newCountry: $,
        metadata: A,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !x
      }), R = Ft(N, $, A);
      b && r.inputRef.current.focus(), r.setState({
        country: $,
        latestCountrySelectedByUser: $,
        hasUserSelectedACountry: !0,
        phoneDigits: N,
        value: R
      }, function() {
        I(R);
      });
    }), tt(r, "onChange", function($) {
      var m = r.props, x = m.defaultCountry, A = m.onChange, I = m.addInternationalOption, b = m.international, w = m.limitMaxLength, S = m.countryCallingCodeEditable, O = m.metadata, N = r.state, R = N.countries, T = N.phoneDigits, E = N.country, L = N.latestCountrySelectedByUser, W = uh($, {
        prevPhoneDigits: T,
        country: E,
        countryRequired: !I,
        defaultCountry: x,
        latestCountrySelectedByUser: L,
        getAnyCountry: function() {
          return r.getFirstSupportedCountry({
            countries: R
          });
        },
        countries: R,
        international: b,
        limitMaxLength: w,
        countryCallingCodeEditable: S,
        metadata: O
      }), D = W.phoneDigits, H = W.country, ee = W.value, V = {
        phoneDigits: D,
        value: ee,
        country: H
      };
      L && ee && !Bt(ee, L, O) && (V.latestCountrySelectedByUser = void 0), S === !1 && !ee && D === r.state.phoneDigits && (V.forceRerender = {}), r.setState(
        V,
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        function() {
          return A(ee);
        }
      );
    }), tt(r, "_onFocus", function() {
      return r.setState({
        isFocused: !0
      });
    }), tt(r, "_onBlur", function() {
      return r.setState({
        isFocused: !1
      });
    }), tt(r, "onFocus", function($) {
      r._onFocus();
      var m = r.props.onFocus;
      m && m($);
    }), tt(r, "onBlur", function($) {
      var m = r.props.onBlur;
      r._onBlur(), m && m($);
    }), tt(r, "onCountryFocus", function($) {
      r._onFocus();
      var m = r.props.countrySelectProps;
      if (m) {
        var x = m.onFocus;
        x && x($);
      }
    }), tt(r, "onCountryBlur", function($) {
      r._onBlur();
      var m = r.props.countrySelectProps;
      if (m) {
        var x = m.onBlur;
        x && x($);
      }
    }), r.inputRef = /* @__PURE__ */ Y.createRef();
    var i = r.props, a = i.value;
    i.labels;
    var o = i.international, l = i.addInternationalOption, s = i.displayInitialValueAsLocalNumber, u = i.initialValueFormat, c = i.metadata, d = r.props, p = d.defaultCountry, h = d.countries;
    p && (r.isCountrySupportedWithError(p) || (p = void 0)), a && rs(a), h = is(h, c);
    var y = ss(a, c);
    r.CountryIcon = as(r.props);
    var C = rh({
      value: a,
      phoneNumber: y,
      defaultCountry: p,
      required: !l,
      countries: h || $o(c),
      getAnyCountry: function() {
        return r.getFirstSupportedCountry({
          countries: h
        });
      },
      metadata: c
    });
    return r.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: r.props,
      // The country selected.
      country: C,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: h,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: ds({
        value: a,
        phoneNumber: y,
        defaultCountry: p,
        international: o,
        useNationalFormat: s || u === "national",
        metadata: c
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: a
    }, r;
  }
  return _h(n, e), bh(n, [{
    key: "componentDidMount",
    value: function() {
      var r = this.props.onCountryChange, i = this.props.defaultCountry, a = this.state.country;
      r && (i && (this.isCountrySupportedWithError(i) || (i = void 0)), a !== i && r(a));
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, i) {
      var a = this.props.onCountryChange, o = this.state.country;
      a && o !== i.country && a(o);
    }
  }, {
    key: "getCountrySelectOptions",
    value: function(r) {
      var i = r.countries, a = this.props, o = a.international, l = a.countryCallingCodeEditable, s = a.countryOptionsOrder, u = a.addInternationalOption, c = a.labels, d = a.locales, p = a.metadata;
      return this.useMemoCountrySelectOptions(function() {
        return G9(ih({
          countries: i || $o(p),
          countryNames: c,
          addInternationalOption: o && l === !1 ? !1 : u,
          compareStringsLocales: d
          // compareStrings
        }), Q9(s, p));
      }, [i, s, u, c, p]);
    }
  }, {
    key: "useMemoCountrySelectOptions",
    value: function(r, i) {
      return (!this.countrySelectOptionsMemoDependencies || !Sh(i, this.countrySelectOptionsMemoDependencies)) && (this.countrySelectOptionsMemo = r(), this.countrySelectOptionsMemoDependencies = i), this.countrySelectOptionsMemo;
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function(r) {
      var i = r.countries, a = this.getCountrySelectOptions({
        countries: i
      });
      return a[0].value;
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.name, a = r.disabled, o = r.readOnly, l = r.autoComplete, s = r.style, u = r.className;
      r.inputRef;
      var c = r.inputComponent, d = r.numberInputProps, p = r.smartCaret, h = r.countrySelectComponent, y = r.countrySelectProps, C = r.containerComponent, $ = r.containerComponentProps;
      r.defaultCountry, r.countries, r.countryOptionsOrder;
      var m = r.labels;
      r.flags, r.flagComponent, r.flagUrl, r.addInternationalOption, r.internationalIcon, r.displayInitialValueAsLocalNumber, r.initialValueFormat, r.onCountryChange, r.limitMaxLength, r.countryCallingCodeEditable, r.focusInputOnCountrySelection, r.reset;
      var x = r.metadata, A = r.international;
      r.locales;
      var I = $h(r, yh), b = this.state, w = b.country, S = b.countries, O = b.phoneDigits, N = b.isFocused, R = p ? w9 : E9, T = this.getCountrySelectOptions({
        countries: S
      });
      return /* @__PURE__ */ Y.createElement(C, jt({
        style: s,
        className: kn(u, "PhoneInput", {
          "PhoneInput--focus": N,
          "PhoneInput--disabled": a,
          "PhoneInput--readOnly": o
        })
      }, $), /* @__PURE__ */ Y.createElement(h, jt({
        name: i ? "".concat(i, "Country") : void 0,
        "aria-label": m.country
      }, y, {
        value: w,
        options: T,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: a || y && y.disabled,
        readOnly: o || y && y.readOnly,
        iconComponent: this.CountryIcon
      })), /* @__PURE__ */ Y.createElement(R, jt({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: l
      }, d, I, {
        inputFormat: A === !0 ? "INTERNATIONAL" : A === !1 ? "NATIONAL" : "INTERNATIONAL_OR_NATIONAL",
        international: A ? !0 : void 0,
        withCountryCallingCode: A ? !0 : void 0,
        name: i,
        metadata: x,
        country: w,
        value: O || "",
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: a,
        readOnly: o,
        inputComponent: c,
        className: kn("PhoneInputInput", d && d.className, I.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: (
      // `state` holds previous props as `props`, and also:
      // * `country` — The currently selected country, e.g. `"RU"`.
      // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
      // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
      // (and a couple of other less significant properties)
      function(r, i) {
        return fs({
          // Emulate `prevProps` via `state.props`.
          props: r
        }, gh(r, i.props, i));
      }
    )
  }]);
}(Y.PureComponent), ms = /* @__PURE__ */ Y.forwardRef(function(e, n) {
  return /* @__PURE__ */ Y.createElement(Ih, jt({}, Eh(e), {
    inputRef: n
  }));
});
ms.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */
  value: B.string,
  /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */
  onChange: B.func.isRequired,
  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: B.func,
  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: B.func,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */
  disabled: B.bool,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */
  readOnly: B.bool,
  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: B.string,
  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: B.oneOf(["national"]),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: B.bool,
  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: B.string,
  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: B.arrayOf(B.string),
  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: ls,
  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: B.oneOfType([B.string, B.arrayOf(B.string)]),
  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */
  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: B.string,
  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: B.objectOf(B.elementType),
  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: B.elementType,
  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: B.bool,
  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: B.elementType,
  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: B.arrayOf(B.string),
  /**
   * `<Phone/>` component CSS style object.
   */
  style: B.object,
  /**
   * `<Phone/>` component CSS class.
   */
  className: B.string,
  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: B.elementType,
  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: B.object,
  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: B.elementType,
  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: B.object,
  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: B.elementType,
  /**
   * Wrapping `<div/>` component props.
   */
  containerComponentProps: B.object,
  /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */
  // Is `true` by default.
  smartCaret: B.bool,
  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format:
   * the user can input their phone number in either "national" or "international" format.
   */
  international: B.bool,
  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: B.bool,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: B.bool,
  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: os,
  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: B.func,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: B.bool
};
var So = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: "tel",
  /**
   * Country `<select/>` component.
   */
  countrySelectComponent: Jl,
  /**
   * Flag icon component.
   */
  flagComponent: Ci,
  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: Gn,
  /**
   * Phone number `<input/>` component.
   */
  inputComponent: "input",
  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: "div",
  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: B.any,
  /**
   *
   */
  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: !0,
  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: !0,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: !0,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: !0
};
function Eh(e) {
  e = fs({}, e);
  for (var n in So)
    e[n] === void 0 && (e[n] = So[n]);
  return e;
}
function Sh(e, n) {
  if (e.length !== n.length)
    return !1;
  for (var t = 0; t < e.length; ) {
    if (e[t] !== n[t])
      return !1;
    t++;
  }
  return !0;
}
const Ph = {
  ext: "ext.",
  country: "Phone number country",
  phone: "Phone",
  AB: "Abkhazia",
  AC: "Ascension Island",
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo, Democratic Republic of the",
  CF: "Central African Republic",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Cote d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Federated States of Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin (French Part)",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  OS: "South Ossetia",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Swaziland",
  TA: "Tristan da Cunha",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Holy See (Vatican City State)",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  ZZ: "International"
};
var kh = ["metadata", "labels"];
function Jr() {
  return Jr = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Jr.apply(this, arguments);
}
function Oh(e, n) {
  if (e == null) return {};
  var t = Th(e, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function Th(e, n) {
  if (e == null) return {};
  var t = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function gs(e) {
  var n = /* @__PURE__ */ Y.forwardRef(function(t, r) {
    var i = t.metadata, a = i === void 0 ? e : i, o = t.labels, l = o === void 0 ? Ph : o, s = Oh(t, kh);
    return /* @__PURE__ */ Y.createElement(ms, Jr({}, s, {
      ref: r,
      metadata: a,
      labels: l
    }));
  });
  return n.propTypes = {
    metadata: os,
    labels: ls
  }, n;
}
gs();
function Lh(e, n) {
  var t = Array.prototype.slice.call(n);
  return t.push(wl), e.apply(this, t);
}
const Fh = gs(wl);
function Mh() {
  return Lh(s7, arguments);
}
const Rh = $e(
  (e, n) => {
    var l;
    const { value: t, disabled: r, onChange: i, className: a } = e, o = _e(null);
    return ce(() => {
      o.current && o.current.focus();
    }, []), /* @__PURE__ */ f(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${Tf.phoneInput} ${(l = e.props) == null ? void 0 : l.className}`,
        children: /* @__PURE__ */ f(
          Fh,
          {
            ref: o,
            onChange: i,
            value: t,
            defaultCountry: navigator.language.includes("-") ? navigator.language.split("-")[1].toLocaleUpperCase() : "AU",
            disabled: r,
            className: a
          }
        )
      }
    );
  }
), Ai = (e, n) => {
  for (const t of n) {
    if (t.id === e)
      return t;
    if (t.type === ue.MultiPart) {
      const r = Ai(e, t.questions);
      if (r)
        return r;
    }
  }
  return null;
}, xt = (e, n) => {
  var a;
  const t = /{{(.*?)(?:, *(.*?))?}}/g;
  let r, i = e;
  for (; r = t.exec(e); ) {
    const l = r[1].trim().split("."), s = l[0], u = (a = r[2]) == null ? void 0 : a.trim(), c = Ai(s, n);
    if (c && c.answer)
      if (typeof c.answer == "object") {
        const d = c.answer;
        l.length > 1 ? i = i.replace(
          r[0],
          d[l[1]] || u || ""
        ) : i = i.replace(r[0], c.answer);
      } else
        i = i.replace(r[0], c.answer);
    else u ? i = i.replace(r[0], u) : i = i.replace(r[0], "");
  }
  return i;
}, Ht = $e(
  (e, n) => {
    var c, d, p, h;
    const { questions: t, question: r, onChange: i, disabled: a = !1, language: o, autoFocus: l = !1 } = e, s = (y) => {
      if (!a) {
        const C = {
          ...r,
          answer: y,
          answeredAt: Date.now()
        };
        i(C);
      }
    };
    let u = null;
    switch (r.type) {
      case ue.Text: {
        u = /* @__PURE__ */ f(
          kf,
          {
            value: r.answer || "",
            onChange: s,
            disabled: a,
            props: { autoFocus: l }
          }
        );
        break;
      }
      case ue.FreeText: {
        u = /* @__PURE__ */ f(
          Os,
          {
            value: r.answer || "",
            onChange: s,
            disabled: a,
            props: { autoFocus: l }
          }
        );
        break;
      }
      case ue.YesNo: {
        const y = (C) => {
          s(C === "yes");
        };
        u = /* @__PURE__ */ f(
          C5,
          {
            value: r.answer === void 0 || r.answer === null ? void 0 : r.answer ? "yes" : "no",
            onChange: y,
            disabled: a,
            language: o
          }
        );
        break;
      }
      case ue.Scale: {
        u = /* @__PURE__ */ f(
          of,
          {
            value: r.answer,
            labels: r.labels,
            min: r.lowerBound,
            max: r.upperBound,
            onChange: s,
            disabled: a
          }
        );
        break;
      }
      case ue.Financial:
      case ue.Numeric: {
        u = /* @__PURE__ */ f(
          w5,
          {
            value: r.answer,
            onChange: s,
            disabled: a,
            props: { autoFocus: l }
          }
        );
        break;
      }
      case ue.Time: {
        u = /* @__PURE__ */ f(
          X5,
          {
            value: r.answer,
            onChange: s,
            disabled: a
          }
        );
        break;
      }
      case ue.Date: {
        u = /* @__PURE__ */ f(
          k5,
          {
            value: r.answer,
            onChange: s,
            disabled: a
          }
        );
        break;
      }
      case ue.SplitDate: {
        u = /* @__PURE__ */ f(
          uf,
          {
            value: r.answer,
            onChange: s,
            disabled: a
          }
        );
        break;
      }
      case ue.File: {
        u = /* @__PURE__ */ f(
          _f,
          {
            value: r.answer,
            onChange: s,
            disabled: a,
            language: o
          }
        );
        break;
      }
      case ue.DateTime: {
        u = /* @__PURE__ */ f(
          M5,
          {
            value: r.answer || Date.now(),
            onChange: s,
            disabled: a
          }
        );
        break;
      }
      case ue.Radio: {
        u = /* @__PURE__ */ f(Fe, { children: (c = r == null ? void 0 : r.options) == null ? void 0 : c.map((y, C) => {
          var $;
          return /* @__PURE__ */ P(Ar, { children: [
            /* @__PURE__ */ f(
              Z5,
              {
                checked: r.answer === y.value,
                value: y.value,
                label: xt(y.label, t),
                name: r.id,
                onChange: s,
                disabled: a
              }
            ),
            r.answer === y.value && y.description ? /* @__PURE__ */ f(
              vn,
              {
                text: xt(y.description, t)
              }
            ) : null,
            r.answer === y.value && y.questions ? ($ = y.questions) == null ? void 0 : $.map((m, x) => /* @__PURE__ */ f(
              Ht,
              {
                questions: t,
                question: m,
                onChange: (A) => {
                  var b;
                  const I = { ...r };
                  I.options = (b = I.options) == null ? void 0 : b.map((w) => {
                    var O;
                    const S = { ...w };
                    return S.value === y.value && (S.questions = (O = S.questions) == null ? void 0 : O.map((N) => N.id === A.id ? A : N)), S;
                  }), i({
                    ...I,
                    answeredAt: Date.now()
                  });
                },
                disabled: a,
                language: o,
                props: {
                  style: { paddingLeft: "20px" },
                  className: Yt.childQuestionWrapper
                }
              },
              x
            )) : null
          ] }, C);
        }) });
        break;
      }
      case ue.Checkbox: {
        const y = (C, $) => {
          const m = [...r.answer || []];
          if ($)
            m.push(C);
          else {
            const x = m.indexOf(C);
            x !== -1 && m.splice(x, 1);
          }
          s(m);
        };
        u = /* @__PURE__ */ f(Fe, { children: (d = r == null ? void 0 : r.options) == null ? void 0 : d.map((C) => {
          var $, m, x;
          return /* @__PURE__ */ P(Ar, { children: [
            /* @__PURE__ */ f(
              N5,
              {
                checked: ($ = r.answer) == null ? void 0 : $.includes(C.value),
                value: C.value,
                label: xt(C.label, t),
                onChange: y,
                disabled: a
              },
              C.value
            ),
            (m = r.answer) != null && m.includes(C.value) ? /* @__PURE__ */ P(Fe, { children: [
              C.description ? /* @__PURE__ */ f(
                vn,
                {
                  text: xt(
                    C.description,
                    t
                  )
                }
              ) : null,
              (x = C.questions) != null && x.length ? /* @__PURE__ */ f(Fe, { children: C.questions.map((A, I) => /* @__PURE__ */ f(
                Ht,
                {
                  questions: t,
                  question: A,
                  onChange: (b) => {
                    var S;
                    const w = { ...r };
                    w.options = (S = w.options) == null ? void 0 : S.map(
                      (O) => {
                        var R;
                        const N = { ...O };
                        return N.value === C.value && (N.questions = (R = N.questions) == null ? void 0 : R.map((T) => T.id === b.id ? b : T)), N;
                      }
                    ), i({
                      ...w,
                      answeredAt: Date.now()
                    });
                  },
                  disabled: a,
                  language: o,
                  props: {
                    style: { paddingLeft: "20px" },
                    className: Yt.childQuestionWrapper
                  }
                },
                I
              )) }) : null
            ] }) : null
          ] }, C.value);
        }) });
        break;
      }
      case ue.Items: {
        u = /* @__PURE__ */ f(
          p5,
          {
            questions: t,
            question: r,
            onChange: i,
            disabled: a,
            language: o
          }
        );
        break;
      }
      case ue.MultiPart: {
        const y = (C) => ($) => {
          const m = { ...r, questions: [...r.questions] };
          m.questions[C] = { ...$, answeredAt: Date.now() }, i(m);
        };
        u = /* @__PURE__ */ f("div", { className: Yt.multiPartQuestion, children: (p = r == null ? void 0 : r.questions) == null ? void 0 : p.map((C, $) => {
          if (C.onlyAvailableIf) {
            const m = C.onlyAvailableIf, x = Ai(
              m.questionId,
              t
            );
            if (x && x.answer !== (m == null ? void 0 : m.answer))
              return null;
          }
          return /* @__PURE__ */ f(
            Ht,
            {
              questions: t,
              question: C,
              onChange: y($),
              disabled: a,
              props: {
                className: Yt.childQuestionWrapper
              }
            },
            $
          );
        }) });
        break;
      }
      case ue.Email: {
        u = /* @__PURE__ */ f(
          Ef,
          {
            value: r.answer || "",
            onChange: s,
            disabled: a
          }
        );
        break;
      }
      case ue.Phone: {
        u = /* @__PURE__ */ f(
          Rh,
          {
            value: r.answer || "",
            onChange: s,
            disabled: a
          }
        );
        break;
      }
    }
    return /* @__PURE__ */ Fo(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${Yt.questionWrapper} ${((h = e.props) == null ? void 0 : h.className) ?? ""}`,
        key: r.id
      },
      r.question && (r.question || "").trim().length > 0 ? /* @__PURE__ */ f(
        W5,
        {
          text: xt(r.question, t),
          language: o
        }
      ) : null,
      r.description ? /* @__PURE__ */ f(
        vn,
        {
          text: /* @__PURE__ */ f(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: xt(r.description, t)
              }
            }
          )
        }
      ) : null,
      u,
      r.information ? /* @__PURE__ */ f(
        vn,
        {
          text: xt(r.information, t)
        }
      ) : null
    );
  }
), Dh = "_progressBar_1x0vt_1", Bh = "_cover_1x0vt_10", Po = {
  progressBar: Dh,
  cover: Bh
}, jh = $e((e, n) => {
  const {
    value: t,
    ...r
    // this must be last and is the div props
  } = e;
  return /* @__PURE__ */ f("div", { ref: n, ...r, className: `${Po.progressBar} ${r.className}`, children: /* @__PURE__ */ f("div", { className: Po.cover, style: { width: `${100 - t}%` } }) });
}), ei = $e(
  (e, n) => {
    var z, J, v, X, ie, K, ne, q;
    const {
      title: t,
      form: r,
      onChange: i,
      onComplete: a,
      complete: o,
      onFileUpload: l,
      onFileRemove: s,
      files: u,
      onBack: c,
      language: d,
      labels: p,
      hideConditionalQuestions: h,
      finishStep: y,
      finishStepCondition: C
    } = e, { t: $ } = Te(void 0, { lng: d }), [m, x] = de(r.questions), [A, I] = de([]), [b, w] = de(0), [S, O] = de(0), [N, R] = de(), [T, E] = de(!1), L = ((z = m[S]) == null ? void 0 : z.type) === ue.File && ((v = (J = m[S]) == null ? void 0 : J.answer) == null ? void 0 : v.some((M) => !("id" in M)));
    ce(() => {
      const M = m.map((Q) => Q.type === ue.File && u ? {
        ...Q,
        answer: [
          ...u,
          ...(Q.answer || []).filter(
            (Z) => !("id" in Z) && !u.some((F) => F.name === Z.name)
          )
        ]
      } : Q);
      x(M);
    }, [u]), ce(() => {
      i && b > 0 && i(m);
    }, [b]), ce(() => {
      o && (w(100), E(!0));
    }, [o]);
    const W = te(
      (M) => {
        if (M > m.length - 1)
          return null;
        let Q = M + 1, Z = m[Q];
        if (h)
          for (; Z != null && Z.hideConditionally; )
            Q++, Z = m[Q];
        if (!Z)
          return null;
        if (Z.onlyAvailableIf) {
          const F = Z.onlyAvailableIf, oe = (ve, xe) => {
            for (const Ie of xe) {
              if (Ie.id === ve)
                return Ie;
              if (Ie.type === ue.MultiPart) {
                const gt = oe(ve, Ie.questions);
                if (gt)
                  return gt;
              }
            }
            return null;
          }, he = oe(
            F.questionId,
            m
          );
          if (he) {
            if (Array.isArray(F.answer)) {
              if (!F.answer.includes(
                he.answer
              ))
                return W(M + 1);
            } else if (he.answer !== (F == null ? void 0 : F.answer))
              return W(M + 1);
          }
        }
        return Z;
      },
      [m]
    ), D = te(
      (M) => {
        if (M && M.type === ue.File) {
          const Z = m.find((he) => he.id === M.id).answer || [], F = M.answer || [], oe = [];
          Z.forEach((he) => {
            "id" in he && (F.filter((ve) => "id" in ve).some((ve) => he.id === ve.id) || (s && s(he), oe.push(he)));
          }), oe.length > 0 && (M.answer = [...M.answer || [], ...oe]);
        }
        x((Q) => {
          const Z = Q.findIndex((oe) => oe.id === M.id), F = [...Q];
          return F[Z] = { ...M, answeredAt: Date.now() }, F;
        }), R("");
      },
      [s, m]
    ), H = te(
      (M, Q) => {
        M && M.preventDefault();
        const Z = { ...m[S] };
        if (Q && (Z.answer = void 0, Z.answeredAt = Date.now()), Z && Z.required && (Z.answer === void 0 || Z.answer === "" || Z.answer === null)) {
          R($("toast.answer-question"));
          return;
        } else if (Z.type === ue.SplitDate && Z.answer && (Z.answer.year === "" || Z.answer.year === void 0 || Z.answer === null)) {
          R($("toast.answer-question"));
          return;
        } else if (Z.type === ue.Email) {
          if (Z.answer && !Z.answer.match(
            // eslint-disable-next-line no-useless-escape
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          )) {
            R($("toast.invalid-email"));
            return;
          }
        } else if (Z.type === ue.Phone && Z.answer && !Mh(Z.answer)) {
          R($("toast.invalid-phone-number"));
          return;
        }
        const F = W(S);
        if (F) {
          D({ ...Z, answeredAt: Date.now() }), I([...A, Z.id]), R("");
          const oe = m.findIndex(
            (he) => he.id === F.id
          );
          if (O(oe), h) {
            const he = m.filter(
              (xe) => !xe.hideConditionally
            ), ve = he.findIndex(
              (xe) => xe.id === F.id
            );
            w(
              ve / he.length * 100
            );
          } else
            w(oe / m.length * 100);
          E(!1);
        } else {
          const oe = {
            ...Z,
            answeredAt: Date.now()
          };
          D(oe), I([...A, Z.id]), R("");
          const ve = m.filter(
            (xe) => xe.type !== ue.File
          ).map((xe) => xe.id == Z.id ? oe : xe);
          if (y && C) {
            const xe = m.find(
              (Ie) => Ie.id === C.questionId
            );
            if ((xe == null ? void 0 : xe.answer) === C.value) {
              e != null && e.onChange && (e == null || e.onChange(ve)), y().then((Ie) => {
                Ie && (a && a(ve), w(100), E(!0));
              });
              return;
            }
          }
          a && a(ve), w(100), E(!0);
        }
      },
      [
        m,
        S,
        W,
        $,
        D,
        A,
        h,
        a
      ]
    ), ee = (M) => {
      M.preventDefault(), H(M, !0);
    }, V = (M) => {
      M && M.preventDefault(), T && E(!1);
      const Q = A[A.length - 1], Z = m.find(
        (F) => F.id === Q
      );
      if (Z) {
        const F = m.findIndex(
          (oe) => oe.id === Z.id
        );
        if (I(A.slice(0, A.length - 1)), O(F), h) {
          const oe = m.filter(
            (ve) => !ve.hideConditionally
          ), he = oe.findIndex(
            (ve) => ve.id === Z.id
          );
          w(
            he / oe.length * 100
          );
        } else
          w(F / m.length * 100);
        R("");
      }
    }, ae = (M) => (Q) => {
      if (Q.preventDefault(), M.type === ue.File && M.answer) {
        const Z = M.answer.filter(
          (F) => !("id" in F)
        );
        if (Z.length > 0) {
          const F = M.answer.map((oe) => ("id" in oe || (oe.uploading = !0), oe));
          D({
            ...M,
            answer: F,
            answeredAt: Date.now()
          }), l && l(Z);
        }
      }
    };
    zt(n, () => ({
      finish: () => {
        a && a(m), w(100), E(!0);
      }
    })), ce(() => {
      const M = (Q) => {
        !o && Q.key === "Enter" && (Q.preventDefault(), Q.stopPropagation(), H());
      };
      return window.addEventListener("keydown", M), () => {
        window.removeEventListener("keydown", M);
      };
    }, [o, H]);
    const g = te(() => {
      var M;
      return y && C ? !(((M = m.find(
        (Z) => Z.id === C.questionId
      )) == null ? void 0 : M.answer) === C.value) : !0;
    }, [y, C, m]);
    return /* @__PURE__ */ P(
      "form",
      {
        ...e.props,
        className: `${vt.inlineForm} ${(X = e.props) == null ? void 0 : X.className}`,
        onSubmit: (M) => {
          M.preventDefault();
        },
        children: [
          /* @__PURE__ */ f("div", { className: vt.inlineFormTitle, children: t || r.name }),
          /* @__PURE__ */ f("div", { className: vt.inlineFormProgressBar, children: /* @__PURE__ */ f(jh, { value: b }) }),
          T ? null : /* @__PURE__ */ P(Fe, { children: [
            /* @__PURE__ */ f("div", { className: vt.inlineFormQuestionWrapper, children: m && m[S] ? /* @__PURE__ */ f(
              Ht,
              {
                questions: m,
                question: m[S],
                onChange: D,
                language: d
              },
              m[S].id
            ) : null }),
            N ? /* @__PURE__ */ f("div", { className: vt.inlineFormError, children: N }) : null,
            /* @__PURE__ */ P("div", { className: vt.formFooter, children: [
              /* @__PURE__ */ f("div", { className: vt.formFooterLeft, children: S > 0 || c ? /* @__PURE__ */ f(
                "button",
                {
                  onClick: S > 0 ? V : c,
                  disabled: A.length === 0 && !c,
                  children: $("chat.back")
                }
              ) : null }),
              /* @__PURE__ */ P("div", { className: vt.formFooterRight, children: [
                ((ie = m[S]) == null ? void 0 : ie.type) === ue.File ? /* @__PURE__ */ f(
                  "button",
                  {
                    onClick: ae(m[S]),
                    disabled: !L || !((K = m[S].answer) != null && K.filter((M) => !("id" in M)).length) || ((ne = m[S].answer) == null ? void 0 : ne.filter(
                      (M) => !("id" in M) && M.uploading
                    ).length) > 0,
                    children: $("prematter.upload")
                  }
                ) : !((q = m[S]) != null && q.required) && W(S) ? /* @__PURE__ */ f("button", { onClick: ee, children: (p == null ? void 0 : p.optional) || $("chat.dunno") }) : null,
                /* @__PURE__ */ f(
                  "button",
                  {
                    onClick: H,
                    disabled: !!N || L,
                    children: W(S) ? $("chat.next") : g() ? (p == null ? void 0 : p.submit) || $("chat.finish") : $("chat.next")
                  }
                )
              ] })
            ] })
          ] })
        ]
      }
    );
  }
), Ug = $e(
  (e, n) => {
    var v, X, ie, K, ne;
    const {
      onSendMessage: t,
      prematter: r,
      isLoading: i,
      children: a,
      inputClassName: o,
      onFormChange: l,
      onFormCompletion: s,
      onFormFileUpload: u,
      contactForm: c,
      onContactFormSubmit: d,
      failedFiles: p,
      onCloseChat: h,
      lawyerImage: y,
      onAddQuestion: C,
      addQuestionPending: $,
      addQuestionError: m,
      placeholder: x,
      chatInputClassName: A,
      skipFileQuestions: I,
      contactDays: b = 3,
      hideConditionalQuestions: w,
      ...S
    } = e, O = _e(null), N = _e(null), R = _e(null), T = _e(r == null ? void 0 : r.messages.length), [E, L] = de(((v = r == null ? void 0 : r.context) == null ? void 0 : v.form) || void 0), { t: W } = Te(), D = [
      Be.PreparingQuestions,
      Be.Questions,
      Be.PreparingForm,
      Be.Form
    ].includes(r == null ? void 0 : r.state), H = [
      Be.PreparingReport,
      Be.ReportReady,
      Be.VerificationPending,
      Be.Verified
    ].includes(r == null ? void 0 : r.state), ee = H || (r == null ? void 0 : r.state) === Be.ContactForm, V = H && typeof ((X = r == null ? void 0 : r.context) == null ? void 0 : X.contactForm) == "object" && ((K = (ie = r == null ? void 0 : r.context) == null ? void 0 : ie.contactForm) == null ? void 0 : K.questions.every(
      (q) => q.answeredAt
    )) && !i, ae = (q) => {
      d == null || d(q);
    };
    Mo(() => {
      var q;
      ((r == null ? void 0 : r.messages.length) === 0 || (r == null ? void 0 : r.messages.length) !== T.current) && ((q = O.current) == null || q.scrollTo({
        top: O.current.scrollHeight,
        behavior: "smooth"
      })), T.current = r == null ? void 0 : r.messages.length;
    }, [r == null ? void 0 : r.messages]), zt(n, () => ({
      inputRef: N ?? null,
      chatRef: R,
      scrollToBottom: () => {
        var q;
        (q = O.current) == null || q.scrollTo({
          top: O.current.scrollHeight,
          behavior: "smooth"
        });
      }
    })), ce(() => {
      var q;
      if ((q = r == null ? void 0 : r.context) != null && q.form && !E)
        if (I) {
          const M = {
            ...r.context.form,
            questions: r.context.form.questions.filter((Q) => Q.type !== ue.File)
          };
          L(M);
        } else
          L(r.context.form);
    }, [E, (ne = r == null ? void 0 : r.context) == null ? void 0 : ne.form, I]), ce(() => {
      var q, M;
      (M = O.current) == null || M.scrollTo({
        top: (q = O.current) == null ? void 0 : q.scrollHeight,
        behavior: "smooth"
      });
    }, []), ce(() => {
      (r == null ? void 0 : r.state) === Be.Form && setTimeout(() => {
        var q, M;
        (M = O.current) == null || M.scrollTo({
          top: (q = O.current) == null ? void 0 : q.scrollHeight,
          behavior: "smooth"
        });
      }, 100);
    }, [r == null ? void 0 : r.state]), ce(() => {
      (r == null ? void 0 : r.state) === Be.ContactForm && setTimeout(() => {
        var q, M;
        (M = O.current) == null || M.scrollTo({
          top: (q = O.current) == null ? void 0 : q.scrollHeight,
          behavior: "smooth"
        });
      }, 100);
    }, [r == null ? void 0 : r.state]);
    const g = (q) => {
      var M, Q, Z, F, oe, he, ve;
      if (I) {
        const xe = [...q], Ie = (Q = (M = r.context) == null ? void 0 : M.form) == null ? void 0 : Q.questions.findIndex((gt) => gt.type === ue.File);
        Ie && ((F = (Z = r.context) == null ? void 0 : Z.form) != null && F.questions[Ie]) && (xe.splice(Ie, 0, (he = (oe = r.context) == null ? void 0 : oe.form) == null ? void 0 : he.questions[Ie]), l == null || l(xe));
      } else
        l == null || l(q), E && L({ ...E, questions: q });
      (ve = O.current) == null || ve.scrollTo({
        top: O.current.scrollHeight,
        behavior: "smooth"
      });
    }, z = (q) => {
      var M, Q, Z, F, oe, he, ve;
      if (I) {
        const xe = [...q], Ie = (Q = (M = r.context) == null ? void 0 : M.form) == null ? void 0 : Q.questions.findIndex((gt) => gt.type === ue.File);
        Ie && ((F = (Z = r.context) == null ? void 0 : Z.form) != null && F.questions[Ie]) && xe.splice(Ie, 0, (he = (oe = r.context) == null ? void 0 : oe.form) == null ? void 0 : he.questions[Ie]), s == null || s(xe);
      } else
        s == null || s(q);
      (ve = O.current) == null || ve.scrollTo({
        top: O.current.scrollHeight,
        behavior: "smooth"
      });
    }, J = () => {
      var q;
      (q = O.current) == null || q.scrollTo({
        top: O.current.scrollHeight,
        behavior: "smooth"
      });
    };
    return /* @__PURE__ */ P(
      "div",
      {
        ...S,
        className: `${Re.chat} ${e.className || ""}`,
        style: {
          ...S.style,
          paddingBottom: D ? 0 : void 0
        },
        ref: R,
        children: [
          /* @__PURE__ */ P("div", { ref: O, className: Re.body, children: [
            a,
            r == null ? void 0 : r.messages.map((q, M) => /* @__PURE__ */ f(
              $n,
              {
                prematter: r,
                message: q,
                files: [],
                sendMessage: t,
                showAction: M === r.messages.length - 1,
                lawyerImage: y,
                addQuestion: C,
                addQuestionError: m,
                addQuestionPending: $
              },
              M
            )),
            (H || (r == null ? void 0 : r.state) === Be.Form) && E ? /* @__PURE__ */ f("div", { className: Re.formWrapper, children: /* @__PURE__ */ f(
              ei,
              {
                title: W("chat.questionnaire"),
                form: E,
                onChange: g,
                onComplete: z,
                complete: H,
                files: [],
                onFileUpload: u,
                language: (r == null ? void 0 : r.language) || navigator.language,
                hideConditionalQuestions: w
              }
            ) }) : null,
            ee && /* @__PURE__ */ f(Fe, { children: /* @__PURE__ */ P("div", { className: Re.completeMessage, children: [
              /* @__PURE__ */ f(
                $n,
                {
                  prematter: r,
                  message: {
                    id: "complete",
                    type: Mt.Chat,
                    from: "lawyer",
                    content: "Thanks for that! I have answered all preliminary questions for your case. Can you provide me with your contact details so that we can get in touch and I can send you your report."
                  },
                  lawyerImage: y,
                  addQuestion: C,
                  addQuestionError: m,
                  addQuestionPending: $
                }
              ),
              c ? /* @__PURE__ */ f("div", { className: `${Re.formWrapper} ${Re.contactForm}`, children: /* @__PURE__ */ f(
                ei,
                {
                  title: "Contact Details",
                  form: c,
                  complete: V,
                  onComplete: ae,
                  onChange: J,
                  language: (r == null ? void 0 : r.language) || navigator.language,
                  labels: {
                    submit: "Send",
                    optional: "Skip"
                  }
                }
              ) }) : null,
              V && /* @__PURE__ */ f("div", { className: Re.completeMessage, children: /* @__PURE__ */ f(
                $n,
                {
                  prematter: r,
                  message: {
                    id: "complete",
                    type: Mt.Chat,
                    from: "lawyer",
                    content: `Thank you for providing your contact details. We have emailed you a free report and will get in touch with you within ${b} business days.`
                  },
                  lawyerImage: y,
                  addQuestion: C,
                  addQuestionError: m,
                  addQuestionPending: $
                }
              ) })
            ] }) }),
            V && /* @__PURE__ */ P("div", { className: Re.chatEnded, children: [
              "Chat ended.",
              h && /* @__PURE__ */ f("span", { onClick: h, children: "Close." })
            ] }),
            i || [
              Be.PreparingQuestions,
              Be.PreparingForm
            ].includes(r == null ? void 0 : r.state) ? /* @__PURE__ */ f("div", { className: Re.completeMessage, children: /* @__PURE__ */ f(
              $n,
              {
                prematter: r,
                message: {
                  id: "complete",
                  type: Mt.Chat,
                  from: "lawyer",
                  content: "loading.."
                },
                children: /* @__PURE__ */ f("div", { className: `${Re.loadingMessage}`, children: /* @__PURE__ */ P("div", { className: Re.loader, children: [
                  /* @__PURE__ */ f("div", { className: Re.dot }),
                  /* @__PURE__ */ f("div", { className: Re.dot }),
                  /* @__PURE__ */ f("div", { className: Re.dot })
                ] }) }),
                lawyerImage: y,
                addQuestion: C,
                addQuestionError: m,
                addQuestionPending: $
              }
            ) }) : null
          ] }),
          !D && !H && /* @__PURE__ */ f(
            p0,
            {
              onSendMessage: t,
              ref: N,
              className: `${Re.input} ${o}`,
              failedFiles: p,
              disableFileInput: !0,
              disabled: i,
              placeholder: x,
              chatInputClassName: A
            }
          )
        ]
      }
    );
  }
), Hh = "_complete_8zcl5_1", Vh = "_overviewForm_8zcl5_11", zh = "_overviewFormTitle_8zcl5_24", Wh = "_overviewQuestions_8zcl5_32", Uh = "_uploadButton_8zcl5_39", qh = "_overviewFormError_8zcl5_65", Zh = "_submitButton_8zcl5_76", Lt = {
  complete: Hh,
  overviewForm: Vh,
  overviewFormTitle: zh,
  overviewQuestions: Wh,
  uploadButton: Uh,
  overviewFormError: qh,
  submitButton: Zh
}, Gh = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M7.64644 3.35355C7.55596 3.26306 7.5 3.13807 7.5 3C7.5 2.72386 7.72386 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73263 13.5 7.85955 13.5 8C13.5 8.14045 13.4421 8.26737 13.3489 8.35819L8.35819 13.3489C8.26737 13.4421 8.14045 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13C7.5 12.8619 7.55596 12.7369 7.64644 12.6465L11.7928 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H11.7928L7.64644 3.35355Z", fill: "#0E5FE3" })), qg = $e(
  (e, n) => {
    var T;
    const {
      title: t,
      form: r,
      onChange: i,
      onSubmit: a,
      onSubmitLabel: o,
      onSubmitDisabled: l = !1,
      disabled: s = !1,
      hideFileUpload: u = !1,
      onFileUpload: c,
      onFileRemove: d,
      files: p,
      language: h,
      hideConditionalQuestions: y
    } = e, C = _e(p || []), { t: $ } = Te(), [m, x] = de(r.questions), [A, I] = de(), b = m.filter(
      (E) => {
        var L;
        return E.type === ue.File && ((L = E.answer) == null ? void 0 : L.some((W) => !("id" in W)));
      }
    ).length > 0;
    ce(() => {
      if (p && p.length !== C.current.length) {
        const E = m.map((L) => L.type === ue.File && p ? {
          ...L,
          answer: [
            ...p,
            ...(L.answer || []).filter(
              (W) => !("id" in W) && !p.some((D) => D.name === W.name)
            )
          ]
        } : L);
        x(E);
      }
    }, [p]);
    const w = (E) => {
      if (E && E.type === ue.File) {
        const W = m.find((ee) => ee.id === E.id).answer || [], D = E.answer || [], H = [];
        W.forEach((ee) => {
          "id" in ee && (D.filter((V) => "id" in V).some((V) => ee.id === V.id) || (d && d(ee), H.push(ee)));
        }), H.length > 0 && (E.answer = [...E.answer || [], ...H]);
      }
      x((L) => {
        const W = L.findIndex((H) => H.id === E.id), D = [...L];
        return D[W] = { ...E }, D;
      }), i && i(m), I("");
    }, S = (E, L) => {
      for (const W of L) {
        if (W.id === E)
          return W;
        if (W.type === ue.MultiPart) {
          const D = S(E, W.questions);
          if (D)
            return D;
        }
      }
      return null;
    }, O = () => {
      const E = (L) => L != null && L !== "";
      for (const L of m)
        if (!(L.hideConditionally && y) && L.required && !E(L.answer)) {
          if (L.onlyAvailableIf) {
            const W = L.onlyAvailableIf, D = S(
              W.questionId,
              m
            );
            if (D && !E(D.answer))
              return I(`${$("toast.answer-question")}: ${L.question}`), !1;
          }
          return I(`${$("toast.answer-question")}: ${L.question}`), !1;
        }
      return !0;
    }, N = (E) => {
      E.preventDefault();
      const L = O();
      if (!s && L) {
        const W = m.filter(
          (D) => D.type !== ue.File
        );
        a && a(W);
      }
    }, R = (E) => (L) => {
      if (L.preventDefault(), E.type === ue.File && E.answer) {
        const W = E.answer.filter(
          (D) => !("id" in D)
        );
        if (W.length > 0) {
          const D = E.answer.map((H) => ("id" in H || (H.uploading = !0), H));
          w({ ...E, answer: D }), c && c(W);
        }
      }
    };
    return /* @__PURE__ */ P(
      "form",
      {
        ref: n,
        ...e.props,
        className: `${Lt.overviewForm} ${(T = e.props) == null ? void 0 : T.className}`,
        children: [
          t ? /* @__PURE__ */ f("div", { className: Lt.overviewFormTitle, children: t }) : null,
          /* @__PURE__ */ P("div", { className: Lt.overviewQuestions, children: [
            m.map((E) => {
              var L, W;
              if (u && E.type === ue.File || y && E.hideConditionally)
                return null;
              if (E.onlyAvailableIf) {
                const D = E.onlyAvailableIf, H = S(
                  D.questionId,
                  m
                );
                if (H) {
                  if (Array.isArray(D.answer)) {
                    if (!D.answer.includes(
                      H.answer
                    ))
                      return null;
                  } else if (H.answer !== (D == null ? void 0 : D.answer))
                    return null;
                }
              }
              return /* @__PURE__ */ P(Ar, { children: [
                /* @__PURE__ */ f(
                  Ht,
                  {
                    questions: m,
                    question: E,
                    onChange: w,
                    disabled: s,
                    language: h
                  }
                ),
                E.type === ue.File && /* @__PURE__ */ f(
                  "button",
                  {
                    className: Lt.uploadButton,
                    onClick: R(E),
                    disabled: s || !((L = E.answer) != null && L.filter((D) => !("id" in D)).length) || ((W = E.answer) == null ? void 0 : W.filter(
                      (D) => !("id" in D) && D.uploading
                    ).length) > 0,
                    children: $("prematter.upload")
                  }
                ),
                /* @__PURE__ */ f(Al, {})
              ] }, E.id);
            }),
            A ? /* @__PURE__ */ f("div", { className: Lt.overviewFormError, children: A }) : null
          ] }),
          /* @__PURE__ */ P(
            "button",
            {
              className: Lt.submitButton,
              type: "submit",
              onClick: N,
              disabled: !!A || s || b || l,
              children: [
                o || $("chat.submit"),
                /* @__PURE__ */ f(Gh, {})
              ]
            }
          )
        ]
      }
    );
  }
), Qh = "_accordionContainer_c9l4k_1", Kh = "_accordionRow_c9l4k_5", Yh = "_accordionHeader_c9l4k_9", Xh = "_accordionTitle_c9l4k_28", Jh = "_accordionIconContainer_c9l4k_37", e8 = "_accordionIcon_c9l4k_37", t8 = "_defaultIcon_c9l4k_53", n8 = "_hidden_c9l4k_53", r8 = "_activeIcon_c9l4k_57", i8 = "_accordionContent_c9l4k_61", Ye = {
  accordionContainer: Qh,
  accordionRow: Kh,
  accordionHeader: Yh,
  accordionTitle: Xh,
  accordionIconContainer: Jh,
  accordionIcon: e8,
  defaultIcon: t8,
  hidden: n8,
  activeIcon: r8,
  accordionContent: i8
}, a8 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/chevron up" }, /* @__PURE__ */ _.createElement("path", { id: "Union", d: "M12.6467 10.8536C12.7372 10.944 12.8622 11 13.0002 11C13.2764 11 13.5002 10.7761 13.5002 10.5C13.5002 10.3596 13.4423 10.2326 13.3491 10.1418L8.35844 5.15115C8.26761 5.05791 8.14069 5 8.00024 5C7.8598 5 7.73287 5.05791 7.64205 5.15115L2.65139 10.1418C2.55815 10.2326 2.50024 10.3596 2.50024 10.5C2.50024 10.7761 2.7241 11 3.00024 11C3.13831 11 3.26331 10.944 3.35379 10.8536L8.00024 6.20717L12.6467 10.8536Z", fill: "#333333" }))), o8 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "#999999", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/chevron down" }, /* @__PURE__ */ _.createElement("path", { id: "Union", d: "M12.6467 5.14644C12.7372 5.05596 12.8622 5 13.0002 5C13.2764 5 13.5002 5.22386 13.5002 5.5C13.5002 5.64045 13.4423 5.76737 13.3491 5.85819L8.35844 10.8489C8.26761 10.9421 8.14069 11 8.00024 11C7.8598 11 7.73287 10.9421 7.64205 10.8489L2.65139 5.85819C2.55815 5.76737 2.50024 5.64045 2.50024 5.5C2.50024 5.22386 2.7241 5 3.00024 5C3.13831 5 3.26331 5.05596 3.35379 5.14644L8.00024 9.79283L12.6467 5.14644Z" }))), Zg = (e) => {
  var t;
  const { items: n } = e;
  return /* @__PURE__ */ f(
    "div",
    {
      className: `${Ye.accordionContainer} ${((t = e.classNames) == null ? void 0 : t.container) ?? ""}`,
      children: n.map((r, i) => /* @__PURE__ */ f(l8, { classNames: e.classNames, item: r }, i))
    }
  );
}, l8 = (e) => {
  const { item: n, classNames: t } = e, [r, i] = de(!1);
  return /* @__PURE__ */ P("div", { className: `${Ye.accordionRow} ${(t == null ? void 0 : t.row) ?? ""}`, children: [
    /* @__PURE__ */ P(
      "div",
      {
        className: Ye.accordionHeader,
        onClick: () => i(!r),
        children: [
          /* @__PURE__ */ f("div", { className: `${Ye.accordionTitle} ${(t == null ? void 0 : t.title) ?? ""}`, children: n.title }),
          /* @__PURE__ */ P("div", { className: Ye.accordionIconContainer, children: [
            /* @__PURE__ */ f(
              a8,
              {
                className: `${Ye.accordionIcon} ${Ye.defaultIcon} ${r ? Ye.hidden : ""}`
              }
            ),
            /* @__PURE__ */ f(
              o8,
              {
                className: `${Ye.accordionIcon} ${Ye.activeIcon} ${r ? "" : Ye.hidden}`
              }
            )
          ] })
        ]
      }
    ),
    r && /* @__PURE__ */ f(
      "div",
      {
        className: `${Ye.accordionContent} ${(t == null ? void 0 : t.content) ?? ""}`,
        children: n.content
      }
    )
  ] });
}, s8 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("rect", { x: 0.5, y: 0.5, width: 15, height: 15, rx: 7.5, stroke: "#666666" }), /* @__PURE__ */ _.createElement("path", { d: "M12.375 4.25C12.7202 4.25 13 4.52982 13 4.875C13 5.04757 12.9301 5.2038 12.817 5.3169L6.56699 11.5669C6.45388 11.68 6.29761 11.75 6.125 11.75C5.94944 11.75 5.79079 11.6776 5.67726 11.5611L3.18893 9.07274C3.07238 8.95921 3 8.80056 3 8.625C3 8.27982 3.27982 8 3.625 8C3.79759 8 3.95385 8.06996 4.06695 8.18307L6.12505 10.2411L11.9302 4.4359C12.0436 4.32113 12.201 4.25 12.375 4.25Z", fill: "#666666" })), u8 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#999999", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/warning circle" }, /* @__PURE__ */ _.createElement("g", { id: "Union" }, /* @__PURE__ */ _.createElement("path", { d: "M12.75 7.5V13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5V7.5C11.25 7.08579 11.5858 6.75 12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5Z" }), /* @__PURE__ */ _.createElement("path", { d: "M12.75 16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5C11.25 16.0858 11.5858 15.75 12 15.75C12.4142 15.75 12.75 16.0858 12.75 16.5Z" }), /* @__PURE__ */ _.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12Z" })))), c8 = "_tickIcon_1lb1d_1", d8 = "_toastWrapper_1lb1d_11", f8 = "_toast_1lb1d_11", h8 = "_body_1lb1d_57", Jt = {
  tickIcon: c8,
  toastWrapper: d8,
  toast: f8,
  body: h8
}, Gg = (e) => /* @__PURE__ */ f(
  Ss,
  {
    position: "bottom-center",
    autoClose: 4e3,
    hideProgressBar: !0,
    newestOnTop: !0,
    closeOnClick: !0,
    rtl: !1,
    pauseOnFocusLoss: !1,
    draggable: !1,
    pauseOnHover: !1,
    icon: (t) => {
      if (t.type === "success")
        return /* @__PURE__ */ f(s8, { className: Jt.tickIcon });
      if (t.type === "error")
        return /* @__PURE__ */ f(u8, { className: Jt.tickIcon });
    },
    closeButton: !1,
    toastClassName: Jt.toast,
    bodyClassName: Jt.body,
    className: Jt.toastWrapper,
    limit: 3,
    ...e
  }
), p8 = "_container_9odmy_1", m8 = "_clickable_9odmy_24", g8 = "_hideMobile_9odmy_28", y8 = "_rowButton_9odmy_28", $8 = "_timestamp_9odmy_29", v8 = "_newDot_9odmy_46", C8 = "_detailsContainer_9odmy_59", b8 = "_lawyerName_9odmy_65", A8 = "_prematterName_9odmy_66", w8 = "_buttonLabel_9odmy_118", x8 = "_ended_9odmy_136", Ke = {
  container: p8,
  clickable: m8,
  hideMobile: g8,
  rowButton: y8,
  timestamp: $8,
  newDot: v8,
  detailsContainer: C8,
  lawyerName: b8,
  prematterName: A8,
  buttonLabel: w8,
  ended: x8
}, Qg = (e) => {
  const {
    isNew: n,
    isEnded: t,
    Image: r,
    description: i,
    timestamp: a,
    title: o,
    button: l,
    items: s,
    showAllMobile: u,
    onClick: c,
    rowClassName: d
  } = e;
  return /* @__PURE__ */ P(
    "div",
    {
      className: `${Ke.container} ${u ? "" : Ke.hideMobile} ${t ? Ke.ended : ""} ${c ? Ke.clickable : ""} ${d ?? ""}`,
      onClick: c ?? (() => {
      }),
      children: [
        n && /* @__PURE__ */ f("div", { className: Ke.newDot }),
        r,
        /* @__PURE__ */ P("div", { className: Ke.detailsContainer, children: [
          /* @__PURE__ */ f("div", { className: Ke.lawyerName, children: o }),
          /* @__PURE__ */ f("div", { className: Ke.prematterName, children: i })
        ] }),
        a && /* @__PURE__ */ f("div", { className: Ke.timestamp, children: W3(a) }),
        l ? /* @__PURE__ */ P(
          "button",
          {
            onClick: l.onClick,
            className: `${Ke.rowButton} ${l.className ?? ""}`,
            children: [
              /* @__PURE__ */ f("div", { className: Ke.buttonLabel, children: l.label }),
              l.icon
            ]
          }
        ) : null,
        s != null && s.length ? /* @__PURE__ */ f(bl, { className: Ke.menuIcon, items: s }) : null
      ]
    }
  );
}, _8 = "_container_ocnyy_1", N8 = "_cardsContainer_ocnyy_1", I8 = "_cards_ocnyy_1", E8 = "_actionBar_ocnyy_36", S8 = "_scrollBar_ocnyy_49", P8 = "_scrolledPosition_ocnyy_57", k8 = "_actionButtonContainer_ocnyy_65", O8 = "_actionButton_ocnyy_65", T8 = "_actionIcon_ocnyy_87", L8 = "_active_ocnyy_92", rt = {
  container: _8,
  cardsContainer: N8,
  cards: I8,
  actionBar: E8,
  scrollBar: S8,
  scrolledPosition: P8,
  actionButtonContainer: k8,
  actionButton: O8,
  actionIcon: T8,
  active: L8
}, F8 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#777777", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M12.5303 5.03032C12.6661 4.8946 12.75 4.7071 12.75 4.5C12.75 4.08579 12.4142 3.75 12 3.75C11.7893 3.75 11.5989 3.83686 11.4627 3.97672L3.97672 11.4627C3.83686 11.5989 3.75 11.7893 3.75 12C3.75 12.2107 3.83686 12.4011 3.97672 12.5373L11.4627 20.0233C11.599 20.1631 11.7893 20.25 12 20.25C12.4142 20.25 12.75 19.9142 12.75 19.5C12.75 19.2929 12.6661 19.1054 12.5303 18.9697L6.31075 12.75H19.5C19.9142 12.75 20.25 12.4142 20.25 12C20.25 11.5858 19.9142 11.25 19.5 11.25H6.31075L12.5303 5.03032Z" })), M8 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "#0E5FE3", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M7.64644 3.35355C7.55596 3.26306 7.5 3.13807 7.5 3C7.5 2.72386 7.72386 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73263 13.5 7.85955 13.5 8C13.5 8.14045 13.4421 8.26737 13.3489 8.35819L8.35819 13.3489C8.26737 13.4421 8.14045 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13C7.5 12.8619 7.55596 12.7369 7.64644 12.6465L11.7928 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H11.7928L7.64644 3.35355Z" })), R8 = (e) => {
  const {
    classNames: n,
    disabledLeftButton: t,
    disabledRightButton: r,
    onLeftButtonClick: i,
    onRightButtonClick: a,
    scrollWidth: o,
    leftPosition: l
  } = e;
  return /* @__PURE__ */ P("div", { className: `${rt.actionBar}  ${(n == null ? void 0 : n.actionBar) ?? ""}`, children: [
    /* @__PURE__ */ f("div", { className: rt.scrollBar, children: /* @__PURE__ */ f(
      "div",
      {
        className: rt.scrolledPosition,
        style: {
          width: `${o * 100}%`,
          left: `${l}%`
        }
      }
    ) }),
    /* @__PURE__ */ P(
      "div",
      {
        className: `${rt.actionButtonContainer} ${(n == null ? void 0 : n.arrowButtonContainer) ?? ""}`,
        children: [
          /* @__PURE__ */ f(
            "button",
            {
              className: rt.actionButton,
              onClick: i,
              disabled: t,
              children: /* @__PURE__ */ f(F8, { className: rt.actionIcon })
            }
          ),
          /* @__PURE__ */ f(
            "button",
            {
              className: rt.actionButton,
              disabled: r,
              onClick: a,
              children: /* @__PURE__ */ f(M8, { className: rt.actionIcon })
            }
          )
        ]
      }
    )
  ] });
}, D8 = 30, Kg = $e((e, n) => {
  const {
    showProgressBar: t,
    items: r,
    offsetWidth: i,
    onInit: a,
    classNames: o,
    debug: l,
    cardWidth: s,
    columnCount: u,
    minColumnWidth: c
  } = e, d = ht(() => i ?? 20, [i]), [p, h] = de(0), [y, C] = de(
    s ?? 0
  ), [$, m] = de(u ?? 0), x = _e(null), A = _e(null), I = _e(null), b = ht(
    () => r != null && r.length && $ ? 1 / (r.length + 1 - $) : 0,
    [$, r == null ? void 0 : r.length]
  ), w = ht(() => $ && p != null && r.length != null && b != null && r.length + 1 - $ > 0 ? p * b * 100 : 0, [p, $, r.length, b]), S = te(
    (H) => {
      I.current && (clearTimeout(I.current), I.current = null), x.current && (l && (console.log("new Index ", H), console.log(
        "scrolling to ",
        H * y + d * H
      )), x.current.scrollTo({
        left: H * y + d * H,
        behavior: "smooth"
      }), h(H));
    },
    [l, d, y]
  ), O = te(() => {
    p > 0 && S(p - 1);
  }, [p, S]), N = te(() => {
    p < r.length && S(p + 1);
  }, [p, r == null ? void 0 : r.length, S]), R = te(() => {
    I.current && (clearTimeout(I.current), I.current = null), I.current = setTimeout(() => {
      var H, ee, V;
      if (A.current && ((H = x.current) == null ? void 0 : H.scrollLeft) != null) {
        l && console.log(
          "on scroll handling set active",
          ((ee = x.current) == null ? void 0 : ee.scrollLeft) / (y + d)
        );
        const ae = ((V = x.current) == null ? void 0 : V.scrollLeft) / (y + d);
        r.length - $ === Math.ceil(ae) ? h(r.length - $) : h(Math.round(ae));
      }
      I.current = null;
    }, D8);
  }, [l, y, d, r.length, $]), T = te(
    (H) => {
      var ee, V;
      if ((ee = A == null ? void 0 : A.current) != null && ee.clientWidth)
        return Math.floor(
          (((V = A == null ? void 0 : A.current) == null ? void 0 : V.clientWidth) + d) / (H + d)
        );
    },
    [d]
  ), E = te(
    (H) => {
      var ee, V;
      if ((ee = x == null ? void 0 : x.current) != null && ee.clientWidth) {
        const ae = window.getComputedStyle(x.current), g = ae.getPropertyValue("padding-left"), z = ae.getPropertyValue("padding-right"), J = g ? parseInt(g) : 0, v = z ? parseInt(z) : 0;
        return (((V = x == null ? void 0 : x.current) == null ? void 0 : V.clientWidth) - J - v - d * (H - 1)) / H;
      }
    },
    [d]
  ), L = te(() => {
    if (s) {
      const H = T(s);
      H && (m(H), a == null || a(H)), s !== y && C(s);
    } else if (u) {
      const H = E(u);
      H && C(Math.max(H, c ?? 0)), u !== $ && (m(u), a == null || a(u));
    }
  }, [
    s,
    u,
    T,
    y,
    a,
    E,
    $,
    c
  ]);
  ce(() => {
    L();
  }, [L]), ce(() => (L(), window.addEventListener("resize", L), () => window.removeEventListener("resize", L)), [L]), zt(n, () => ({
    cardsScrollRef: x,
    getExpectedCards: T
  })), ce(() => {
    l && console.log("expectedCards", $);
  }, [l, $]), ce(() => {
    l && console.log("cardWidth", s);
  }, [l, s]), ce(() => {
    l && console.log("offsetWidth", d);
  }, [l, d]), ce(() => {
    l && console.log("activeIndex", p);
  }, [l, p]);
  const W = ht(() => {
    const H = {
      gap: `0 ${d}px`
    };
    return y && (H.gridTemplateColumns = `repeat(auto-fill, minmax(${y}px, 1fr)`, H.gridAutoColumns = `minmax(${y}px, 1fr)`), H;
  }, [y, d]), D = ht(() => t ? r.length > $ : !1, [t, r.length, $]);
  return /* @__PURE__ */ P(
    "div",
    {
      className: `${rt.container} ${(o == null ? void 0 : o.container) ?? ""}`,
      ref: A,
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            className: `${rt.cardsContainer} ${(o == null ? void 0 : o.cardsPosition) ?? ""}`,
            children: /* @__PURE__ */ f(
              "div",
              {
                ref: x,
                className: `${rt.cards} ${(o == null ? void 0 : o.cardsContainer) ?? ""}`,
                onScroll: R,
                style: W,
                children: r.map((H) => H)
              }
            )
          }
        ),
        D ? /* @__PURE__ */ f(
          R8,
          {
            classNames: o,
            disabledLeftButton: p <= 0,
            disabledRightButton: p >= r.length - $,
            onLeftButtonClick: O,
            onRightButtonClick: N,
            scrollWidth: b,
            leftPosition: w
          }
        ) : null
      ]
    }
  );
}), B8 = "_sectionedForm_zsdpq_1", j8 = "_title_zsdpq_8", H8 = "_section_zsdpq_1", V8 = "_sectionTitle_zsdpq_30", z8 = "_available_zsdpq_46", W8 = "_sectionTitleText_zsdpq_50", U8 = "_complete_zsdpq_53", q8 = "_caret_zsdpq_54", Z8 = "_submitButton_zsdpq_62", De = {
  sectionedForm: B8,
  title: j8,
  section: H8,
  sectionTitle: V8,
  available: z8,
  sectionTitleText: W8,
  complete: U8,
  caret: q8,
  submitButton: Z8
}, ko = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M7.71966 5.03032C7.58394 4.8946 7.5 4.7071 7.5 4.5C7.5 4.08579 7.83579 3.75 8.25 3.75C8.46067 3.75 8.65105 3.83686 8.78729 3.97672L16.2733 11.4627C16.4131 11.5989 16.5 11.7893 16.5 12C16.5 12.2107 16.4131 12.4011 16.2733 12.5373L8.78728 20.0233C8.65105 20.1631 8.46067 20.25 8.25 20.25C7.83579 20.25 7.5 19.9142 7.5 19.5C7.5 19.2929 7.58394 19.1054 7.71966 18.9697L14.6892 12L7.71966 5.03032Z", fill: "#666666" })), Oo = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M21.75 5.25C21.75 4.83579 21.4142 4.5 21 4.5C20.7912 4.5 20.6023 4.58535 20.4663 4.72308L7.50006 17.6893L3.53039 13.7196C3.39466 13.5839 3.20711 13.5 3 13.5C2.58579 13.5 2.25 13.8358 2.25 14.25C2.25 14.4607 2.33686 14.6511 2.47672 14.7873L6.96272 19.2733C7.09896 19.4131 7.28934 19.5 7.5 19.5C7.70713 19.5 7.89465 19.416 8.03038 19.2803L21.5304 5.7803C21.6661 5.64458 21.75 5.45708 21.75 5.25Z", fill: "#666666" })), G8 = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M7.64644 3.35355C7.55596 3.26306 7.5 3.13807 7.5 3C7.5 2.72386 7.72386 2.5 8 2.5C8.14045 2.5 8.26737 2.55791 8.35819 2.65115L13.3489 7.64181C13.4421 7.73263 13.5 7.85955 13.5 8C13.5 8.14045 13.4421 8.26737 13.3489 8.35819L8.35819 13.3489C8.26737 13.4421 8.14045 13.5 8 13.5C7.72386 13.5 7.5 13.2761 7.5 13C7.5 12.8619 7.55596 12.7369 7.64644 12.6465L11.7928 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H11.7928L7.64644 3.35355Z", fill: "#0E5FE3" })), Yg = $e(
  (e, n) => {
    var x;
    const { title: t, form: r, onChange: i, onSubmit: a, disabled: o, onSubmitLabel: l } = e, { t: s } = Te(void 0, { lng: e.language ?? void 0 }), [u, c] = de([]), [d, p] = de(null), h = u.every((A) => A.complete);
    ce(() => {
      const A = r.questions.reduce(
        (N, R) => {
          var T, E;
          if (R.section) {
            const L = R.section.split("/");
            if (L.length > 1) {
              N[L[0]] || (N[L[0]] = {
                id: L[0],
                title: L[0],
                questions: [],
                children: [],
                complete: !1
              });
              const W = N[L[0]], D = (T = W.children) == null ? void 0 : T.find(
                (H) => H.title === L[1]
              );
              D ? D.questions.push(R) : (E = W.children) == null || E.push({
                id: R.section,
                title: L[1],
                questions: [R],
                children: [],
                complete: !1
              });
            } else
              N[L[0]] ? N[L[0]].questions.push(R) : N[L[0]] = {
                id: R.section,
                title: L[0],
                questions: [R],
                children: [],
                complete: !1
              };
          }
          return N;
        },
        {}
      ), I = (N, R) => {
        for (const T of R) {
          if (T.id === N)
            return T;
          if (T.type === ue.MultiPart) {
            const E = I(N, T.questions);
            if (E)
              return E;
          }
        }
        return null;
      }, b = (N) => N != null && N !== "", w = (N) => {
        if (N.answeredAt)
          return !0;
        if (N.onlyAvailableIf) {
          const R = N.onlyAvailableIf, T = I(
            R.questionId,
            r.questions
          );
          if (T)
            return Array.isArray(R.answer) ? R.answer.includes(
              T.answer
            ) ? !0 : null : T.answer !== (R == null ? void 0 : R.answer) ? null : N.required && !b(N.answer) ? !1 : !N.required && N.answer === null;
        }
        return N.required && !b(N.answer) ? !1 : !N.required && N.answer === null;
      };
      let S = !1;
      const O = Object.values(A).map(
        (N) => {
          if (Object.keys(A).indexOf(N.id) > 0 && !S)
            return N.complete = !1, N;
          let T = !1;
          if (N.children && N.children.length > 0) {
            const L = N.children.map((W) => W.questions.map((D) => w(D))).filter((W) => W !== null).map((W) => W.filter((D) => D !== null).every((D) => D));
            T = L.every((W) => W), N.children = N.children.map((W, D) => (W.complete = L[D], W));
          } else
            T = N.questions.map((L) => w(L)).filter((L) => L !== null).every((L) => L);
          return T ? (N.complete = !0, S = !0) : S = !1, N;
        }
      );
      c(O);
    }, [r.questions]);
    const y = (A) => (I) => {
      I.preventDefault(), o || p(A);
    }, C = (A) => {
      if (!d || o)
        return;
      const I = {
        ...d,
        questions: A
      };
      p(I);
      const b = u.map((S) => {
        var N;
        if (S.id === I.id)
          return I;
        const O = d.id.split("/");
        return O.length > 1 && S.id === O[0] ? {
          ...S,
          children: (N = S.children) == null ? void 0 : N.map((R) => R.id === d.id ? I : R)
        } : S;
      }), w = b.reduce((S, O) => O.children && O.children.length > 0 ? S.concat(
        O.children.reduce(
          (N, R) => N.concat(R.questions),
          []
        )
      ) : S.concat(O.questions), []);
      i && i(w), c(b);
    }, $ = (A) => {
      if (!d || o)
        return;
      const I = {
        ...d,
        questions: A,
        complete: !0
      }, b = u.map((S) => {
        var N;
        if (S.id === I.id)
          return I;
        const O = d.id.split("/");
        return O.length > 1 && S.id === O[0] ? {
          ...S,
          children: (N = S.children) == null ? void 0 : N.map((R) => R.id === d.id ? I : R)
        } : S;
      }), w = b.reduce((S, O) => O.children && O.children.length > 0 ? S.concat(
        O.children.reduce(
          (N, R) => N.concat(R.questions),
          []
        )
      ) : S.concat(O.questions), []);
      i && i(w), c(b), console.log(b), p(null);
    }, m = (A) => {
      if (A.preventDefault(), h && !o) {
        const I = u.reduce((b, w) => w.children && w.children.length > 0 ? b.concat(
          w.children.reduce(
            (S, O) => S.concat(O.questions),
            []
          )
        ) : b.concat(w.questions), []);
        a && a(I);
      }
    };
    return /* @__PURE__ */ P(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${De.sectionedForm} ${(x = e.props) == null ? void 0 : x.className}`,
        children: [
          d ? null : /* @__PURE__ */ P(Fe, { children: [
            t ? /* @__PURE__ */ f("div", { className: De.title, children: t }) : null,
            u.map((A, I) => {
              var w, S;
              const b = I === 0 || A.complete || I > 0 && u[I - 1].complete;
              return /* @__PURE__ */ P("div", { className: De.section, children: [
                A.title && /* @__PURE__ */ P(
                  "div",
                  {
                    className: `${De.sectionTitle} ${b ? De.available : ""}`,
                    style: {
                      cursor: !o && A.children && (A.children.length >= 0 && b || b && A.children.length === 0) ? "pointer" : "default"
                    },
                    onClick: !A.children || A.children.length === 0 && b ? y(A) : void 0,
                    children: [
                      /* @__PURE__ */ f("div", { className: De.sectionTitleText, children: s(`intake.${r.source}.section.${A.title}`) }),
                      A.complete ? /* @__PURE__ */ f("div", { className: De.complete, children: /* @__PURE__ */ f(Oo, {}) }) : null,
                      !A.children || A.children.length === 0 ? /* @__PURE__ */ f("div", { className: De.caret, children: /* @__PURE__ */ f(ko, {}) }) : null
                    ]
                  }
                ),
                A.children && ((w = A.children) == null ? void 0 : w.length) > 0 ? /* @__PURE__ */ f("div", { className: De.section, children: (S = A.children) == null ? void 0 : S.map((O, N) => {
                  const R = I === 0 && N === 0 || O.complete || I > 0 && u[I - 1].complete && (N === 0 || N > 0 && A.children && A.children[N - 1].complete);
                  return /* @__PURE__ */ P(
                    "div",
                    {
                      className: `${De.sectionTitle} ${R ? De.available : ""}`,
                      onClick: !o && (!O.children || O.children.length === 0 && R) ? y(O) : void 0,
                      children: [
                        /* @__PURE__ */ f("div", { className: De.sectionTitleText, children: s(`intake.${r.source}.section.${O.title}`) }),
                        O.complete ? /* @__PURE__ */ f("div", { className: De.complete, children: /* @__PURE__ */ f(Oo, {}) }) : null,
                        /* @__PURE__ */ f("div", { className: De.caret, children: /* @__PURE__ */ f(ko, {}) })
                      ]
                    },
                    N
                  );
                }) }) : null
              ] }, I);
            }),
            /* @__PURE__ */ P(
              "button",
              {
                className: De.submitButton,
                type: "submit",
                onClick: m,
                disabled: !h || o,
                children: [
                  l || s("chat.submit"),
                  /* @__PURE__ */ f(G8, {})
                ]
              }
            )
          ] }),
          d ? /* @__PURE__ */ f(
            ei,
            {
              form: {
                id: d.id,
                name: s(`intake.${r.source}.section.${d.id}`),
                questions: d.questions
              },
              onChange: C,
              onComplete: $,
              onBack: () => p(null),
              language: e.language
            }
          ) : null
        ]
      }
    );
  }
);
var Dn, wn = Ns;
if (process.env.NODE_ENV === "production")
  Dn = wn.createRoot, wn.hydrateRoot;
else {
  var To = wn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  Dn = function(e, n) {
    To.usingClientEntryPoint = !0;
    try {
      return wn.createRoot(e, n);
    } finally {
      To.usingClientEntryPoint = !1;
    }
  };
}
const Q8 = "_confirmModalWrapper_1v2jc_1", K8 = "_confirmModal_1v2jc_1", Y8 = "_confirmModalHeader_1v2jc_25", X8 = "_confirmModalTitle_1v2jc_34", J8 = "_confirmModalDescription_1v2jc_45", ep = "_confirmModalFooter_1v2jc_55", tp = "_disabled_1v2jc_90", _t = {
  confirmModalWrapper: Q8,
  confirmModal: K8,
  confirmModalHeader: Y8,
  confirmModalTitle: X8,
  confirmModalDescription: J8,
  confirmModalFooter: ep,
  disabled: tp
}, np = $e(
  (e, n) => {
    const { t } = Te();
    return /* @__PURE__ */ P("div", { className: _t.confirmModalWrapper, children: [
      /* @__PURE__ */ P("div", { ref: n, className: _t.confirmModal, children: [
        /* @__PURE__ */ P("div", { className: _t.confirmModalHeader, children: [
          /* @__PURE__ */ f("div", { className: _t.confirmModalTitle, children: e.title }),
          /* @__PURE__ */ f("div", { className: _t.confirmModalDescription, children: e.description })
        ] }),
        /* @__PURE__ */ P("div", { className: _t.confirmModalFooter, children: [
          /* @__PURE__ */ f("button", { onClick: e.onCancel, children: t("confirm.cancel") }),
          /* @__PURE__ */ f("button", { onClick: e.onConfirm, children: t("confirm.yes") })
        ] })
      ] }),
      /* @__PURE__ */ f("div", { className: _t.confirmModalBackground })
    ] });
  }
), Xg = ({
  title: e,
  description: n,
  onConfirm: t
}) => {
  const r = document.createElement("div");
  document.body.appendChild(r);
  const i = Dn(r);
  document.body.style.overflow = "hidden";
  const a = () => {
    t(), l();
  }, o = () => {
    l();
  }, l = () => {
    i.unmount(), document.body.removeChild(r), document.body.style.overflow = "auto";
  };
  i.render(
    /* @__PURE__ */ f(
      np,
      {
        title: e,
        description: n,
        onConfirm: a,
        onCancel: o
      }
    )
  );
}, rp = "_aiLawyerSelectorWrapper_1okk2_1", ip = "_aiLawyerIconContainer_1okk2_9", ap = "_aiLawyerIcon_1okk2_9", op = "_hoverEnabled_1okk2_41", lp = "_popupOverlay_1okk2_45", sp = "_aiLawyerPickerWrapper_1okk2_52", up = "_aiLawyerPickerItem_1okk2_63", cp = "_aiLawyerPickerImage_1okk2_73", dp = "_selectedLawyer_1okk2_77", fp = "_topStart_1okk2_87", hp = "_topMiddle_1okk2_100", pp = "_bottomStart_1okk2_105", mp = "_bottomMiddle_1okk2_119", gp = "_noSelect_1okk2_181", ke = {
  aiLawyerSelectorWrapper: rp,
  aiLawyerIconContainer: ip,
  aiLawyerIcon: ap,
  hoverEnabled: op,
  popupOverlay: lp,
  aiLawyerPickerWrapper: sp,
  aiLawyerPickerItem: up,
  aiLawyerPickerImage: cp,
  selectedLawyer: dp,
  topStart: fp,
  topMiddle: hp,
  bottomStart: pp,
  bottomMiddle: mp,
  noSelect: gp
}, Jg = (e) => {
  const [n, t] = de(""), [r, i] = de(!1), {
    isSelectorEnabled: a,
    selectedAiLawyer: o,
    aiLawyers: l,
    onAiLawyerChange: s,
    headerContainerRef: u,
    chatContainerRef: c
  } = e, [d, p] = de(!1), h = _e(null), [y, C] = de("topMiddle"), $ = 76, m = 312, x = _e(null), A = (N) => {
    s && s(N), p(!1);
  };
  ce(() => {
    o && ((R) => {
      const T = l.find(
        (E) => E.aiLawyer === R
      );
      T && (t(T.image), i(!0));
    })(o);
  }, [o, l]);
  const I = () => {
    var N;
    if (x.current && clearTimeout(x.current), u && u.current && c && c.current) {
      const R = u.current.getBoundingClientRect(), T = c.current.getBoundingClientRect(), E = (N = h.current) == null ? void 0 : N.getBoundingClientRect();
      R && E && T && (R.bottom < E.top - $ && T.left < E.left - m / 2 ? C("topMiddle") : R.bottom < E.top - $ && T.left >= E.left - m / 2 ? C("topStart") : T.left < E.left - m / 2 ? C("bottomMiddle") : C("bottomStart"));
    }
    p(!0);
  }, b = () => {
    x.current = setTimeout(() => {
      p(!1);
    }, 300);
  }, w = () => {
    x.current && clearTimeout(x.current);
  }, S = () => {
    x.current = setTimeout(() => {
      p(!1);
    }, 300);
  }, O = () => {
    i(!1);
  };
  return /* @__PURE__ */ P("div", { className: ke.aiLawyerSelectorWrapper, children: [
    /* @__PURE__ */ f(
      "div",
      {
        className: `${ke.aiLawyerIconContainer} ${ke.noSelect} ${d && a ? ke.hoverEnabled : ""} `,
        onMouseEnter: () => I(),
        onMouseLeave: () => b(),
        ref: h,
        children: r ? /* @__PURE__ */ f(
          "img",
          {
            className: `${ke.aiLawyerIcon} ${ke.noSelect}`,
            src: n,
            onError: O
          }
        ) : null
      }
    ),
    d && a && /* @__PURE__ */ f(
      "div",
      {
        className: `${ke.popupOverlay} ${ke.noSelect} ${ke[y]}`,
        onMouseEnter: () => w(),
        onMouseLeave: () => S(),
        children: /* @__PURE__ */ f("div", { className: ke.aiLawyerPickerWrapper, children: l.map((N) => /* @__PURE__ */ f(
          "div",
          {
            className: `${ke.aiLawyerPickerItem} ${o === N.aiLawyer ? ke.selectedLawyer : ""}`,
            onClick: () => A(N.aiLawyer),
            children: /* @__PURE__ */ f(
              "img",
              {
                className: `${ke.aiLawyerPickerImage} ${ke.noSelect}`,
                src: N.image
              }
            )
          },
          N.aiLawyer
        )) })
      }
    )
  ] });
}, ey = (e) => {
  const { iconImage: n, className: t, iconClassName: r } = e, [i, a] = de(!1), o = () => {
    a(!0);
  };
  return /* @__PURE__ */ f("div", { className: ke.aiLawyerSelectorWrapper, children: /* @__PURE__ */ f("div", { className: `${ke.aiLawyerIconContainer} ${ke.noSelect} ${t}`, children: i ? null : /* @__PURE__ */ f(
    "img",
    {
      className: `${ke.aiLawyerIcon} ${ke.noSelect} ${r}`,
      src: n,
      onError: o
    }
  ) }) });
}, yp = "_financialInput_1m2l1_1", $p = {
  financialInput: yp
}, ty = $e(
  (e, n) => {
    var o;
    const { value: t, disabled: r, onChange: i } = e, a = te((l) => {
      l.preventDefault(), l.stopPropagation(), r || i(l.target.value);
    }, [r, i]);
    return /* @__PURE__ */ f(
      "input",
      {
        ref: n,
        ...e.props,
        className: `${$p.numericInput} ${(o = e.props) == null ? void 0 : o.className}`,
        type: "number",
        value: t,
        onChange: a
      }
    );
  }
), vp = "_onOffInputContainer_geq9i_1", Cp = "_onOffInputTitle_geq9i_15", bp = "_onOffInputValue_geq9i_28", Ap = "_switchButton_geq9i_36", wp = "_switchButtonCircle_geq9i_45", xp = "_on_geq9i_1", _p = "_off_geq9i_60", Np = "_disabled_geq9i_65", at = {
  onOffInputContainer: vp,
  onOffInputTitle: Cp,
  onOffInputValue: bp,
  switchButton: Ap,
  switchButtonCircle: wp,
  on: xp,
  off: _p,
  disabled: Np
}, ny = $e(
  (e, n) => {
    const {
      title: t,
      value: r,
      disabled: i,
      onChange: a,
      className: o,
      hideLabel: l,
      titleClassName: s,
      switchButtonClassName: u
    } = e, { t: c } = Te(), d = () => {
      a(!r);
    };
    return /* @__PURE__ */ P(
      "div",
      {
        ref: n,
        ...e.props,
        className: `${at.onOffInputContainer} ${o || ""}`,
        children: [
          /* @__PURE__ */ f(
            "div",
            {
              className: `${at.onOffInputTitle} ${s || ""}`,
              children: t
            }
          ),
          !l && /* @__PURE__ */ f("div", { className: `${at.onOffInputValue}`, children: c(r ? "confirm.on" : "confirm.off") }),
          /* @__PURE__ */ f(
            "div",
            {
              className: `${at.switchButton} ${r ? at.on : at.off} ${i ? at.disabled : ""} ${u || ""}`,
              onClick: d,
              children: /* @__PURE__ */ f(
                "div",
                {
                  className: `${at.switchButtonCircle} ${r ? at.on : at.off}`
                }
              )
            }
          )
        ]
      }
    );
  }
), Ip = "_mobileMenuWrapper_1k9nn_2", Ep = "_mobileMenuContainer_1k9nn_6", Sp = "_menuIconContainer_1k9nn_16", Pp = "_iconWrapper_1k9nn_21", kp = "_logoContainer_1k9nn_26", Op = "_menuIcon_1k9nn_16", Tp = "_defaultIcon_1k9nn_46", Lp = "_hidden_1k9nn_46", Fp = "_activeIcon_1k9nn_50", Mp = "_burgerIcon_1k9nn_54", Rp = "_closeIcon_1k9nn_62", Dp = "_logo_1k9nn_26", Bp = "_menuModalOverlay_1k9nn_74", jp = "_menuModalOverlayOpen_1k9nn_88", Hp = "_menuModalContent_1k9nn_93", Vp = "_menuLinksContainer_1k9nn_101", zp = "_mainMenuLink_1k9nn_105", Wp = "_subMenuLink_1k9nn_112", Up = "_mobileLogoContainer_1k9nn_119", qp = "_logoImage_1k9nn_126", Zp = "_desktopMenuContainer_1k9nn_133", Gp = "_floatingContainer_1k9nn_152", Qp = "_shrink_1k9nn_183", Kp = "_menuContentContainer_1k9nn_189", Yp = "_textWrapper_1k9nn_189", Xp = "_active_1k9nn_50", Jp = "_accountContainer_1k9nn_297", em = "_accountImage_1k9nn_306", tm = "_spacer_1k9nn_325", nm = "_accountLink_1k9nn_328", rm = "_userImageContainer_1k9nn_336", im = "_userImage_1k9nn_336", am = "_notificationBadge_1k9nn_352", om = "_userAccountTextContainer_1k9nn_362", lm = "_chevronIcon_1k9nn_380", sm = "_rotated_1k9nn_388", um = "_hoverMenu_1k9nn_391", cm = "_isOpen_1k9nn_434", dm = "_menuItem_1k9nn_438", fm = "_menuItemText_1k9nn_453", G = {
  mobileMenuWrapper: Ip,
  mobileMenuContainer: Ep,
  menuIconContainer: Sp,
  iconWrapper: Pp,
  logoContainer: kp,
  menuIcon: Op,
  defaultIcon: Tp,
  hidden: Lp,
  activeIcon: Fp,
  burgerIcon: Mp,
  closeIcon: Rp,
  logo: Dp,
  menuModalOverlay: Bp,
  menuModalOverlayOpen: jp,
  menuModalContent: Hp,
  menuLinksContainer: Vp,
  mainMenuLink: zp,
  subMenuLink: Wp,
  mobileLogoContainer: Up,
  logoImage: qp,
  desktopMenuContainer: Zp,
  floatingContainer: Gp,
  shrink: Qp,
  menuContentContainer: Kp,
  textWrapper: Yp,
  active: Xp,
  accountContainer: Jp,
  accountImage: em,
  spacer: tm,
  accountLink: nm,
  userImageContainer: rm,
  userImage: im,
  notificationBadge: am,
  userAccountTextContainer: om,
  chevronIcon: lm,
  rotated: sm,
  hoverMenu: um,
  isOpen: cm,
  menuItem: dm,
  menuItemText: fm
}, ys = "data:image/webp;base64,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", hm = "data:image/svg+xml,%3csvg%20width='65'%20height='64'%20viewBox='0%200%2065%2064'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_3791_65565)'%3e%3cpath%20d='M32.5%2064C50.1731%2064%2064.5%2049.6731%2064.5%2032H48.5C48.5%2040.8365%2041.3366%2048%2032.5%2048C23.6634%2048%2016.5%2040.8365%2016.5%2032C16.5%2023.1635%2023.6634%2016%2032.5%2016V0C14.8269%200%200.5%2014.3269%200.5%2032C0.5%2049.6731%2014.8269%2064%2032.5%2064Z'%20fill='%230E5FE3'/%3e%3cpath%20d='M53.8333%2021.3333C59.7244%2021.3333%2064.5%2016.5577%2064.5%2010.6667C64.5%204.77564%2059.7244%200%2053.8333%200C47.9423%200%2043.1667%204.77564%2043.1667%2010.6667C43.1667%2016.5577%2047.9423%2021.3333%2053.8333%2021.3333Z'%20fill='%230E5FE3'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_3791_65565'%3e%3crect%20width='64'%20height='64'%20fill='white'%20transform='translate(0.5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", pm = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='icon/menu'%3e%3cg%20id='Union'%3e%3cpath%20d='M21%207.5C21%207.91421%2020.6642%208.25%2020.25%208.25H3.75C3.33579%208.25%203%207.91421%203%207.5C3%207.08579%203.33579%206.75%203.75%206.75H20.25C20.6642%206.75%2021%207.08579%2021%207.5Z'%20fill='%23333333'/%3e%3cpath%20d='M21%2012C21%2012.4142%2020.6642%2012.75%2020.25%2012.75H3.75C3.33579%2012.75%203%2012.4142%203%2012C3%2011.5858%203.33579%2011.25%203.75%2011.25H20.25C20.6642%2011.25%2021%2011.5858%2021%2012Z'%20fill='%23333333'/%3e%3cpath%20d='M20.25%2017.25C20.6642%2017.25%2021%2016.9142%2021%2016.5C21%2016.0858%2020.6642%2015.75%2020.25%2015.75H3.75C3.33579%2015.75%203%2016.0858%203%2016.5C3%2016.9142%203.33579%2017.25%203.75%2017.25H20.25Z'%20fill='%23333333'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", mm = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.5%203.75C19.9142%203.75%2020.25%204.08579%2020.25%204.5C20.25%204.70708%2020.1661%204.89456%2020.0304%205.03028L13.0607%2012L20.0304%2018.9696C20.1661%2019.1054%2020.25%2019.2929%2020.25%2019.5C20.25%2019.9142%2019.9142%2020.25%2019.5%2020.25C19.2894%2020.25%2019.099%2020.1632%2018.9628%2020.0233L12.0001%2013.0606L5.03039%2020.0303C4.89466%2020.166%204.70713%2020.25%204.5%2020.25C4.08579%2020.25%203.75%2019.9142%203.75%2019.5C3.75%2019.2912%203.83535%2019.1023%203.97308%2018.9663L10.9394%2012L3.97671%205.03727C3.83685%204.90104%203.75%204.71066%203.75%204.5C3.75%204.08579%204.08579%203.75%204.5%203.75C4.70711%203.75%204.89462%203.83395%205.03034%203.96968L12.0001%2010.9393L18.9663%203.97308C19.1023%203.83535%2019.2912%203.75%2019.5%203.75Z'%20fill='%23333333'/%3e%3c/svg%3e", ti = "data:image/svg+xml,%3csvg%20width='112'%20height='112'%20viewBox='0%200%20112%20112'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='56'%20cy='56'%20r='56'%20fill='%23EEEFF1'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M68%2047C68%2053.6274%2062.6274%2059%2056%2059C49.3726%2059%2044%2053.6274%2044%2047C44%2040.3726%2049.3726%2035%2056%2035C62.6274%2035%2068%2040.3726%2068%2047ZM65%2047C65%2051.9706%2060.9706%2056%2056%2056C51.0294%2056%2047%2051.9706%2047%2047C47%2042.0294%2051.0294%2038%2056%2038C60.9706%2038%2065%2042.0294%2065%2047Z'%20fill='%23B0B7BD'/%3e%3cpath%20d='M38.0118%2075.9768C40.6329%2068.9068%2048.1368%2065.1578%2056%2065.1578C63.8632%2065.1578%2071.3671%2068.9068%2073.9882%2075.9768C74.2908%2076.7929%2075.1879%2077.2055%2075.9919%2076.8984C76.796%2076.5913%2077.2025%2075.6807%2076.8999%2074.8646C73.6674%2066.1455%2064.6541%2062%2056%2062C47.3459%2062%2038.3326%2066.1455%2035.1001%2074.8646C34.7975%2075.6807%2035.204%2076.5913%2036.0081%2076.8984C36.8121%2077.2055%2037.7092%2076.7929%2038.0118%2075.9768Z'%20fill='%23B0B7BD'/%3e%3c/svg%3e", $s = (e) => /* @__PURE__ */ _.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "#333333", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/chevron down" }, /* @__PURE__ */ _.createElement("path", { id: "Union", d: "M12.6467 5.14644C12.7372 5.05596 12.8622 5 13.0002 5C13.2764 5 13.5002 5.22386 13.5002 5.5C13.5002 5.64045 13.4423 5.76737 13.3491 5.85819L8.35844 10.8489C8.26761 10.9421 8.14069 11 8.00024 11C7.8598 11 7.73287 10.9421 7.64205 10.8489L2.65139 5.85819C2.55815 5.76737 2.50024 5.64045 2.50024 5.5C2.50024 5.22386 2.7241 5 3.00024 5C3.13831 5 3.26331 5.05596 3.35379 5.14644L8.00024 9.79283L12.6467 5.14644Z" }))), gm = (e) => /* @__PURE__ */ _.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "white", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("g", { id: "icon/folder" }, /* @__PURE__ */ _.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M18.75 5.25C19.5 5.25 20.25 6 20.25 6.75V8.25H21.75C22.5784 8.25 23.25 8.92157 23.25 9.75V18.75C23.25 19.5784 22.5784 20.25 21.75 20.25H5.25C4.42157 20.25 3.75 19.5784 3.75 18.75V17.25H2.25C1.42157 17.25 0.75 16.5784 0.75 15.75V3.75C0.75 2.92157 1.42157 2.25 2.25 2.25H9C9.20885 2.25 9.39776 2.33537 9.53374 2.47311L12.3106 5.25H18.75ZM2.25 3.75H8.68932L11.4696 6.53029C11.6053 6.66605 11.7929 6.75 12 6.75H18.75V15.75H2.25L2.25 3.75ZM20.25 9.75V15.75C20.25 16.5784 19.5784 17.25 18.75 17.25H5.25V18.75H21.75V9.75H20.25Z" }))), ym = (e) => /* @__PURE__ */ _.createElement("svg", { width: 21, height: 22, viewBox: "0 0 21 22", fill: "#B0B7BD", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { id: "Subtract (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M8.43438 4.51673L7.68918 4.85752C7.29771 5.03655 6.92599 5.25211 6.57842 5.50001L5.91028 5.97656L3.54852 5.02858L1.84946 7.97144L3.84969 9.54151L3.77283 10.3567C3.7529 10.568 3.74268 10.7826 3.74268 11C3.74268 11.2172 3.75289 11.4317 3.77279 11.6429L3.84959 12.458L1.84873 14.0286L3.54779 16.9714L5.91007 16.0232L6.57822 16.4998C6.92585 16.7478 7.29764 16.9634 7.68918 17.1425L8.43438 17.4833L8.79391 20L12.192 20L12.5516 17.4831L13.2967 17.1422C13.688 16.9632 14.0596 16.7477 14.4071 16.4999L15.0753 16.0233L17.4374 16.9714L19.1365 14.0286L17.1357 12.4581L17.2126 11.643C17.2325 11.4317 17.2427 11.2173 17.2427 11C17.2427 10.7827 17.2325 10.5683 17.2126 10.357L17.1357 9.54189L19.1365 7.97141L17.4374 5.02856L15.0752 5.97671L14.4071 5.50012C14.0596 5.25228 13.688 5.03676 13.2967 4.85776L12.5516 4.51694L12.192 2L8.79391 2L8.43438 4.51673ZM13.9206 3.49369L13.677 1.78787C13.5714 1.04889 12.9385 0.5 12.192 0.5H8.79391C8.04744 0.5 7.41456 1.04889 7.30899 1.78787L7.06534 3.4934C6.58632 3.71246 6.13192 3.97603 5.70741 4.27881L4.10727 3.63654C3.41452 3.35847 2.62272 3.63212 2.24948 4.27858L0.550426 7.22144C0.177188 7.8679 0.336103 8.69044 0.923289 9.15135L2.27945 10.2159C2.25512 10.474 2.24268 10.7355 2.24268 11C2.24268 11.2643 2.2551 11.5257 2.27941 11.7836L0.922559 12.8487C0.335373 13.3096 0.176456 14.1321 0.549694 14.7786L2.24875 17.7214C2.62199 18.3679 3.41379 18.6415 4.10654 18.3635L5.70716 17.721C6.13174 18.0239 6.58623 18.2875 7.06534 18.5066L7.30899 20.2121C7.41456 20.9511 8.04744 21.5 8.79391 21.5H12.192C12.9385 21.5 13.5714 20.9511 13.677 20.2121L13.9206 18.5063C14.3995 18.2873 14.8538 18.0237 15.2782 17.721L16.8787 18.3635C17.5714 18.6415 18.3632 18.3679 18.7365 17.7214L20.4355 14.7786C20.8088 14.1321 20.6498 13.3096 20.0627 12.8486L18.7059 11.7837C18.7302 11.5257 18.7427 11.2643 18.7427 11C18.7427 10.7357 18.7302 10.4743 18.7059 10.2163L20.0627 9.15133C20.6498 8.69042 20.8088 7.86788 20.4355 7.22142L18.7365 4.27856C18.3632 3.6321 17.5714 3.35845 16.8787 3.63651L15.2781 4.27895C14.8538 3.97624 14.3995 3.71273 13.9206 3.49369ZM14.9927 11C14.9927 13.4853 12.978 15.5 10.4927 15.5C8.00739 15.5 5.99268 13.4853 5.99268 11C5.99268 8.51472 8.00739 6.5 10.4927 6.5C12.978 6.5 14.9927 8.51472 14.9927 11ZM13.4927 11C13.4927 12.6569 12.1495 14 10.4927 14C8.83582 14 7.49268 12.6569 7.49268 11C7.49268 9.34315 8.83582 8 10.4927 8C12.1495 8 13.4927 9.34315 13.4927 11Z" })), $m = (e) => /* @__PURE__ */ _.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "#B0B7BD", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M2 3.75024C2 3.33603 2.33579 3.00024 2.75 3.00024H13.25C13.6642 3.00024 14 3.33603 14 3.75024V9.00024C14 9.41446 13.6642 9.75024 13.25 9.75024C12.8358 9.75024 12.5 9.41446 12.5 9.00024V4.50024H3.5V19.5002H12.5V15.0002C12.5 14.586 12.8358 14.2502 13.25 14.2502C13.6642 14.2502 14 14.586 14 15.0002V20.2502C14 20.6645 13.6642 21.0002 13.25 21.0002H2.75C2.33579 21.0002 2 20.6645 2 20.2502V3.75024Z" }), /* @__PURE__ */ _.createElement("path", { d: "M17.75 6.75024C17.3358 6.75024 17 7.08603 17 7.50024C17 7.70735 17.0839 7.89484 17.2197 8.03056L20.4392 11.2502H7.25C6.83579 11.2502 6.5 11.586 6.5 12.0002C6.5 12.4145 6.83579 12.7502 7.25 12.7502H20.4392L17.2196 15.9699C17.0839 16.1056 17 16.2931 17 16.5002C17 16.9145 17.3358 17.2502 17.75 17.2502C17.9607 17.2502 18.151 17.1634 18.2873 17.0235L22.7733 12.5375C22.9131 12.4013 23 12.2109 23 12.0002C23 11.7896 22.9131 11.5992 22.7733 11.463L18.2873 6.97695C18.151 6.8371 17.9607 6.75024 17.75 6.75024Z" })), vs = (e) => {
  const {
    isAuthenticated: n,
    userImage: t,
    openAuthModal: r,
    logout: i,
    onAccountClick: a,
    hasNotifications: o,
    isActive: l
  } = e;
  return n ? /* @__PURE__ */ f(
    vm,
    {
      userImage: t,
      logout: i,
      onAccountClick: a,
      hasNotifications: o,
      isActive: l
    }
  ) : /* @__PURE__ */ f(
    Cm,
    {
      openAuthModal: r,
      isActive: l
    }
  );
}, vm = (e) => {
  const { userImage: n, logout: t, onAccountClick: r, hasNotifications: i, isActive: a } = e, [o, l] = de(!1), { t: s } = Te(), u = _e(null), c = ht(
    () => [
      {
        label: s("account.my-cases"),
        icon: /* @__PURE__ */ f(gm, { className: G.menuIcon }),
        link: "/account"
      },
      {
        label: s("account.settings"),
        icon: /* @__PURE__ */ f(ym, { className: G.menuIcon }),
        link: "/account/edit"
      },
      {
        label: s("account.sign-out"),
        icon: /* @__PURE__ */ f($m, { className: G.menuIcon }),
        onClick: t
      }
    ],
    [s, t]
  );
  Cl(u, () => l(!1));
  const d = te(() => {
    l((p) => !p), r && r();
  }, [r]);
  return /* @__PURE__ */ P("div", { ref: u, children: [
    /* @__PURE__ */ P(
      "div",
      {
        className: `${G.mainMenuLink} ${G.accountLink} ${o ? G.isOpen : ""} ${a ? G.active : ""}`,
        onClick: d,
        children: [
          /* @__PURE__ */ P("div", { className: G.userImageContainer, children: [
            /* @__PURE__ */ f(
              "img",
              {
                src: n ?? ti,
                onError: (p) => {
                  p.currentTarget.src = ti;
                },
                alt: "user",
                className: G.userImage,
                width: 24,
                height: 24
              }
            ),
            i && /* @__PURE__ */ f("div", { className: G.notificationBadge })
          ] }),
          /* @__PURE__ */ P("div", { className: G.userAccountTextContainer, children: [
            /* @__PURE__ */ f("span", { className: G.textWrapper, title: s("pages.account"), children: s("pages.account") }),
            /* @__PURE__ */ f(
              $s,
              {
                className: `${G.chevronIcon} ${o ? G.rotated : ""}`
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ f("div", { className: `${G.hoverMenu} ${o ? G.isOpen : ""}`, children: c.map(
      (p) => p.link ? /* @__PURE__ */ P("a", { href: p.link, className: G.menuItem, children: [
        /* @__PURE__ */ f("span", { className: G.menuItemText, children: p.label }),
        p.icon
      ] }, p.label) : /* @__PURE__ */ P(
        "div",
        {
          onClick: p.onClick,
          className: G.menuItem,
          children: [
            /* @__PURE__ */ f("span", { className: G.menuItemText, children: p.label }),
            p.icon
          ]
        },
        p.label
      )
    ) })
  ] });
}, Cm = (e) => {
  const { t: n } = Te(), { openAuthModal: t } = e;
  return /* @__PURE__ */ P(
    "div",
    {
      className: `${G.mainMenuLink} ${G.accountLink} ${e.isActive ? G.active : ""}`,
      onClick: t,
      children: [
        /* @__PURE__ */ f("div", { className: G.userImageContainer, children: /* @__PURE__ */ f(
          "img",
          {
            src: ti,
            alt: "user",
            className: G.userImage,
            width: 24,
            height: 24
          }
        ) }),
        /* @__PURE__ */ P("div", { className: G.userAccountTextContainer, children: [
          /* @__PURE__ */ f("span", { className: G.textWrapper, title: n("pages.account"), children: n("pages.account") }),
          /* @__PURE__ */ f(
            $s,
            {
              className: G.chevronIcon,
              width: 16,
              height: 16
            }
          )
        ] })
      ]
    }
  );
}, bm = (e) => {
  const { t: n, i18n: t } = Te(), r = t.language, [i, a] = de(!1), o = te(() => {
    a(!0);
  }, []), l = te(() => {
    a(!1);
  }, []);
  ce(() => {
    i ? document.body.style.overflow = "hidden" : document.body.style.overflow = "auto";
  }, [i]);
  const s = te(() => {
    a(!1), e.isAuthenticated ? window.location.href = "/account" : e.openAuthModal();
  }, [e.openAuthModal, e.isAuthenticated]), u = te(() => {
    a(!1), window.location.href = "/account";
  }, []), c = te(() => {
    a(!1), e.logout();
  }, [e.logout]), d = () => /* @__PURE__ */ f("a", { href: "/", className: G.logoContainer, children: /* @__PURE__ */ f(
    "img",
    {
      src: ys,
      alt: "logo",
      width: 130,
      height: 18,
      className: G.logo
    }
  ) });
  return /* @__PURE__ */ P(Fe, { children: [
    /* @__PURE__ */ P("div", { className: G.mobileMenuContainer, children: [
      /* @__PURE__ */ f(
        "div",
        {
          className: G.menuIconContainer,
          onClick: i ? l : o,
          children: /* @__PURE__ */ P("div", { className: G.iconWrapper, children: [
            /* @__PURE__ */ f(
              "img",
              {
                src: pm,
                alt: "hamburger",
                width: 24,
                height: 24,
                className: `${G.menuIcon} ${G.defaultIcon} ${i ? G.hidden : ""}`
              }
            ),
            /* @__PURE__ */ f(
              "img",
              {
                src: mm,
                alt: "close",
                width: 24,
                height: 24,
                className: `${G.menuIcon} ${G.activeIcon} ${i ? "" : G.hidden}`
              }
            )
          ] })
        }
      ),
      /* @__PURE__ */ f(d, {}),
      /* @__PURE__ */ f(
        vs,
        {
          isAuthenticated: e.isAuthenticated,
          userImage: e.userImage,
          openAuthModal: s,
          logout: c,
          hasNotifications: e.hasNotifications
        }
      )
    ] }),
    /* @__PURE__ */ P(
      "div",
      {
        className: `${G.menuModalOverlay} ${i ? G.menuModalOverlayOpen : ""}`,
        children: [
          /* @__PURE__ */ P("div", { className: G.menuModalContent, children: [
            /* @__PURE__ */ P("div", { className: G.menuLinksContainer, children: [
              /* @__PURE__ */ f(
                "a",
                {
                  href: "/chat",
                  className: G.mainMenuLink,
                  onClick: l,
                  children: n("pages.chat")
                }
              ),
              /* @__PURE__ */ f(
                "a",
                {
                  href: `/${r}/library`,
                  className: G.mainMenuLink,
                  onClick: l,
                  children: n("pages.knowledge-base")
                }
              ),
              /* @__PURE__ */ f(
                "a",
                {
                  href: "/help",
                  className: G.mainMenuLink,
                  onClick: l,
                  children: n("pages.help")
                }
              ),
              /* @__PURE__ */ f(
                "div",
                {
                  className: G.mainMenuLink,
                  onClick: u,
                  children: n("pages.account")
                }
              )
            ] }),
            /* @__PURE__ */ P("div", { className: G.menuLinksContainer, children: [
              /* @__PURE__ */ f(
                "a",
                {
                  href: "/about",
                  className: G.subMenuLink,
                  onClick: l,
                  children: n("pages.about")
                }
              ),
              /* @__PURE__ */ f(
                "a",
                {
                  href: "/sailing",
                  className: G.subMenuLink,
                  onClick: l,
                  children: n("pages.sailing")
                }
              ),
              /* @__PURE__ */ f(
                "a",
                {
                  href: "/careers",
                  className: G.subMenuLink,
                  onClick: l,
                  children: n("pages.careers")
                }
              ),
              /* @__PURE__ */ f(
                "a",
                {
                  href: "/contact-us",
                  className: G.subMenuLink,
                  onClick: l,
                  children: n("pages.contact-us")
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ f("div", { className: G.mobileLogoContainer, children: /* @__PURE__ */ f(
            "img",
            {
              src: hm,
              alt: "lawconnect-icon-background",
              className: G.logoImage,
              width: 0,
              height: 0
            }
          ) })
        ]
      }
    )
  ] });
}, Am = () => {
  const [e, n] = de(window.location.pathname);
  return ce(() => {
    const t = () => {
      n(window.location.pathname);
    };
    return window.addEventListener("popstate", t), () => window.removeEventListener("popstate", t);
  }, []), e;
}, Cr = "FLOATING_CONTAINER_ID", wm = ["en-au", "en-gb", "en-ie"], xm = (e) => {
  const { t: n, i18n: t } = Te(), r = t.language, i = Am(), a = te(
    (o) => {
      switch (o) {
        case "/chat":
          return i === "/chat";
        case "/library":
          return i.includes("/library") || wm.some(
            (l) => i.startsWith(`/${l}/`)
          );
        case "/help":
          return i.startsWith("/help");
        case "/account":
          return i.startsWith("/account") || i.startsWith("/case");
        default:
          return !1;
      }
    },
    [i]
  );
  return Mo(() => {
    const o = () => {
      var u, c;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? (u = document.getElementById(Cr)) == null || u.classList.add(G.shrink) : (c = document.getElementById(Cr)) == null || c.classList.remove(G.shrink);
    };
    window.addEventListener("scroll", o), document.body.addEventListener("scroll", o);
    const l = window.innerWidth - document.body.clientWidth;
    return document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${l}px`
    ), o(), () => {
      window.removeEventListener("scroll", o), document.body.removeEventListener("scroll", o);
    };
  }, []), /* @__PURE__ */ f(Fe, { children: /* @__PURE__ */ f("div", { className: G.floatingContainer, id: Cr, children: /* @__PURE__ */ P("div", { className: G.menuContentContainer, children: [
    /* @__PURE__ */ f("a", { href: "/", className: G.logoContainer, children: /* @__PURE__ */ f(
      "img",
      {
        src: ys,
        alt: "logo",
        width: 0,
        height: 20,
        className: G.logo
      }
    ) }),
    /* @__PURE__ */ P("div", { className: G.menuLinksContainer, children: [
      /* @__PURE__ */ f(
        "a",
        {
          href: "/chat",
          className: `${G.mainMenuLink} ${a(
            "/chat"
            /* CHAT */
          ) ? G.active : ""}`,
          children: /* @__PURE__ */ f("span", { className: G.textWrapper, title: n("pages.chat"), children: n("pages.chat") })
        }
      ),
      /* @__PURE__ */ f(
        "a",
        {
          href: `/${r}/library`,
          className: `${G.mainMenuLink} ${a(
            "/library"
            /* KNOWLEDGE_BASE */
          ) ? G.active : ""}`,
          children: /* @__PURE__ */ f(
            "span",
            {
              className: G.textWrapper,
              title: n("pages.knowledge-base"),
              children: n("pages.knowledge-base")
            }
          )
        }
      ),
      /* @__PURE__ */ f(
        "a",
        {
          href: "/help",
          className: `${G.mainMenuLink} ${a(
            "/help"
            /* HELP */
          ) ? G.active : ""}`,
          children: /* @__PURE__ */ f("span", { className: G.textWrapper, title: n("pages.help"), children: n("pages.help") })
        }
      ),
      /* @__PURE__ */ f("div", { className: G.spacer }),
      /* @__PURE__ */ f(
        vs,
        {
          isActive: a(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: e.isAuthenticated,
          userImage: e.userImage,
          openAuthModal: e.openAuthModal,
          logout: e.logout,
          hasNotifications: e.hasNotifications
        }
      )
    ] })
  ] }) }) });
}, ry = (e) => {
  const { isAuthenticated: n, openAuthModal: t, userImage: r, logout: i, hasNotifications: a } = e;
  return /* @__PURE__ */ P(Fe, { children: [
    /* @__PURE__ */ f("div", { className: G.mobileMenuWrapper, children: /* @__PURE__ */ f(
      bm,
      {
        isAuthenticated: n,
        openAuthModal: t,
        userImage: r,
        logout: i,
        hasNotifications: a
      }
    ) }),
    /* @__PURE__ */ f("div", { className: G.desktopMenuContainer, id: "MENU_HEADER_ID", children: /* @__PURE__ */ f(
      xm,
      {
        isAuthenticated: n,
        openAuthModal: t,
        userImage: r,
        logout: i,
        hasNotifications: a
      }
    ) })
  ] });
}, _m = "_footer_1pms7_1", Nm = "_footerContainer_1pms7_21", Im = "_gridContainer_1pms7_33", Em = "_column_1pms7_57", Sm = "_logoColumn_1pms7_63", Pm = "_logo_1pms7_63", km = "_menuItem_1pms7_78", Om = "_socialContainer_1pms7_95", Tm = "_socialIconContainer_1pms7_100", Lm = "_socialIcon_1pms7_100", Fm = "_bottomBarContainer_1pms7_114", Mm = "_bottomSocialContainer_1pms7_119", Rm = "_languageSelectorContainer_1pms7_132", Dm = "_copyright_1pms7_136", Bm = "_copyrightBottom_1pms7_147", jm = "_showSmallDesktop_1pms7_161", Hm = "_showLargeDesktop_1pms7_166", ye = {
  footer: _m,
  footerContainer: Nm,
  gridContainer: Im,
  column: Em,
  logoColumn: Sm,
  logo: Pm,
  menuItem: km,
  socialContainer: Om,
  socialIconContainer: Tm,
  socialIcon: Lm,
  bottomBarContainer: Fm,
  bottomSocialContainer: Mm,
  languageSelectorContainer: Rm,
  copyright: Dm,
  copyrightBottom: Bm,
  showSmallDesktop: jm,
  showLargeDesktop: Hm
}, Vm = (e) => /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", fill: "#666666", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M28.376 16.0005C28.376 9.37286 23.0031 4 16.3755 4C9.74786 4 4.375 9.37286 4.375 16.0005C4.375 21.6283 8.24972 26.3507 13.4767 27.6477V19.6678H11.0022V16.0005H13.4767V14.4203C13.4767 10.3358 15.3252 8.44258 19.3353 8.44258C20.0957 8.44258 21.4075 8.59187 21.9442 8.74068V12.0648C21.661 12.0351 21.169 12.0202 20.5579 12.0202C18.5903 12.0202 17.83 12.7656 17.83 14.7035V16.0005H21.7498L21.0763 19.6678H17.83V27.9132C23.7721 27.1955 28.3765 22.1361 28.3765 16.0005H28.376Z" })), zm = (e) => /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", fill: "#666666", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M11.4052 4.08393C10.1284 4.14417 9.25643 4.34793 8.49418 4.64745C7.70529 4.95489 7.03665 5.36745 6.37136 6.03513C5.70607 6.70281 5.29639 7.37194 4.99111 8.16202C4.69566 8.92594 4.4955 9.79859 4.4391 11.0761C4.3827 12.3536 4.37022 12.7643 4.37646 16.023C4.3827 19.2817 4.3971 19.6902 4.45902 20.9704C4.51998 22.2469 4.72302 23.1186 5.02255 23.8811C5.33047 24.67 5.74255 25.3384 6.41048 26.0039C7.07841 26.6694 7.74705 27.0782 8.53906 27.3839C9.30227 27.6789 10.1752 27.88 11.4525 27.9359C12.7297 27.9918 13.1409 28.0048 16.3987 27.9986C19.6565 27.9923 20.0666 27.9779 21.3465 27.9172C22.6265 27.8565 23.4936 27.652 24.2563 27.3539C25.0452 27.0453 25.7141 26.6339 26.3792 25.9658C27.0442 25.2976 27.4537 24.628 27.7587 23.8374C28.0544 23.0742 28.2553 22.2013 28.3107 20.925C28.3666 19.6441 28.3798 19.2352 28.3736 15.9769C28.3673 12.7187 28.3527 12.3102 28.292 11.0305C28.2313 9.75083 28.028 8.88178 27.7287 8.11882C27.4203 7.32994 27.0087 6.66201 26.341 5.99601C25.6733 5.33001 25.0032 4.92081 24.2129 4.61649C23.4492 4.32105 22.5768 4.11969 21.2995 4.06449C20.0222 4.00929 19.6111 3.99513 16.3521 4.00137C13.0931 4.00761 12.6851 4.02153 11.4052 4.08393ZM11.5453 25.7771C10.3753 25.7262 9.74003 25.5318 9.31667 25.3691C8.75602 25.1531 8.35666 24.892 7.93474 24.4742C7.51281 24.0563 7.25361 23.6555 7.03473 23.0961C6.87032 22.6727 6.67232 22.0381 6.6176 20.8681C6.55808 19.6036 6.5456 19.2239 6.53864 16.0201C6.53168 12.8164 6.54392 12.4372 6.59936 11.1721C6.64928 10.0031 6.84488 9.36706 7.00737 8.94394C7.22337 8.38258 7.48353 7.98394 7.90234 7.56226C8.32114 7.14058 8.72074 6.8809 9.28067 6.66201C9.70355 6.49689 10.3381 6.30057 11.5077 6.24489C12.7732 6.18489 13.1524 6.17289 16.3557 6.16593C19.559 6.15897 19.9392 6.17097 21.2052 6.22665C22.3742 6.27753 23.0105 6.47121 23.4331 6.63465C23.994 6.85066 24.3931 7.1101 24.8148 7.52962C25.2365 7.94914 25.4964 8.3473 25.7153 8.90842C25.8807 9.3301 26.077 9.96443 26.1322 11.1347C26.1924 12.4002 26.2061 12.7796 26.2119 15.9827C26.2176 19.1857 26.2064 19.5661 26.1509 20.8307C26.0998 22.0007 25.9059 22.6362 25.7429 23.0601C25.5269 23.6205 25.2665 24.0201 24.8475 24.4415C24.4284 24.863 24.0293 25.1226 23.4691 25.3415C23.0467 25.5064 22.4114 25.7032 21.2429 25.7589C19.9773 25.8184 19.5981 25.8309 16.3936 25.8378C13.1891 25.8448 12.8111 25.8318 11.5456 25.7771M21.3281 9.58642C21.3285 9.87125 21.4135 10.1495 21.5721 10.3861C21.7308 10.6226 21.956 10.8068 22.2193 10.9154C22.4827 11.0239 22.7723 11.0519 23.0515 10.9959C23.3308 10.9398 23.5872 10.8022 23.7882 10.6004C23.9892 10.3986 24.1259 10.1418 24.181 9.8623C24.236 9.58285 24.2069 9.29334 24.0974 9.03041C23.9879 8.76747 23.8029 8.54291 23.5658 8.38514C23.3286 8.22736 23.05 8.14345 22.7652 8.14402C22.3834 8.14478 22.0175 8.29716 21.748 8.56765C21.4785 8.83814 21.3274 9.20459 21.3281 9.58642ZM10.2136 16.012C10.2203 19.4152 12.9841 22.1677 16.3867 22.1613C19.7892 22.1548 22.5437 19.3912 22.5372 15.988C22.5307 12.5848 19.7661 9.83147 16.3631 9.83819C12.9601 9.84491 10.2071 12.6092 10.2136 16.012ZM12.375 16.0076C12.3735 15.2165 12.6065 14.4427 13.0448 13.784C13.483 13.1253 14.1067 12.6114 14.837 12.3072C15.5674 12.003 16.3715 11.9222 17.1477 12.075C17.924 12.2278 18.6375 12.6073 19.198 13.1656C19.7586 13.724 20.141 14.436 20.2968 15.2116C20.4527 15.9872 20.3751 16.7917 20.0738 17.5232C19.7725 18.2547 19.261 18.8804 18.6041 19.3213C17.9471 19.7621 17.1742 19.9983 16.3831 19.9998C15.8577 20.0009 15.3373 19.8985 14.8516 19.6985C14.3659 19.4985 13.9243 19.2047 13.5521 18.834C13.1799 18.4632 12.8844 18.0228 12.6824 17.5379C12.4804 17.0529 12.376 16.533 12.375 16.0076Z" })), Wm = (e) => /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", fill: "#666666", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M27.6154 16.0127C27.6154 18.1511 27.6266 20.2895 27.6098 22.4275C27.6034 23.2508 27.5754 24.0814 27.2697 24.8651C26.5373 26.743 25.1374 27.7437 23.1516 27.928C22.4816 27.99 21.8047 27.9939 21.1309 27.9948C17.2995 28.0008 13.4678 28.003 9.63647 27.9939C8.75636 27.9918 7.87022 27.9969 7.01422 27.7287C5.31859 27.1969 4.23395 26.0618 3.8348 24.3432C3.66645 23.6189 3.63975 22.8499 3.63631 22.1011C3.61951 18.0684 3.62425 14.0358 3.63243 10.0032C3.63415 9.07951 3.62339 8.14682 3.93944 7.25848C4.58057 5.45725 5.86199 4.38892 7.74363 4.13486C8.73354 4.00094 9.7467 4.02247 10.7495 4.0074C11.9616 3.98974 13.1746 4.00912 14.3871 4.00998C16.8268 4.01127 19.266 4.00094 21.7057 4.01644C22.5712 4.02204 23.4396 4.03496 24.2836 4.29375C26.0628 4.83933 27.3696 6.37918 27.5306 8.33198C27.6137 9.33788 27.6094 10.3524 27.618 11.3635C27.6314 12.9132 27.6215 14.4634 27.6215 16.0131C27.6197 16.0131 27.6172 16.0127 27.6154 16.0127ZM14.8775 16.6504C14.8775 15.8306 14.8797 15.0141 14.8711 14.1973C14.8706 14.1538 14.7781 14.0801 14.7221 14.0737C11.6542 13.7077 9.56327 16.1587 9.49998 18.5752C9.46208 20.0118 9.96371 21.2256 11.0384 22.2139C12.8994 23.9251 15.9113 23.8373 17.6414 21.9938C18.5568 21.0181 18.9655 19.8572 18.9538 18.5266C18.9401 16.9626 18.95 15.3982 18.95 13.8338C18.95 13.7585 18.95 13.6836 18.95 13.5716C19.8219 14.1624 20.7304 14.531 21.7475 14.6417V11.54C21.676 11.5344 21.62 11.5301 21.5636 11.5262C20.9668 11.4862 20.3937 11.3411 19.9003 11.0039C19.0934 10.4523 18.5172 9.7181 18.2981 8.74278C18.2666 8.60197 18.1999 8.55848 18.0617 8.5602C17.588 8.56666 17.1144 8.56235 16.6412 8.56278C16.442 8.56278 16.3424 8.66154 16.3424 8.85904C16.3424 12.1528 16.3424 15.4465 16.3424 18.7402C16.3424 19.6767 15.7404 20.4958 14.8297 20.7606C13.8536 21.0443 12.9636 20.6598 12.4378 19.9131C11.5844 18.7006 12.2841 16.9592 13.736 16.6616C14.0904 16.5889 14.4723 16.6509 14.8784 16.6509L14.8775 16.6504Z" })), Um = (e) => /* @__PURE__ */ _.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", fill: "#666666", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M29.4149 9.12932C29.0929 7.89755 28.1441 6.92745 26.9394 6.59823C24.7558 6 16 6 16 6C16 6 7.2442 6 5.06058 6.59823C3.8559 6.9275 2.90711 7.89755 2.58509 9.12932C2 11.362 2 16.0202 2 16.0202C2 16.0202 2 20.6784 2.58509 22.9111C2.90711 24.1429 3.8559 25.0726 5.06058 25.4018C7.2442 26 16 26 16 26C16 26 24.7558 26 26.9394 25.4018C28.1441 25.0726 29.0929 24.1429 29.4149 22.9111C30 20.6784 30 16.0202 30 16.0202C30 16.0202 30 11.362 29.4149 9.12932ZM13.1363 20.2495V11.7909L20.4545 16.0203L13.1363 20.2495Z" })), qm = (e) => /* @__PURE__ */ _.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", fill: "#666666", ...e }, /* @__PURE__ */ _.createElement("path", { d: "M25.3303 4C26.8037 4 27.9973 5.19366 27.9973 6.66699V25.333C27.9973 26.8063 26.8037 28 25.3303 28H6.66431C5.19097 28 3.99731 26.8063 3.99731 25.333V6.66699C3.99731 5.19366 5.19097 4 6.66431 4H25.3303ZM7.67407 24.667H11.2542V13.1104H7.67407V24.667ZM20.4602 12.7578C18.0337 12.758 16.9972 14.6316 16.9778 14.667V13.1104H13.5442V24.667H16.9778V18.6006C16.9778 16.974 17.7242 16.0078 19.1575 16.0078C20.4707 16.0079 21.1037 16.9374 21.1038 18.6006V24.667H24.6672V17.3506C24.6672 14.254 22.9102 12.7578 20.4602 12.7578ZM9.44751 7.33105C8.27757 7.33105 7.33043 8.28396 7.33032 9.46387C7.33032 10.6439 8.27751 11.5977 9.44751 11.5977C10.6174 11.5976 11.5637 10.6438 11.5637 9.46387C11.5636 8.28402 10.6174 7.33116 9.44751 7.33105Z" })), Zm = "data:image/webp;base64,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", Nt = [
  {
    key: "en-au",
    name: "Australia",
    nativeName: "Australia"
  },
  {
    key: "nl-be",
    name: "Belgium (Dutch)",
    nativeName: "Belgium"
  },
  {
    key: "pt-br",
    name: "Brazil",
    nativeName: "Brasil"
  },
  {
    key: "en-ca",
    name: "Canada (English)",
    nativeName: "Canada (English)"
  },
  {
    key: "fr-ca",
    name: "Canada (French)",
    nativeName: "Canada (Français)"
  },
  {
    key: "de-de",
    name: "German",
    nativeName: "Deutschland"
  },
  {
    key: "da-dk",
    name: "Danish",
    nativeName: "Danmark"
  },
  {
    key: "es-us",
    name: "United States (Spanish)",
    nativeName: "USA (Español)"
  },
  {
    key: "es-es",
    name: "Spain",
    nativeName: "España"
  },
  {
    key: "fr-fr",
    name: "France",
    nativeName: "France"
  },
  {
    key: "bn-in",
    name: "Bengali (India)",
    nativeName: "India (Bengali)"
  },
  {
    key: "hi-in",
    name: "Hindi (India)",
    nativeName: "India (Hindi)"
  },
  {
    key: "en-ie",
    name: "Ireland",
    nativeName: "Ireland"
  },
  {
    key: "it-it",
    name: "Italy",
    nativeName: "Italia"
  },
  {
    key: "nl-nl",
    name: "Netherlands",
    nativeName: "Nederland"
  },
  {
    key: "en-nz",
    name: "New Zealand",
    nativeName: "New Zealand"
  },
  {
    key: "en-gb",
    name: "United Kingdom",
    nativeName: "United Kingdom"
  },
  {
    key: "en-us",
    name: "English",
    nativeName: "USA"
  },
  {
    key: "ja-jp",
    name: "Japan",
    nativeName: "日本"
  },
  {
    key: "zh-hk",
    name: "Hong Kong (Traditional)",
    nativeName: "香港"
  },
  {
    key: "zh-cn",
    name: "China (Simplified)",
    nativeName: "简体中文"
  },
  {
    key: "ko-kr",
    name: "Korea (South)",
    nativeName: "대한민국"
  }
], Gm = "_countryLanguageSelector_1lg1q_1", Qm = "_clickableWrapper_1lg1q_8", Km = "_language_1lg1q_15", Ym = "_icon_1lg1q_19", Xm = "_selectorWrapper_1lg1q_52", Jm = "_selector_1lg1q_52", eg = "_languages_1lg1q_93", tg = "_languageName_1lg1q_115", ng = "_active_1lg1q_127", rg = "_bottomGradient_1lg1q_133", ot = {
  countryLanguageSelector: Gm,
  clickableWrapper: Qm,
  language: Km,
  icon: Ym,
  selectorWrapper: Xm,
  selector: Jm,
  languages: eg,
  languageName: tg,
  active: ng,
  bottomGradient: rg
}, ig = (e) => {
  const { language: n, onLanguageChange: t } = e, r = _e(
    null
  ), i = _e(null), [a, o] = Y.useState(!1), [l, s] = Y.useState(1), [u, c] = Y.useState(
    Nt.find(
      (h) => h.key.toLowerCase() === (n == null ? void 0 : n.toLowerCase())
    ) || Nt[0]
  );
  Cl(i, () => {
    o(!1);
  }), ce(() => {
    c(
      Nt.find(
        (h) => h.key.toLowerCase() === (n == null ? void 0 : n.toLowerCase())
      ) || Nt[0]
    );
  }, [n]);
  const d = () => {
    const h = r.current;
    if (!h) return;
    const { scrollTop: y, scrollHeight: C, clientHeight: $ } = h;
    let m = 1;
    y + $ < C ? m = 1 : m = 0, s(m);
  }, p = (h) => (y) => {
    y.preventDefault(), y.stopPropagation();
    const C = Nt.find(
      ($) => $.key.toLowerCase() === h.toLowerCase()
    ) || Nt[0];
    window.localStorage.setItem("i18nextLng", C.key), t != null && (t == null || t(C.key)), c(C), o(!1);
  };
  return /* @__PURE__ */ f("div", { className: ot.countryLanguageSelector, ref: i, children: /* @__PURE__ */ P(
    "div",
    {
      className: ot.clickableWrapper,
      onClick: () => o(!a),
      children: [
        /* @__PURE__ */ f("div", { className: ot.icon, children: /* @__PURE__ */ P(
          "svg",
          {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "#666666",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
              /* @__PURE__ */ f("g", { clipPath: "url(#clip0_36_1915)", children: /* @__PURE__ */ f("path", { d: "M11.8839 24.0007C5.09198 23.8856 -0.282071 18.4079 0.011478 11.3781C0.280085 4.94307 5.67716 -0.237198 12.4403 0.00838562C18.9175 0.244376 24.0921 5.46302 23.9635 12.347C23.8426 18.7974 18.505 24.0046 11.8839 23.9988V24.0007ZM1.61352 9.01438C1.52911 9.2427 1.46963 9.35782 1.44277 9.47869C0.679157 13.0051 1.38713 16.2169 3.69714 18.9797C7.10845 23.0568 13.0811 24.0966 17.6302 21.2878C17.9467 21.0921 18.0657 20.8964 18.0331 20.5261C17.9371 19.467 18.1942 18.5115 18.9291 17.6981C19.1478 17.4563 19.3473 17.157 19.4452 16.8481C19.8097 15.7065 19.7157 14.3923 18.0273 14.2829C17.5534 14.2522 17.0833 14.1371 16.619 14.0258C15.0784 13.6594 14.3378 12.4218 14.7023 10.885C15.0112 9.58038 15.7825 8.59804 16.809 7.78839C17.728 7.06507 18.7199 6.79838 19.8327 7.32984C20.0476 7.43152 20.2683 7.53129 20.4966 7.59652C20.9743 7.73083 21.4578 7.84019 21.9931 7.97257C21.0913 4.36557 15.2818 0.451587 12.0662 1.20752C12.0815 1.29578 12.0949 1.38595 12.1122 1.47613C12.4134 3.18754 11.6997 4.43464 10.0152 4.91429C9.15178 5.15988 8.22125 5.1618 7.33485 5.33447C6.52903 5.48988 5.72896 5.69709 4.94425 5.94075C4.53942 6.06546 4.33029 6.42425 4.27657 6.85594C4.14418 7.88623 4.85599 8.83979 5.87861 8.98177C6.2892 9.03932 6.7017 9.08153 7.1142 9.10456C8.04282 9.15636 8.77189 9.54968 9.2362 10.3593C9.75039 11.2592 10.4085 12.0055 11.2661 12.6022C12.0374 13.1394 12.4518 13.8934 12.2139 14.8738C11.9568 15.9387 11.3448 16.7234 10.2281 16.8826C9.24579 17.0208 8.62224 17.5542 8.08694 18.3139C7.73008 18.8185 7.34828 19.3174 6.91275 19.7529C6.39856 20.2671 5.72896 20.2402 5.26082 19.728C5.05169 19.4977 4.87326 19.2157 4.75622 18.926C4.38593 18.0108 4.23244 17.0592 4.41663 16.0711C4.54326 15.39 4.41663 14.7741 3.9504 14.2426C3.78156 14.0508 3.62807 13.8474 3.47075 13.6478C3.05057 13.1164 2.6726 12.5638 2.71865 11.8405C2.78772 10.7584 2.19103 9.94491 1.61161 9.01055L1.61352 9.01438Z" }) }),
              /* @__PURE__ */ f("defs", { children: /* @__PURE__ */ f("clipPath", { id: "clip0_36_1915", children: /* @__PURE__ */ f("rect", { width: "23.9655", height: "24", fill: "white" }) }) })
            ]
          }
        ) }),
        /* @__PURE__ */ P(
          "div",
          {
            className: ot.language,
            style: a ? { pointerEvents: "all" } : {},
            children: [
              u == null ? void 0 : u.nativeName,
              /* @__PURE__ */ P(
                "div",
                {
                  className: ot.selectorWrapper,
                  style: a ? { opacity: 1, pointerEvents: "all" } : {},
                  children: [
                    /* @__PURE__ */ f("div", { className: ot.selector, children: /* @__PURE__ */ f(
                      "div",
                      {
                        ref: r,
                        className: ot.languages,
                        onScroll: d,
                        children: Nt.sort(
                          (h, y) => h.key === u.key ? -1 : y.key === u.key ? 1 : h.nativeName.localeCompare(y.nativeName)
                        ).map((h) => /* @__PURE__ */ P(
                          "div",
                          {
                            className: `${ot.languageName} ${h.key === u.key ? ot.active : ""}`,
                            onClick: p(h.key),
                            children: [
                              h.nativeName,
                              h.key === u.key && /* @__PURE__ */ f(
                                "svg",
                                {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 16 16",
                                  fill: "none",
                                  children: /* @__PURE__ */ f(
                                    "path",
                                    {
                                      d: "M14.5 3.5C14.5 3.22386 14.2761 3 14 3C13.8608 3 13.7348 3.0569 13.6442 3.14872L5.00004 11.7929L2.35359 9.14642C2.26311 9.05594 2.13807 9 2 9C1.72386 9 1.5 9.22386 1.5 9.5C1.5 9.64045 1.55791 9.76737 1.65115 9.85819L4.64181 12.8489C4.73264 12.9421 4.85956 13 5 13C5.13809 13 5.2631 12.944 5.35358 12.8535L14.3536 3.85353C14.4441 3.76305 14.5 3.63806 14.5 3.5Z",
                                      fill: "#666666"
                                    }
                                  )
                                }
                              )
                            ]
                          },
                          h.key
                        ))
                      }
                    ) }),
                    /* @__PURE__ */ f(
                      "div",
                      {
                        className: ot.bottomGradient,
                        style: { opacity: l }
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ f(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: "17",
            height: "16",
            viewBox: "0 0 17 16",
            fill: "none",
            children: /* @__PURE__ */ f(
              "path",
              {
                d: "M13.6118 5.14644C13.7023 5.05596 13.8273 5 13.9653 5C14.2415 5 14.4653 5.22386 14.4653 5.5C14.4653 5.64045 14.4074 5.76737 14.3142 5.85819L9.32353 10.8489C9.2327 10.9421 9.10578 11 8.96533 11C8.82488 11 8.69796 10.9421 8.60714 10.8489L3.61648 5.85819C3.52324 5.76737 3.46533 5.64045 3.46533 5.5C3.46533 5.22386 3.68919 5 3.96533 5C4.1034 5 4.2284 5.05596 4.31888 5.14644L8.96533 9.79283L13.6118 5.14644Z",
                fill: "#666666"
              }
            )
          }
        )
      ]
    }
  ) });
}, ag = [
  {
    link: "https://www.facebook.com/asklawconnect",
    Icon: Vm
  },
  {
    link: "https://www.instagram.com/asklawconnect/",
    Icon: zm
  },
  {
    link: "https://www.tiktok.com/@asklawconnect",
    Icon: Wm
  },
  {
    link: "https://www.linkedin.com/company/lawconnect/",
    Icon: qm
  },
  {
    link: "https://www.youtube.com/@asklawconnect",
    Icon: Um
  }
], Lo = () => /* @__PURE__ */ f("div", { className: ye.socialContainer, children: ag.map((e, n) => /* @__PURE__ */ f(
  "a",
  {
    href: e.link,
    target: "_blank",
    rel: "noreferrer",
    className: ye.socialIconContainer,
    children: /* @__PURE__ */ f(e.Icon, { width: 32, height: 32, className: ye.socialIcon })
  },
  n
)) }), iy = (e) => {
  const {
    className: n = "",
    libraryPath: t = "/library",
    onLanguageChange: r,
    language: i,
    isAuthenticated: a,
    openAuthModal: o
  } = e, { t: l } = Te(), s = l("auth.copyright-terms-privacy").replace(/TERMS_LINK/g, "/terms").replace(/PRIVACY_LINK/g, "/privacy"), u = /* @__PURE__ */ f(
    ig,
    {
      onLanguageChange: r,
      language: i ?? ""
    }
  );
  return /* @__PURE__ */ f("footer", { className: `${ye.footer} ${n}`, children: /* @__PURE__ */ P("div", { className: ye.footerContainer, children: [
    /* @__PURE__ */ P("div", { className: ye.gridContainer, children: [
      /* @__PURE__ */ P("div", { className: `${ye.column} ${ye.logoColumn}`, children: [
        /* @__PURE__ */ f("a", { href: "/", className: ye.logo, children: /* @__PURE__ */ f(
          "img",
          {
            src: Zm,
            width: 202,
            height: 28,
            alt: "LawConnect",
            loading: "lazy",
            className: ye.logoImage
          }
        ) }),
        /* @__PURE__ */ f("div", { className: ye.showSmallDesktop, children: u })
      ] }),
      /* @__PURE__ */ P("div", { className: ye.column, children: [
        /* @__PURE__ */ f("a", { href: "/chat", className: `${ye.menuItem}`, children: l("pages.chat") }),
        /* @__PURE__ */ f("a", { href: t, className: `${ye.menuItem}`, children: l("pages.knowledge-base") }),
        /* @__PURE__ */ f("a", { href: "/help", className: `${ye.menuItem}`, children: l("pages.help") }),
        /* @__PURE__ */ f(
          "a",
          {
            href: "/account",
            className: `${ye.menuItem}`,
            onClick: (c) => {
              a || (c.preventDefault(), o == null || o());
            },
            children: l("pages.account")
          }
        )
      ] }),
      /* @__PURE__ */ P("div", { className: ye.column, children: [
        /* @__PURE__ */ f("a", { href: "/about", className: `${ye.menuItem}`, children: l("pages.about") }),
        /* @__PURE__ */ f("a", { href: "/careers", className: `${ye.menuItem}`, children: l("pages.careers") }),
        /* @__PURE__ */ f("a", { href: "/sailing", className: `${ye.menuItem}`, children: l("pages.sailing") }),
        /* @__PURE__ */ f("a", { href: "/contact-us", className: `${ye.menuItem}`, children: l("pages.contact-us") })
      ] }),
      /* @__PURE__ */ P("div", { className: `${ye.column} ${ye.showLargeDesktop}`, children: [
        /* @__PURE__ */ f(Lo, {}),
        /* @__PURE__ */ f("div", { className: ye.languageSelectorContainer, children: u })
      ] })
    ] }),
    /* @__PURE__ */ P("div", { className: ye.bottomBarContainer, children: [
      /* @__PURE__ */ P("div", { className: ye.bottomSocialContainer, children: [
        /* @__PURE__ */ f(Lo, {}),
        /* @__PURE__ */ f("div", { className: ye.languageSelectorContainer, children: u })
      ] }),
      /* @__PURE__ */ P("div", { className: ye.copyright, children: [
        /* @__PURE__ */ f("div", { children: l("auth.copyright").replace(
          "<YEAR>",
          (/* @__PURE__ */ new Date()).getFullYear().toString()
        ) }),
        /* @__PURE__ */ P("div", { className: ye.copyrightBottom, children: [
          /* @__PURE__ */ P("div", { children: [
            l("auth.copyright-description"),
            " "
          ] }),
          /* @__PURE__ */ f("div", { dangerouslySetInnerHTML: { __html: s } })
        ] })
      ] })
    ] })
  ] }) });
}, og = "_modal_1tjys_38", lg = "_fadeIn_1tjys_1", sg = "_fullscreen_1tjys_52", ug = "_closing_1tjys_67", cg = "_fadeOut_1tjys_1", dg = "_modalContent_1tjys_70", fg = "_slideIn_1tjys_1", hg = "_authStyle_1tjys_94", pg = "_slideOut_1tjys_1", mg = "_close_1tjys_127", gg = "_logo_1tjys_134", yg = "_titleContainer_1tjys_139", $g = "_titleIcon_1tjys_153", vg = "_title_1tjys_139", Cg = "_content_1tjys_181", bg = "_description_1tjys_187", Ag = "_childrenContainer_1tjys_206", wg = "_buttonContainer_1tjys_209", xg = "_primaryButton_1tjys_217", _g = "_secondaryButton_1tjys_246", Ng = "_footer_1tjys_273", Ne = {
  modal: og,
  fadeIn: lg,
  fullscreen: sg,
  closing: ug,
  fadeOut: cg,
  modalContent: dg,
  slideIn: fg,
  authStyle: hg,
  slideOut: pg,
  close: mg,
  logo: gg,
  titleContainer: yg,
  titleIcon: $g,
  title: vg,
  content: Cg,
  description: bg,
  childrenContainer: Ag,
  buttonContainer: wg,
  primaryButton: xg,
  secondaryButton: _g,
  footer: Ng
}, Ig = "_loadingIcon_mgd1d_1", Eg = "_rotateSpinner_mgd1d_1", Sg = "_dash_mgd1d_1", Pg = {
  loadingIcon: Ig,
  rotateSpinner: Eg,
  dash: Sg
}, br = (e) => {
  const { className: n } = e;
  return /* @__PURE__ */ f("svg", { className: `${Pg.loadingIcon} ${n ?? ""}`, viewBox: "0 0 50 50", fill: "none", children: /* @__PURE__ */ f("circle", { className: "path", cx: "25", cy: "25", r: "20", strokeWidth: "5" }) });
}, kg = $e(
  ({
    children: e,
    defaultOpen: n = !1,
    onClose: t,
    onOpen: r,
    className: i = "",
    logo: a = !0,
    titleIcon: o,
    title: l,
    description: s,
    primaryButton: u,
    secondaryPrimaryButton: c,
    secondaryButton: d,
    footerText: p,
    hideCloseButton: h = !1,
    useAuthStyle: y = !1,
    fullscreen: C = !1
  }, $) => {
    const [m, x] = de(n), [A, I] = de(!1), b = _s(), w = _e(null), S = te(() => {
      w.current && (clearTimeout(w.current), w.current = null), I(!1), x(!0), r == null || r();
    }, [r]), O = te(() => {
      A || (I(!0), w.current = setTimeout(() => {
        x(!1), I(!1), t == null || t();
      }, 200));
    }, [A, t]);
    ce(() => () => {
      w.current && clearTimeout(w.current);
    }, []);
    const N = te(() => {
      d == null || d.onClick(), O();
    }, [d, O]);
    return zt($, () => ({
      openModal: S,
      closeModal: O
    })), ce(() => {
      m ? document.body.style.overflow = "hidden" : document.body.style.overflow = "auto";
    }, [m]), m ? Ro(
      /* @__PURE__ */ f(
        "div",
        {
          className: `${Ne.modal} ${i} ${A ? Ne.closing : ""} ${C ? Ne.fullscreen : ""}`,
          children: /* @__PURE__ */ P(
            "div",
            {
              ref: b,
              className: `${Ne.modalContent} ${A ? Ne.closing : ""} ${y ? Ne.authStyle : ""} ${C ? Ne.fullscreen : ""}`,
              children: [
                !h && /* @__PURE__ */ f("div", { className: Ne.close, onClick: O, children: /* @__PURE__ */ f(
                  "svg",
                  {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /* @__PURE__ */ f(
                      "path",
                      {
                        d: "M19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5C20.25 4.70708 20.1661 4.89456 20.0304 5.03028L13.0607 12L20.0304 18.9696C20.1661 19.1054 20.25 19.2929 20.25 19.5C20.25 19.9142 19.9142 20.25 19.5 20.25C19.2894 20.25 19.099 20.1632 18.9628 20.0233L12.0001 13.0606L5.03039 20.0303C4.89466 20.166 4.70713 20.25 4.5 20.25C4.08579 20.25 3.75 19.9142 3.75 19.5C3.75 19.2912 3.83535 19.1023 3.97308 18.9663L10.9394 12L3.97671 5.03727C3.83685 4.90104 3.75 4.71066 3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75C4.70711 3.75 4.89462 3.83395 5.03034 3.96968L12.0001 10.9393L18.9663 3.97308C19.1023 3.83535 19.2912 3.75 19.5 3.75Z",
                        fill: "#B0B7BD"
                      }
                    )
                  }
                ) }),
                a && /* @__PURE__ */ f("div", { className: Ne.logo, children: /* @__PURE__ */ P(
                  "svg",
                  {
                    width: "48",
                    height: "48",
                    viewBox: "0 0 48 48",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                      /* @__PURE__ */ P("g", { "clip-path": "url(#clip0_6687_23096)", children: [
                        /* @__PURE__ */ f(
                          "path",
                          {
                            d: "M24 48C37.2548 48 48 37.2548 48 24H36C36 30.6274 30.6274 36 24 36C17.3726 36 12 30.6274 12 24C12 17.3726 17.3726 12 24 12V0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
                            fill: "#0E5FE3"
                          }
                        ),
                        /* @__PURE__ */ f(
                          "path",
                          {
                            d: "M40 16C44.4183 16 48 12.4183 48 7.99999C48 3.58173 44.4183 0 40 0C35.5817 0 32 3.58173 32 7.99999C32 12.4183 35.5817 16 40 16Z",
                            fill: "#0E5FE3"
                          }
                        )
                      ] }),
                      /* @__PURE__ */ f("defs", { children: /* @__PURE__ */ f("clipPath", { id: "clip0_6687_23096", children: /* @__PURE__ */ f("rect", { width: "48", height: "48", fill: "white" }) }) })
                    ]
                  }
                ) }),
                l && /* @__PURE__ */ P("div", { className: Ne.titleContainer, children: [
                  o && /* @__PURE__ */ f("div", { className: Ne.titleIcon, children: o }),
                  /* @__PURE__ */ f("h2", { className: `${Ne.title} ${y ? Ne.authStyle : ""}`, dangerouslySetInnerHTML: { __html: l } })
                ] }),
                s && /* @__PURE__ */ f("div", { className: `${Ne.description} ${y ? Ne.authStyle : ""}`, dangerouslySetInnerHTML: { __html: s } }),
                e && /* @__PURE__ */ f("div", { className: Ne.content, children: /* @__PURE__ */ f("div", { className: Ne.childrenContainer, children: e }) }),
                (u || c || d) && /* @__PURE__ */ P("div", { className: Ne.buttonContainer, children: [
                  u && /* @__PURE__ */ f(
                    "button",
                    {
                      className: Ne.primaryButton,
                      onClick: u.onClick,
                      disabled: u.pending || u.disabled,
                      children: u.pending ? /* @__PURE__ */ f(br, {}) : u.label
                    }
                  ),
                  c && /* @__PURE__ */ f(
                    "button",
                    {
                      className: Ne.primaryButton,
                      onClick: c.onClick,
                      disabled: c.pending || c.disabled,
                      children: c.pending ? /* @__PURE__ */ f(br, {}) : c.label
                    }
                  ),
                  d && /* @__PURE__ */ f(
                    "button",
                    {
                      className: Ne.secondaryButton,
                      onClick: N,
                      disabled: d.pending || d.disabled,
                      children: d.pending ? /* @__PURE__ */ f(br, {}) : d.label
                    }
                  )
                ] }),
                p && /* @__PURE__ */ f("div", { className: Ne.footer, dangerouslySetInnerHTML: { __html: p } })
              ]
            }
          )
        }
      ),
      document.body
    ) : null;
  }
), ay = (e, n = !1) => {
  const t = document.createElement("div");
  document.body.appendChild(t);
  const r = { current: null };
  let i = !1;
  const a = Dn(t), o = () => {
    i && r.current ? r.current.openModal() : setTimeout(() => o(), 0);
  }, l = () => {
    i && r.current && r.current.closeModal();
  }, s = () => {
    if (r.current)
      r.current.closeModal(), setTimeout(() => {
        try {
          a.unmount(), document.body.contains(t) && document.body.removeChild(t);
        } catch (c) {
          console.error("Error destroying modal:", c);
        }
      }, 300);
    else
      try {
        a.unmount(), document.body.contains(t) && document.body.removeChild(t);
      } catch (c) {
        console.error("Error destroying modal:", c);
      }
  }, u = Fo(kg, {
    ...e,
    ref: (c) => {
      c && (r.current = c, i = !0, n && r.current.openModal());
    },
    // Ensure we properly handle the onClose event
    onClose: () => {
      e.onClose && e.onClose();
    }
  });
  return a.render(u), {
    open: o,
    close: l,
    destroy: s
  };
};
export {
  Zg as Accordion,
  ey as AiLawyerPlaceholder,
  Jg as AiLawyerSelector,
  Kg as Carousel,
  Ug as ChatElement,
  p0 as ChatInput,
  en as ChatMessageType,
  ga as ChatMessageWrapper,
  N5 as CheckboxInput,
  np as ConfirmModal,
  bl as ContextMenu,
  k5 as DateInput,
  M5 as DateTimeInput,
  Ef as EmailInput,
  _f as FileInput,
  ty as FinancialInput,
  iy as FooterComponent,
  ei as InlineForm,
  vn as InputDescription,
  W5 as InputLabel,
  Al as InputSeparator,
  Hg as LawyerChatMessage,
  ry as MenuComponent,
  Qg as MessageRow,
  kg as Modal,
  w5 as NumericInput,
  ny as OnOffInput,
  qg as OverviewForm,
  Rh as PhoneInput,
  jh as ProgressBar,
  Td as QuestionList,
  Ht as QuestionWrapper,
  Z5 as RadioInput,
  ag as SOCIAL_MEDIA_LINKS,
  of as ScaleInput,
  Yg as SectionedForm,
  uf as SplitDateInput,
  kf as TextInput,
  Os as TextareaInput,
  X5 as TimeInput,
  Gg as Toast,
  jg as UserChatMessage,
  C5 as YesNoInput,
  Xg as confirm,
  ay as createModal,
  W3 as formatDate,
  zg as formatDateTime,
  ya as formatLongDateTime,
  Wg as formatMediumDateTime,
  Vg as formatTime
};
